import React from "react";
import { storeProducts } from "../Data";
import setToken from "./../util/setToken";
import errorAduio from "./../img/error.mp4";
import warningAdiuo from "./../img/Bleep.mp3";
import notifyAudio from "./../img/notify.wav";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import swal from "sweetalert";
import Swal from "sweetalert2";
import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";
import _, { cloneDeep } from "lodash";
import Instance from "../util/Instance";
import { v4 as uuidv4 } from "uuid";
import { getAuditLogs, getAuditLogById } from "../util/AuditLogAPI";

const ProductContext = React.createContext();

class AddProWakel extends React.Component {
  constructor() {
    super();
    let curr = new Date();
    curr.setDate(curr.getDate());
    let today = curr.toISOString().substr(0, 10);
    this.state = {
      ///Print Raffa
      PR_code: "",
      PR_productCode: "",
      PR_barcode: "",
      PR_number: "",
      PR_numberOfDana: "",
      PR_numberOfDarzan: "",
      PR_height: "",
      PR_width: "",
      PR_length: "",
      PR_dnk: "",
      PR_zhmarayDwkan: "",
      PR_price: "",
      PR_nrxeFroshtnDolar2: "",
      PR_nrxeFroshtnDenar2: "",
      PR_nsbayfrohtn: "",
      PR_nrxifroshtnkarton2: "",
      PR_nsbayfrohtn2: "",
      PR_qazanj2: "",
      PR_nrxifroshtnkarton2_IQD: "",
      PR_nsbayfrohtn2_IQD: "",
      PR_qazanj2_IQD: "",
      PR_qazanj: "",
      PR_rasidKarton: "",
      PR_weight: "",
      PR_Karton_price: "",
      PR_priceOneRRR: "",
      PR_nrxifroshtnkarton: "",
      PR_Chine_invoice: "",
      PR_singleSale: "",
      PR_total: "",
      P_nrxDinar: "",
      P_nrxkamtrlaniw: "",
      P_nrxkamptrlada: "",
      P_mufrad_: "",
      P_nrxDolar: "",
      P_data: [],
      P_nrxDolar2: "",
      R_Nrx_J_T_check: false,
      R_Nrx_IQD_check: false,
      R_Mufrad_check: false,
      R_Item_check: false,
      FIB: false,
      cash: false,
      owe: false,
      M_FIB: false,
      P_pashDashkan: 0,
      M_cash: false,
      R_dataProduct: "",
      R_addToTable: false,
      PR_rezha: "",
      PR_name: "",
      PR_nrxID: "",
      PR_kamtrlaniw: "",
      PR_nrdkarton: "",
      PR_font: "",
      PR_display: "",
      PR_nrxdadarzan: "",
      PR_nrxdolar: "",
      PR_dp: "",
      PR_detail: "",
      PR_nrxdinarishandan: false,
      PR_nrxkartonpishandan: false,
      PR_nrxniwpishandan: false,
      PR_data: [],

      // disabled navdolar
      disabled_navdolar: false,
      // end
      /// loading state
      loading: false,
      P_loading: false,
      ProductLoading: false,
      G_loading: false,
      // print
      print: false,
      // end
      ///draw
      dinar: false,
      dolar: false,
      //////user
      isAuthUser: null,
      L_error: null,
      L_name: "",
      L_password: "",
      role: "",
      L_user: null,
      //////end
      //////Audit Log
      AL_data: [],
      AL_total: 0,
      AL_page: 1,
      AL_pages: 1,
      AL_from: "",
      AL_to: "",
      AL_action: "",
      AL_model: "",
      AL_selectedLog: null,
      AL_modalOpen: false,
      //////end
      products: [],
      koygshty: "",
      data: [],
      productdata: [],
      addnrxKraton: "",
      rezha: "",
      nrx: "",
      darzan: "",
      karton: "",
      barwar: "",
      nawneshan: "",
      raseddolar: "",
      raseddenar: "",
      mob: "",
      naw: "",
      code: "",
      navdolar: "",
      zhmara: "",
      zhmaraySht: "",
      barcode: "",
      naweSht: "",
      kren: "",
      nrxeFroshtnDolar: "",
      nrxeFroshtnDenar: "",
      nrxeKamtrlanewCarton: "",
      nrxeKamtrlaDaDarzan: "",
      nrxeDarzan: "",
      zhmarayKarton: "",
      qazanj: "",
      prodactdata: "",
      priceOneRRR: "",
      search: null,
      edit: null,
      Edit_date: today,
      ok: null,
      error: null,
      Add_rasidkarton: "",
      wazn_karton: "",
      nrxmufrad: "",
      NumberOfDana: "",
      P_meterPrice: 0,
      P_remembiPrice: 0,
      del_dis: null,
      open: null,
      page: "",
      width: "",
      height: "",
      length: "",
      productNum: "",
      techw: "",
      zhmarayDwkan: "",
      dp: "",
      dnk: "",
      meterPrice: "",
      remembiPrice: "",
      metercheck: false,
      nrxifroshtnkarton2: "",
      nsbayfrohtn2: "",
      nsbayfrohtn: "",
      qazanj2: "",
      nrxeFroshtnDolar2: "",
      nrxifroshtnkarton2_IQD: "",
      nsbayfrohtn2_IQD: "",
      qazanj2_IQD: "",
      nrxeFroshtnDenar2: "",
      Chine_invoice: "",
      productNum: "",
      // states of 3arze kala
      HK_all3arzKala: [],
      HK_draw: "",
      HK_naw: "",
      HK_zhmara: "",
      HK_modalOpen: false,
      HK_code: "",
      HK_code2: "",
      HK_name: "",
      KD_all3arzKala: [],
      KD_draw: "",
      KD_naw: "",
      KD_zhmara: "",
      KD_modalOpen: false,
      KD_code: "",
      KD_name: "",
      //end of states of 3arze kala
      /// Rent Context && States
      R_dataRent: [],
      R_header: null,
      R_dataTable: [],
      R_suggestions: [],
      R_cursor: 0,
      R_wakilSuggestions: [],
      R_wakilCursor: -1,
      R_zh_wasl: "",
      R_zh_barez: "",
      R_nawe_barez: "",
      R_mob: "",
      R_zhmara: "",
      R_zhmarasht: "",
      R_naweSht: "",
      R_productId: "",
      R_karton: "",
      R_darzan: "",
      R_nrx: "",
      R_rezha: "",
      R_koygshty$: "",
      R_koygshtyID: "",
      R_total: "",
      R_totalID: "",
      R_dashkan: "",
      R_dashkanID: "",
      R_mawa$: "",
      R_paraDan$: "",
      R_paraDanID: "",
      R_error: null,
      R_frosth: "فرۆشتنی وەکیل",
      R_joripara: "دینار",
      R_wargr: "ئەنوەر",
      R_search: null,
      R_search_wasl: null,
      R_search_wakil: null,
      R_nrx_dolar: "",
      R_paradanPechawana: "",
      R_nrx_dinarr: "",
      R_nrx_dinarr2: "",
      R_nrx_niwkarton: "",
      R_nrx_kmtrdadarzan: "",
      R_Dolar2: "",
      R_Dinar2: "",
      R_save: null,
      R_rasidKarton: "",
      R_qazanj: "",
      R_kren: "",
      R_nrxkaton: "",
      R_rasidWakildolar: "",
      R_rasidWakildinar: "",
      R_rasidWakildolarSave: "",
      R_rasidWakildinarSave: "",
      R_rasidWakildolarNew: "",
      R_rasidWakildinarNew: "",
      R_kateQarz: "",
      R_kartonakan: "",
      R_kreysayara: "",
      R_kreykrekar: "",
      R_nwe: null,
      R_isChecked: false,
      R_WakilQard_isChecked: false,
      R_wasl: null,
      R_pass: null,
      R_ko: "",
      R_koywaznkarton: "",
      R_zh_wasl_katy: "",
      R_up_wasl: null,
      R_paraywasl: "",
      R_NO_page: "",
      R_del_dis: null,
      R_open: null,
      R_up_froshtn: null,
      R_date: "",
      R_togler: false,
      R_page: 0,
      R_qazanjywasl: "",
      R_waznkarton: "",
      R_table: false,
      R_dp: "",
      R_singleSale: 0,
      // end statets
      // wakel States
      W_dataWakel: [],
      W_nawneshan: "",
      W_raseddenar: "",
      W_raseddolar: "",
      W_mob_Wakel: "",
      W_naw: "",
      W_code: "",
      W_error: null,
      W_show: false,
      W_wakelakan: [],
      W_wakelakanSearch: [],
      W_search: "",
      // end states wakel

      // Take Money states
      P_zhmara: "",
      P_briparaypechawana: "",
      P_barwar: "",
      P_zh_barez: "",
      P_nawe_barez: "",
      //// name search of the wakil inside پارە وەرگرتن
      P_wakilSuggestions: [],
      P_wakilCursor: -1,
      P_qarzeKonDolar: "",
      P_qarzeKonID: "",
      P_qarzeKonDolar_: "",
      P_qarzeKonID_: "",
      P_brePara: "",
      P_dashkan: "",
      P_paraPashDashkan: "",
      P_error: null,
      P_note: "",
      P_isChecked: false,
      P_joripara: "دینار",
      P_wargr: "ئەنوەر",
      P_save: null,
      P_search_wasl: null,
      P_up_wasl: null,
      P_paraywasl: "",
      P_del_dis: null,
      P_open: null,
      P_wasl: null,
      P_page: "",
      P_togler: false,
      P_wakilSearch: false,
      P_Amount_Dolar: "",
      P_High_Dolar: "",
      P_Low_Dolar: "",
      P_Amount_Dinar: "",
      P_Remebi_Price: "",
      P_DolarTR: false,
      P_DinarTR: false,
      // end of Take Money states

      // Add User States
      A_addUserData: [],
      A_bakarhenar: "",
      A_zh_mobile: "",
      A_role: "",
      A_password: "",
      A_newPassword: "",
      A_passCheck: "",
      A_error: null,
      A_openmodel: false,
      // Enf Of  Add User States

      // Update admin password States
      U_currentpasword: "",
      U_newPassword: "",
      U_newPassword2: "",
      U_error: null,
      U_save: false,
      U_show: false,
      AU_newPassword: "",
      AU_error: null,
      AU_save: false,
      AU_show: false,
      // Enf Of  Update admin password  States

      // states of garawanwa bo koga
      G_togler: false,
      G_zhmaraysht: "",
      G_productId: "",
      G_karton: "",
      G_darzan: "",
      G_nrx: "",
      G_naweSht: "",
      G_rezha: "",
      G_zhmara: "",
      G_mob: "",
      G_nawe_barez: "",
      G_zh_barez: "",
      G_zh_wasl: "",
      G_zh_wasl_katy: "",
      G_wasl: null,
      G_search_wakil: null,
      G_search: null,
      G_del_dis: null,
      G_joripara: "دینار",
      G_wargr: "ئەنوەر",
      G_nrx_dolar: "",
      G_nrx_dinarr: "",
      G_nrx_niwkarton: "",
      G_nrx_kmtrdadarzan: "",
      G_Dolar2: "",
      G_Dinar2: "",
      G_Nrx_J_T_check: false,
      G_Nrx_IQD_check: false,
      G_dataProduct: "",
      G_rasidKarton: "",
      G_qazanj: "",
      G_kren: "",
      G_nrxkaton: "",
      G_dataTable: [],
      G_totalID: "",
      G_total: "",
      G_kartonakan: "",
      G_search_wasl: null,
      G_waznkarton: "",
      G_WakilQard_isChecked: null,
      G_save: null,
      G_open: null,
      G_paraDan$: "",
      G_paraDanID: "",
      G_dashkanID: "",
      G_dashkan: "",
      G_kreysayara: "",
      G_kreykrekar: "",
      G_paraywasl: "",
      G_page: "",
      G_qazanjywasl: "",
      G_date: "",
      G_koywaznkarton: "",
      G_pass: null,
      G_table: false,
      G_dp: "",
      //end of states of garawanwa bo koga

      // states of raporty qazanj
      Q_modalOpen: false,
      Q_to: today,
      Q_from: today,
      Q_data: [],
      Q_koyQazanj: 0,
      Q_qazanjysafi: 0,
      Q_dashkandolar: 0,
      Q_dashkandinar: 0,
      Q_ganawa: 0,
      Q_kala: false,
      Q_wakel: false,
      Q_wasl: false,
      Q_rastawxo: false,
      //end of states of raporty qazanj

      //state of Raporty Rozhana
      d_from: today,
      d_to: today,
      d_zhmara: "",
      d_barwar: "",
      d_jula: "",
      d_koyPsula: "",
      d_jorydraw: "دینار",
      d_lexoshbun: "",
      d_paraydrwa: "",
      d_mawa: "",
      d_naweWakel: "",
      d_zhmaraWakel: "",
      d_dataRozhana: [],
      d_paraynadrawID: "",
      d_paraynadraw$: "",
      d_wargrtnawayQarzID: "",
      d_fib: "",
      d_fib_Iqd: "",
      d_cash: "",
      d_cash_Iqd: "",
      d_dashkan: "",
      d_dashkan_iqd: "",
      d_garanawa_Dolar: "",
      d_garanawa_Dinar: "",
      d_wargrtnawayQarz$: "",
      d_paraywargerawID: "",
      d_paraywargeraw$: "",
      d_froshrawID: "",
      d_froahraw$: "",
      d_rahelID: "",
      d_rahel$: "",
      d_yassinID: "",
      d_yassin$: "",
      d_modalOpen: false,
      d_incart: false,
      d_hamw: false,
      d_froshtn: false,
      d_parawargrtn: false,
      d_garanawa: false,
      d_koyparadandolar: "",
      d_koyparadandinar: "",
      d_koyparadanRRR: "",
      d_koyparakomdolar: "",
      d_koyparakomdinar: "",
      d_koyparakomRRR: "",
      // end of state of Raporty Rozhana

      // states of Raporty julay kompanyakan
      JK_modalOpen: false,
      JK_from: today,
      JK_to: today,
      JK_hamu: false,
      JK_paradan: false,
      JK_kompanyakan: false,
      JK_data: [],
      JK_barwar: "",
      // end of states of Raporty julay kompanyakan

      // states of Raporty Wakel
      RW_dataWakelRaport: [],
      RW_modalOpen: false,
      RW_zh_barez: "",
      RW_nawibrez: "",
      //// name search of the wakil inside ڕاپۆرتی وەکیل
      RW_wakilSuggestions: [],
      RW_wakilCursor: -1,
      RW_mob: "",
      RW_from: today,
      RW_to: today,
      RW_zhmara: "",
      RW_barwar: "",
      RW_jula: "",
      RW_koyPsula: "",
      RW_jorepara: "",
      RW_lexoshbun: "",
      RW_paraydraw: "",
      RW_mawa: "",
      RW_rasedyKotaye$: "",
      RW_rasedyKotayeID: "",
      RW_koyfroshtndolar: "",
      RW_koyfroshtndianr: "",
      RW_koyGaranawadolar: "",
      RW_koyGaranawadianr: "",
      RW_koyDashkanDolar: 0,
      RW_koyDashkanDinar: 0,
      RW_hamw: false,
      RW_froshtn: false,
      RW_parawargrtn: false,
      RW_garanawa: false,
      Rw_koyparaydrawba$: "",
      Rw_koyparaydrawbaID: "",
      //end of  states of Raporty Wakel

      // states of qarze wakel
      QW_dataWakelQarz: [],
      QW_zhmara: "",
      Qw_naw: "",
      Qw_barwar: "",
      QW_rasiddinar: "",
      QW_rasiddolar: "",
      //end of states of qarze wakel
      // states of Rapoty rozhanay Mawad
      RDM_dataWakelQarz: [],
      RDM_from: today,
      RDM_to: today,
      RDM_modalOpen: false,
      RDM_harzantr: false,
      RDM_harzantr_IQD: false,
      RDM_isSingle: false,
      GDM_grantr: false,
      GDM_grantr_IQD: false,
      GDM_isSingle: false,
      //end of states of Rapoty rozhanay Mawad

      // states of Jarde Maxzan
      JM_dataRaportyKoga: [],
      JM_allproducts: [],
      JM_naw: "",
      JM_zhmara: "",
      JM_barwar: today,
      JM_footer_rasedyhamukartonakan: "",
      JM_modalOpen: false,
      JM_code: "",
      JM_name: "",
      JM_koyrasidkarton: "",
      JM_koyrasidparakan: "",
      JM_yaksanbasfr: false,
      JM_zyattrlasfr: false,
      //end of states of Jarde Maxzan

      // states of raporty kala
      K_datatable: [],
      K_modalOpen: false,
      K_barwar: "",
      K_zhamara: "",
      K_naweKala: "",
      k_navbar_tomarkrdn: false,
      k_navbar_froshtn: false,
      k_navbar_garanawa: false,
      K_from: today,
      K_to: today,
      K_rasedeKarton: "",
      K_rasedekartonfroshtn: "",
      K_rasedekartongarnawa: "",
      K_rasedekartonKren: "",
      K_datafilter: [],
      K_yaksanbasfr: false,
      K_zyattrlasfr: false,
      K_kamtrlasfr: false,
      K_dolar2: "",
      // end of states of raporty kala

      /////states  qarzy rastawxo
      QR_data: [],
      QR_zhmara: "",
      QR_naw: "",
      QR_barwar: "",
      QR_rasiddinar: "",
      QR_rasiddolar: "",
      QR_openmodel: false,
      QR_name: "",
      QR_from: today,
      QR_to: today,
      /////end qarzy rastawxo

      // states of Raporty Chin
      RC_data: [],
      RC_kalladata: [],
      RC_zhmarayKala: "",
      RC_zhmaaryDukan: "",
      RC_zhmaaryPswla: "",
      RC_nrxeNavR: "",
      RC_nrxNavM: "",
      RC_dabash: "",
      RC_rezhaynawKarton: "",
      RC_nrxRRR: "",
      RC_koygshtyR: "",
      RC_koygshty$: "",
      RC_drezhe: "",
      RC_pane: "",
      RC_barze: "",
      RC_koymatr$: "",
      RC_nrxekotayeKala$: "",
      RC_kren: "",
      RC_froshtn: "",
      RC_qazanj: "",
      RC_R_disaebl: true,
      RC_M_desaebl: true,
      RC_search_wasl: null,
      RC_wasl: null,
      RC_open: false,
      RC_save: false,
      RC_dis: false,
      RC_updatekala: false,
      RC_kreneakcartoon: "",
      RC_froshtneakcartoon: "",
      RC_froshtnID: "",
      RC_kamtrlaDadarzan: "",
      RC_kamtrlaNewkarton: "",
      RC_nawikalla: "",
      RC_rezhaykarton: "",
      // end of states of Raporty Chin

      // states of Raporty Kalay Nafroshraw
      KN_openmodel: false,
      KN_data: [],
      KN_from: today,
      KN_to: today,

      // states of Raporty Paray Nagaranawa
      RP_dataPara: [],
      RP_zhmara: "",
      RP_naw: "",
      RP_from: today,
      RP_to: today,
      RP_openmodel: false,

      //end of states of Raporty Paray Nagaranawa

      // states of add prople
      Ap_data: [],
      Ap_kasakan: [],
      Ap_code: "",
      Ap_naw: "",
      Ap_mob: "",
      Ap_jor: "فرۆشیار",
      Ap_show: false,
      Ap_paradolar: "",
      Ap_paradinar: "",
      // end of states of add prople

      // states of masrufat
      Ms_data: [],
      Ms_naw: "",
      Ms_koypara: "",
      Ms_draw: null,
      Ms_koymasruf$: "",
      Ms_koymasrufID: "",
      Ms_show: false,
      Ms_date: "",

      // states of paradan
      PD_zhamara: "",
      Pd_barwar: "",
      PD_parayesta$: "",
      PD_parayestaID: "",
      PD_parayesta_RRR: "",
      PD_nawebarez: "",
      //// name search of the kas inside پارە دان
      PD_kasSuggestions: [],
      PD_kasCursor: -1,
      PD_zhmaraybarez: "",
      PD_brepara: "",
      PD_joredraw: "دۆلار",
      PD_nawewargr: "ئەنوەر",
      PD_page: "",
      PD_del_dis: null,
      PD_open: null,
      PD_toggler: false,
      PD_note: "",
      PD_search_wasl: null,
      PD_save: null,
      PD_wasl: null,
      PD_qardekon$: 0,
      PD_qardekonID: 0,
      PD_qardekonRR: 0,
      PD_isChecked: false,
      PD_wasleShareka: "",
      PD_show: false,
      PD_wakilSearch: false,
      // end of states of paradan

      // states of para darhenan
      PM_zhamara: "",
      PM_barwar: "",
      PM_parayesta$: "",
      PM_parayestaID: "",
      PM_brepara: "",
      PM_joredraw: "دۆلار",
      PM_nawewargr: "",
      PM_page: "",
      PM_del_dis: null,
      PM_open: null,
      PM_toggler: false,
      PM_note: "",
      PM_search_wasl: null,
      PM_save: null,
      PM_wasl: null,
      PM_nawikas: "",
      PM_show: false,
      // end of states of para darhenan

      // states of paray mandubakan
      MM_zhamara: "",
      MM_barwar: "",
      MM_nawebarez: "",
      //// name search of the kas inside مافی کۆمپانیا
      MM_kasSuggestions: [],
      MM_kasCursor: -1,
      MM_zhmaraybarez: "",
      MM_lastPayment: "",
      MM_qarzeKonDolar: 0,
      MM_qarzeKonID: 0,
      MM_qarzeKonR: 0,
      MM_qarzeKonRState: 0,
      MM_brepara: "",
      MM_joredraw: "دۆلار",
      MM_nawewargr: "ئەنوەر",
      MM_page: "",
      MM_del_dis: null,
      MM_open: null,
      MM_toggler: false,
      MM_note: "",
      MM_search_wasl: null,
      MM_save: null,
      MM_wasl: null,
      MM_wasleShareka: "",
      MM_isChecked: false,
      MM_jorfilter: "",
      MM_wakilSearch: false,
      MM_Amount_Dolar: "",
      MM_High_Dolar: "",
      MM_Low_Dolar: "",
      MM_Amount_Dinar: "",
      MM_Remebi_Price: "",
      MM_DolarTR: false,
      MM_DinarTR: false,
      // end of states of paray mandubakan

      /// states of raporty Paradan
      RPD_data: [],
      RPD_openmodel: false,
      RPD_from: today,
      RPD_to: today,
      RPD_para$: "",
      RPD_paraID: "",
      RPD_paraRRR: "",
      RPD_jorfilter: "",
      /// end of  states of raporty Paradan

      // states of raporty paradarhenraw
      RPM_data: [],
      RPM_openmodel: false,
      RPM_from: today,
      RPM_to: today,
      RPM_para$: "",
      RPM_paraID: "",
      // end of states of raporty paradarhenraw

      // states of raporty masrufat
      RMS_data: [],
      RMS_openmodel: false,
      RMS_from: today,
      RMS_to: today,
      RMS_para$: "",
      RMS_paraID: "",
      RMS_koymasruf$: "",
      RMS_koymasrufID: "",
      // end of states of raporty masrufat

      // states of raporty tak kasakan
      RT_data: [],
      RT_openmodel: false,
      RT_from: today,
      RT_to: today,
      RT_para$: "",
      RT_paraID: "",
      RT_paraRR: "",
      RT_nawibrez: "",
      //// name search of the kas inside ڕاپۆرتی کەسەکان
      RT_kasSuggestions: [],
      RT_kasCursor: -1,
      PD_para$_kon: 0,
      PD_paraID_kon: 0,
      PD_paraRR_kon: 0,
      RT_zhmaraybarez: "",
      RT_mob: "",
      RT_mandub: false,
      RT_paradan: false,
      RT_koyparadan$: "",
      RT_koyparadanID: "",
      RT_koyparadanRRR: "",
      RT_koyparadarhinan$: "",
      RT_koyparadarhinanID: "",
      RT_jor: "",
      RT_koyparadarhinanRRR: "",
      RT_KoyKriniRR: "",
      PD_RR_IQD: 0,
      PD_RR_$: 0,
      MM_RR_IQD: 0,
      MM_RR_$: 0,

      /// states of raporty mandub
      RMM_data: [],
      RMM_openmodel: false,
      RMM_from: today,
      RMM_to: today,
      RMM_paraRRR: "",
      RMM_paraID: "",
      RMM_para$: "",
      /// end of  states of raporty mandub

      // states of para wargrtn
      PW_zhamara: "",
      PW_barwar: "",
      PW_parayesta$: "",
      PW_parayestaID: "",
      PW_brepara: "",
      PW_joredraw: "دۆلار",
      PW_nawewargr: "",
      PW_page: "",
      PW_del_dis: null,
      PW_open: null,
      PW_toggler: false,
      PW_note: "",
      PW_search_wasl: null,
      PW_save: null,
      PW_wasl: null,
      PW_nawikas: "",
      PW_show: false,
      // end of states of para wargrtn

      // states of raporty parawargrtn
      RPW_data: [],
      RPW_openmodel: false,
      RPW_from: today,
      RPW_to: today,
      RPW_para$: "",
      RPW_paraID: "",
      // end of states of raporty parawargrtn

      // states of ParaGorenawa
      PG_zhmara: "",
      PG_search_wasl: null,
      PG_barwar: "",
      PG_del_dis: null,
      PG_parayesta$: "",
      PG_parayestaID: "",
      PG_toggler: false,
      PG_breParabaID: "",
      PG_nrxeKrine$: "",
      PG_breKrini$: "",
      PG_save: null,
      PG_nawewargr: "",
      PG_open: null,
      PG_wasl: null,
      PG_show: false,
      PG_note: "",

      // states of Raporty Para Gorenawa
      RPG_openmodel: false,
      RPG_data: [],
      RPG_from: today,
      RPG_to: today,

      //// states of Old Rasid
      OR_zhmarayBarez: "",
      OR_nawiBarez: "",
      OR_briQarz: "",
      OR_joriDraw: "دینار",
      OR_open: null,
      OR_save: null,
      OR_del_dis: null,
      // zyad krdni remembe
      PD_nrx_Remembe: "",
      PD_Kren_Remembe: "",
      PD_ok: null,
      PD_nrx_Remembe_2: "",
      PD_nrx_dolar_2: "",
      PD_Kren_dinar_2: "",
      PD_ok_2: null,
      PD_indexState: "",
      // zyad krdni remembe
      M_nrx_Remembe: "",
      M_Kren_Remembe: "",
      ok: null,
      M_nrx_Remembe_2: "",
      M_nrx_dolar_2: "",
      M_Kren_dinar_2: "",
      ok_2: null,
      indexState: "",
      // bas hatnaway wasle remembe
      RB_data: [],
      RB_from: today,
      RB_to: today,
      RB_openmodel: false,
      RB_para$: "",
      RB_paraRRR: "",
      /// QarziAsto State
      QA_modalOpen: false,
      QA_qarzdinar: "",
      QA_qarzdolar: "",

      //Total IN And Out
      IO_openmodel: false,
      IO_from: today,
      IO_to: today,
      IO_totaldolar: 0,
      IO_totaldinar: 0,
      IO_dashakandolar: 0,
      IO_dashakandinar: 0,
      IO_paraywargirawdolar_p: 0,
      IO_paraywargirawdinar_p: 0,
      IO_masrwf_D: 0,
      IO_masrwf_IQD: 0,
      IO_rejaDolar: 0,
      IO_rejaDinar: 0,
      IO_qarziAsto_D: 0,
      IO_qarziAsto_IQ: 0,
      IO_totalgaranawadolar: 0,
      IO_totalgaranwadinar: 0,
      IO_daxiladinar: 0,
      IO_daxiladolar: 0,
      IO_paradandolar: 0,
      IO_paradandinar: 0,
      dashkan_kren: 0,
      IO_paradarhinaidolar: 0,
      IO_paradarhinaidinar: 0,
      IO_paragaranawadolar: 0,
      IO_paragaranawadinar: 0,
      IO_oldrasiddolar: 0,
      IO_oldrasiddinar: 0,
      IO_outexpdolar: 0,

      IT_items: "",
      IT_name: "راستەوخۆ",
      IT_kren: "",
      IT_saleprice: "",
      IT_no_invoice: 0,
      IT_joripara: "دینار",
      IT_date: "",
      IT_phone: "",
      IT_code: "",
      IT_code: "",
      IT_itemName: "",
      IT_qty: "",
      IT_searchedNames: [],
      IT_suggestionWakil: [],
      IT_suggestionItems: [],
      IT_total: "",
      IT_discount: "",
      IT_paied: "",
      IT_remain: "",
      IT_disabled: false,
      IT_searched: false,
      IT_isOpen: false,
      IT_saved: false,
      IT_saving: false,
      IT_table: [],
      IT_isEdited: false,
      IT_ItemData: {},
      IT_dana: "",
      IT_darzan: "",
      IT_danaCHanged: false,
      IT_darzanCHanged: false,
      IT_kartonCHanged: false,
      IT_karton: "",
      IT_FIB: false,
      IT_cash: true,
      IT_owe: false,
      IT_nrx: "",
      IT_nrxChanged: false,
      IT_Note: "",
      IT_darzanInCarton: 0,
      IT_danaInDarzan: 12,
      IT_totalPages: 1,
      IT_checkItem: true,
      IT_productNumber: "",
      IT_height: 0,
      IT_width: 0,
      IT_length: 0,
      IT_dnk: 0,
      IT_zhmarayDwkan: "",
      IT_nsbayfrohtn: 0,
      IT_nrxifroshtnkarton2: 0,
      IT_nsbayfrohtn2: 0,
      IT_qazanj2: 0,
      IT_nrxeFroshtnDolar2: 0,
      IT_nrxifroshtnkarton2_IQD: 0,
      IT_nsbayfrohtn2_IQD: 0,
      IT_qazanj2_IQD: 0,
      IT_nrxeFroshtnDenar2: 0,
      IT_productCode: "",
      IT_barcode: "",
      IT_price: 0,
      IT_saleDinar: 0,
      IT_saleDolar: 0,
      IT_saleOfLessHalfCarton: 0,
      IT_saleOfLessTenDarzan: 0,
      IT_qazanj: 0,
      IT_productTable: [],
      IT_rasidKarton: 0,
      IT_weight: "",
      IT_Karton_price: 0,
      IT_priceOneRRR: 0,
      IT_nrxifroshtnkarton: 0,
      IT_singleSale: 0,
      IT_Chine_invoice: "",
      IT_dp: "",
      IT_productTotal: 0,
      IT_froshtn: "",

      // IT sale market extra fields
      IT_metr: 0,
      IT_remembi: 0,
      IT_editProfit: 0
    };
  }

  IT_OnChangePaymentFIB = (e) => {
    this.setState({
      IT_FIB: true,
      IT_cash: false,
      IT_owe: false
    });
  };
  IT_OnChangePayment = (e) => {
    this.setState({
      IT_FIB: false,
      IT_cash: false,
      IT_owe: true
    });
  };
  IT_OnChangePaymentCash = (e) => {
    this.setState({
      IT_FIB: false,
      IT_cash: true,
      IT_owe: false
    });
  };
  IT_get_Invoice = async (e) => {
    if (e.key === "Enter") {
      const res = await Instance.get(
        `/api/v1/searchwasll?numberofwasl=${this.state.IT_no_invoice}`
      );
      let data = res.data.pswla;
      this.setState({
        IT_name: data.wakil,
        IT_invoiceId: data._id,
        IT_no_invoice: data.numberofwasl,
        IT_phone: data.phone,
        IT_froshtn: data.froshtn,
        IT_total: data.joripara == "دینار" ? data.koalldinar : data.koalldolar,
        IT_discount:
          data.joripara == "دینار" ? data.dashkandinar : data.dashkandolar,
        IT_paied:
          data.joripara == "دینار" ? data.paraydrawdinar : data.paraydrawdolar,
        IT_remain: data.qarzinwedinar,
        IT_code: data.numberOfWakil,
        IT_disabled: true,
        IT_searched: true,
        IT_saved: true,
        IT_table: data.saleTable,
        IT_date: data.date,
        IT_joripara: data.joripara
      });
    }
  };

  IT_fetchSalePage = async (page) => {
    try {
      const res = await Instance.get(`/api/v1/salepage?page=${page}&limit=1`);
      const data = res.data;

      if (data.success && data.sales && data.sales.length > 0) {
        const saleData = data.sales[0];
        this.setState({
          IT_name: saleData.wakil,
          IT_invoiceId: saleData._id,
          IT_no_invoice: saleData.numberofwasl,
          IT_phone: saleData.phone,
          IT_froshtn: saleData.froshtn,
          IT_total:
            saleData.joripara == "دینار"
              ? saleData.koalldinar
              : saleData.koalldolar,
          IT_discount:
            saleData.joripara == "دینار"
              ? saleData.dashkandinar
              : saleData.dashkandolar,
          IT_paied:
            saleData.joripara == "دینار"
              ? saleData.paraydrawdinar
              : saleData.paraydrawdolar,
          IT_remain:
            saleData.joripara == "دینار"
              ? saleData.paraymawadinar
              : saleData.paraymawadolar,
          IT_code: saleData.numberOfWakil,
          IT_disabled: true,
          IT_searched: true,
          IT_saved: true,
          IT_table: saleData.saleTable,
          IT_date: saleData.date,
          IT_joripara: saleData.joripara,
          IT_totalPages: data.totalPages || 1,
          IT_Note: saleData.Note || ""
        });
      }
    } catch (error) {
      console.error("Error fetching sale page:", error);
    }
  };

  IT_nextPage = async () => {
    const currentPage = parseInt(this.state.IT_no_invoice) || 1;
    const { IT_totalPages } = this.state;
    if (currentPage < IT_totalPages) {
      await this.IT_fetchSalePage(currentPage + 1);
    }
  };

  IT_prevPage = async () => {
    const currentPage = parseInt(this.state.IT_no_invoice) || 1;
    if (currentPage > 1) {
      await this.IT_fetchSalePage(currentPage - 1);
    }
  };

  IT_pageplusone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page = parseInt(this.state.IT_no_invoice) + 1;
      const res = await Instance.get(
        `/api/v1/salepage?page=${page}&limit=1`,
        config
      );
      const data = res.data.sales;

      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState({
          IT_no_invoice: data.numberofwasl,
          IT_name: data.wakil,
          IT_invoiceId: data._id,
          IT_no_invoice: data.numberofwasl,
          IT_phone: data.phone,
          IT_froshtn: data.froshtn,
          IT_total:
            data.joripara == "دینار" ? data.koalldinar : data.koalldolar,
          IT_discount:
            data.joripara == "دینار" ? data.dashkandinar : data.dashkandolar,
          IT_paied:
            data.joripara == "دینار"
              ? data.paraydrawdinar
              : data.paraydrawdolar,
          IT_remain:
            data.joripara == "دینار" ? data.qarzinwedinar : data.qarzinwedolar,
          IT_code: data.numberOfWakil,
          IT_disabled: true,
          IT_searched: true,
          IT_saved: true,
          IT_table: data.saleTable,
          IT_date: data.date,
          IT_joripara: data.joripara,
          IT_totalPages: res.data.totalPages || 1
        });
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };

  IT_pageminsone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page = parseInt(this.state.IT_no_invoice) - 1;
      const res = await Instance.get(
        `/api/v1/salepage?page=${page}&limit=1`,
        config
      );
      const data = res.data.sales;
      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState({
          IT_no_invoice: data.numberofwasl,
          IT_name: data.wakil,
          IT_invoiceId: data._id,
          IT_no_invoice: data.numberofwasl,
          IT_phone: data.phone,
          IT_froshtn: data.froshtn,
          IT_total:
            data.joripara == "دینار" ? data.koalldinar : data.koalldolar,
          IT_discount:
            data.joripara == "دینار" ? data.dashkandinar : data.dashkandolar,
          IT_paied:
            data.joripara == "دینار"
              ? data.paraydrawdinar
              : data.paraydrawdolar,
          IT_remain:
            data.joripara == "دینار" ? data.qarzinwedinar : data.qarzinwedolar,
          IT_code: data.numberOfWakil,
          IT_disabled: true,
          IT_searched: true,
          IT_saved: true,
          IT_table: data.saleTable,
          IT_date: data.date,
          IT_joripara: data.joripara,
          IT_totalPages: res.data.totalPages || 1
        });
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };

  IT_createNewPage = (e) => {
    e.preventDefault();

    // Clear localStorage when creating new invoice
    localStorage.removeItem("IT_unsaved_invoice");

    this.setState(
      {
        IT_name: "راستەوخۆ",
        IT_kren: "",
        IT_saleprice: "",
        IT_no_invoice: 0,
        IT_joripara: "دینار",
        IT_date: "",
        IT_phone: "",
        IT_froshtn: "",
        IT_code: "",
        IT_code: "",
        IT_itemName: "",
        IT_qty: "",
        IT_suggestionWakil: [],
        IT_suggestionItems: [],
        IT_total: "",
        IT_discount: "",
        IT_paied: "",
        IT_remain: "",
        IT_disabled: false,
        IT_searched: false,
        IT_isOpen: false,
        IT_saved: false,
        IT_table: [],
        IT_isEdited: false,
        IT_ItemData: {},
        IT_dana: "",
        IT_nrx: "",
        IT_FIB: false,
        IT_cash: true,
        IT_owe: false,
        IT_darzan: "",
        IT_karton: "",
        IT_nrxChanged: false,
        IT_Note: "",
        IT_darzanInCarton: 0,
        IT_danaInDarzan: 12
      },
      () => {
        this.getWaslakan();
      }
    );
    window.document.getElementById("SearchItem_").focus();
  };

  daynamictoanotherInput = (e, num, opr, cb) => {
    if (e.key === "Enter") {
      const form = e.target.form;
      const index = Array.prototype.indexOf.call(form, e.target);
      if (opr === "p") {
        form.elements[index + num].focus();
      } else {
        form.elements[index - num].focus();
      }
      if (cb) {
        cb(e);
      }
    }
  };
  IT_disCount = (e) => {
    this.setState(
      {
        IT_discount: e.target.value
      },
      () => {
        this.IT_getDiscount();
      }
    );
  };
  IT_searchBySelect = async (item) => {
    const data = {
      zhmarasht: [item]
    };
    const res = await Instance.post(`/api/v1/searchFoMultipleName`, data);
    this.setState({
      IT_items: res.data.products
    });
  };
  IT_getDiscount = () => {
    this.setState(
      {
        IT_paied: Number(
          Number(
            _.subtract(
              Number(this.state.IT_total),
              Number(this.state.IT_discount)
            )
          ).toFixed(2)
        )
      },
      () => {
        this.setState(
          {
            IT_paied: Number(
              Number(
                _.subtract(
                  Number(this.state.IT_total),
                  Number(this.state.IT_discount)
                )
              ).toFixed(2)
            )
          },
          () => this.IT_countRemain()
        );
      }
    );
  };
  IT_countChange = (e) => {
    this.setState(
      {
        IT_paied: e.target.value
      },
      () => {
        this.IT_countRemain();
      }
    );
  };
  IT_countRemain = () => {
    this.setState({
      IT_remain: Number(
        Number(
          _.subtract(
            Number(this.state.IT_total),
            _.add(Number(this.state.IT_paied), Number(this.state.IT_discount))
          )
        ).toFixed(2)
      )
    });
  };
  IT_searchItemINArray = async () => {
    if (!this.state.IT_code) {
      return;
    } else {
      try {
        const res = await Instance.get(
          `/api/v1/searchBarcode?code=${this.state.IT_code}`
        );
        if (res.data.product && res.data.product.rasidKarton > 0) {
          const product = res.data.product;
          this.setState({
            IT_items: product,
            IT_darzanInCarton: Number(product.numberOfDarzan) || 0,
            IT_danaInDarzan: Number(product.numberOfDana) || 0,
            IT_itemName: product.nameofproduct || "",
            IT_productNumber: product.number || "",
            IT_height: product.height || 0,
            IT_width: product.width || 0,
            IT_length: product.length || 0,
            IT_dnk: product.dnk || 0,
            IT_zhmarayDwkan: product.zhmarayDwkan || "",
            IT_nsbayfrohtn: product.nsbayfrohtn || 0,
            IT_nrxifroshtnkarton2: product.nrxifroshtnkarton2 || 0,
            IT_nsbayfrohtn2: product.nsbayfrohtn2 || 0,
            IT_qazanj2: product.qazanj2 || 0,
            IT_nrxeFroshtnDolar2: product.nrxeFroshtnDolar2 || 0,
            IT_nrxifroshtnkarton2_IQD: product.nrxifroshtnkarton2_IQD || 0,
            IT_nsbayfrohtn2_IQD: product.nsbayfrohtn2_IQD || 0,
            IT_qazanj2_IQD: product.qazanj2_IQD || 0,
            IT_nrxeFroshtnDenar2: product.nrxeFroshtnDenar2 || 0,
            IT_productCode: product.productCode || "",
            IT_barcode: product.barcode || "",
            IT_price: product.price || 0,
            IT_saleDinar: product.saleDinar || 0,
            IT_saleDolar: product.saleDolar || 0,
            IT_saleOfLessHalfCarton: product.saleOfLessHalfCarton || 0,
            IT_saleOfLessTenDarzan: product.saleOfLessTenDarzan || 0,
            IT_qazanj:
              _.multiply(
                _.subtract(
                  this.dinartodolar(Number(product.saleDinar)),
                  Number(product.price) || 0
                ),
                product.numberOfDarzan
              ) || 0,
            IT_productTable: product.table || [],
            IT_rasidKarton: product.rasidKarton || 0,
            IT_weight: product.weight || "",
            IT_Karton_price: product.Karton_price || 0,
            IT_priceOneRRR: product.priceOneRRR || 0,
            IT_nrxifroshtnkarton: product.nrxifroshtnkarton || 0,
            IT_singleSale: product.singleSale || 0,
            IT_Chine_invoice: product.Chine_invoice || "",
            IT_dp: product.dp || "",
            IT_productTotal: product.total || 0,
            IT_metr:
              product.metr && Number(product.metr) > 0
                ? Number(product.metr)
                : this.state.meterPrice || 0,
            IT_remembi:
              product.remembi && Number(product.remembi) > 0
                ? Number(product.remembi)
                : this.state.remembiPrice || 0
          });
        } else {
          alert("کاڵا نەدۆزرایەوە یان لە کۆگا نییە"); // Product not found or not in stock
          this.setState({
            IT_items: {},
            IT_darzanInCarton: 0,
            IT_danaInDarzan: 0,
            IT_itemName: "",
            IT_productNumber: "",
            IT_height: 0,
            IT_width: 0,
            IT_length: 0,
            IT_dnk: 0,
            IT_zhmarayDwkan: "",
            IT_nsbayfrohtn: 0,
            IT_nrxifroshtnkarton2: 0,
            IT_nsbayfrohtn2: 0,
            IT_qazanj2: 0,
            IT_nrxeFroshtnDolar2: 0,
            IT_nrxifroshtnkarton2_IQD: 0,
            IT_nsbayfrohtn2_IQD: 0,
            IT_qazanj2_IQD: 0,
            IT_nrxeFroshtnDenar2: 0,
            IT_productCode: "",
            IT_barcode: "",
            IT_price: 0,
            IT_saleDinar: 0,
            IT_saleDolar: 0,
            IT_saleOfLessHalfCarton: 0,
            IT_saleOfLessTenDarzan: 0,
            IT_qazanj: 0,
            IT_productTable: [],
            IT_rasidKarton: 0,
            IT_weight: "",
            IT_Karton_price: 0,
            IT_priceOneRRR: 0,
            IT_nrxifroshtnkarton: 0,
            IT_singleSale: 0,
            IT_Chine_invoice: "",
            IT_dp: "",
            IT_productTotal: 0,
            IT_metr: this.state.meterPrice || 0,
            IT_remembi: this.state.remembiPrice || 0
          });
        }
      } catch (error) {
        if (error.response) {
          this.setState({
            IT_items: {},
            IT_darzanInCarton: 0,
            IT_danaInDarzan: 0,
            IT_itemName: "",
            IT_productNumber: "",
            IT_height: 0,
            IT_width: 0,
            IT_length: 0,
            IT_dnk: 0,
            IT_zhmarayDwkan: "",
            IT_nsbayfrohtn: 0,
            IT_nrxifroshtnkarton2: 0,
            IT_nsbayfrohtn2: 0,
            IT_qazanj2: 0,
            IT_nrxeFroshtnDolar2: 0,
            IT_nrxifroshtnkarton2_IQD: 0,
            IT_nsbayfrohtn2_IQD: 0,
            IT_qazanj2_IQD: 0,
            IT_nrxeFroshtnDenar2: 0,
            IT_productCode: "",
            IT_barcode: "",
            IT_price: 0,
            IT_saleDinar: 0,
            IT_saleDolar: 0,
            IT_saleOfLessHalfCarton: 0,
            IT_saleOfLessTenDarzan: 0,
            IT_qazanj: 0,
            IT_productTable: [],
            IT_rasidKarton: 0,
            IT_weight: "",
            IT_Karton_price: 0,
            IT_priceOneRRR: 0,
            IT_nrxifroshtnkarton: 0,
            IT_singleSale: 0,
            IT_Chine_invoice: "",
            IT_dp: "",
            IT_productTotal: 0,
            IT_metr: this.state.meterPrice || 0,
            IT_remembi: this.state.remembiPrice || 0
          });
        } else {
          alert("هەڵەیەک ڕوویدا لە گەڕان بۆ کاڵا"); // An error occurred searching for product
        }
      }
    }
  };
  IT_setItemEmpty = () => {
    this.setState({
      IT_items: {},
      IT_darzanInCarton: 0,
      IT_danaInDarzan: 0,
      IT_itemName: "",
      IT_productNumber: "",
      IT_height: 0,
      IT_width: 0,
      IT_length: 0,
      IT_dnk: 0,
      IT_zhmarayDwkan: "",
      IT_nsbayfrohtn: 0,
      IT_nrxifroshtnkarton2: 0,
      IT_nsbayfrohtn2: 0,
      IT_qazanj2: 0,
      IT_nrxeFroshtnDolar2: 0,
      IT_nrxifroshtnkarton2_IQD: 0,
      IT_nsbayfrohtn2_IQD: 0,
      IT_qazanj2_IQD: 0,
      IT_nrxeFroshtnDenar2: 0,
      IT_productCode: "",
      IT_barcode: "",
      IT_price: 0,
      IT_saleDinar: 0,
      IT_saleDolar: 0,
      IT_saleOfLessHalfCarton: 0,
      IT_saleOfLessTenDarzan: 0,
      IT_qazanj: 0,
      IT_productTable: [],
      IT_rasidKarton: 0,
      IT_weight: "",
      IT_Karton_price: 0,
      IT_priceOneRRR: 0,
      IT_nrxifroshtnkarton: 0,
      IT_singleSale: 0,
      IT_Chine_invoice: "",
      IT_dp: "",
      IT_productTotal: 0,
      IT_dana: "",
      IT_darzan: "",
      IT_karton: "",
      IT_code: ""
    });
  };

  IT_searchItemName = (e) => {
    e.preventDefault();
    if (e.key === "Enter") {
      if (!this.state.IT_code) {
        window.document.getElementById("SearchItem_").focus();
        return;
      }
      this.IT_searchItemINArray();
    }
  };
  IT_deleteSearchedItem = (e, item) => {
    window.document.getElementById("SearchItem_").focus();
    this.setState({
      IT_searchedNames: this.state.IT_searchedNames.filter((el) => el !== item)
    });
  };
  IT_getWakilData = async () => {
    let search = {
      code: Number(this.state.IT_code),
      Name: this.state.IT_name,
      phone: this.state.IT_phone
    };
    const res = await Instance.post(`/api/v1/searchwakilBody`, search);
    const data = res.data.wakils;
    if (!data) {
      this.setState({
        IT_code: "",
        IT_name: "راستەوخۆ",
        IT_phone: ""
      });
    } else {
      this.setState({
        IT_code: data.code,
        IT_name: data.Name,
        IT_phone: data.phone
      });
    }
  };

  IT_openEditModel = (el, e) => {
    if (this.state.IT_disabled) {
      return;
    } else {
      if (!el.raqam) {
        swal({
          title: "ببورە",
          text: "ئەم کاڵایە داخل بە کۆگا نیە بۆیە دەسکاری ناکرێ ! تکایە بیسڕەوە ئینجا داخڵی بکەرەوە!",
          icon: "error",
          timer: 300,
          buttons: false
        });
      } else {
        // Check if pricing data is already stored with the item
        const hasPricingData =
          el.singleSale !== undefined &&
          el.saleDinar !== undefined &&
          el.saleOfLessHalfCarton !== undefined &&
          el.saleOfLessTenDarzan !== undefined;
        if (hasPricingData) {
          // Use stored pricing data
          this.setState(
            {
              IT_isEdited: true,
              IT_code: el.raqam,
              IT_ItemData: el,
              IT_itemName: el.nawisht,
              IT_dana: el.dana,
              IT_darzan: el.darzan,
              IT_karton: el.carton,
              IT_nrx: el.nrx,
              IT_darzanInCarton: el.numberOfDarzan,
              IT_danaInDarzan: el.numberOfDana,
              IT_metr: el.metr !== undefined ? el.metr : this.state.IT_metr,
              IT_remembi:
                el.remembi !== undefined ? el.remembi : this.state.IT_remembi,
              IT_price: el.price || 0,
              // Restore change flags from saved item
              IT_danaCHanged: el.danaChanged || false,
              IT_darzanCHanged: el.darzanChanged || false,
              IT_kartonCHanged: el.kartonChanged || false,
              // Set pricing data from stored item
              IT_singleSale: el.singleSale || 0,
              IT_saleDinar: el.saleDinar || 0,
              IT_saleOfLessHalfCarton: el.saleOfLessHalfCarton || 0,
              IT_saleOfLessTenDarzan: el.saleOfLessTenDarzan || 0
            },
            () => {
              window.document.getElementById("IT_dana").focus();
              this.UpdateRasidCarton(
                el.raqam,
                Number(this.state.IT_karton),
                "plus"
              );
            }
          );
        } else {
          // Pricing data not stored, fetch from API
          const fetchProductAndSetState = async () => {
            try {
              // Fetch product data to get all pricing information
              const res = await Instance.post(`/api/v1/searchFoMultipleName`, {
                zhmarasht: [el.raqam]
              });
              const productData =
                res.data.products && res.data.products.length > 0
                  ? res.data.products[0]
                  : null;

              this.setState(
                {
                  IT_isEdited: true,
                  IT_ItemData: el,
                  IT_itemName: el.nawisht,
                  IT_dana: el.dana,
                  IT_darzan: el.darzan,
                  IT_karton: el.carton,
                  IT_nrx: el.nrx,
                  IT_darzanInCarton: el.numberOfDarzan,
                  IT_danaInDarzan: el.numberOfDana,
                  IT_metr: el.metr !== undefined ? el.metr : this.state.IT_metr,
                  IT_remembi:
                    el.remembi !== undefined
                      ? el.remembi
                      : this.state.IT_remembi,
                  IT_price: el.price || 0,
                  // Restore change flags from saved item
                  IT_danaCHanged: el.danaChanged || false,
                  IT_darzanCHanged: el.darzanChanged || false,
                  IT_kartonCHanged: el.kartonChanged || false,
                  // Set pricing data from product if available
                  IT_singleSale: productData ? productData.singleSale : 0,
                  IT_saleDinar: productData ? productData.saleDinar : 0,
                  IT_saleOfLessHalfCarton: productData
                    ? productData.saleOfLessHalfCarton
                    : 0,
                  IT_saleOfLessTenDarzan: productData
                    ? productData.saleOfLessTenDarzan
                    : 0
                },
                () => {
                  window.document.getElementById("IT_dana").focus();
                  this.UpdateRasidCarton(
                    el.raqam,
                    Number(this.state.IT_karton),
                    "plus"
                  );
                }
              );
            } catch (error) {
              console.error("Error fetching product data:", error);
              // Fallback to simple calculation if fetch fails
              this.setState(
                {
                  IT_isEdited: true,
                  IT_ItemData: el,
                  IT_itemName: el.nawisht,
                  IT_dana: el.dana,
                  IT_darzan: el.darzan,
                  IT_karton: el.carton,
                  IT_nrx: el.nrx,
                  IT_darzanInCarton: el.numberOfDarzan,
                  IT_danaInDarzan: el.numberOfDana,
                  IT_metr: el.metr !== undefined ? el.metr : this.state.IT_metr,
                  IT_remembi:
                    el.remembi !== undefined
                      ? el.remembi
                      : this.state.IT_remembi,
                  IT_price: el.price || 0,
                  IT_danaCHanged: el.danaChanged || false,
                  IT_darzanCHanged: el.darzanChanged || false,
                  IT_kartonCHanged: el.kartonChanged || false,
                  IT_editProfit: Number(
                    _.subtract(
                      this.dinartodolar(Number(el.nrx)),
                      Number(el.price || 0)
                    ) * Number(el.numberOfDarzan || 0)
                  ).toFixed(2),
                  IT_qazanj: Number(
                    _.subtract(
                      this.dinartodolar(Number(el.nrx)),
                      Number(el.price || 0)
                    ) * Number(el.numberOfDarzan || 0)
                  ).toFixed(2),
                  IT_profitPerCarton: Number(
                    _.subtract(
                      this.dinartodolar(Number(el.nrx)),
                      Number(el.price || 0)
                    ) * Number(el.numberOfDarzan || 0)
                  ).toFixed(2)
                },
                () => {
                  window.document.getElementById("IT_dana").focus();
                  this.UpdateRasidCarton(
                    el.raqam,
                    Number(this.state.IT_karton),
                    "plus"
                  );
                }
              );
            }
          };

          fetchProductAndSetState();
        }
      }
    }
  };
  IT_closeModel = () => {
    this.setState({
      IT_isEdited: false,
      IT_ItemData: {},
      IT_itemName: "",
      IT_dana: "",
      IT_nrx: "",
      IT_nrxChanged: false,
      IT_darzan: "",
      IT_karton: "",
      IT_editProfit: 0,
      IT_metr: this.state.meterPrice || 0,
      IT_remembi: this.state.remembiPrice || 0
    });
    window.document.getElementById("SearchItem_").focus();
  };
  IT_onKeyUP = (e, ItemData) => {
    if (e.key === "Enter") {
      this.IT_updateItemInTable(e, ItemData);
    }
  };
  IT_OnChangeSwitch = (checked) => {
    this.setState({
      IT_checkItem: checked
    });
  };
  IT_updateItemInTable = (e, ItemData) => {
    e.preventDefault();
    if (
      ItemData &&
      ItemData.rasidKarton > 0 &&
      ItemData.rasidKarton > this.state.IT_karton
    ) {
      const data = {
        _id: ItemData._id,
        uuid: ItemData.uuid,
        raqam: ItemData.raqam,
        jamaraysht: ItemData.jamaraysht,
        nawisht: ItemData.nawisht,
        carton: this.state.IT_karton,
        darzan: this.state.IT_darzan,
        dana: this.state.IT_dana,
        nrx: this.state.IT_nrx,
        reja: ItemData.reja,
        kodolar:
          this.state.IT_joripara == "دینار"
            ? 0
            : _.multiply(
                ItemData.danaChanged
                  ? this.state.IT_dana
                  : this.state.IT_darzan,
                this.state.IT_nrx
              ),
        kodinar:
          this.state.IT_joripara == "دینار"
            ? _.multiply(
                ItemData.danaChanged
                  ? this.state.IT_dana
                  : this.state.IT_darzan,
                this.state.IT_nrx
              )
            : 0,
        wazn: ItemData.wazn,
        numberOfDarzan: ItemData.numberOfDarzan,
        numberOfDana: ItemData.numberOfDana,
        rasidKarton: ItemData.rasidKarton,
        danaChanged: this.state.IT_danaCHanged,
        darzanChanged: this.state.IT_darzanCHanged,
        kartonChanged: this.state.IT_kartonCHanged,
        price:
          ItemData.price !== undefined
            ? ItemData.price
            : this.state.IT_price || 0,
        metr: this.state.IT_metr || 0,
        remembi: this.state.IT_remembi || 0,
        // Keep pricing data for consistent profit calculation
        singleSale: ItemData.singleSale || 0,
        saleDinar: ItemData.saleDinar || 0,
        saleOfLessHalfCarton: ItemData.saleOfLessHalfCarton || 0,
        saleOfLessTenDarzan: ItemData.saleOfLessTenDarzan || 0
      };
      this.setState(
        {
          IT_table: this.state.IT_table.map((item) =>
            item.uuid === ItemData.uuid ? Object.assign(item, data) : item
          ),
          IT_isEdited: false,
          IT_ItemData: {},
          IT_itemName: "",
          IT_dana: "",
          IT_nrx: "",
          IT_nrxChanged: false,
          IT_darzan: "",
          IT_karton: "",
          IT_darzanInCarton: 0,
          IT_danaInDarzan: 12
        },
        () => {
          this.IT_total();

          // Save to localStorage to prevent data loss on refresh
          const invoiceData = {
            IT_table: this.state.IT_table,
            IT_name: this.state.IT_name,
            IT_phone: this.state.IT_phone,
            IT_code: this.state.IT_code,
            IT_no_invoice: this.state.IT_no_invoice,
            IT_total: this.state.IT_total,
            IT_discount: this.state.IT_discount,
            IT_paied: this.state.IT_paied,
            IT_remain: this.state.IT_remain,
            IT_joripara: this.state.IT_joripara,
            IT_Note: this.state.IT_Note,
            IT_FIB: this.state.IT_FIB,
            IT_cash: this.state.IT_cash,
            IT_owe: this.state.IT_owe,
            IT_Nrx_J_T_check: this.state.IT_Nrx_J_T_check,
            IT_Nrx_IQD_check: this.state.IT_Nrx_IQD_check
          };
          localStorage.setItem(
            "IT_unsaved_invoice",
            JSON.stringify(invoiceData)
          );

          window.document.getElementById("SearchItem_").focus();
          this.UpdateRasidCarton(
            ItemData.raqam,
            Number(
              !this.state.IT_karton ? ItemData.carton : this.state.IT_karton
            ),
            "-"
          );
        }
      );
    } else {
      swal({
        title: "ببورە",
        text: `کارتۆن ببورە رەسیدت بریتیە لە ${ItemData.rasidKarton}`,
        icon: "error",
        timer: 3300,
        buttons: false
      });
    }
  };
  IT_OnDanaChange = (e) => {
    const zhmarayKarton = this.state.IT_darzanInCarton;
    const zhmaraydarzan = this.state.IT_danaInDarzan;
    let darzan = Number(_.divide(e.target.value, zhmaraydarzan)).toFixed(2);
    let karton = Number(_.divide(darzan, zhmarayKarton));
    this.setState(
      {
        IT_dana: e.target.value,
        IT_darzan: darzan,
        IT_karton: karton,
        IT_danaCHanged: true,
        IT_darzanCHanged: false,
        IT_kartonCHanged: false,
        IT_nrxChanged: false
      },
      () => {
        this.IT_calculate_Profit(
          this.state.IT_darzan,
          zhmarayKarton,
          this.state.IT_isEdited,
          true
        );
      }
    );
  };

  IT_calculate_Profit = () => {
    const elForNrx = {
      numberOfDarzan: this.state.IT_darzanInCarton,
      singleSale: this.state.IT_singleSale,
      saleDinar: this.state.IT_saleDinar,
      saleOfLessHalfCarton: this.state.IT_saleOfLessHalfCarton,
      saleOfLessTenDarzan: this.state.IT_saleOfLessTenDarzan
    };
    const rezha = this.state.IT_darzanInCarton;
    const zhmarayKarton = this.state.IT_darzanInCarton;
    const zhmaraydarzan = this.state.IT_danaInDarzan;
    const dalasat = zhmarayKarton * 0.1;
    const panjalasat = zhmarayKarton * 0.5;

    let nrx = elForNrx.saleDinar;
    if (this.state.IT_danaCHanged) {
      if (this.state.IT_nrxChanged) {
        nrx = _.multiply(this.state.IT_nrx, zhmaraydarzan);
      } else {
        nrx = _.multiply(elForNrx.singleSale, zhmaraydarzan);
      }
    } else if (this.state.IT_darzanCHanged) {
      if (this.state.IT_nrxChanged) {
        nrx = this.state.IT_nrx;
      } else {
        if (zhmarayKarton === 20) {
          if (
            this.state.IT_darzan >= 10 &&
            this.state.IT_darzan >= panjalasat
          ) {
            nrx = elForNrx.saleDinar;
          } else if (this.state.IT_darzan < 10 && this.state.IT_darzan > 4) {
            nrx = elForNrx.saleOfLessHalfCarton;
          } else {
            nrx = elForNrx.saleOfLessTenDarzan;
          }
        } else {
          if (dalasat <= 1 && this.state.IT_darzan <= 1) {
            nrx = elForNrx.saleOfLessTenDarzan;
          } else if (
            this.state.IT_darzan >= 0 &&
            this.state.IT_darzan < 10 &&
            panjalasat > 10
          ) {
            nrx = elForNrx.saleOfLessTenDarzan;
          } else if (this.state.IT_darzan < panjalasat) {
            if (this.state.IT_darzan >= 10 && panjalasat > 10) {
              nrx = elForNrx.saleOfLessHalfCarton;
            } else if (
              panjalasat < 10 &&
              this.state.IT_darzan > 0 &&
              this.state.IT_darzan < panjalasat
            ) {
              nrx = elForNrx.saleOfLessHalfCarton;
            } else if (this.state.IT_darzan <= 1) {
              nrx = elForNrx.saleOfLessTenDarzan;
            }
          } else if (
            this.state.IT_darzan < dalasat &&
            this.state.IT_darzan > 0
          ) {
            nrx = elForNrx.saleOfLessTenDarzan;
          } else if (
            this.state.IT_darzan >= dalasat &&
            this.state.IT_darzan < panjalasat
          ) {
            nrx = elForNrx.saleOfLessHalfCarton;
          } else {
            nrx = elForNrx.saleDinar;
          }
        }
      }
    } else if (this.state.IT_kartonCHanged) {
      if (this.state.IT_nrxChanged) {
        nrx = this.state.IT_nrx;
      } else {
        nrx = elForNrx.saleDinar;
      }
    }

    const nrxForProfit = nrx;
    const buyPrice = this.state.isEditing
      ? Number(this.state.IT_ItemData.price || 0)
      : Number(this.state.IT_price || 0);
    const profitPerDarzan_ = _.subtract(
      this.dinartodolar(Number(nrx)),
      buyPrice
    );
    const profitPerCarton = Number(
      _.multiply(profitPerDarzan_, Number(rezha))
    ).toFixed(2);

    this.setState({
      IT_qazanj: profitPerCarton,
      IT_editProfit: profitPerCarton,
      IT_profitPerCarton: profitPerCarton
    });
  };
  IT_OnDarzanChange = (e) => {
    const zhmarayKarton = this.state.IT_darzanInCarton;
    const zhmaraydarzan = this.state.IT_danaInDarzan;

    let dana = Number(_.multiply(e.target.value, zhmaraydarzan)).toFixed(2);
    let karton = _.divide(e.target.value, zhmarayKarton);

    this.setState(
      {
        IT_darzan: e.target.value,
        IT_dana: dana,
        IT_karton: karton,
        IT_danaCHanged: false,
        IT_darzanCHanged: true,
        IT_kartonCHanged: false,
        IT_nrxChanged: false
      },
      () => {
        this.IT_calculate_Profit(this.state.IT_darzan, zhmarayKarton, false);
      }
    );
  };
  IT_OnKartonChange = (e) => {
    const zhmarayKarton = this.state.IT_darzanInCarton;
    const zhmaraydarzan = this.state.IT_danaInDarzan;
    let darzan = _.multiply(e.target.value, zhmarayKarton);
    let dana = _.multiply(darzan, zhmaraydarzan);

    this.setState(
      {
        IT_karton: e.target.value,
        IT_darzan: darzan,
        IT_dana: dana,
        IT_danaCHanged: false,
        IT_darzanCHanged: false,
        IT_kartonCHanged: true,
        IT_nrxChanged: false
      },
      () => {
        this.IT_calculate_Profit(
          this.state.IT_darzan,
          zhmarayKarton,
          this.state.IT_isEdited,
          false
        );
      }
    );
  };

  IT_OnNrxChange = (e) => {
    this.setState({ IT_nrx: e.target.value, IT_nrxChanged: true }, () => {
      this.IT_calculate_Profit();
    });
  };

  IT_OnMetrChange = (e) => {
    this.setState({ IT_metr: e.target.value });
  };

  IT_OnRememberChange = (e) => {
    this.setState({ IT_remembi: e.target.value });
  };

  IT_calculateNrx = (darzan, el) => {
    // Parse numeric inputs
    const darzanNum = Number(darzan);
    const rezhaNum = Number(el.numberOfDarzan);

    // Parse all rates from product for clarity
    const nrxDana = Number(el.singleSale);
    const nrxDinar = Number(el.saleDinar);
    const nrxNiwKarton = Number(el.saleOfLessHalfCarton);
    const nrxKmtrDaDarzan = Number(el.saleOfLessTenDarzan);

    // Calculate thresholds
    const dalasat = rezhaNum * 0.1;
    const panjalasat = rezhaNum * 0.5;

    let nrx = nrxDinar; // Default to saleDinar

    // Check if dana changed - use single sale price
    if (this.state.IT_danaCHanged) {
      nrx = nrxDana;
    } else if (this.state.IT_darzanCHanged || this.state.IT_kartonCHanged) {
      // Apply the same logic as IT_calculate_Profit
      if (rezhaNum === 20) {
        if (darzanNum >= 10 && darzanNum >= panjalasat) {
          nrx = nrxDinar;
        } else if (darzanNum < 10 && darzanNum > 4) {
          nrx = nrxNiwKarton;
        } else {
          nrx = nrxKmtrDaDarzan;
        }
      } else {
        if (dalasat <= 1 && darzanNum <= 1) {
          nrx = nrxKmtrDaDarzan;
        } else if (darzanNum >= 0 && darzanNum < 10 && panjalasat > 10) {
          nrx = nrxKmtrDaDarzan;
        } else if (darzanNum < panjalasat) {
          if (darzanNum >= 10 && panjalasat > 10) {
            nrx = nrxNiwKarton;
          } else if (
            panjalasat < 10 &&
            darzanNum > 0 &&
            darzanNum < panjalasat
          ) {
            nrx = nrxNiwKarton;
          } else if (darzanNum <= 1) {
            nrx = nrxKmtrDaDarzan;
          }
        } else if (darzanNum < dalasat && darzanNum > 0) {
          nrx = nrxKmtrDaDarzan;
        } else if (darzanNum >= dalasat && darzanNum < panjalasat) {
          nrx = nrxNiwKarton;
        } else {
          nrx = nrxDinar;
        }
      }
    }

    return Number(nrx);
  };

  IT_saveDetail = (el) => {
    if (!this.state.IT_dana || !this.state.IT_darzan || !this.state.IT_karton) {
      window.document.getElementById("SearchItem_").focus();
      return;
    } else if (this.state.IT_rasidKarton < this.state.IT_karton) {
      swal({
        title: "ببورە",
        text: "کارتۆن ببورە رەسیدت بریتیە لە " + this.state.IT_rasidKarton,
        icon: "error",
        timer: 3000,
        buttons: false
      });
      window.document.getElementById("SearchItem_").focus();
    } else {
      const zhmarayKarton = el.numberOfDarzan;
      const zhmaraydarzan = el.numberOfDana;
      const dalasat = Number(this.state.IT_darzanInCarton) * 0.1;
      const panjalasat = Number(this.state.IT_darzanInCarton) * 0.5;
      const danaState = this.state.IT_dana ? this.state.IT_dana : 1;
      let danaCheck = false;
      let nrx = el.saleDinar;
      if (this.state.IT_danaCHanged) {
        danaCheck = true;
        nrx = el.singleSale;
      } else if (this.state.IT_darzanCHanged || this.state.IT_kartonCHanged) {
        if (zhmarayKarton === 20) {
          if (
            this.state.IT_darzan >= 10 &&
            this.state.IT_darzan >= panjalasat
          ) {
            nrx = el.saleDinar;
          } else if (this.state.IT_darzan < 10 && this.state.IT_darzan > 4) {
            nrx = el.saleOfLessHalfCarton;
          } else {
            nrx = el.saleOfLessTenDarzan;
          }
        } else {
          if (dalasat <= 1 && this.state.IT_darzan <= 1) {
            nrx = el.saleOfLessTenDarzan;
          } else if (
            this.state.IT_darzan >= 0 &&
            this.state.IT_darzan < 10 &&
            panjalasat > 10
          ) {
            nrx = el.saleOfLessTenDarzan;
          } else if (this.state.IT_darzan < panjalasat) {
            if (this.state.IT_darzan >= 10 && panjalasat > 10) {
              nrx = el.saleOfLessHalfCarton;
            } else if (
              panjalasat < 10 &&
              this.state.IT_darzan > 0 &&
              this.state.IT_darzan < panjalasat
            ) {
              nrx = el.saleOfLessHalfCarton;
            } else if (this.state.IT_darzan <= 1) {
              nrx = el.saleOfLessTenDarzan;
            }
          } else if (
            this.state.IT_darzan < dalasat &&
            this.state.IT_darzan > 0
          ) {
            nrx = el.saleOfLessTenDarzan;
          } else if (
            this.state.IT_darzan >= dalasat &&
            this.state.IT_darzan < panjalasat
          ) {
            nrx = el.saleOfLessHalfCarton;
          } else {
            nrx = el.saleDinar;
          }
        }
      }
      let darzan = Number(_.divide(danaState, zhmaraydarzan)).toFixed(2);
      let karton = Number(_.divide(darzan, zhmarayKarton)).toFixed(4);
      this.IT_calculate_Profit(
        this.state.IT_darzan,
        zhmarayKarton,
        this.state.IT_isEdited,
        this.state.IT_danaCHanged
      );
      const data = {
        _id: el._id,
        uuid: uuidv4(),
        raqam: this.state.IT_code,
        jamaraysht: el.productCode,
        nawisht: el.nameofproduct,
        carton: karton,
        darzan: darzan,
        dana: danaState,
        nrx: nrx,
        reja: el.numberOfDana,
        kodolar:
          this.state.IT_joripara == "دینار"
            ? 0
            : _.multiply(danaCheck ? danaState : darzan, nrx),
        kodinar:
          this.state.IT_joripara == "دینار"
            ? _.multiply(danaCheck ? danaState : darzan, nrx)
            : 0,
        wazn: el.weight,
        numberOfDarzan: el.numberOfDarzan,
        numberOfDana: el.numberOfDana,
        rasidKarton: el.rasidKarton,
        danaChanged: this.state.IT_danaCHanged,
        darzanChanged: this.state.IT_darzanCHanged,
        kartonChanged: this.state.IT_kartonCHanged,
        price: this.state.IT_price || 0,
        metr: this.state.IT_metr || 0,
        remembi: this.state.IT_remembi || 0,
        // Store pricing data for accurate profit calculation in edit modal
        singleSale: el.singleSale || 0,
        saleDinar: el.saleDinar || 0,
        saleOfLessHalfCarton: el.saleOfLessHalfCarton || 0,
        saleOfLessTenDarzan: el.saleOfLessTenDarzan || 0
      };

      this.setState(
        {
          IT_table: [data, ...this.state.IT_table],
          IT_itemName: "",
          IT_dana: "",
          IT_nrx: "",
          IT_nrxChanged: false,
          IT_darzan: "",
          IT_karton: "",
          IT_saleprice: "",
          IT_kren: "",
          IT_code: ""
        },
        () => {
          this.IT_total();
          this.IT_setItemEmpty();
          this.UpdateRasidCarton(el.code, Number(karton), "-");

          // Save to localStorage to prevent data loss on refresh
          const invoiceData = {
            IT_table: this.state.IT_table,
            IT_name: this.state.IT_name,
            IT_phone: this.state.IT_phone,
            IT_code: this.state.IT_code,
            IT_no_invoice: this.state.IT_no_invoice,
            IT_total: this.state.IT_total,
            IT_discount: this.state.IT_discount,
            IT_paied: this.state.IT_paied,
            IT_remain: this.state.IT_remain,
            IT_joripara: this.state.IT_joripara,
            IT_Note: this.state.IT_Note,
            IT_FIB: this.state.IT_FIB,
            IT_cash: this.state.IT_cash,
            IT_owe: this.state.IT_owe,
            IT_Nrx_J_T_check: this.state.IT_Nrx_J_T_check,
            IT_Nrx_IQD_check: this.state.IT_Nrx_IQD_check
          };
          localStorage.setItem(
            "IT_unsaved_invoice",
            JSON.stringify(invoiceData)
          );
        }
      );
    }
  };
  IT_saveOutStore = (el) => {
    const data = {
      _id: uuidv4(),
      raqam: "",
      jamaraysht: "",
      nawisht: this.state.IT_itemName,
      kren: this.state.IT_kren,
      carton: this.state.IT_karton,
      darzan: this.state.IT_darzan,
      dana: this.state.IT_dana,
      nrx: this.state.IT_saleprice,
      reja: "",
      kodolar:
        this.state.IT_joripara == "دینار"
          ? 0
          : _.multiply(this.state.IT_dana, this.state.IT_saleprice),
      kodinar:
        this.state.IT_joripara == "دینار"
          ? _.multiply(this.state.IT_dana, this.state.IT_saleprice)
          : 0,
      wazn: "",
      numberOfDarzan: "",
      numberOfDana: ""
    };
    this.setState(
      {
        IT_table: [data, ...this.state.IT_table],
        IT_itemName: "",
        IT_dana: "",
        IT_nrx: "",
        IT_nrxChanged: false,
        IT_darzan: "",
        IT_karton: "",
        IT_saleprice: "",
        IT_kren: ""
      },
      () => {
        this.IT_total();
      }
    );
  };
  IT_total = () => {
    const totalPrice = this.state.IT_table.reduce(
      (total, item) =>
        total +
        (this.state.IT_joripara == "دینار" ? item.kodinar : item.kodolar),
      0
    );
    const formattedTotal = Number(Number(totalPrice).toFixed(2));
    const discountValue = Number(this.state.IT_discount) || 0;
    const paidAmount = Number(
      _.subtract(formattedTotal, discountValue).toFixed(2)
    );
    const remain = 0;

    this.setState({
      IT_total: formattedTotal,
      IT_paied: paidAmount,
      IT_remain: remain
    });
  };
  IT_deleteItem = (i, el) => {
    const check = window.confirm("دڵنیای لە سڕینەوەی ئەم کاڵایە؟");
    if (!check) {
      return;
    }
    window.document.getElementById("SearchItem_").focus();
    this.setState(
      {
        IT_table: this.state.IT_table.filter((el, index) => index !== i)
      },
      () => {
        window.document.getElementById("SearchItem_").focus();
        this.IT_total();
        this.IT_getDiscount();
        this.UpdateRasidCarton(el.raqam, Number(el.carton), "plus");

        // Save to localStorage to prevent data loss on refresh
        const invoiceData = {
          IT_table: this.state.IT_table,
          IT_name: this.state.IT_name,
          IT_phone: this.state.IT_phone,
          IT_code: this.state.IT_code,
          IT_no_invoice: this.state.IT_no_invoice,
          IT_total: this.state.IT_total,
          IT_discount: this.state.IT_discount,
          IT_paied: this.state.IT_paied,
          IT_remain: this.state.IT_remain,
          IT_joripara: this.state.IT_joripara,
          IT_Note: this.state.IT_Note,
          IT_FIB: this.state.IT_FIB,
          IT_cash: this.state.IT_cash,
          IT_owe: this.state.IT_owe,
          IT_Nrx_J_T_check: this.state.IT_Nrx_J_T_check,
          IT_Nrx_IQD_check: this.state.IT_Nrx_IQD_check
        };
        localStorage.setItem("IT_unsaved_invoice", JSON.stringify(invoiceData));
      }
    );
  };

  IT_save = async (e) => {
    e.preventDefault();

    // Prevent duplicate saves
    if (this.state.IT_saving || this.state.IT_saved) {
      return;
    }

    // Clear localStorage after saving
    localStorage.removeItem("IT_unsaved_invoice");

    if (!this.state.IT_name) {
      swal({
        title: "ببورە",
        text: "تکایە ناوی بەڕێز داخل بکە!",
        icon: "error",
        timer: 3300,
        buttons: false
      });
    } else {
      // Set saving flag
      this.setState({ IT_saving: true });
      const data = {
        numberOfWakil: "",
        wakil: this.state.IT_name + " - مفرد",
        phone: "",
        whossale: "یوسف",
        froshtn: "فرۆشتنی ڕاستەوخۆ",
        saleTable: this.state.IT_table,
        joripara: this.state.IT_joripara,
        koalldinar: Number(this.state.IT_total ?? 0) || 0,
        koalldolar: 0,
        dashkandinar: Number(this.state.IT_discount ?? 0) || 0,
        dashkandolar: 0,
        paraydrawdinar: Number(this.state.IT_paied ?? 0) || 0,
        paraydrawdolar: 0,
        paraymawadolar: 0,
        paraymawadinar: Number(this.state.IT_remain ?? 0) || 0,
        qarzinwedolar: 0,
        qarzinwedinar: Number(this.state.IT_remain ?? 0) || 0,
        date: Date.now(),
        DolarPrice: this.state.navdolar,
        FIB: this.state.IT_FIB,
        cash: this.state.IT_cash,
        owe: this.state.IT_owe,
        Note: this.state.IT_Note,
        R_Mufrad_check: true
      };
      const res = await Instance.post("/api/v1/newSale", data);
      if (res) {
        swal({
          title: "تەواو",
          text: "پسولە سورکەوتوو بوو!",
          icon: "success",
          timer: 300,
          buttons: false
        });
        this.setState({
          IT_saved: true,
          IT_saving: false,
          IT_disabled: true,
          IT_invoiceId: res.data.data ? res.data.data._id : 0,
          IT_date: res.data.data.createdAt,
          IT_isOpen: false
        });
      } else {
        // Reset saving flag if request failed
        this.setState({ IT_saving: false });
      }
    }
  };

  IT_openInvoice = async (e, id, userid) => {
    e.preventDefault();
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(
      `api/v1/openSale/${id}?id=${userid}`,
      data
    );
    const res = await Instance.get(
      `/api/v1/searchwasll?numberofwasl=${this.state.IT_no_invoice}`
    );
    let dataC = res.data.pswla;
    if (
      !pass ||
      dataC.froshtn != "فرۆشتنی ڕاستەوخۆ" ||
      dataC.joripara == "دۆلار"
    ) {
      return;
    } else {
      this.setState(
        {
          IT_isOpen: true,
          IT_disabled: false
        },
        async () => {
          const res = await Instance.get(
            `/api/v1/searchwasll?numberofwasl=${this.state.IT_no_invoice}`
          );
          let data = res.data.pswla;
          this.setState({
            IT_name: data.wakil,
            IT_invoiceId: data._id,
            IT_no_invoice: data.numberofwasl,
            IT_phone: data.phone,
            IT_froshtn: data.froshtn,
            IT_total:
              data.joripara == "دینار" ? data.koalldinar : data.koalldolar,
            IT_discount:
              data.joripara == "دینار" ? data.dashkandinar : data.dashkandolar,
            IT_paied:
              data.joripara == "دینار"
                ? data.paraydrawdinar
                : data.paraydrawdolar,
            IT_remain:
              data.joripara == "دینار"
                ? data.qarzinwedinar
                : data.qarzinwedolar,
            IT_code: data.numberOfWakil,
            IT_table: data.saleTable,
            IT_date: data.date,
            IT_joripara: data.joripara
          });
        }
      );
    }
  };
  IT_updateInvoice = async (id, e) => {
    e.preventDefault();
    const data = {
      numberOfWakil: "",
      wakil: this.state.IT_name,
      phone: "",
      whossale: "یوسف",
      froshtn: "فرۆشتنی ڕاستەوخۆ",
      saleTable: this.state.IT_table,
      joripara: this.state.IT_joripara,
      koalldinar:
        this.state.IT_joripara == "دینار"
          ? Number(this.state.IT_total ?? 0) || 0
          : 0,
      koalldolar:
        this.state.IT_joripara == "دینار"
          ? 0
          : Number(this.state.IT_total ?? 0) || 0,
      dashkandinar:
        this.state.IT_joripara == "دینار"
          ? Number(this.state.IT_discount ?? 0) || 0
          : 0,
      dashkandolar:
        this.state.IT_joripara == "دینار"
          ? 0
          : Number(this.state.IT_discount ?? 0) || 0,
      paraydrawdinar:
        this.state.IT_joripara == "دینار"
          ? Number(this.state.IT_paied ?? 0) || 0
          : 0,
      paraydrawdolar:
        this.state.IT_joripara == "دینار"
          ? 0
          : Number(this.state.IT_paied ?? 0) || 0,
      paraymawadolar:
        this.state.IT_joripara == "دینار"
          ? 0
          : Number(this.state.IT_remain ?? 0) || 0,
      paraymawadinar:
        this.state.IT_joripara == "دینار"
          ? Number(this.state.IT_remain ?? 0) || 0
          : 0,
      qarzinwedolar:
        this.state.IT_joripara == "دینار"
          ? 0
          : Number(this.state.IT_remain ?? 0) || 0,
      qarzinwedinar:
        this.state.IT_joripara == "دینار"
          ? Number(this.state.IT_remain ?? 0) || 0
          : 0,
      date: Date.now(),
      DolarPrice: this.state.navdolar,
      FIB: this.state.IT_FIB,
      cash: this.state.IT_cash,
      owe: this.state.IT_owe,
      Note: this.state.IT_Note
    };
    await Instance.put(`/api/v1/updateSaleAll/${id}`, data);
    localStorage.removeItem("IT_unsaved_invoice");
    this.setState({
      IT_isOpen: false,
      IT_disabled: true
    });
  };
  ///7sabaty 3am
  OnChangeSwitch = (checked) => {
    this.setState(
      {
        R_Nrx_J_T_check: !this.state.R_Nrx_J_T_check
      },
      () => {
        let data = this.state.R_dataProduct;
        this.setState({
          R_nrx:
            this.state.R_joripara != "دینار" && !this.state.R_Nrx_J_T_check
              ? data.saleDolar
              : data.nrxeFroshtnDolar2,
          R_joripara: "دۆلار"
        });
      }
    );
  };
  OnChangeSwitch_IQD = (checked) => {
    this.setState(
      {
        R_Nrx_IQD_check: !this.state.R_Nrx_IQD_check
      },
      () => {
        let data = this.state.R_dataProduct;
        this.setState({
          R_nrx:
            this.state.R_joripara === "دینار" && !this.state.R_Nrx_IQD_check
              ? data.saleDinar
              : data.nrxeFroshtnDenar2,
          R_joripara: "دینار"
        });
      }
    );
  };
  OnChangeSwitch_Mufrad = (checked) => {
    this.setState(
      {
        R_Mufrad_check: !this.state.R_Mufrad_check
      },
      () => {
        let data = this.state.R_dataProduct;
        this.setState({
          R_nrx:
            this.state.R_joripara != "دینار" && !this.state.R_Mufrad_check
              ? data.singleSale
              : data.singleSale
        });
      }
    );
  };
  OnChangeSwitch_Item = (checked) => {
    this.setState({
      R_Item_check: !this.state.R_Item_check
    });
  };
  P_getListUpdatedItems = async () => {
    const res = await Instance.get("/api/v1/getListOFUpdateItem");
    if (res) {
      this.setState({
        P_data: res.data.doc
      });
    }
  };
  P_productUpdatePrice = async (e) => {
    e.preventDefault();
    const data = {
      saleDinar: Number(this.state.P_nrxDinar),
      saleOfLessHalfCarton: Number(this.state.P_nrxkamtrlaniw),
      saleOfLessTenDarzan: Number(this.state.P_nrxkamptrlada),
      singleSale: Number(this.state.P_mufrad_),
      saleDolar: Number(this.state.P_nrxDolar),
      saleDolar2: Number(this.state.P_nrxDolar2)
    };

    Swal.fire({
      title: "دڵنیای!؟",
      text: "دەتەوێ نرخی هەموو کاڵاکان لە یەک کاتدا بگۆڕی؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "بەڵێ، هەمووی بگۆڕە",
      cancelButtonText: "نەخێر!"
    }).then(async (result) => {
      if (result.isConfirmed) {
        const res = await Instance.put("/api/v1/updateAllProductPrice", data);
        if (res) {
          this.setState({
            P_nrxDinar: "",
            P_nrxkamtrlaniw: "",
            P_nrxkamptrlada: "",
            P_mufrad_: "",
            P_nrxDolar: "",
            P_nrxDolar2: ""
          });
        }
        this.P_getListUpdatedItems();
      } else {
        return;
      }
    });
  };
  IO_OpenModal = async (e, userid) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const { value: text } = await Swal.fire({
        input: "password",
        inputLabel: "Password",
        showLoaderOnConfirm: true,
        inputPlaceholder: "وشەی نهێنی داخیل بکە...",
        inputAttributes: {
          "aria-label": "وشەی نهێنی داخیل بکە"
        },
        showCancelButton: true
      });
      const data = {
        password: text
      };
      const pass = await Instance.post(
        `api/v1/open?id=${userid}`,
        data,
        config
      );

      if (pass.data.status === false) {
        alert("وشەی نهێنی هەڵەیە");
      } else if (pass.data.status === true) {
        this.setState(() => {
          return {
            IO_openmodel: !this.state.IO_openmodel,
            IO_totaldolar: 0,
            IO_totaldinar: 0,
            IO_dashakandolar: 0,
            IO_dashakandinar: 0,
            IO_paraywargirawdolar_p: 0,
            IO_paraywargirawdinar_p: 0,
            IO_masrwf_D: 0,
            IO_masrwf_IQD: 0,
            IO_rejaDolar: 0,
            IO_rejaDinar: 0,
            IO_qarziAsto_D: 0,
            IO_qarziAsto_IQ: 0,
            IO_totalgaranawadolar: 0,
            IO_totalgaranwadinar: 0,
            dashkan_kren: 0,
            IO_paradarhinaidolar: 0,
            IO_paradarhinaidinar: 0,
            IO_paragaranawadolar: 0,
            IO_paragaranawadinar: 0,
            IO_oldrasiddolar: 0,
            IO_oldrasiddinar: 0,
            IO_outexpdolar: 0
          };
        });
      }
    } catch {}
  };

  IO_CloseModal = () => {
    this.setState(() => {
      return { IO_openmodel: false };
    });
  };

  IO_peshandan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/report?from=${this.state.IO_from}&to=${this.state.IO_to}`,
        config
      );
      let data = res.data.data;

      this.setState(
        {
          IO_totaldolar: data.froshtnTotalDolar,
          IO_totaldinar: data.froshtnTotalDinar,
          IO_dashakandolar: data.froshtndashkanDolar,
          IO_dashakandinar: data.froshtndashkaninar,
          IO_paraywargirawdolar_p: data.parawargrtnDolar,
          IO_paraywargirawdinar_p: data.parawargrtnDinar,
          IO_masrwf_D: data.masrwfdolar,
          IO_masrwf_IQD: data.masrwfdinar,
          IO_rejaDolar: data.qarzDolar,
          IO_rejaDinar: data.qarzDinar,
          IO_qarziAsto_D: data.qarziastoDolar,
          IO_qarziAsto_IQ: data.qarziastoDinar,
          IO_totalgaranawadolar: data.garanawaTotalDolar,
          IO_totalgaranwadinar: data.garanawaTotalDinar,
          IO_daxiladinar: data.daxiladinar,
          IO_daxiladolar: data.daxiladolar,
          IO_paradandolar: data.paradandolar,
          IO_paradandinar: data.paradandinar,
          Q_from: this.state.IO_from,
          Q_to: this.state.IO_to,
          dashkan_kren: data.dashkan_kren,
          IO_paradarhinaidolar: data.paradarhinaidolar,
          IO_paradarhinaidinar: data.paradarhinaidinar,
          IO_paragaranawadolar: data.paragaranawadolar,
          IO_paragaranawadinar: data.paragaranawadinar,
          IO_oldrasiddolar: data.oldrasiddolar,
          IO_oldrasiddinar: data.oldrasiddinar,
          IO_outexpdolar: data.outexpdolar
        }
        // () => {
        //   this.Q_getfooter();
        // }
      );
      this.JM_pshandan();
      this.IO_CloseModal();
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببوورە هەڵەیەک ڕویدا!؟",
        icon: "error"
      });
    }
  };
  ///print Raffa
  PR_getProductByCode = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      if (this.state.PR_code === "") {
        alert("بەبێ ژمارەی کاڵا ناتوانی بگەڕێی");
      } else {
        const res = await Instance.get(
          `/api/v1/searchtoproduct?code=${this.state.PR_code}&nameofproduct=`,
          config
        );

        const data = res.data.product;
        if (data === null) {
          alert("ببورە ئەم کاڵایە بونی نیە");
        } else {
          this.setState(() => {
            return {
              PR_code: data.code,
              PR_productCode: data.productCode,
              PR_barcode: data.barcode,
              PR_name: data.nameofproduct,
              PR_number: data.number,
              PR_numberOfDana: data.numberOfDana,
              PR_numberOfDarzan: data.numberOfDarzan,
              PR_height: data.height,
              PR_width: data.width,
              PR_length: data.length,
              PR_dnk: data.dnk,
              PR_zhmarayDwkan: data.zhmarayDwkan,
              PR_price: data.price,
              PR_nrxID: data.saleDinar,
              PR_nrxdolar: data.saleDolar,
              PR_nrxeFroshtnDolar2: data.nrxeFroshtnDolar2,
              PR_nrxeFroshtnDenar2: data.nrxeFroshtnDenar2,
              PR_kamtrlaniw: data.saleOfLessHalfCarton,
              PR_nrxdadarzan: data.saleOfLessTenDarzan,
              PR_nsbayfrohtn: data.nsbayfrohtn,
              PR_nrxifroshtnkarton2: data.nrxifroshtnkarton2,
              PR_nsbayfrohtn2: data.nsbayfrohtn2,
              PR_qazanj2: data.qazanj2,
              PR_nrxifroshtnkarton2_IQD: data.nrxifroshtnkarton2_IQD,
              PR_nsbayfrohtn2_IQD: data.nsbayfrohtn2_IQD,
              PR_qazanj2_IQD: data.qazanj2_IQD,
              PR_qazanj: data.qazanj,
              PR_rasidKarton: data.rasidKarton,
              PR_weight: data.weight,
              PR_Karton_price: data.Karton_price,
              PR_priceOneRRR: data.priceOneRRR,
              PR_nrxifroshtnkarton: data.nrxifroshtnkarton,
              PR_Chine_invoice: data.Chine_invoice,
              PR_singleSale: data.singleSale,
              PR_rezha: data.numberOfDarzan,
              PR_dp: data.dp || "",
              PR_total: data.total,
              PR_detail: data
            };
          });
        }
      }
    } catch (error) {
      alert("ببورە ئەم کاڵایە بونی نیە");
    }
  };

  PR_newpage = (e) => {
    e.preventDefault();
    this.setState({
      PR_code: "",
      PR_rezha: "",
      PR_name: "",
      PR_nrxID: "",
      PR_kamtrlaniw: "",
      PR_nrdkarton: "",
      PR_font: "",
      PR_display: "",
      PR_nrxdadarzan: "",
      PR_nrxdolar: "",
      PR_dp: "",
      PR_detail: "",
      PR_nrxdinarishandan: false,
      PR_nrxkartonpishandan: false,
      PR_nrxniwpishandan: false,
      PR_data: []
    });
  };

  PR_setempty = (e) => {
    e.preventDefault();
    this.setState({
      PR_code: "",
      PR_rezha: "",
      PR_name: "",
      PR_nrxID: "",
      PR_kamtrlaniw: "",
      PR_nrdkarton: "",
      PR_nrxdadarzan: "",
      PR_nrxdolar: "",
      PR_dp: "",
      PR_detail: ""
    });
  };
  PR_checkboxchange = (e) => {
    this.setState({
      [e.target.name]: !e.target.value
    });
  };
  PR_delete = (e, code) => {
    e.preventDefault();
    this.setState({
      PR_data: this.state.PR_data.filter((el) => el.code !== code)
    });
  };

  PR_drowpdownchange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  PR_save = (e) => {
    e.preventDefault();
    if (this.state.PR_name !== "" && this.state.PR_code !== 0) {
      const table = this.state.PR_data;
      table.unshift({
        name: this.state.PR_name,
        code: this.state.PR_code,
        nrxdadarzan: this.state.PR_nrxdadarzan,
        nrxdolar: this.state.PR_nrxdolar,
        nrxdinar: this.state.PR_nrxID,
        nrxiwkarton: this.state.PR_kamtrlaniw,
        nrxkartondinar: Number(
          this.state.PR_nrxdolar * this.state.PR_rezha
        ).toFixed(2),
        nrxkartondolar: Number(
          this.state.PR_nrxID * this.state.PR_rezha
        ).toFixed(2),
        display: this.state.PR_display,
        font: this.state.PR_font,
        rezha: this.state.PR_rezha,
        dolar2: this.state.PR_nrxeFroshtnDolar2,
        dinar2: this.state.PR_nrxeFroshtnDenar2,
        dp: this.state.PR_dp || "",
        singleSale: this.state.PR_detail.singleSale || 0
      });
      this.setState({
        PR_data: table,
        PR_code: "",
        PR_rezha: "",
        PR_name: "",
        PR_nrxID: "",
        PR_kamtrlaniw: "",
        PR_nrdkarton: "",
        PR_nrxdadarzan: "",
        PR_nrxdolar: "",
        PR_dp: "",
        PR_detail: ""
      });
    }
  };

  // Gorine Remembe bo Dolar
  Change_R_Dolar = (e) => {
    e.preventDefault();
    let RRR = parseFloat(this.state.M_nrx_Remembe.toString().replace(/,/g, ""));
    let K_R = parseFloat(
      this.state.M_Kren_Remembe.toString().replace(/,/g, "")
    );
    let all = Number(K_R / RRR).toFixed(2);

    this.setState({
      MM_brepara: all,
      MM_joredraw: "دۆلار",
      ok: true
    });
  };

  Change_Dinar_to_R = (e) => {
    e.preventDefault();
    let RRR = parseFloat(
      this.state.M_nrx_Remembe_2.toString().replace(/,/g, "")
    );
    let K_R = parseFloat(
      this.state.M_Kren_dinar_2.toString().replace(/,/g, "")
    );
    let nrxdolar = parseFloat(
      this.state.M_nrx_dolar_2.toString().replace(/,/g, "")
    );
    let changedinartodolar = _.divide(K_R, nrxdolar);
    let all = Number(_.multiply(changedinartodolar, RRR)).toFixed(2);
    this.setState({
      MM_brepara: all,
      ok_2: true,
      MM_joredraw: "ڕیمێمبی"
    });
  };
  // toogle navdolar
  toggleNavdolar = () => {
    localStorage.setItem("nav", this.state.navdolar);
    this.setState(
      {
        disabled_navdolar: !this.state.disabled_navdolar
      },
      async () => {
        if (!this.state.disabled_navdolar) {
          let data = {
            dolar: this.state.navdolar
          };
          await Instance.put(`/api/v1/updateDolarPrice`, data);
        }
      }
    );
  };
  //end
  HandleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value
    });
  };
  ///////input pass
  aynamictoanotherInput = (e, num, opr, cb) => {
    // e.preventDefault();
    if (e.key === "Enter") {
      e.preventDefault();
      const form = e.target.form;
      const index = Array.prototype.indexOf.call(form, e.target);
      if (opr === "p") {
        form.elements[index + num].focus();
      } else {
        form.elements[index - num].focus();
      }
      if (cb) {
        cb(e);
      }
    }
  };
  ///////input pass
  toanotherInput = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index - 1].focus();
  };
  tofirstInput = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 11].focus();
  };

  tofirstInpuMatr = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 10].focus();
  };

  tofirstInpuKalla = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 9].focus();
    this.RC_saveToTable(e);
  };

  saerch = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 1].focus();
  };
  tofirstInputINRent = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 6].focus();
    this.saveDetail(e, this.state.R_wasl);
  };
  toKoyGshtiSave = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index - 1].focus();
    // this.saveDetail(e, this.state.R_wasl);
  };
  tofirstInputINRentRasidNmaya = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 6].focus();
  };
  NrxtofirstInputINRent = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 4].focus();
    this.saveDetail(e, this.state.R_wasl);
  };

  //////  user
  loginuser = async (e) => {
    e.preventDefault();

    try {
      const data = {
        name: this.state.L_name,
        password: this.state.L_password
      };
      const res = await Instance.post("/api/v1/login", data);
      localStorage.setItem("token", res.data.token);
      window.location.reload(true);
      this.setState({
        isAuthUser: true,
        L_error: null,
        L_name: "",
        L_password: ""
      });
      this.L_ClearError();
    } catch (error) {
      this.setState({
        L_error: error.response.data
      });
    }
  };
  L_setError = (err) => {
    this.setState({ L_error: err });
  };

  L_ClearError = () => {
    this.setState({ L_error: null });
  };

  getProductsLength = async () => {
    const res = await Instance.get(`/api/v1/getProductsCount`);
    this.setState({
      productNum: res.data.doc
    });
  };
  getUserIlgoin = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(`/api/v1/user`, config);
      this.setState(
        {
          isAuthUser: true,
          role: res.data.user.role,
          L_user: res.data.user
        },
        () => {
          if (this.state.isAuthUser === true) {
            this.W_getwakelakan();
            this.getParakan();
            this.getWaslakan();
            this.getNameOfData();
            this.getWakiltableData();
            this.getUsertableData();
            this.G_getWaslakan();
            this.Ap_getWakiltableData();
            this.Ap_getkasakan();
            this.Ms_getWakiltableData();
            this.PD_getParakan();
            this.PM_getParakan();
            this.MM_getParakan();
            this.PB_gegtparaybardast();
            this.PW_getParakan();
            this.PG_getParakan();
            this.getNotfication();
            this.getProductsLength();
          }
        }
      );
    } catch (error) {
      this.setState({ User_error: { msg: "User IsNotAdmin" } });
    }
  };
  logoutUser = () => {
    localStorage.removeItem("token");
    this.setState({ isAuthUser: null });
  };
  //// end of user

  setStateEmpty = () => {
    this.setState({
      rezha: 0,
      nrx: 0,
      darzan: 0,
      karton: 0,
      barwar: "",
      zhmara: "",
      zhmaraySht: "",
      barcode: "",
      naweSht: "",
      kren: "",
      nrxeFroshtnDolar: "",
      nrxeFroshtnDenar: "",
      nrxeKamtrlanewCarton: "",
      nrxeKamtrlaDaDarzan: "",
      zhmarayKarton: "",
      nrxifroshtnkarton: "",
      nsbayfrohtn: "",
      nrxifroshtnkarton2: "",
      nsbayfrohtn2: "",
      qazanj2: "",
      nrxeFroshtnDolar2: "",
      nrxifroshtnkarton2_IQD: "",
      nsbayfrohtn2_IQD: "",
      qazanj2_IQD: "",
      nrxeFroshtnDenar2: "",
      Chine_invoice: "",
      nrxeDarzan: "",
      qazanj: "",
      search: null,
      edit: null,
      koygshty: "",
      prodactdata: null,
      priceOneRRR: "",
      ok: null,
      data: [],
      Add_rasidkarton: "",
      wazn_karton: "",
      nrxmufrad: "",
      NumberOfDana: "",
      P_meterPrice: 0,
      P_remembiPrice: 0,
      del_dis: null,
      open: null,
      addnrxKraton: "",
      width: "",
      height: "",
      length: "",
      techw: "",
      metercheck: false,
      zhmarayDwkan: "",
      dnk: "",
      dp: "",
      P_remembiPrice: 0,
      P_meterPrice: 0
    });
  };
  newPage = (e) => {
    e.preventDefault();
    this.setStateEmpty();
    this.ClearError();
    this.getProductsLength();
  };

  ////notfication function
  getNotfication = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(`/api/v1/getNotfication`, config);
      let data = res.data.qard;
      if (data.length !== 0) {
        let sawt = new Audio(notifyAudio);
        sawt.play().catch(() => {});
        data.map((el) => {
          return toast.info(
            `ئەمڕۆ کاتی هێنانەوەی قەرزی بەڕیز
            ${el.wakil}ە`,
            {
              position: toast.POSITION.TOP_RIGHT
            }
          );
        });
      }
      //// ئاگادارکردنەوەی ٪20 ی کاڵاکان کوژێنراوەتەوە
      //// the ≤20% stock toast is disabled on purpose, uncomment to bring it back
      // const resp = await Instance.get(`/api/v1/getProductsNotfication`, config);
      // const datap = resp.data.array;
      // if (datap.length !== 0) {
      //   let sawt = new Audio(notifyAudio);
      //   sawt.play().catch(() => {});
      //   datap.map((el) => {
      //     return toast.info(
      //       `نزیکەی کەمتر لە ٪20 ماوە لە کاڵای
      //       ${el.nameofproduct} بە کۆدی ${el.code}`,
      //       {
      //         position: toast.POSITION.TOP_RIGHT
      //       }
      //     );
      //   });
      // }
    } catch (error) {
      this.setState({ User_error: { msg: "User IsNotAdmin" } });
    }
  };
  getNrxDolar = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/DolarPriceakan`, config);
    let nrx = res.data.DolarPriceakan;
    this.setState({
      navdolar: nrx.dolar,
      meterPrice: nrx.metr,
      remembiPrice: nrx.remembi
    });
  };
  componentDidMount() {
    this.getNrxDolar();
    if (localStorage.getItem("nav")) {
      this.setState({
        navdolar: localStorage.getItem("nav")
      });
    }
    if (localStorage.getItem("rm")) {
      this.setState({
        RC_nrxeNavR: localStorage.getItem("rm")
      });
    }
    if (localStorage.getItem("mm")) {
      this.setState({
        RC_nrxNavM: localStorage.getItem("mm")
      });
    }

    if (localStorage.getItem("item")) {
      this.setState(
        {
          R_dataTable: JSON.parse(localStorage.getItem("item"))
        },
        () => {
          if (this.state.R_dataTable.length !== 0) {
            this.setState({
              R_table: true
            });
          }
        }
      );
    }

    if (localStorage.getItem("saledata")) {
      this.R_onopenandrefresh(JSON.parse(localStorage.getItem("saledata")));
    }

    if (localStorage.getItem("paradata")) {
      this.P_onopenUpdateAndRefresh(
        JSON.parse(localStorage.getItem("paradata"))
      );
    }

    if (localStorage.getItem("product")) {
      this.SetLocalProduct(JSON.parse(localStorage.getItem("product")));
    }
    if (localStorage.getItem("mandub")) {
      this.MM_getDataOnRefresh(JSON.parse(localStorage.getItem("mandub")));
    }

    if (localStorage.getItem("paradan")) {
      this.PD_getDataOnRefresh(JSON.parse(localStorage.getItem("paradan")));
    }

    // Restore unsaved invoice from localStorage
    if (localStorage.getItem("IT_unsaved_invoice")) {
      try {
        const invoiceData = JSON.parse(
          localStorage.getItem("IT_unsaved_invoice")
        );
        this.setState(
          {
            IT_table: invoiceData.IT_table || [],
            IT_name: invoiceData.IT_name || "راستەوخۆ",
            IT_phone: invoiceData.IT_phone || "",
            IT_code: invoiceData.IT_code || "",
            IT_froshtn: invoiceData.IT_froshtn || "",
            IT_no_invoice: invoiceData.IT_no_invoice || 0,
            IT_discount: invoiceData.IT_discount || "",
            IT_joripara: invoiceData.IT_joripara || "دینار",
            IT_Note: invoiceData.IT_Note || "",
            IT_FIB: invoiceData.IT_FIB || false,
            IT_cash:
              invoiceData.IT_cash !== undefined ? invoiceData.IT_cash : true,
            IT_owe: invoiceData.IT_owe || false,
            IT_Nrx_J_T_check: invoiceData.IT_Nrx_J_T_check || false,
            IT_Nrx_IQD_check: invoiceData.IT_Nrx_IQD_check || false
          },
          () => {
            // Recalculate totals based on restored IT_table to ensure accuracy
            this.IT_total();
          }
        );
      } catch (error) {
        console.error("Error restoring invoice from localStorage:", error);
      }
    }

    this.getUserIlgoin();
    this.setProduct();
  }
  R_hanldeKeyup = (e) => {
    if (e.keyCode === 27) {
      this.setState({ R_suggestions: [] });
      return false;
    }
  };
  R_hanldeKeydown = (e) => {
    const { R_cursor, R_suggestions } = this.state;
    // arrow up/down button should select next/previous list element
    if (e.keyCode === 38 && R_cursor > 0) {
      this.setState((prevState) => ({
        R_cursor: prevState.R_cursor - 1
      }));
    } else if (e.keyCode === 40 && R_cursor < R_suggestions.length - 1) {
      this.setState((prevState) => ({
        R_cursor: prevState.R_cursor + 1
      }));
    }
    if (e.keyCode === 46) {
      this.setState(() => {
        return {
          R_search: null,
          R_zhmara: "",
          R_zhmarasht: "",
          R_naweSht: "",
          R_rezha: "",
          R_garanti: "",
          R_nrx_dolar: "",
          R_nrx_dinarr: "",
          R_nrx: "",
          R_nrx_niwkarton: "",
          R_nrx_kmtrdadarzan: "",
          R_rasidKarton: "",
          R_qazanj: "",
          R_kren: "",
          R_karton: "",
          R_darzan: ""
        };
      });
    }
  };
  R_emptysuggections = () => {
    this.setState({
      R_suggestions: []
    });
  };
  Search_Rent_Handle = (e) => {
    this.setState(
      {
        R_naweSht: e.target.value
      },
      () => {
        if (
          !this.state.R_naweSht ||
          this.state.R_naweSht === "" ||
          this.state.R_naweSht === null
        ) {
          this.setState({ R_suggestions: [] });
        } else {
          this.R_Serach_ByName();
        }
      }
    );
  };
  R_handleListKeydown(evt) {}
  R_suggestionSelected = async (id) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/searchtoproduct?id=${id}`, config);
    const data = res.data.product;
    if (
      this.state.R_naweSht.toString().length === 0 ||
      this.state.R_naweSht === null
    ) {
      this.setState({
        R_suggestions: []
      });
    }
      if (data === null) {
        // alert("ببورە ئەم کاڵایە بونی نیە");
        this.setState({
          R_search: null,
          R_zhmara: "",
          R_zhmarasht: "",
          R_naweSht: "",
          R_rezha: "",
          R_nrx_dolar: "",
          R_nrx_dinarr: "",
          R_nrx_dinarr2: "",
          R_nrx: "",
          R_nrx_niwkarton: "",
          R_nrx_kmtrdadarzan: "",
          R_Dolar2: "",
          R_Dinar2: "",
          R_rasidKarton: "",
          R_qazanj: "",
          R_kren: "",
          R_karton: "",
          R_darzan: "",
          R_suggestions: []
        });
      } else {
        this.setState(() => {
          // Safe fallback values for null/undefined fields
          const saleDolar = data.saleDolar || 0;
          const saleDinar = data.saleDinar || 0;
          const nrxeFroshtnDenar2 = data.nrxeFroshtnDenar2 || 0;
          const nrxeFroshtnDolar2 = data.nrxeFroshtnDolar2 || 0;
          const saleOfLessTenDarzan = data.saleOfLessTenDarzan || 0;
          const saleOfLessHalfCarton = data.saleOfLessHalfCarton || 0;
          const singleSale = data.singleSale || 0;
          const price = data.price || 0;
          const numberOfDarzan = data.numberOfDarzan || 0;

          // Calculate R_nrx based on conditions
          let calculatedNrx;
          if (this.state.R_joripara === "دینار") {
            calculatedNrx = saleDinar;
          } else  {
            calculatedNrx = saleDolar;
          } 

          // Calculate R_qazanj
          let calculatedQazanj;
          if (this.state.R_joripara === "دینار") {
            const nrxToUse = !this.state.R_Nrx_IQD_check
              ? saleDinar
              : nrxeFroshtnDenar2;
            calculatedQazanj = (
              (this.dinartodolar(nrxToUse) - price) *
              numberOfDarzan
            ).toFixed(2);
          } else {
            const nrxToUse = !this.state.R_Nrx_J_T_check
              ? saleDolar
              : nrxeFroshtnDolar2;
            calculatedQazanj = _.multiply(
              _.subtract(nrxToUse, price),
              numberOfDarzan
            );
          }

          return {
            R_search: true,
            R_productId: data._id || "",
            R_zhmara: data.code || "",
            R_zhmarasht: data.productCode || "",
            R_naweSht: data.nameofproduct || "",
            R_rezha: numberOfDarzan,
            R_nrx_dolar: saleDolar,
            R_nrx_dinarr: saleDinar,
            R_nrx_dinarr2: nrxeFroshtnDenar2,
            R_nrx: calculatedNrx,
            R_nrx_niwkarton: saleOfLessHalfCarton,
            R_nrx_kmtrdadarzan: saleOfLessTenDarzan,
            R_Dolar2: nrxeFroshtnDolar2,
            R_Dinar2: nrxeFroshtnDenar2,
            R_rasidKarton: data.rasidKarton
              ? Number(
                  parseFloat(data.rasidKarton.toString().split("e-"))
                ).toFixed(2)
              : "0.00",
            R_qazanj: calculatedQazanj,
            R_kren: price,
            R_nrxkaton: (price * numberOfDarzan).toFixed(2),
            R_waznkarton: data.weight || 0,
            R_karton: "",
            R_darzan: "",
            R_dataProduct: data,
            R_nrximufrad: singleSale,
            R_dp: data.dp || "",
            R_singleSale: singleSale,
            // Add missing fields from API response
            R_barcode: data.barcode || "",
            R_isopen: data.isopen || false,
            R_is_in_progress: data.is_in_progress || false,
            R_Karton_price: data.Karton_price || 0,
            R_nrxifroshtnkarton: data.nrxifroshtnkarton || 0,
            R_status: data.status || "",
            R_dateEmpty: data.dateEmpty || "",
            R_suggestions: []
          };
        });
      }
  };
  ////qarzi kon w nwe la print
  getNewRaidForwakil = async (NOW, e) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    if (this.state.R_frosth === "فرۆشتنی وەکیل") {
      const res = await Instance.get(
        `/api/v1/searchwakil?code=${NOW}&&Name=&&phone=`,
        config
      );
      this.setState({
        R_rasidWakildolarNew:
          res.data.wakils && Number(res.data.wakils.rejaDolar).toFixed(2),
        R_rasidWakildinarNew:
          res.data.wakils && Number(res.data.wakils.rejaDinar).toFixed(2)
      });
    }
  };
  getPrint = (NOW) => {
    window.setTimeout("window.print()", 1000);
    if (this.state.R_frosth === "فرۆشتنی وەکیل") {
      this.getNewRaidForwakil(NOW);
    }
  };

  componentDidUpdate(prevProps, prevState) {
    // Only update if edit actually changed (not just any state change)
    if (prevState.edit !== this.state.edit) {
      if (this.state.edit !== null) {
        // Only setState if values are different to avoid infinite loop
        const shouldUpdate =
          this.state.karton !== this.state.edit.numberOfCarton ||
          this.state.darzan !== this.state.edit.numberOfDarzan;

        if (shouldUpdate) {
          this.setState({
            karton: this.state.edit.numberOfCarton,
            darzan: this.state.edit.numberOfDarzan,
            Edit_date: this.state.edit.date,
            koygshty: this.state.edit.total,
            W_mob_Wakel: this.state.edit.phone,
            W_naw: this.state.edit.Name,
            W_nawneshan: this.state.edit.adress,
            W_raseddolar: this.state.edit.rejaDolar,
            W_raseddenar: this.state.edit.rejaDinar,
            W_code: this.state.edit.code,
            A_zh_mobile: this.state.edit.phone,
            A_bakarhenar: this.state.edit.name,
            A_role: this.state.edit.role,
            Ap_code: this.state.edit.code,
            Ap_naw: this.state.edit.Name,
            Ap_mob: this.state.edit.phone,
            Ap_jor: this.state.edit.jor,
            Ms_draw: this.state.edit.joripara,
            Ms_date: this.state.edit.date,
            Ms_koypara: this.state.edit.koypara,
            Ms_naw: this.state.edit.shwen
          });
        }
      } else {
        // Only reset if values aren't already at defaults
        const shouldReset = this.state.karton !== 0 || this.state.W_naw !== "";

        if (shouldReset) {
          this.setState({
            karton: 0,
            darzan: 0,
            koygshty: 0,
            W_mob_Wakel: 0,
            W_naw: "",
            W_nawneshan: "",
            W_raseddolar: 0,
            W_raseddenar: 0,
            W_code: "",
            A_zh_mobile: 0,
            A_bakarhenar: "",
            A_role: "",
            Ap_code: 0,
            Ap_naw: "",
            Ap_mob: 0,
            Ap_jor: "فرۆشیار",
            Ms_draw: null,
            Ms_date: null,
            Ms_koypara: 0,
            Ms_naw: ""
          });
        }
      }
    }
  }

  setProduct = () => {
    let tempProduct = [];
    storeProducts.forEach((item) => {
      const singleItem = { ...item };
      tempProduct = [...tempProduct, singleItem];
    });

    this.setState(() => {
      return {
        products: tempProduct
      };
    });
  };

  /////// delete table product
  clickOnDelete = async (user, id, userid) => {
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data);

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      const check = window.confirm("دڵنیای لە سڕینەوەی ئەم کاڵایە؟");
      if (check) {
        this.setState(
          {
            data: this.state.data.filter((r) => r._id !== id)
          },
          () => {
            this.setState({
              Add_rasidkarton: this.state.Add_rasidkarton - user.numberOfCarton
            });
          }
        );
      }
    }
  };

  DolarChange = (e) => {
    this.setState({
      navdolar: e.target.value
    });
  };
  ////// qzanj
  getQazanj = () => {
    const nrxeFroshtnDolar = this.state.nrxeFroshtnDolar;
    const kren = parseFloat(this.state.kren);
    const zhmarayKarton = this.state.zhmarayKarton;

    const qazanj = _.multiply(
      _.subtract(Number(nrxeFroshtnDolar), Number(kren)),
      Number(zhmarayKarton)
    );
    //const qazanj = (nrxeFroshtnDolar - kren) * zhmarayKarton;
    return Number(qazanj).toFixed(2);
  };
  getQazanj2 = () => {
    const nrxeFroshtnDolar = this.state.nrxeFroshtnDolar2;
    const kren = parseFloat(this.state.kren);
    const zhmarayKarton = this.state.zhmarayKarton;
    const qazanj = _.multiply(
      _.subtract(Number(nrxeFroshtnDolar), Number(kren)),
      Number(zhmarayKarton)
    );
    return Number(qazanj).toFixed(2);
  };

  ///carton darzan change
  DarzanChange = (e) => {
    const { name, value } = e.target;

    // Handle typing only "."
    if (value === ".") {
      this.setState({ [name]: "0." });
      this.ClearError();
      return;
    }

    // Prevent double dots (e.g., "0..")
    if (value.includes("..")) {
      this.setState({ [name]: "0." });
      this.ClearError();
      return;
    }

    // Handle Delete (dot keyCode 46) – clear the field
    if (e.keyCode === 46) {
      this.setState({ [name]: "" });
      this.ClearError();
      return;
    }

    // Normal value update
    this.setState({ [name]: value }, () => {
      // Calculate dependent fields only if the input is a valid number (allow "0." and numbers like "0.5")
      const validNumber =
        value === "" || value === "0." || !isNaN(Number(value));
      if (!validNumber) return;

      // Calculate related values
      const karton = this.calculateDarzan();
      const R_karton = this.R_calculateDarzan();
      const koygshty = this.getkoygahty(
        Number(this.state.darzan),
        Number(karton)
      );
      const R_nrx = this.nrxRent(Number(this.state.R_darzan), Number(R_karton));

      // Update calculated states
      this.setState(
        {
          karton,
          R_karton,
          koygshty,
          R_nrx
        },
        () => {
          let qazanj = "";
          if (this.state.R_joripara === "دۆلار") {
            qazanj = (
              (Number(this.state.R_nrx) - this.state.R_kren) *
              this.state.R_rezha
            ).toFixed(2);
          } else if (this.state.R_joripara === "دینار") {
            qazanj = (
              (this.dinartodolar(Number(this.state.R_nrx)) -
                this.state.R_kren) *
              this.state.R_rezha
            ).toFixed(2);
          }
          this.setState({ R_qazanj: qazanj });
        }
      );
    });

    this.ClearError();
  };

  CartonChange = (e) => {
    this.setState(
      {
        karton:
          (e.target.value === "." && this.state.karton === "") ||
          _.includes(e.target.value, "..")
            ? "0."
            : e.target.value
      },
      () => {
        this.setState({
          darzan: this.calculateCarton(),
          koygshty: this.getkoygahty(
            Number(this.state.darzan),
            Number(this.state.karton)
          )
        });
      }
    );
    if (e.target.value === ".") {
      this.setState({
        karton: "0."
      });
    }
    this.ClearError();
  };
  /////////////////////////////
  ///////handle chnage  product
  MeterTogler = async (e) => {
    e.preventDefault();
    this.setState(
      {
        metercheck: !this.state.metercheck
      },
      async () => {
        if (!this.state.metercheck) {
          let data = {
            metr: this.state.meterPrice,
            remembi: this.state.remembiPrice
          };
          await Instance.put(`/api/v1/updateDolarPrice`, data);
        }
        this.MerterChange();
        this.KoyGshtydolar_();
        this.KoyGshtyR();
        this.nrxKarton();
      }
    );
  };

  nrxKarton = (e) => {
    let tch = Number(
      _.add(Number(this.KoyGshtydolar_()), Number(this.MerterChange()))
    ).toFixed(2);
    this.setState(
      {
        addnrxKraton: tch
      },
      () => {
        let nsbaA = _.multiply(
          _.subtract(
            _.divide(
              Number(this.state.nrxifroshtnkarton),
              Number(this.state.addnrxKraton)
            ),
            1
          ),
          100
        );
        let nsbaB = _.multiply(
          _.subtract(
            _.divide(
              Number(this.state.nrxifroshtnkarton2),
              Number(this.state.addnrxKraton)
            ),
            1
          ),
          100
        );
        this.setState({
          nsbayfrohtn: Number(nsbaA).toFixed(2),
          nsbayfrohtn2: Number(nsbaB).toFixed(2)
        });
        if (this.state.zhmarayKarton > 0) {
          let krens = Number(
            _.divide(
              Number(this.state.addnrxKraton),
              Number(this.state.zhmarayKarton)
            )
          ).toFixed(3);
          let last = krens.charAt(krens.length - 1);
          this.setState(
            {
              kren: last == 0 ? Number(krens).toFixed(2) : krens
            },
            () => {
              this.setState({
                qazanj: this.getQazanj(),
                qazanj2: this.getQazanj2()
              });
            }
          );
        }
      }
    );
  };
  MerterChange = (e) => {
    let result = _.multiply(
      Number(this.state.height),
      _.multiply(Number(this.state.width), Number(this.state.length))
    );
    let tch = _.multiply(
      Number(result),
      Number(
        this.state.P_meterPrice
          ? this.state.P_meterPrice
          : this.state.meterPrice
      )
    );
    return tch;
  };
  KoyGshtyR = (e) => {
    let tch = _.multiply(
      Number(this.state.dnk),
      Number(this.state.priceOneRRR)
    );
    return tch;
  };
  KoyGshtydolar_ = (e) => {
    let tch = _.divide(
      Number(this.KoyGshtyR()),
      Number(
        this.state.P_remembiPrice
          ? this.state.P_remembiPrice
          : this.state.remembiPrice
      )
    );
    return tch;
  };
  calculateQazanj = (e) => {
    this.setState(
      {
        ...this.state,
        qazanj: e.target.value === "." ? "0." : e.target.value
      },
      () => {
        if (this.state.zhmarayKarton > 0) {
          let qazanj = Number(
            _.add(Number(this.state.addnrxKraton), Number(this.state.qazanj))
          ).toFixed(2);
          this.setState(
            {
              nrxifroshtnkarton: qazanj
            },
            () => {
              let nrxdarzan = Number(
                _.divide(
                  Number(this.state.nrxifroshtnkarton),
                  Number(this.state.zhmarayKarton)
                )
              ).toFixed(2);
              let nrxdarzan2 = Number(
                _.divide(
                  Number(this.state.nrxifroshtnkarton2),
                  Number(this.state.zhmarayKarton)
                )
              ).toFixed(2);
              this.setState({
                nrxeFroshtnDolar: nrxdarzan,
                nrxeFroshtnDolar2: nrxdarzan2
              });
            }
          );
        }
      }
    );
  };
  CartonDarzanChange = async (e) => {
    this.setState(
      {
        ...this.state,
        [e.target.name]: e.target.value === "." ? "0." : e.target.value
      },
      () => {
        if (this.state.zhmarayKarton > 0) {
          let nrxdarzan = Number(
            _.divide(
              Number(this.state.nrxifroshtnkarton),
              Number(this.state.zhmarayKarton)
            )
          ).toFixed(2);
          // let qazanj = _.add(Number(this.state.addnrxKraton), this.state.qazanj);
          this.setState(
            {
              nrxeFroshtnDolar: nrxdarzan
              // nrxifroshtnkarton: qazanj,
            },
            () => {
              this.setState({
                qazanj: this.getQazanj()
              });
            }
          );
          this.KoyGshtyR();
          this.KoyGshtydolar_();
          this.nrxKarton();
          this.R_getALLkoygshtyID();
          this.R_getALLkoygshty();
        }
      }
    );
  };
  OnCHange = (e) => {
    this.setState({
      ...this.state,
      [e.target.name]:
        e.target.value === "." || _.includes(e.target.value, "..")
          ? "0."
          : e.target.value
    });
  };
  OnKrenChange = (e) => {
    this.setState(
      {
        ...this.state,
        [e.target.name]:
          (e.target.value === "." &&
            (this.state[e.target.name] < 1 ||
              this.state[e.target.name] === "")) ||
          _.includes(e.target.value, "..")
            ? "0."
            : e.target.value
      },
      () => {
        this.setState({
          addnrxKraton: _.multiply(
            Number(this.state.kren),
            Number(this.state.zhmarayKarton)
          )
        });
      }
    );
  };
  AddProChange = (e) => {
    this.setState(
      {
        ...this.state,
        [e.target.name]:
          (e.target.value === "." &&
            (this.state[e.target.name] < 1 ||
              this.state[e.target.name] === "")) ||
          _.includes(e.target.value, "..")
            ? "0."
            : e.target.value
      },
      () => {
        if (this.state.zhmarayKarton > 0) {
          this.setState({
            qazanj: this.getQazanj(),
            qazanj2: this.getQazanj2()
          });
          if (
            this.state.nrxeFroshtnDolar !== 0 ||
            this.state.nrxeFroshtnDolar !== ""
          ) {
            let nrxdarzan = Number(
              _.multiply(
                Number(this.state.nrxeFroshtnDolar),
                Number(this.state.zhmarayKarton)
              )
            ).toFixed(2);
            let nrxdarzan2 = Number(
              _.multiply(
                Number(this.state.nrxeFroshtnDolar2),
                Number(this.state.zhmarayKarton)
              )
            ).toFixed(2);
            this.setState({
              nrxifroshtnkarton: nrxdarzan,
              nrxifroshtnkarton2: nrxdarzan2
            });
          }
        }

        if (this.state.dnk && this.state.priceOneRRR) { 
           this.KoyGshtyR();
        this.KoyGshtydolar_();
        this.nrxKarton();
        this.R_getALLkoygshtyID();
        this.R_getALLkoygshty();
        }

        if (Number(this.state.R_paraDanID) !== 0) {
          this.setState({
            R_paradanPechawana: this.dinartodolar(
              Number(this.state.R_paraDanID.toString().replace(/,/g, ""))
            )
          });
        } else if (Number(this.state.R_paraDan$) !== 0) {
          this.setState({
            R_paradanPechawana: this.dolartodinar(
              Number(this.state.R_paraDan$.toString().replace(/,/g, ""))
            )
          });
        } else if (
          Number(this.state.R_paraDan$) === 0 ||
          Number(this.state.R_paraDanID) === 0
        ) {
          this.setState({
            R_paradanPechawana: 0
          });
        }
      }
    );

    this.ClearError();
    this.W_ClearError();
    this.R_ClearError();
    this.U_ClearError();
    this.P_ClearError();
  };

  dolartodinar = (nrx) => {
    const dolar = this.state.navdolar;
    let dinar = 0;
    dinar = (nrx / 100) * dolar;
    return !dinar ? 0 : Number(dinar).toFixed(2);
  };
  dinartodolar = (nrx) => {
    const dolar = this.state.navdolar / 100;
    let dinar = 0;
    dinar = nrx / dolar;
    return !dinar ? 0 : Number(dinar).toFixed(2);
  };
  ///// calculate
  calculateCarton = () => {
    const zhmarayKarton = this.state.zhmarayKarton;
    const carton = Number(this.state.karton);
    const darzan = carton * zhmarayKarton;

    return Number(darzan).toFixed(2);
  };
  calculateDarzan = () => {
    const zhmarayKarton = this.state.zhmarayKarton;
    const darzan = Number(this.state.darzan);
    const karton = darzan / zhmarayKarton;
    return Number(karton).toFixed(4);
  };

  getkoygahty = (darzan, karton) => {
    if (Number(this.state.karton) > 0) {
      const kren = this.state.kren;
      let koygshty = darzan * kren;

      return koygshty.toFixed(2);
    } else if (darzan > 0) {
      const kren = this.state.kren;
      let koygshty = darzan * kren;

      return koygshty.toFixed(2);
    }
  };

  calculateNrxDarzan = (e) => {
    this.setState(
      {
        // ...this.state,
        [e.target.name]: e.target.value
      },
      () => {
        if (this.state.zhmarayKarton > 0) {
          let krens = Number(
            _.divide(
              Number(this.state.addnrxKraton),
              Number(this.state.zhmarayKarton)
            )
          ).toFixed(3);
          let last = krens.charAt(krens.length - 1);
          this.setState(
            {
              kren: last == 0 ? Number(krens).toFixed(2) : krens
            },
            () => {
              this.setState({
                qazanj: this.getQazanj(),
                qazanj2: this.getQazanj2()
              });
            }
          );
        }
      }
    );
  };

  ////product data
  getNameOfData = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get("/api/v1/getProducts", config);

    this.setState({
      productdata: res.data.products,
      page: res.data.products.length + 1
    });
  };
  ////// setError
  setError = (err) => {
    this.setState({
      error: err
    });
  };
  ClearError = () => {
    this.setState({
      error: null
    });
  };
  /// to another input in add product
  Addsaerch_toanotherInput = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 2].focus();
    this.getProductDataBySearch(e);
  };

  Add_toanotherInputttttt = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 4].focus();
  };

  Add_toanotherInput = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 1].focus();
  };

  SetLocalProduct = (data) => {
    this.setState({
      del_dis: null,
      open: true,
      prodactdata: data,
      search: true,
      zhmaraySht: data.productCode || "",
      priceOneRRR: data.priceOneRRR || 0,
      zhmara: data.code || "",
      naweSht: data.nameofproduct || "",
      barcode: data.barcode || "",
      kren: data.price || 0,
      nrxeFroshtnDolar: data.saleDolar || 0,
      nrxeFroshtnDenar: data.saleDinar || 0,
      nrxeKamtrlanewCarton: data.saleOfLessHalfCarton || 0,
      nrxeKamtrlaDaDarzan: data.saleOfLessTenDarzan || 0,
      zhmarayKarton: data.numberOfDarzan || 0,
      qazanj: data.qazanj || 0,
      Add_rasidkarton: data.rasidKarton
        ? Number(parseFloat(data.rasidKarton.toString().split("e-"))).toFixed(2)
        : "0.00",
      data: data.table || [],
      wazn_karton: data.weight || 0,
      addnrxKraton: data.Karton_price
        ? Number(data.Karton_price).toFixed(2)
        : "0.00",
      height: data.height || 0,
      width: data.width || 0,
      length: data.length || 0,
      productNum: data.number || 0
    });
  };
  OpenSaveInLocal = (id) => {
    let datas = {
      _id: id,
      code: this.state.zhmara,
      productCode: this.state.zhmaraySht,
      barcode: this.state.barcode,
      nameofproduct: this.state.naweSht,
      price: this.state.kren,
      saleDinar: this.state.nrxeFroshtnDenar
        ? parseFloat(this.state.nrxeFroshtnDenar.toString().replace(/,/g, ""))
        : 0,
      saleDolar: this.state.nrxeFroshtnDolar || 0,
      saleOfLessHalfCarton: this.state.nrxeKamtrlanewCarton
        ? parseFloat(
            this.state.nrxeKamtrlanewCarton.toString().replace(/,/g, "")
          )
        : 0,
      saleOfLessTenDarzan: this.state.nrxeKamtrlaDaDarzan
        ? parseFloat(
            this.state.nrxeKamtrlaDaDarzan.toString().replace(/,/g, "")
          )
        : 0,
      numberOfDarzan: this.state.zhmarayKarton || 0,
      qazanj: this.state.qazanj || 0,
      table: this.state.data || [],
      rasidKarton: this.state.Add_rasidkarton || 0,
      weight: this.state.wazn_karton || 0,
      Karton_price: this.state.addnrxKraton
        ? Number(this.state.addnrxKraton).toFixed(2)
        : "0.00",
      priceOneRRR: this.state.priceOneRRR || 0,
      height: this.state.height || 0,
      width: this.state.width || 0,
      length: this.state.length || 0
    };
    localStorage.setItem("product", JSON.stringify(datas));
  };

  ////// search product
  getProductDataBySearchByNumber = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/getProductByNumber/${this.state.productNum}`,
        config
      );

      const data = res.data.doc;
      if (data === null) {
        this.setState({
          error: { msg: "ببورە ئەم کاڵایە بونی نیە" },
          prodactdata: [],
          priceOneRRR: "",
          zhmaraySht: "",
          naweSht: "",
          barcode: "",
          kren: 0,
          nrxeFroshtnDolar: 0,
          nrxeFroshtnDenar: 0,
          nrxeKamtrlanewCarton: 0,
          nrxeKamtrlaDaDarzan: 0,
          zhmarayKarton: 0,
          qazanj: 0,
          Add_rasidkarton: 0,
          data: []
        });
      } else {
        this.setState(
          () => {
            return {
              prodactdata: data,
              search: true,
              zhmaraySht: data.productCode || "",
              priceOneRRR: data.priceOneRRR || 0,
              zhmara: data.code || "",
              naweSht: data.nameofproduct || "",
              barcode: data.barcode || "",
              kren: data.price || 0,
              nrxeFroshtnDolar: data.saleDolar || 0,
              nrxeFroshtnDenar: data.saleDinar || 0,
              nrxeKamtrlanewCarton: data.saleOfLessHalfCarton || 0,
              nrxeKamtrlaDaDarzan: data.saleOfLessTenDarzan || 0,
              zhmarayKarton: data.numberOfDarzan || 0,
              qazanj: data.qazanj || 0,
              Add_rasidkarton: data.rasidKarton
                ? Number(
                    parseFloat(data.rasidKarton.toString().split("e-"))
                  ).toFixed(2)
                : 0,
              data: data.table || [],
              wazn_karton: data.weight || 0,
              del_dis: true,
              addnrxKraton: data.Karton_price
                ? Number(data.Karton_price).toFixed(2)
                : 0,
              height: data.height || 0,
              width: data.width || 0,
              length: data.length || 0,
              productNum: data.number || 0,
              dnk: data.dnk || "",
              zhmarayDwkan: data.zhmarayDwkan || "",
              nrxifroshtnkarton: data.nrxifroshtnkarton || 0,
              nsbayfrohtn: data.nsbayfrohtn || 0,
              nrxifroshtnkarton2: data.nrxifroshtnkarton2 || 0,
              nsbayfrohtn2: data.nsbayfrohtn2 || 0,
              qazanj2: data.qazanj2 || 0,
              nrxeFroshtnDolar2: data.nrxeFroshtnDolar2 || 0,
              nrxifroshtnkarton2_IQD: data.nrxifroshtnkarton2_IQD || 0,
              nsbayfrohtn2_IQD: data.nsbayfrohtn2_IQD || 0,
              qazanj2_IQD: data.qazanj2_IQD || 0,
              nrxeFroshtnDenar2: data.nrxeFroshtnDenar2 || 0,
              nrxmufrad: data.singleSale || 0,
              Chine_invoice: data.Chine_invoice || 0,
              NumberOfDana: data.numberOfDana || 0,
              P_meterPrice: data.metr || 0,
              P_remembiPrice: data.remembi || 0,
              dp: data.dp || ""
            };
          },
          () => {
            if (this.state.dnk && this.state.priceOneRRR) { 
              this.MerterChange();
            this.KoyGshtyR();
            this.KoyGshtydolar_();
            this.nrxKarton();
            }
          }
        );
      }
    } catch (error) {
      this.setError({ msg: "ببورە ئەم کاڵایە بونی نیە" });
    }
  };
  getProductDataBySearch = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      if (this.state.zhmara === "") {
        alert("بەبێ ژمارەی کاڵا ناتوانی بگەڕێی");
      } else {
        const res = await Instance.get(
          `/api/v1/searchtoproduct?code=${this.state.zhmara}&nameofproduct=`,
          config
        );

        const data = res.data.product;
        if (data === null) {
          this.setState({
            error: { msg: "ببورە ئەم کاڵایە بونی نیە" },
            prodactdata: [],
            priceOneRRR: "",
            zhmaraySht: "",
            naweSht: "",
            barcode: "",
            kren: 0,
            nrxeFroshtnDolar: 0,
            nrxeFroshtnDenar: 0,
            nrxeKamtrlanewCarton: 0,
            nrxeKamtrlaDaDarzan: 0,
            zhmarayKarton: 0,
            qazanj: 0,
            Add_rasidkarton: 0,
            data: []
          });
        } else {
          this.setState(
            () => {
              return {
                prodactdata: data,
                search: true,
                zhmaraySht: data.productCode || "",
                priceOneRRR: data.priceOneRRR || 0,
                zhmara: data.code || "",
                naweSht: data.nameofproduct || "",
                barcode: data.barcode || "",
                kren: data.price || 0,
                nrxeFroshtnDolar: data.saleDolar || 0,
                nrxeFroshtnDenar: data.saleDinar || 0,
                nrxeKamtrlanewCarton: data.saleOfLessHalfCarton || 0,
                nrxeKamtrlaDaDarzan: data.saleOfLessTenDarzan || 0,
                zhmarayKarton: data.numberOfDarzan || 0,
                qazanj: data.qazanj || 0,
                Add_rasidkarton: data.rasidKarton
                  ? Number(
                      parseFloat(data.rasidKarton.toString().split("e-"))
                    ).toFixed(2)
                  : 0,
                data: data.table || [],
                wazn_karton: data.weight || 0,
                del_dis: true,
                addnrxKraton: data.Karton_price
                  ? Number(data.Karton_price).toFixed(2)
                  : 0,
                height: data.height || 0,
                width: data.width || 0,
                length: data.length || 0,
                productNum: data.number || 0,
                dnk: data.dnk || "",
                zhmarayDwkan: data.zhmarayDwkan || "",
                dp: data.dp || "",
                nrxifroshtnkarton: data.nrxifroshtnkarton || 0,
                nsbayfrohtn: data.nsbayfrohtn || 0,
                nrxifroshtnkarton2: data.nrxifroshtnkarton2 || 0,
                nsbayfrohtn2: data.nsbayfrohtn2 || 0,
                qazanj2: data.qazanj2 || 0,
                nrxeFroshtnDolar2: data.nrxeFroshtnDolar2 || 0,
                nrxifroshtnkarton2_IQD: data.nrxifroshtnkarton2_IQD || 0,
                nsbayfrohtn2_IQD: data.nsbayfrohtn2_IQD || 0,
                qazanj2_IQD: data.qazanj2_IQD || 0,
                nrxeFroshtnDenar2: data.nrxeFroshtnDenar2 || 0,
                nrxmufrad: data.singleSale || 0,
                NumberOfDana: data.numberOfDana || 0,
                P_meterPrice: data.metr || 0,
                P_remembiPrice: data.remembi || 0,
                Chine_invoice: data.Chine_invoice || 0
              };
            },
            () => {
              // Move these calls to setState callback to prevent race conditions
              if (this.state.dnk && this.state.priceOneRRR) {
                this.MerterChange();
                this.KoyGshtyR();
                this.KoyGshtydolar_();
                this.nrxKarton();
              }
            }
          );
        }
      }
    } catch (error) {
      this.setError({ msg: "ببورە ئەم کاڵایە بونی نیە" });
    }
  };
  getProductDataBySearchName = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/searchtoproduct?code=${this.state.zhmara}&nameofproduct=`,
        config
      );

      const data = res.data.product;
      if (data === null) {
        this.ClearError();
      } else {
        this.setState(
          () => {
            return {
              prodactdata: data,
              search: true,
              zhmaraySht: data.productCode || "",
              zhmara: data.code || "",
              priceOneRRR: data.priceOneRRR || 0,
              naweSht: data.nameofproduct || "",
              barcode: data.barcode || "",
              kren: data.price || 0,
              nrxeFroshtnDolar: data.saleDolar || 0,
              nrxeFroshtnDenar: data.saleDinar || 0,
              nrxeKamtrlanewCarton: data.saleOfLessHalfCarton || 0,
              nrxeKamtrlaDaDarzan: data.saleOfLessTenDarzan || 0,
              zhmarayKarton: data.numberOfDarzan || 0,
              qazanj: data.qazanj || 0,
              Add_rasidkarton: data.rasidKarton
                ? Number(
                    parseFloat(data.rasidKarton.toString().split("e-"))
                  ).toFixed(2)
                : 0,
              data: data.table || [],
              wazn_karton: data.weight || 0,
              del_dis: true,
              addnrxKraton: data.Karton_price
                ? Number(data.Karton_price).toFixed(2)
                : 0,
              height: data.height || 0,
              width: data.width || 0,
              length: data.length || 0,
              productNum: data.number || 0,
              dnk: data.dnk || "",
              zhmarayDwkan: data.zhmarayDwkan || "",
              dp: data.dp || "",
              nrxifroshtnkarton: data.nrxifroshtnkarton || 0,
              nsbayfrohtn: data.nsbayfrohtn || 0,
              nrxifroshtnkarton2: data.nrxifroshtnkarton2 || 0,
              nsbayfrohtn2: data.nsbayfrohtn2 || 0,
              qazanj2: data.qazanj2 || 0,
              nrxeFroshtnDolar2: data.nrxeFroshtnDolar2 || 0,
              nrxmufrad: data.singleSale || 0,
              NumberOfDana: data.numberOfDana || 0,
              P_meterPrice: data.metr || 0,
              P_remembiPrice: data.remembi || 0,
              Chine_invoice: data.Chine_invoice || 0
            };
          },
          () => {
             if (this.state.dnk && this.state.priceOneRRR) { 
              this.MerterChange();
            this.KoyGshtyR();
            this.KoyGshtydolar_();
            this.nrxKarton();
            }
          
          }
        );
      }
    } catch (error) {
      this.setError({ msg: "ببورە ئەم کاڵایە بونی نیە" });
      this.ClearError();
    }
  };
  setProductSearchEmty = (e) => {
    e.preventDefault();
    this.setState({
      prodactdata: [],
      zhmaraySht: "",
      priceOneRRR: "",
      zhmara: "",
      naweSht: "",
      barcode: 0,
      kren: 0,
      nrxeFroshtnDolar: 0,
      nrxeFroshtnDenar: 0,
      nrxeKamtrlanewCarton: 0,
      nrxeKamtrlaDaDarzan: 0,
      zhmarayKarton: 0,
      qazanj: 0,
      Add_rasidkarton: 0,
      data: [],
      wazn_karton: 0,
      nrxmufrad: "",
      NumberOfDana: "",
      P_meterPrice: 0,
      P_remembiPrice: 0,
      addnrxKraton: "",
      nrxifroshtnkarton: 0,
      nsbayfrohtn: 0,
      nrxifroshtnkarton2: 0,
      nsbayfrohtn2: 0,
      qazanj2: 0,
      nrxeFroshtnDolar2: 0,
      Chine_invoice: "",
      dp: ""
    });
  };
  //////product pagination
  productpageplusone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page = this.state.page + 1;
      const res = await Instance.get(
        `/api/v1/ppage?page=${page}&limit=1`,
        config
      );

      const data = res.data.pros;
      if (data.status === false) {
        alert("ببورە ئەم کاڵایە بونی نیە");
      } else {
        this.setState(() => {
          return {
            page: page,
            prodactdata: data,
            search: true,
            zhmaraySht: data.productCode,
            priceOneRRR: data.priceOneRRR,
            zhmara: data.code,
            naweSht: data.nameofproduct,
            barcode: data.barcode,
            kren: data.price,
            nrxeFroshtnDolar: data.saleDolar,
            nrxeFroshtnDenar: data.saleDinar,
            nrxeKamtrlanewCarton: data.saleOfLessHalfCarton,
            nrxeKamtrlaDaDarzan: data.saleOfLessTenDarzan,
            zhmarayKarton: data.numberOfDarzan,
            qazanj: data.qazanj,
            Add_rasidkarton: data.rasidKarton
              ? Number(
                  parseFloat(data.rasidKarton.toString().split("e-"))
                ).toFixed(2)
              : 0,
            data: data.table,
            wazn_karton: data.weight,
            del_dis: true,
            addnrxKraton: Number(data.Karton_price).toFixed(2),
            height: data.height,
            width: data.width,
            length: data.length,
            productNum: data.number,
            dnk: data.dnk,
            zhmarayDwkan: data.zhmarayDwkan,
            nrxifroshtnkarton: data.nrxifroshtnkarton,
            nsbayfrohtn: data.nsbayfrohtn ? data.nsbayfrohtn : 0,
            nrxifroshtnkarton2: data.nrxifroshtnkarton2,
            nsbayfrohtn2: data.nsbayfrohtn2,
            qazanj2: data.qazanj2,
            nrxeFroshtnDolar2: data.nrxeFroshtnDolar2,
            nrxmufrad: !data.singleSale ? 0 : data.singleSale,
            NumberOfDana: data.numberOfDana,
            P_meterPrice: data.metr || 0,
            P_remembiPrice: data.remembi || 0,
            Chine_invoice: !data.Chine_invoice ? 0 : data.Chine_invoice,
            dp: data.dp || ""
          };
        });
        if (this.state.dnk && this.state.priceOneRRR) { 
          
        this.MerterChange();
        this.KoyGshtyR();
        this.KoyGshtydolar_();
        this.nrxKarton();
        }
      }
    } catch (error) {
      alert("ببورە ئەم کاڵایە بونی نیە");
    }
  };
  productpageminsone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page;
      this.state.page <= 1 ? (page = 1) : (page = this.state.page - 1);
      const res = await Instance.get(
        `/api/v1/ppage?page=${page}&limit=1`,
        config
      );

      const data = res.data.pros;
      if (data.status === false) {
        alert("ببورە ئەم کاڵایە بونی نیە");
      } else {
        this.setState(() => {
          return {
            page: page,
            prodactdata: data,
            search: true,
            priceOneRRR: data.priceOneRRR,
            zhmaraySht: data.productCode,
            zhmara: data.code,
            naweSht: data.nameofproduct,
            barcode: data.barcode,
            kren: data.price,
            nrxeFroshtnDolar: data.saleDolar,
            nrxeFroshtnDenar: data.saleDinar,
            nrxeKamtrlanewCarton: data.saleOfLessHalfCarton,
            nrxeKamtrlaDaDarzan: data.saleOfLessTenDarzan,
            zhmarayKarton: data.numberOfDarzan,
            qazanj: data.qazanj,
            Add_rasidkarton: data.rasidKarton
              ? Number(
                  parseFloat(data.rasidKarton.toString().split("e-"))
                ).toFixed(2)
              : 0,
            data: data.table,
            wazn_karton: data.weight,
            del_dis: true,
            addnrxKraton: Number(data.Karton_price).toFixed(2),
            height: data.height,
            width: data.width,
            length: data.length,
            productNum: data.number,
            dnk: data.dnk,
            zhmarayDwkan: data.zhmarayDwkan,
            nrxifroshtnkarton: data.nrxifroshtnkarton,
            nsbayfrohtn: data.nsbayfrohtn ? data.nsbayfrohtn : 0,
            nrxifroshtnkarton2: data.nrxifroshtnkarton2,
            nsbayfrohtn2: data.nsbayfrohtn2,
            qazanj2: data.qazanj2,
            nrxeFroshtnDolar2: data.nrxeFroshtnDolar2,
            nrxmufrad: !data.singleSale ? 0 : data.singleSale,
            NumberOfDana: data.numberOfDana,
            P_meterPrice: data.metr || 0,
            P_remembiPrice: data.remembi || 0,
            Chine_invoice: !data.Chine_invoice ? 0 : data.Chine_invoice,
            dp: data.dp || ""
          };
        });
        if (this.state.dnk && this.state.priceOneRRR) { 
          
        this.MerterChange();
        this.KoyGshtyR();
        this.KoyGshtydolar_();
        this.nrxKarton();
        }
      }
    } catch (error) {
      alert("ببورە ئەم کاڵایە بونی نیە");
    }
  };

  //////////save table product
  onSaveTable = async () => {
    if (
      this.state.karton === 0 ||
      this.state.darzan === 0
      // this.state.wazn_karton===0
    ) {
      this.setState({ error: { msg: "تکایە خانەکان داخیل بکە" } });
    } else {
      let Table = this.state.data;
      Table.push({
        _id: Math.random(),
        price: this.state.kren,
        numberOfDarzan: Number(this.state.darzan),
        numberOfCarton: Number(this.state.karton),
        numberOfAllDarzans: this.state.zhmarayKarton,
        total: this.getkoygahty(
          Number(this.state.darzan),
          Number(this.state.karton)
        ),
        date: Date.now()
      });
      if (this.state.data.length === 0) {
        this.setState({ Add_rasidkarton: 0 });
      } else {
        this.setState({
          Add_rasidkarton:
            Number(this.state.Add_rasidkarton) + Number(this.state.karton)
        });
      }
      this.setState({
        data: Table,
        darzan: 0,
        karton: 0
      });
    }
  };
  getRasidKarton = () => {
    let subTotal = 0;
    this.state.data.forEach((item) => {
      subTotal =
        Number(item.numberOfCarton) + Number(this.state.Add_rasidkarton);
    });

    let cartTotals;
    const decimalPart = subTotal % 1;

    if (decimalPart === 0) {
      // Exact number
      cartTotals = subTotal;
    } else {
      const decimalLength = decimalPart.toString().split(".")[1]?.length || 0;
      if (decimalLength === 2) {
        cartTotals = subTotal.toFixed(2);
      } else {
        cartTotals = subTotal.toFixed(3);
      }
    }

    this.setState(() => ({
      Add_rasidkarton: cartTotals
    }));
  };
  ///// loading product
  ProducthideLoader = () => {
    this.setState({ ProductLoading: false });
  };

  ProductshowLoader = () => {
    this.setState({ ProductLoading: true });
  };
  ////////////////save product
  onSave = async () => {
    if (this.state.zhmara === "") {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    } else {
      if (localStorage.token) {
        setToken(localStorage.token);
      }
      const config = {
        "Content-Type": "application/json"
      };
      try {
        let data;
        data = {
          code: this.state.zhmara,
          productCode: this.state.zhmaraySht,
          barcode: this.state.barcode,
          nameofproduct: this.state.naweSht,
          price: this.state.kren,
          saleDinar: parseFloat(
            (this.state.nrxeFroshtnDenar || 0).toString().replace(/,/g, "")
          ),
          saleDolar: this.state.nrxeFroshtnDolar,
          saleOfLessHalfCarton: parseFloat(
            (this.state.nrxeKamtrlanewCarton || 0).toString().replace(/,/g, "")
          ),
          saleOfLessTenDarzan: parseFloat(
            (this.state.nrxeKamtrlaDaDarzan || 0).toString().replace(/,/g, "")
          ),
          numberOfDarzan: this.state.zhmarayKarton,
          qazanj: this.state.qazanj,
          table: this.state.data,
          rasidKarton: this.state.Add_rasidkarton,
          weight: this.state.wazn_karton,
          Karton_price: Number(this.state.addnrxKraton || 0).toFixed(2),
          priceOneRRR: this.state.priceOneRRR,
          height: this.state.height,
          width: this.state.width,
          length: this.state.length,
          zhmarayDwkan: this.state.zhmarayDwkan,
          dp: this.state.dp,
          dnk: this.state.dnk,
          nrxifroshtnkarton: this.state.nrxifroshtnkarton,
          nsbayfrohtn: this.state.nsbayfrohtn,
          nrxifroshtnkarton2: this.state.nrxifroshtnkarton2,
          nsbayfrohtn2: this.state.nsbayfrohtn2,
          qazanj2: this.state.qazanj2,
          nrxeFroshtnDolar2: this.state.nrxeFroshtnDolar2,
          nrxifroshtnkarton2_IQD: this.state.nrxifroshtnkarton2_IQD,
          nsbayfrohtn2_IQD: this.state.nsbayfrohtn2_IQD,
          qazanj2_IQD: this.state.qazanj2_IQD,
          nrxeFroshtnDenar2: parseFloat(
            (this.state.nrxeFroshtnDenar2 || 0).toString().replace(/,/g, "")
          ),
          Chine_invoice: this.state.Chine_invoice,
          singleSale: Number(
            (this.state.nrxmufrad || 0).toString().replace(/,/g, "")
          ),
          numberOfDana: this.state.NumberOfDana,
          remembi: Number(
            (this.state.remembiPrice || 0).toString().replace(/,/g, "")
          ),
          metr: Number(
            (this.state.meterPrice || 0).toString().replace(/,/g, "")
          )
        };
        const res = await Instance.post("/api/v1/newProduct", data, config);
        this.ProductshowLoader();
        if (res) {
          this.ProducthideLoader();
        }
        this.setState({
          ok: true,
          del_dis: true
        });
        swal({
          title: "تەواو",
          text: "پسولە سورکەوتوو بوو!",
          icon: "success",
          timer: 1500
        });
      } catch (error) {
        this.setError({ msg: "تکایە خانەکان پڕبکەوە" });
      }
    }
  };

  /////edit product
  edit_product = (data) => {
    this.setState({
      ...this.state,
      edit: data
    });
  };

  KM_onchangeSalePer = (e, state) => {
    const name = e.target.name;
    const rawValue =
      (e.target.value === "." && this.state[name] === "") ||
      _.includes(e.target.value, "..")
        ? "0."
        : e.target.value;

    const get = (key) => (key === name ? rawValue : this.state[key]);

    let next = { [name]: rawValue };

    // Check if value actually changed - prevents recalculation when loading from DB
    const valueChanged = String(this.state[name]) !== String(rawValue);
    if (!valueChanged) {
      return; // Exit early if value hasn't changed
    }

    // Only recalculate other fields if the name matches the state parameter
    // This prevents cascading updates when loading from database
    if (state === "nrxeFroshtnDolar" && name === "nrxeFroshtnDolar") {
      const nrx = Number(get("nrxeFroshtnDolar")) || 0;
      const kren = Number(get("kren")) || 0;
      const zhmarayKarton = Number(get("zhmarayKarton")) || 0;
      const addnrxKraton = Number(get("addnrxKraton")) || 0;

      let nsbaA =
        kren > 0 ? _.multiply(_.subtract(_.divide(nrx, kren), 1), 100) : 0;
      let nrxdarzan = Number(_.multiply(nrx, zhmarayKarton)).toFixed(2);
      let qazanj = Number(_.subtract(Number(nrxdarzan), addnrxKraton)).toFixed(
        2
      );

      Object.assign(next, {
        nsbayfrohtn: Number(isNaN(nsbaA) ? 0 : Number(nsbaA).toFixed(2)),
        nrxifroshtnkarton: Number(Number(nrxdarzan).toFixed(2)),
        qazanj: Number(Number(qazanj).toFixed(2))
      });
    } else if (state === "nrxifroshtnkarton" && name === "nrxifroshtnkarton") {
      const nrxif = Number(get("nrxifroshtnkarton")) || 0;
      const zhmarayKarton = Number(get("zhmarayKarton")) || 0;
      const kren = Number(get("kren")) || 0;
      const addnrxKraton = Number(get("addnrxKraton")) || 0;

      let nrxdarzan =
        zhmarayKarton > 0
          ? Number(_.divide(nrxif, zhmarayKarton)).toFixed(2)
          : 0;
      let nsbaA =
        kren > 0
          ? _.multiply(_.subtract(_.divide(Number(nrxdarzan), kren), 1), 100)
          : 0;
      let qazanj = Number(_.subtract(nrxif, addnrxKraton)).toFixed(2);

      Object.assign(next, {
        nrxeFroshtnDolar: Number(Number(nrxdarzan).toFixed(2)),
        nsbayfrohtn: Number(isNaN(nsbaA) ? 0 : Number(nsbaA).toFixed(2)),
        qazanj: Number(Number(qazanj).toFixed(2))
      });
    } else if (state === "qazanj" && name === "qazanj") {
      const addnrxKraton = Number(get("addnrxKraton")) || 0;
      const zhmarayKarton = Number(get("zhmarayKarton")) || 0;
      const qazanjVal = Number(get("qazanj")) || 0;
      const kren = Number(get("kren")) || 0;

      let nrxif = Number(_.add(addnrxKraton, qazanjVal)).toFixed(2);
      let nrxdarzan =
        zhmarayKarton > 0
          ? Number(_.divide(nrxif, zhmarayKarton)).toFixed(2)
          : 0;
      let nsbaA =
        kren > 0
          ? _.multiply(_.subtract(_.divide(Number(nrxdarzan), kren), 1), 100)
          : 0;

      Object.assign(next, {
        nrxifroshtnkarton: Number(Number(nrxif).toFixed(2)),
        nrxeFroshtnDolar: Number(Number(nrxdarzan).toFixed(2)),
        nsbayfrohtn: Number(isNaN(nsbaA) ? 0 : Number(nsbaA).toFixed(2))
      });
    } else if (state === "nsbayfrohtn" && name === "nsbayfrohtn") {
      const kren = Number(get("kren"));
      const ns = Number(get("nsbayfrohtn"));
      const zhmarayKarton = Number(get("zhmarayKarton"));
      const addnrxKraton = Number(get("addnrxKraton"));

      let priceB = _.add(_.multiply(kren, _.divide(ns, 100)), kren);
      let nrxdarzan = Number(_.multiply(priceB, zhmarayKarton)).toFixed(2);
      let qazanj = Number(_.subtract(Number(nrxdarzan), addnrxKraton)).toFixed(
        2
      );

      Object.assign(next, {
        nrxeFroshtnDolar: Number(Number(priceB).toFixed(2)),
        nrxifroshtnkarton: Number(Number(nrxdarzan).toFixed(2)),
        qazanj: Number(Number(qazanj).toFixed(2))
      });
    } else if (state === "nrxeFroshtnDolar2" && name === "nrxeFroshtnDolar2") {
      const nrx = Number(get("nrxeFroshtnDolar2")) || 0;
      const kren = Number(get("kren")) || 0;
      const zhmarayKarton = Number(get("zhmarayKarton")) || 0;
      const addnrxKraton = Number(get("addnrxKraton")) || 0;

      let nsbaA =
        kren > 0 ? _.multiply(_.subtract(_.divide(nrx, kren), 1), 100) : 0;
      let nrxdarzan = Number(_.multiply(nrx, zhmarayKarton)).toFixed(2);
      let qazanj = Number(_.subtract(Number(nrxdarzan), addnrxKraton)).toFixed(
        2
      );

      Object.assign(next, {
        nsbayfrohtn2: Number(isNaN(nsbaA) ? 0 : Number(nsbaA).toFixed(2)),
        nrxifroshtnkarton2: Number(Number(nrxdarzan).toFixed(2)),
        qazanj2: Number(Number(qazanj).toFixed(2))
      });
    } else if (
      state === "nrxifroshtnkarton2" &&
      name === "nrxifroshtnkarton2"
    ) {
      const nrxif = Number(get("nrxifroshtnkarton2")) || 0;
      const zhmarayKarton = Number(get("zhmarayKarton")) || 0;
      const kren = Number(get("kren")) || 0;
      const addnrxKraton = Number(get("addnrxKraton")) || 0;

      let nrxdarzan =
        zhmarayKarton > 0
          ? Number(_.divide(nrxif, zhmarayKarton)).toFixed(2)
          : 0;
      let nsbaA =
        kren > 0
          ? _.multiply(_.subtract(_.divide(Number(nrxdarzan), kren), 1), 100)
          : 0;
      let qazanj = Number(_.subtract(nrxif, addnrxKraton)).toFixed(2);

      Object.assign(next, {
        nrxeFroshtnDolar2: Number(Number(nrxdarzan).toFixed(2)),
        nsbayfrohtn2: Number(isNaN(nsbaA) ? 0 : Number(nsbaA).toFixed(2)),
        qazanj2: Number(Number(qazanj).toFixed(2))
      });
    } else if (state === "qazanj2" && name === "qazanj2") {
      const addnrxKraton = Number(get("addnrxKraton")) || 0;
      const zhmarayKarton = Number(get("zhmarayKarton")) || 0;
      const qazanjVal = Number(get("qazanj2")) || 0;
      const kren = Number(get("kren")) || 0;

      let nrxif = Number(_.add(addnrxKraton, qazanjVal)).toFixed(2);
      let nrxdarzan =
        zhmarayKarton > 0
          ? Number(_.divide(qazanjVal, zhmarayKarton)).toFixed(2)
          : 0;
      let nsbaA =
        kren > 0
          ? _.multiply(_.subtract(_.divide(Number(nrxdarzan), kren), 1), 100)
          : 0;

      Object.assign(next, {
        nrxifroshtnkarton2: Number(Number(nrxif).toFixed(2)),
        nrxeFroshtnDolar2: Number(Number(nrxdarzan).toFixed(2)),
        nsbayfrohtn2: Number(isNaN(nsbaA) ? 0 : Number(nsbaA).toFixed(2))
      });
    } else if (state === "nsbayfrohtn2" && name === "nsbayfrohtn2") {
      const kren = Number(get("kren"));
      const ns = Number(get("nsbayfrohtn2"));
      const zhmarayKarton = Number(get("zhmarayKarton"));
      const addnrxKraton = Number(get("addnrxKraton"));

      let priceB = _.add(_.multiply(kren, _.divide(ns, 100)), kren);
      let nrxdarzan = Number(_.multiply(priceB, zhmarayKarton)).toFixed(2);
      let qazanj = Number(_.subtract(Number(nrxdarzan), addnrxKraton)).toFixed(
        2
      );

      Object.assign(next, {
        nrxeFroshtnDolar2: priceB ? Number(Number(priceB).toFixed(2)) : 0,
        nrxifroshtnkarton2: Number(Number(nrxdarzan).toFixed(2)),
        qazanj2: Number(Number(qazanj).toFixed(2))
      });
    } else if (state === "nrxeFroshtnDenar2" && name === "nrxeFroshtnDenar2") {
      const nrx = Number(get("nrxeFroshtnDenar2")) || 0;
      const krenD = Number(get("kren")) || 0;
      const zhmarayKarton = Number(get("zhmarayKarton")) || 0;
      const addnrxKraton = Number(get("addnrxKraton")) || 0;

      const krenDinarValue = this.dolartodinar(krenD) || 0;
      let nsbaA =
        krenDinarValue > 0
          ? _.multiply(_.subtract(_.divide(nrx, krenDinarValue), 1), 100)
          : 0;
      let nrxdarzan = Number(_.multiply(nrx, zhmarayKarton)).toFixed(2);
      let qazanj = Number(
        _.subtract(Number(nrxdarzan), Number(this.dolartodinar(addnrxKraton)))
      ).toFixed(2);

      Object.assign(next, {
        nsbayfrohtn2_IQD: Number(isNaN(nsbaA) ? 0 : Number(nsbaA).toFixed(2)),
        nrxifroshtnkarton2_IQD: Number(Number(nrxdarzan).toFixed(2)),
        qazanj2_IQD: Number(Number(qazanj).toFixed(2))
      });
    } else if (
      state === "nrxifroshtnkarton2_IQD" &&
      name === "nrxifroshtnkarton2_IQD"
    ) {
      const nrxif = Number(get("nrxifroshtnkarton2_IQD")) || 0;
      const zhmarayKarton = Number(get("zhmarayKarton")) || 0;
      const kren = Number(get("kren")) || 0;

      let nrxdarzan =
        zhmarayKarton > 0
          ? Number(_.divide(nrxif, zhmarayKarton)).toFixed(2)
          : 0;
      const krenDinarValue = this.dolartodinar(kren) || 0;
      let nsbaA =
        krenDinarValue > 0
          ? _.multiply(
              _.subtract(_.divide(Number(nrxdarzan), krenDinarValue), 1),
              100
            )
          : 0;
      let qazanj = Number(
        _.subtract(
          Number(nrxif),
          Number(this.dolartodinar(Number(get("addnrxKraton"))))
        )
      ).toFixed(2);

      Object.assign(next, {
        nrxeFroshtnDenar2: Number(Number(nrxdarzan).toFixed(2)),
        nsbayfrohtn2_IQD: Number(isNaN(nsbaA) ? 0 : Number(nsbaA).toFixed(2)),
        qazanj2_IQD: Number(Number(qazanj).toFixed(2))
      });
    } else if (state === "qazanj2_IQD" && name === "qazanj2_IQD") {
      const addnrx =
        Number(this.dolartodinar(Number(get("addnrxKraton")))) || 0;
      const qazanjVal = Number(get("qazanj2_IQD")) || 0;
      const zhmarayKarton = Number(get("zhmarayKarton")) || 0;
      const kren = Number(get("kren")) || 0;

      let nrxkarton = Number(_.add(addnrx, qazanjVal)).toFixed(2);
      let nrxdarzan =
        zhmarayKarton > 0
          ? Number(_.divide(Number(nrxkarton), zhmarayKarton)).toFixed(2)
          : 0;
      const krenDinarValue = this.dolartodinar(kren) || 0;
      let nsbaA =
        krenDinarValue > 0
          ? _.multiply(
              _.subtract(_.divide(Number(nrxdarzan), krenDinarValue), 1),
              100
            )
          : 0;

      Object.assign(next, {
        nrxifroshtnkarton2_IQD: Number(Number(nrxkarton).toFixed(2)),
        nrxeFroshtnDenar2: Number(Number(nrxdarzan).toFixed(2)),
        nsbayfrohtn2_IQD: Number(isNaN(nsbaA) ? 0 : Number(nsbaA).toFixed(2))
      });
    } else if (state === "nsbayfrohtn2_IQD" && name === "nsbayfrohtn2_IQD") {
      const kren = Number(this.dolartodinar(Number(get("kren"))));
      const ns = Number(get("nsbayfrohtn2_IQD"));
      const zhmarayKarton = Number(get("zhmarayKarton"));
      const addnrx = Number(this.dolartodinar(Number(get("addnrxKraton"))));

      let priceB = _.add(_.multiply(kren, _.divide(ns, 100)), kren);
      let nrxdarzan = Number(_.multiply(priceB, zhmarayKarton)).toFixed(2);
      let qazanj = Number(_.subtract(Number(nrxdarzan), addnrx)).toFixed(2);

      Object.assign(next, {
        nrxeFroshtnDenar2: Number(priceB).toFixed(2),
        nrxifroshtnkarton2_IQD: Number(nrxdarzan).toFixed(2),
        qazanj2_IQD: Number(qazanj).toFixed(2)
      });
    }

    const changed = Object.keys(next).some((k) => this.state[k] !== next[k]);
    if (changed) this.setState(next);
  };
  EditTableProduct = async (data, userid) => {
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let dataOpen = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, dataOpen);
    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState({
        darzan: data.numberOfDarzan,
        karton: data.numberOfCarton,
        edit: data,
        Edit_date: data.date
      });
    }
  };
  clear_edit = (e) => {
    e.preventDefault();
    this.setState({
      ...this.state,
      edit: null
    });
  };
  close_update = (e) => {
    e.preventDefault();
    this.setState({
      ...this.state,
      ok: null
    });
    this.setStateEmpty();
  };
  /////// open to update product by password
  openUpdateproduct = async (e, id) => {
    e.preventDefault();
    try {
      const res = await Instance.get(`api/v1/OpenProduct/${id}`);
      let data = {};
      if (res.data.product) {
        data = res.data.product;
      }
      this.setState(
        {
          del_dis: null,
          open: true,
          prodactdata: data,
          zhmaraySht: data.productCode,
          zhmara: data.code,
          priceOneRRR: data.priceOneRRR,
          naweSht: data.nameofproduct,
          barcode: data.barcode,
          kren: data.price,
          nrxeFroshtnDolar: data.saleDolar,
          nrxeFroshtnDenar: data.saleDinar,
          nrxeKamtrlanewCarton: data.saleOfLessHalfCarton,
          nrxeKamtrlaDaDarzan: data.saleOfLessTenDarzan,
          zhmarayKarton: data.numberOfDarzan,
          qazanj: data.qazanj,
          Add_rasidkarton: data.rasidKarton
            ? Number(
                parseFloat(data.rasidKarton.toString().split("e-"))
              ).toFixed(2)
            : 0,
          data: data.table,
          wazn_karton: data.weight,
          addnrxKraton: Number(data.Karton_price).toFixed(2),
          height: data.height,
          width: data.width,
          length: data.length,
          productNum: data.number,
          dnk: data.dnk,
          zhmarayDwkan: data.zhmarayDwkan,
          nrxifroshtnkarton: data.nrxifroshtnkarton,
          nsbayfrohtn: data.nsbayfrohtn ? data.nsbayfrohtn : 0,
          nrxifroshtnkarton2: data.nrxifroshtnkarton2,
          nsbayfrohtn2: data.nsbayfrohtn2,
          qazanj2: data.qazanj2,
          nrxeFroshtnDolar2: data.nrxeFroshtnDolar2,
          nrxifroshtnkarton2_IQD: data.nrxifroshtnkarton2_IQD,
          nsbayfrohtn2_IQD: data.nsbayfrohtn2_IQD,
          qazanj2_IQD: data.qazanj2_IQD,
          nrxeFroshtnDenar2: data.nrxeFroshtnDenar2,
          nrxmufrad: !data.singleSale ? 0 : data.singleSale,
          NumberOfDana: data.numberOfDana,
          P_meterPrice: data.metr || 0,
          P_remembiPrice: data.remembi || 0,
          Chine_invoice: !data.Chine_invoice ? 0 : data.Chine_invoice,
          dp: data.dp || ""
        },
        () => {
          this.OpenSaveInLocal(id);
         if (this.state.dnk && this.state.priceOneRRR) { 
          
        this.MerterChange();
        this.KoyGshtyR();
        this.KoyGshtydolar_();
        this.nrxKarton();
        }
        }
      );
    } catch {}
  };
  //////////////////update table product
  updtae_product = async (id, edit) => {
    if (!this.state.darzan || !this.state.karton) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    } else {
      let data = {
        price: this.state.kren,
        numberOfDarzan: Number(this.state.darzan),
        numberOfCarton: Number(this.state.karton),
        numberOfAllDarzans: this.state.zhmarayKarton,
        total: this.getkoygahty(
          Number(this.state.darzan),
          Number(this.state.karton)
        ),
        date: this.state.Edit_date,
        update: true
      };
      let obj = this.state.data.find((el) => el._id === id);
      let kartoni;
      if (Number(obj.numberOfCarton) < Number(this.state.karton)) {
        kartoni = Number(
          _.subtract(Number(this.state.karton), Number(obj.numberOfCarton))
        ).toFixed(2);
        this.setState({
          Add_rasidkarton: Number(
            Number(this.state.Add_rasidkarton) + Number(kartoni)
          ).toFixed(2)
        });
      } else if (Number(obj.numberOfCarton) > Number(this.state.karton)) {
        kartoni = Number(
          _.subtract(Number(obj.numberOfCarton), Number(this.state.karton))
        ).toFixed(2);
        this.setState({
          Add_rasidkarton: Number(
            Number(this.state.Add_rasidkarton) - Number(kartoni)
          ).toFixed(2)
        });
      }
      this.setState({
        data: this.state.data.map((pro) =>
          pro._id === id ? Object.assign(pro, data) : pro
        ),
        edit: null
      });
      swal({
        title: "تەواو",
        text: "پسولە سورکەوتوو بوو!",
        icon: "success",
        timer: 1500
      });
    }
  };
  //////////////////////////////update right side
  updtae_Right_product = async (e, prodactdata) => {
    if (!this.state.zhmara) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    } else {
      if (localStorage.token) {
        setToken(localStorage.token);
      }
      const config = {
        "Content-Type": "application/json"
      };

      let data;
      data = {
        code: this.state.zhmara,
        productCode: this.state.zhmaraySht,
        barcode: this.state.barcode,
        nameofproduct: this.state.naweSht,
        price: this.state.kren,
        saleDinar: parseFloat(
          (this.state.nrxeFroshtnDenar || 0).toString().replace(/,/g, "")
        ),
        saleDolar: this.state.nrxeFroshtnDolar,
        saleOfLessHalfCarton: parseFloat(
          (this.state.nrxeKamtrlanewCarton || 0).toString().replace(/,/g, "")
        ),
        saleOfLessTenDarzan: parseFloat(
          (this.state.nrxeKamtrlaDaDarzan || 0).toString().replace(/,/g, "")
        ),
        numberOfDarzan: this.state.zhmarayKarton,
        qazanj: this.state.qazanj,
        table: this.state.data,
        rasidKarton: this.state.Add_rasidkarton,
        weight: this.state.wazn_karton,
        Karton_price: this.state.addnrxKraton,
        priceOneRRR: this.state.priceOneRRR,
        height: this.state.height,
        width: this.state.width,
        length: this.state.length,
        zhmarayDwkan: this.state.zhmarayDwkan,
        dnk: this.state.dnk,
        nrxifroshtnkarton: this.state.nrxifroshtnkarton,
        nsbayfrohtn: this.state.nsbayfrohtn,
        nrxifroshtnkarton2: this.state.nrxifroshtnkarton2,
        nsbayfrohtn2: this.state.nsbayfrohtn2,
        qazanj2: this.state.qazanj2,
        nrxeFroshtnDolar2: this.state.nrxeFroshtnDolar2,
        nrxifroshtnkarton2_IQD: this.state.nrxifroshtnkarton2_IQD,
        nsbayfrohtn2_IQD: this.state.nsbayfrohtn2_IQD,
        qazanj2_IQD: this.state.qazanj2_IQD,
        nrxeFroshtnDenar2: parseFloat(
          (this.state.nrxeFroshtnDenar2 || 0).toString().replace(/,/g, "")
        ),
        Chine_invoice: this.state.Chine_invoice,
        singleSale: Number(
          (this.state.nrxmufrad || 0).toString().replace(/,/g, "")
        ),
        numberOfDana: this.state.NumberOfDana,
        dp: this.state.dp,
        remembi: Number(
          (this.state.P_remembiPrice || 0).toString().replace(/,/g, "")
        ),
        metr: Number(
          (this.state.P_meterPrice || 0).toString().replace(/,/g, "")
        )
      };
      const res = await Instance.put(
        `/api/v1/updateProduct/${prodactdata._id}`,
        data,
        config
      );

      this.setState({
        data: this.state.data.map((pro) =>
          pro._id === res.data.update._id ? res.data.update : pro
        ),
        prodactdata: res.data.update,
        ok: true,
        del_dis: true,
        open: null
      });
      swal({
        title: "تەواو",
        text: "پسولە سورکەوتوو بوو!",
        icon: "success",
        timer: 1500
      });
      localStorage.removeItem("product");
      this.clear_edit(e);
    }
  };
  ///// refresh
  refreshPage = () => {
    window.location.reload(false);
  };

  // Rent Context Functions()

  // Rent Delete Mithod

  DeleteSail = async (id, table, wasl, index) => {
    window.document.getElementById("code_Sale").focus();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const check = window.confirm("دڵنیای لە سڕینەوەی ئەم کاڵایە؟");
    if (!window.navigator.onLine) {
      swal({
        title: "ببورە",
        text: "هێڵی ئنتەرنێتەکەت کێشەی هەیە",
        icon: "error"
      });
      window.document.getElementById("code_Sale").focus();
    } else if (check) {
      window.document.getElementById("code_Sale").focus();
      this.setState(
        {
          R_dataTable: this.state.R_dataTable.filter((r, i) => i !== index)
        },
        async () => {
          this.R_koyqazanjywasll();
          if (this.state.R_joripara === "دۆلار") {
            this.R_getALLkoygshty();
          } else if (this.state.R_joripara === "دینار") {
            this.R_getALLkoygshtyID();
          }
          window.document.getElementById("code_Sale").focus();
          //// agar ql remove bka yan waslli kon remove bka
          if (this.state.R_open !== true) {
            localStorage.setItem(
              "item",
              JSON.stringify(this.state.R_dataTable)
            );
          } else if (this.state.R_open === true) {
            let hamwi = {
              _id: wasl._id,
              numberofwasl: this.state.R_zh_wasl,
              numberOfWakil:
                this.state.R_frosth === "فرۆشتنی وەکیل"
                  ? Number(this.state.R_zh_barez)
                  : "",
              wakil: this.state.R_nawe_barez,
              phone: this.state.R_mob,
              whossale: this.state.R_wargr,
              joripara: this.state.R_joripara,
              froshtn: this.state.R_frosth,
              saleTable: this.state.R_dataTable,
              koalldinar:
                this.state.R_joripara === "دینار" ? this.state.R_totalID : 0,
              koalldolar:
                this.state.R_joripara === "دۆلار" ? this.state.R_total : 0,
              dashkandolar:
                this.state.R_joripara === "دۆلار" &&
                this.state.R_dashkan !== null
                  ? this.state.R_dashkan
                  : 0,
              dashkandinar:
                this.state.R_joripara === "دینار" &&
                this.state.R_dashkanID !== null
                  ? this.state.R_dashkanID
                  : 0,
              paraydrawdolar:
                this.state.R_joripara === "دۆلار" &&
                this.state.R_paraDan$ !== "" &&
                this.state.R_paraDan$ !== null
                  ? parseFloat(
                      this.state.R_paraDan$.toString().replace(/,/g, "")
                    )
                  : 0,
              paraydrawdinar:
                this.state.R_joripara === "دینار" &&
                this.state.R_paraDanID !== "" &&
                this.state.R_paraDanID !== null
                  ? parseFloat(
                      this.state.R_paraDanID.toString().replace(/,/g, "")
                    )
                  : 0,
              qarzinwedolar:
                this.state.R_joripara === "دۆلار"
                  ? this.state.R_paraDan$ !== ""
                    ? this.R_waslKrdn()
                    : this.R_kamkrdnawayNrx$()
                  : 0,
              qarzinwedinar:
                this.state.R_joripara === "دینار"
                  ? this.state.R_paraDanID !== ""
                    ? this.R_waslKrdnID()
                    : this.R_kamkrdnawayNrxID()
                  : 0,
              kreysayra: this.state.R_kreysayara,
              kreykrekar: this.state.R_kreykrekar,
              koykartonkan: this.state.R_kartonakan,
              waznakan: this.state.R_koywaznkarton,
              date: this.state.R_date,
              qazanjywasl: this.state.R_qazanjywasl
            };
            localStorage.setItem("saledata", JSON.stringify(hamwi));
            window.document.getElementById("code_Sale").focus();
          }

          //// agar mawad daxil kra natwani new bka
          if (this.state.R_dataTable.length === 0) {
            localStorage.removeItem("item");
            this.setState({
              R_table: false,
              R_addToTable: false
              // R_dashkan: 0,
              // R_dashkanID: 0,
              // R_paraDan$: 0,
              // R_paraDanID: 0,
            });
          }
          this.R_getkartonakan();
          this.R_waznkartonakan();
          this.R_koyqazanjywasll();
          this.UpdateRasidCarton(table.raqam, Number(table.carton), "plus");
        }
      );
    }
  };

  ////to open update
  openUpdate = async (NOW, userid, e, id) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(
      `api/v1/openSale/${id}?id=${userid}`,
      data,
      config
    );

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.R_koyqazanjywasll();
      let wakil;
      if (this.state.R_frosth === "فرۆشتنی وەکیل") {
        let search = {
          code: Number(this.state.R_zh_barez)
        };
        const res = await Instance.post(
          `/api/v1/searchwakilBody`,
          search,
          config
        );
        wakil = res.data.wakils;
      }
      let hamwi = {
        _id: id,
        numberofwasl: this.state.R_zh_wasl,
        numberOfWakil:
          this.state.R_frosth === "فرۆشتنی وەکیل"
            ? Number(this.state.R_zh_barez)
            : "",
        wakil: this.state.R_nawe_barez,
        phone: this.state.R_mob,
        whossale: this.state.R_wargr,
        joripara: this.state.R_joripara,
        froshtn: this.state.R_frosth,
        saleTable: this.state.R_dataTable,
        koalldinar:
          this.state.R_joripara === "دینار" ? this.state.R_totalID : 0,
        koalldolar: this.state.R_joripara === "دۆلار" ? this.state.R_total : 0,
        dashkandolar:
          this.state.R_joripara === "دۆلار" && this.state.R_dashkan !== null
            ? this.state.R_dashkan
            : 0,
        dashkandinar:
          this.state.R_joripara === "دینار" && this.state.R_dashkanID !== null
            ? this.state.R_dashkanID
            : 0,
        paraydrawdolar:
          this.state.R_joripara === "دۆلار" &&
          this.state.R_paraDan$ !== "" &&
          this.state.R_paraDan$ !== null
            ? parseFloat(this.state.R_paraDan$.toString().replace(/,/g, ""))
            : 0,
        paraydrawdinar:
          this.state.R_joripara === "دینار" &&
          this.state.R_paraDanID !== "" &&
          this.state.R_paraDanID !== null
            ? parseFloat(this.state.R_paraDanID.toString().replace(/,/g, ""))
            : 0,
        qarzinwedolar:
          this.state.R_joripara === "دۆلار"
            ? this.state.R_paraDan$ !== ""
              ? this.R_waslKrdn()
              : this.R_kamkrdnawayNrx$()
            : 0,
        qarzinwedinar:
          this.state.R_joripara === "دینار"
            ? this.state.R_paraDanID !== ""
              ? this.R_waslKrdnID()
              : this.R_kamkrdnawayNrxID()
            : 0,
        kreysayra: this.state.R_kreysayara,
        kreykrekar: this.state.R_kreykrekar,
        koykartonkan: this.state.R_kartonakan,
        waznakan: this.state.R_koywaznkarton,
        date: this.state.R_date,
        qazanjywasl: this.state.R_qazanjywasl
      };
      localStorage.setItem("saledata", JSON.stringify(hamwi));
      this.setState({
        R_del_dis: null,
        R_open: true,
        // R_rasidWakildolar: wakil && Number(wakil.rejaDolar),
        // R_rasidWakildinar: wakil && Number(wakil.rejaDinar),
        R_addToTable: true
      });
      this.R_koyqazanjywasll();
    }
    this.getWaslDataBySearchRent_ForOpenSale(e);
  };

  /// on refresh and open
  R_onopenandrefresh = (data) => {
    this.R_koyqazanjywasll();
    this.setState(
      {
        R_wasl: data,
        R_search_wasl: true,
        R_zh_wasl: data.numberofwasl,
        R_nawe_barez: data.wakil,
        R_mob: data.phone,
        R_zh_barez: data.numberOfWakil,
        R_total: data.koalldolar,
        R_totalID: data.koalldinar,
        R_dashkan: data.dashkandolar,
        R_dashkanID: data.dashkandinar,
        R_dataTable: data.saleTable,
        R_joripara: data.joripara,
        R_frosth: data.froshtn,
        R_wargr: data.whossale,
        R_paraDanID: data.paraydrawdinar,
        R_paraDan$: data.paraydrawdolar,
        R_kartonakan: data.koykartonkan,
        R_kreysayara: data.kreysayra,
        R_kreykrekar: data.kreykrekar,
        R_koywaznkarton: data.waznakan,
        R_paraywasl:
          data.joripara === "دۆلار" ? data.qarzinwedolar : data.qarzinwedinar,
        R_del_dis: null,
        R_up_froshtn: data.froshtn,
        R_date: data.date,
        R_togler: false,
        R_open: true
      },
      () => {
        if (this.state.R_joripara === "دۆلار") {
          this.R_getALLkoygshty();
        } else if (this.state.R_joripara === "دینار") {
          this.R_getALLkoygshtyID();
        }
      }
    );
  };
  //////update sale
  updateSale = async (NOW, id, e) => {
    e.preventDefault();
    this.checkForCashAndOweINRent();
    try {
      await this.checkForCashAndOweINRent();
      if (this.state.R_nawe_barez === "" || this.state.R_date === "") {
        swal({
          title: "ببورە",
          text: "هەڵە هەیە لە خانەکان",
          icon: "error"
        });
      } else if (
        this.state.R_frosth === "فرۆشتنی وەکیل" &&
        (this.state.R_zh_barez === 0 || this.state.R_zh_barez === "")
      ) {
        swal({
          title: "ببورە",
          text: "تکایە خانەکان پڕبکەرەوە",
          icon: "error"
        });
      } else {
        let wakil;
        if (this.state.R_frosth === "فرۆشتنی وەکیل") {
          let search = {
            code: Number(this.state.R_zh_barez)
          };
          const res = await Instance.post(`/api/v1/searchwakilBody`, search);
          wakil = res.data.wakils;
        }
        this.R_koyqazanjywasll();
        this.checkForCashAndOweINRent();
        console.log("first", this.state.cash);
        let hamwi = {
          numberOfWakil:
            this.state.R_frosth === "فرۆشتنی وەکیل"
              ? Number(this.state.R_zh_barez)
              : "",
          wakil: this.state.R_nawe_barez,
          phone: this.state.R_mob,
          whossale: this.state.R_wargr,
          joripara: this.state.R_joripara,
          froshtn: this.state.R_frosth,
          saleTable: this.state.R_dataTable,
          koalldinar:
            this.state.R_joripara === "دینار" ? this.state.R_totalID : 0,
          koalldolar:
            this.state.R_joripara === "دۆلار" ? this.state.R_total : 0,
          dashkandolar:
            this.state.R_joripara === "دۆلار" && this.state.R_dashkan !== null
              ? this.state.R_dashkan
              : 0,
          dashkandinar:
            this.state.R_joripara === "دینار" && this.state.R_dashkanID !== null
              ? this.state.R_dashkanID
              : 0,
          paraydrawdolar:
            this.state.R_joripara === "دۆلار" &&
            this.state.R_paraDan$ !== "" &&
            this.state.R_paraDan$ !== null
              ? parseFloat(this.state.R_paraDan$.toString().replace(/,/g, ""))
              : 0,
          paraydrawdinar:
            this.state.R_joripara === "دینار" &&
            this.state.R_paraDanID !== "" &&
            this.state.R_paraDanID !== null
              ? parseFloat(this.state.R_paraDanID.toString().replace(/,/g, ""))
              : 0,
          qarzinwedolar:
            this.state.R_joripara === "دۆلار"
              ? this.state.R_paraDan$ !== ""
                ? this.R_waslKrdn()
                : this.R_kamkrdnawayNrx$()
              : 0,
          qarzinwedinar:
            this.state.R_joripara === "دینار"
              ? this.state.R_paraDanID !== ""
                ? this.R_waslKrdnID()
                : this.R_kamkrdnawayNrxID()
              : 0,
          kreysayra: this.state.R_kreysayara,
          kreykrekar: this.state.R_kreykrekar,
          koykartonkan: this.state.R_kartonakan,
          waznakan: this.state.R_koywaznkarton,
          date: this.state.R_date,
          qazanjywasl: this.state.R_qazanjywasl,
          dateQazrz: this.state.R_kateQarz,
          paradnPechawana: !isNaN(this.state.R_paradanPechawana)
            ? this.state.R_paradanPechawana
            : 0,
          joripara_dolar: this.state.R_Nrx_J_T_check,
          joripara_IQD: this.state.R_Nrx_IQD_check,
          R_Mufrad_check: this.state.R_Mufrad_check,
          R_Item_check: this.state.R_Item_check,
          DolarPrice: this.state.navdolar,
          FIB: this.state.FIB,
          cash: this.state.cash,
          owe: this.state.owe
        };
        const res = await Instance.put(`/api/v1/updateSaleAll/${id}`, hamwi);
        localStorage.removeItem("saledata");
        ///dyarikrdni jori draw
        let data = res.data.data.update;
        let wakils = res.data.data.wakil;
        this.setState(
          {
            R_up_wasl: true,
            R_del_dis: true,
            R_open: null,
            R_wasl: data,
            R_paraywasl:
              data.joripara === "دۆلار"
                ? data.qarzinwedolar
                : data.qarzinwedinar,
            R_togler: false,
            R_table: false,
            R_date: data.date,
            // R_rasidWakildinar: wakil && Number(wakil.rejaDinar),
            // R_rasidWakildolar: wakil && Number(wakil.rejaDolar),
            R_zhmara: "",
            R_zhmarasht: "",
            R_naweSht: "",
            R_karton: "",
            R_darzan: "",
            R_search: null,
            R_rezha: 0,
            R_nrx: 0,
            R_addToTable: false
          },
          () => {
            this.GetRasidNEWOfWakil();
          }
        );
        swal({
          title: "تەواو",
          text: "پسولە سورکەوتوو بوو!",
          icon: "success",
          timer: 1500
        });
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "هەڵە هەیە لە خانەکان",
        icon: "error"
      });
    }
  };

  OnChangePaymentFIB = (e) => {
    // e.preventDefault()
    this.setState({
      FIB: true,
      cash: false,
      owe: false
    });
  };
  OnChangePayment = (e) => {
    // e.preventDefault()
    this.setState({
      FIB: false,
      cash: false,
      owe: true
    });
  };
  OnChangePaymentCash = (e) => {
    // e.preventDefault()
    this.setState({
      FIB: false,
      cash: true,
      owe: false,
      R_paraDanID:this.state.R_joripara === "دینار" ? this.state.R_totalID : this.state.R_total,
    });
  };
  M_OnChangePaymentFIB = (e) => {
    // e.preventDefault()
    this.setState({
      M_FIB: true,
      M_cash: false
    });
  };
  M_OnChangePaymentCash = (e) => {
    // e.preventDefault()
    this.setState({
      M_FIB: false,
      M_cash: true
    });
  };
  OnHarzantrChange = (e) => {
    this.setState({
      RDM_harzantr: true,
      RDM_harzantr_IQD: false,
      RDM_isSingle: false,
      GDM_grantr_IQD: false,
      GDM_grantr: false,
      GDM_isSingle: false
    });
  };
  OnHarzantrChange_IQD = (e) => {
    this.setState({
      RDM_harzantr_IQD: true,
      RDM_harzantr: false,
      RDM_isSingle: false,
      GDM_grantr_IQD: false,
      GDM_grantr: false,
      GDM_isSingle: false
    });
  };
  OnIsSignleReturn = (e) => {
    this.setState({
      RDM_harzantr_IQD: false,
      RDM_harzantr: false,
      RDM_isSingle: true,
      GDM_grantr_IQD: false,
      GDM_grantr: false,
      GDM_isSingle: false
    });
  };
  onGrantrCHange = (e) => {
    this.setState({
      GDM_grantr: true,
      GDM_grantr_IQD: false,
      GDM_isSingle: false,
      RDM_harzantr_IQD: false,
      RDM_harzantr: false,
      RDM_isSingle: false
    });
  };
  onGrantrCHange_IQD = (e) => {
    this.setState({
      GDM_grantr_IQD: true,
      GDM_grantr: false,
      GDM_isSingle: false,
      RDM_harzantr_IQD: false,
      RDM_harzantr: false,
      RDM_isSingle: false
    });
  };
  OnIsSignleGrantrChange = (e) => {
    this.setState({
      GDM_grantr_IQD: false,
      GDM_grantr: false,
      GDM_isSingle: true,
      RDM_harzantr_IQD: false,
      RDM_harzantr: false,
      RDM_isSingle: false
    });
  };
  OnCancleHarzantrChange = (e) => {
    this.setState({
      RDM_harzantr: false,
      RDM_harzantr_IQD: false,
      RDM_isSingle: false,
      GDM_grantr: false,
      GDM_grantr_IQD: false,
      GDM_isSingle: false
    });
  };
  ///// nrx change
  R_nrxchange = (e) => {
    this.setState(
      {
        R_nrx: e.target.value
      },
      () => {
        if (this.state.R_joripara === "دۆلار") {
          this.setState({
            R_qazanj: (
              (Number(this.state.R_nrx) - this.state.R_kren) *
              this.state.R_rezha
            ).toFixed(4)
          });
        } else if (this.state.R_joripara === "دینار") {
          this.setState({
            R_qazanj: (
              (this.dinartodolar(Number(this.state.R_nrx)) -
                this.state.R_kren) *
              this.state.R_rezha
            ).toFixed(4)
          });
        }
      }
    );
  };
  /////get print with password in Rent
  getPrintPasswordRent = (NOW) => {
    if (this.state.R_dataTable.length === 0) {
      swal({
        title: "ببورە",
        text: "بەبێ کاڵا ناتوانی پسوولە چاپ بکەی",
        icon: "error"
      });
    } else {
      const p = prompt("وشەی نهێنی داخیل بکە!");
      if (p === "55") {
        this.setState({ R_pass: true }, () => {
          if (this.state.R_frosth === "فرۆشتنی وەکیل") {
            this.getNewRaidForwakil(NOW);
          }
          window.setTimeout("window.print()", 3500);
        });
      }
    }
  };
  ////Rent Clear Error
  R_ClearError = () => {
    this.setState({ R_error: null });
  };
  // Rent Find Number Of Carton Or darzan

  R_DarzanChange = (e) => {
    this.setState({
      R_darzan: "",
      R_karton: ""
    });
    this.R_ClearError();
  };
  R_CartonDarzanSfr = (e) => {
    if (e.keyCode === 13) {
      if (this.state.R_rasidKarton <= 0 && this.state.R_karton.length !== 0) {
        alert("!رەسیدی پێویست نیە");
        this.tofirstInputINRentRasidNmaya(e);
      } else {
        this.tofirstInputINRent(e);
      }
    } else if (e.keyCode === 8) {
      this.setState({
        R_darzan: "",
        R_karton: ""
      });
    }
    this.R_ClearError();
  };
  R_CartonChange = (e) => {
    this.setState(
      {
        R_karton:
          (e.target.value === "." && this.state.R_karton === "") ||
          _.includes(e.target.value, "..")
            ? "0."
            : e.target.value
      },
      () => {
        this.setState(
          {
            R_darzan: Number(this.R_calculateCarton()).toFixed(2),
            R_nrx: this.nrxRent(
              Number(this.R_calculateCarton()),
              Number(this.state.R_karton)
            )
          },
          () => {
            if (this.state.R_joripara === "دۆلار") {
              this.setState({
                R_qazanj: (
                  (Number(this.state.R_nrx) - this.state.R_kren) *
                  this.state.R_rezha
                ).toFixed(4)
              });
            } else if (this.state.R_joripara === "دینار") {
              this.setState({
                R_qazanj: (
                  (this.dinartodolar(Number(this.state.R_nrx)) -
                    this.state.R_kren) *
                  this.state.R_rezha
                ).toFixed(4)
              });
            }
          }
        );
      }
    );
    if (this.state.R_karton.toString().includes("..")) {
      this.setState({
        [e.target.name]: "0."
      });
    }
    if (e.target.value === ".") {
      this.setState({
        [e.target.name]: "0."
      });
    }
    this.R_ClearError();
  };
  R_calculateCarton = () => {
    const zhmarayKarton = this.state.R_rezha;
    const carton = Number(this.state.R_karton);
    const darzan = carton * zhmarayKarton;

    return Number(darzan);
  };
  R_calculateDarzan = () => {
    const zhmarayKarton = this.state.R_rezha;
    const darzan = Number(this.state.R_darzan);
    const karton = darzan / zhmarayKarton;
    return Number(karton);
  };
  // Rent OnSaveRent()
  setRentSaveSale = () => {
    this.setState({
      R_zhmarasht: "",
      R_karton: "",
      R_darzan: "",
      R_nrx: 0,
      R_naweSht: "",
      R_rezha: 0,
      R_koygshty$: 0,
      R_koygshtyID: 0,
      R_zhmara: "",
      R_nrx_dolar: 0,
      R_nrx_dinarr: 0,
      R_nrx_dinarr2: 0,
      R_nrx_niwkarton: 0,
      R_nrx_kmtrdadarzan: 0,
      R_Dolar2: "",
      R_Dinar2: "",
      R_search: null,
      R_rasidKarton: 0,
      R_qazanj: 0,
      R_kren: 0,
      R_nrxkaton: 0,
      R_dataProduct: "",
      R_addToTable: false,
      R_productId: ""
    });
  };
  R_Serach_ByName = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(
      `/api/v1/searchName?nameofproduct=${this.state.R_naweSht}`,
      config
    );
    if (this.state.R_naweSht === "" || this.state.R_naweSht === null) {
      this.setState({
        R_suggestions: []
      });
    }
    this.setState({
      R_suggestions: res.data.search
    });
  };
  ////// new page
  createNewPage = (e) => {
    e.preventDefault();
    this.setState(
      {
        R_nawe_barez: "",
        R_mob: 0,
        R_zh_barez: 0,
        R_total: 0,
        R_totalID: 0,
        R_dashkan: 0,
        R_dashkanID: 0,
        R_dataTable: [],
        R_suggestions: [],
        R_cursor: 0,
        R_search: null,
        dinar: false,
        dolar: false,
        R_search_wasl: null,
        R_kartonakan: 0,
        R_nwe: true,
        R_joripara: "دینار",
        R_zhmara: "",
        R_zhmarasht: "",
        R_naweSht: "",
        R_karton: "",
        R_darzan: "",
        R_kreykrekar: 0,
        R_kreysayara: 0,
        R_save: null,
        R_nrx: 0,
        R_waznkarton: 0,
        R_koywaznkarton: 0,
        R_paraDan$: "",
        R_paraDanID: "",
        R_WakilQard_isChecked: false,
        R_isChecked: false,
        R_search_wakil: null,
        R_zh_wasl: 0,
        R_wargr: "ئەنوەر",
        R_frosth: "فرۆشتنی وەکیل",
        R_rezha: 0,
        R_rasidKarton: 0,
        R_up_wasl: null,
        R_del_dis: null,
        R_paraywasl: 0,
        R_open: null,
        R_wasl: null,
        R_togler: false,
        R_date: "",
        R_rasidWakildolar: 0,
        R_rasidWakildolarNew: 0,
        R_rasidWakildinarNew: 0,
        R_rasidWakildinar: 0,
        R_kateQarz: 0,
        R_paradanPechawana: "",
        R_productId: "",
        R_Nrx_J_T_check: false,
        R_Nrx_IQD_check: false,
        R_Mufrad_check: false,
        R_Item_check: false,
        R_ItemSelect: "",
        R_addToTable: false,
        FIB: false,
        cash: false,
        owe: false,
        R_dp: "",
        R_singleSale: 0
      },
      () => {
        this.getWaslakan();
      }
    );
    this.R_ClearError();
  };

  R_getIsChecked = (e) => {
    this.setState({
      R_isChecked: !this.state.R_isChecked
    });
  };
  R_WakilQard_getIsChecked = (e) => {
    this.setState({
      R_WakilQard_isChecked: !this.state.R_WakilQard_isChecked
    });
  };
  R_darzankartontoanotherInput = (e) => {
    if (
      (this.state.R_rasidKarton <= 0 ||
        Number(this.state.R_karton) > Number(this.state.R_rasidKarton)) &&
      this.state.R_karton.length !== 0
    ) {
      alert("!رەسیدی پێویست نیە");
    }
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index - 1].focus();
  };
  ///////save befor

  saveDetail = async (e, wasl) => {
    e.preventDefault();
    if (this.state.open) {
      alert("!تکایە قوفلی کاڵا قەپات بکە");
    } else if (
      this.state.R_karton === 0 ||
      this.state.R_zhmara === "" ||
      this.state.R_joripara === null
    ) {
      alert("!تکایە خانەکان پڕ بکەرەوە");
    } else if (
      (this.state.R_rasidKarton <= 0 ||
        Number(this.state.R_karton) > this.state.R_rasidKarton) &&
      this.state.R_karton.length !== 0
    ) {
      alert("!رەسیدی پێویستت نیە");
    } else if (this.state.R_karton.toString().includes("..")) {
      alert("!هەڵەهەیە لە داخیل کردنی کارتۆن");
    } else {
      if (this.state.R_karton === "" || this.state.R_darzan === "") {
        alert("!تکایە خانەکان پڕ بکەرەوە");
      } else {
        if (localStorage.token) {
          setToken(localStorage.token);
        }
        const config = {
          "Content-Type": "application/json"
        };
        let Table = this.state.R_dataTable;
        this.R_koyqazanjywasll();
        Table.unshift({
          _id: this.state.R_productId,
          raqam: this.state.R_zhmara,
          jamaraysht: this.state.R_zhmarasht,
          nawisht: this.state.R_naweSht,
          carton: Number.isInteger(Number(this.state.R_karton))
            ? Number(this.state.R_karton)
            : Number(this.state.R_karton).toFixed(4),
          darzan: Number(this.state.R_darzan),
          nrx:
            this.state.R_joripara === "دۆلار"
              ? parseFloat(this.state.R_nrx)
              : parseFloat(this.state.R_nrx),
          reja: this.state.R_rezha,
          kodolar:
            this.state.R_joripara === "دۆلار"
              ? this.R_getkoygahty(this.state.R_darzan, this.state.R_karton)
              : 0,
          kodinar:
            this.state.R_joripara === "دینار"
              ? this.R_getkoygahty(this.state.R_darzan, this.state.R_karton)
              : 0,
          wazn: this.state.R_waznkarton,
          qazanj: this.state.R_qazanj * Number(this.state.R_karton),
          dp: this.state.R_dp || "",
          singleSale: this.state.R_singleSale > 0 ? this.state.R_singleSale : 0
        });
        this.UpdateRasidCarton(
          this.state.R_zhmara,
          Number(this.state.R_karton),
          "-"
        );

        this.setState(
          {
            R_dataTable: Table,
            R_zhmarasht: "",
            R_productId: "",
            R_karton: 0,
            R_darzan: 0,
            R_nrx: 0,
            R_naweSht: "",
            R_rezha: 0,
            R_koygshty$: 0,
            R_koygshtyID: 0,
            R_zhmara: "",
            R_nrx_dolar: 0,
            R_nrx_dinarr: 0,
            R_nrx_dinarr2: 0,
            R_nrx_niwkarton: 0,
            R_nrx_kmtrdadarzan: 0,
            R_Dolar2: "",
            R_Dinar2: "",
            R_search: null,
            R_rasidKarton: 0,
            R_qazanj: 0,
            R_kren: 0,
            R_nrxkaton: 0,
            R_table: true,
            R_dataProduct: "",
            R_addToTable: true,
            R_dp: "",
            R_singleSale: 0
          },
          () => {
            if (this.state.R_joripara === "دۆلار") {
              this.R_getALLkoygshty();
            } else if (this.state.R_joripara === "دینار") {
              this.R_getALLkoygshtyID();
            }
            this.R_getkartonakan();
            this.R_waznkartonakan();
            this.R_koyqazanjywasll();
            if (this.state.R_open !== true) {
              localStorage.setItem(
                "item",
                JSON.stringify(this.state.R_dataTable)
              );
            } else if (this.state.R_open === true) {
              let hamwi = {
                _id: wasl._id,
                numberofwasl: this.state.R_zh_wasl,
                numberOfWakil:
                  this.state.R_frosth === "فرۆشتنی وەکیل"
                    ? Number(this.state.R_zh_barez)
                    : "",
                wakil: this.state.R_nawe_barez,
                phone: this.state.R_mob,
                whossale: this.state.R_wargr,
                joripara: this.state.R_joripara,
                froshtn: this.state.R_frosth,
                saleTable: this.state.R_dataTable,
                koalldinar:
                  this.state.R_joripara === "دینار" ? this.state.R_totalID : 0,
                koalldolar:
                  this.state.R_joripara === "دۆلار" ? this.state.R_total : 0,
                dashkandolar:
                  this.state.R_joripara === "دۆلار" &&
                  this.state.R_dashkan !== null
                    ? this.state.R_dashkan
                    : 0,
                dashkandinar:
                  this.state.R_joripara === "دینار" &&
                  this.state.R_dashkanID !== null
                    ? this.state.R_dashkanID
                    : 0,
                paraydrawdolar:
                  this.state.R_joripara === "دۆلار" &&
                  this.state.R_paraDan$ !== "" &&
                  this.state.R_paraDan$ !== null
                    ? parseFloat(
                        this.state.R_paraDan$.toString().replace(/,/g, "")
                      )
                    : 0,
                paraydrawdinar:
                  this.state.R_joripara === "دینار" &&
                  this.state.R_paraDanID !== "" &&
                  this.state.R_paraDanID !== null
                    ? parseFloat(
                        this.state.R_paraDanID.toString().replace(/,/g, "")
                      )
                    : 0,
                qarzinwedolar:
                  this.state.R_joripara === "دۆلار"
                    ? this.state.R_paraDan$ !== ""
                      ? this.R_waslKrdn()
                      : this.R_kamkrdnawayNrx$()
                    : 0,
                qarzinwedinar:
                  this.state.R_joripara === "دینار"
                    ? this.state.R_paraDanID !== ""
                      ? this.R_waslKrdnID()
                      : this.R_kamkrdnawayNrxID()
                    : 0,
                kreysayra: this.state.R_kreysayara,
                kreykrekar: this.state.R_kreykrekar,
                koykartonkan: this.state.R_kartonakan,
                waznakan: this.state.R_koywaznkarton,
                date: this.state.R_date,
                qazanjywasl: this.state.R_qazanjywasl
              };
              localStorage.setItem("saledata", JSON.stringify(hamwi));
            }
          }
        );

        this.R_ClearError();
      }
    }
  };

  UpdateRasidCarton = async (code, karton, opr) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.put(
      `/api/v1/updateRasidKarton/${code}/${karton}?opr=${opr}`,
      config
    );
    if (res.data.status) {
      return;
    }
  };
  //// loading function
  hideLoader = () => {
    this.setState({ loading: false });
  };

  showLoader = () => {
    this.setState({ loading: true });
  };
  R_calculateBripara = (e) => {
    this.setState(
      {
        [e.target.name]: parseFloat(e.target.value.toString().replace(/,/g, ""))
      },
      () => {
        let zhamra = !isNaN(this.state.R_paradanPechawana)
          ? this.state.R_paradanPechawana
          : 0;
        let bripara =
          this.state.R_joripara === "دینار"
            ? this.dolartodinar(zhamra)
            : this.dinartodolar(zhamra);
        if (this.state.R_joripara === "دینار") {
          this.setState({
            R_paraDanID: Number(bripara) !== 0 ? bripara : 0
          });
        } else if (this.state.R_joripara === "دۆلار") {
          this.setState({
            R_paraDan$: Number(bripara) !== 0 ? bripara : 0
          });
        }
      }
    );
  };
  ////// save tabel
  GetRasidNEWOfWakil = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    let search = {
      code: Number(this.state.R_zh_barez)
    };
    if (this.state.R_frosth === "فرۆشتنی وەکیل") {
      const res = await Instance.post(
        `/api/v1/searchwakilBody`,
        search,
        config
      );

      const data = res.data.wakils;
      this.setState({
        R_rasidWakildinarNew: data && Number(data.rejaDinar),
        R_rasidWakildolarNew: data && Number(data.rejaDolar)
      });
    }
  };
  checkForCashAndOweINRent = async () => {
    if (
      (this.state.R_joripara === "دۆلار" &&
        parseFloat(this.state.R_paraDan$.toString().replace(/,/g, "")) ==
          this.state.R_total &&
        this.state.owe) ||
      (this.state.R_joripara === "دینار" &&
        parseFloat(this.state.R_paraDanID.toString().replace(/,/g, "")) ==
          this.state.R_totalID &&
        this.state.owe)
    ) {
      this.setState({
        cash: true,
        FIB: false,
        owe: false
      });
    } else if (
      (this.state.R_joripara === "دۆلار" &&
        parseFloat(this.state.R_paraDan$.toString().replace(/,/g, "")) !==
          this.state.R_total &&
        !this.state.owe) ||
      (this.state.R_joripara === "دینار" &&
        parseFloat(this.state.R_paraDanID.toString().replace(/,/g, "")) !==
          this.state.R_totalID &&
        !this.state.owe)
    ) {
      this.setState(
        {
          cash: false,
          FIB: false,
          owe: true
        },
        () => {
          this.OnChangePayment();
        }
      );
    }
  };
  onSaveRent = async (e) => {
    e.preventDefault();
    await this.checkForCashAndOweINRent();
    this.R_koyqazanjywasll();
    let data, wakil;
    if (this.state.R_frosth === "فرۆشتنی وەکیل") {
      let search = {
        code: Number(this.state.R_zh_barez)
      };
      const res = await Instance.post(`/api/v1/searchwakilBody`, search);
      wakil = res.data.wakils;
    }
    data = {
      numberOfWakil:
        this.state.R_frosth === "فرۆشتنی وەکیل"
          ? Number(this.state.R_zh_barez)
          : 0,
      wakil: this.state.R_nawe_barez,
      phone: this.state.R_mob,
      whossale: this.state.R_wargr,
      joripara: this.state.R_joripara,
      froshtn: this.state.R_frosth,
      saleTable: this.state.R_dataTable,
      koalldinar: this.state.R_joripara === "دینار" ? this.state.R_totalID : 0,
      koalldolar: this.state.R_joripara === "دۆلار" ? this.state.R_total : 0,
      dashkandolar:
        this.state.R_joripara === "دۆلار" && this.state.R_dashkan !== null
          ? this.state.R_dashkan
          : 0,
      dashkandinar:
        this.state.R_joripara === "دینار" && this.state.R_dashkanID !== null
          ? this.state.R_dashkanID
          : 0,
      paraymawadolar:
        this.state.R_joripara === "دۆلار"
          ? this.state.R_dashkan !== 0
            ? this.R_kamkrdnawayNrx$()
            : this.state.R_total
          : 0,
      paraymawadinar:
        this.state.R_joripara === "دینار"
          ? this.state.R_dashkanID !== 0
            ? this.R_kamkrdnawayNrxID()
            : this.state.R_totalID
          : 0,
      paraydrawdolar:
        this.state.R_joripara === "دۆلار" &&
        this.state.R_paraDan$ !== "" &&
        this.state.R_paraDan$ !== null
          ? parseFloat(this.state.R_paraDan$.toString().replace(/,/g, ""))
          : 0,
      paraydrawdinar:
        this.state.R_joripara === "دینار" &&
        this.state.R_paraDanID !== "" &&
        this.state.R_paraDanID !== null
          ? parseFloat(this.state.R_paraDanID.toString().replace(/,/g, ""))
          : 0,
      qarzinwedolar:
        this.state.R_joripara === "دۆلار"
          ? this.state.R_paraDan$ !== ""
            ? this.R_waslKrdn()
            : this.R_kamkrdnawayNrx$()
          : 0,
      qarzinwedinar:
        this.state.R_joripara === "دینار"
          ? this.state.R_paraDanID !== ""
            ? this.R_waslKrdnID()
            : this.R_kamkrdnawayNrxID()
          : 0,
      kreysayra: this.state.R_kreysayara,
      kreykrekar: this.state.R_kreykrekar,
      koykartonkan: this.state.R_kartonakan,
      waznakan: this.state.R_koywaznkarton,
      date: this.state.R_date === "" ? Date.now : this.state.R_date,
      jwlla: "فرۆشتن",
      qazanjywasl: this.state.R_qazanjywasl,
      dateQazrz: this.state.R_kateQarz,
      qarzikonwakildolar: wakil ? Number(wakil.rejaDolar) : 0,
      qarzikonwakildinar: wakil ? Number(wakil.rejaDinar) : 0,
      paradnPechawana: !isNaN(this.state.R_paradanPechawana)
        ? this.state.R_paradanPechawana
        : 0,
      joripara_dolar: this.state.R_Nrx_J_T_check,
      joripara_IQD: this.state.R_Nrx_IQD_check,
      R_Mufrad_check: this.state.R_Mufrad_check,
      R_Item_check: this.state.R_Item_check,
      DolarPrice: this.state.navdolar,
      FIB: this.state.FIB,
      cash: this.state.cash,
      owe: this.state.owe
    };
    await Instance.post(`/api/v1/newSale`, data)
      .then((res) => {
        this.GetRasidNEWOfWakil();
        localStorage.removeItem("item");
        this.setState(
          {
            R_save: true,
            R_zh_wasl: Number(res.data.data.numberofwasl),
            W_raseddenar: 0,
            W_raseddolar: 0,
            R_wasl: res.data.data,
            R_paraywasl:
              res.data.data.joripara === "دۆلار"
                ? res.data.data.qarzinwedolar
                : res.data.data.qarzinwedinar,
            R_del_dis: true,
            R_up_froshtn: res.data.data.froshtn,
            R_date: res.data.data.date,
            R_togler: false,
            R_rasidWakildinar: Number(res.data.data.qarzikonwakildinar),
            R_rasidWakildolar: Number(res.data.data.qarzikonwakildolar),
            R_zh_wasl_katy: Number(res.data.data.numberofwasl) + 1,
            R_table: false,
            R_open: null,
            R_zhmara: "",
            R_zhmarasht: "",
            R_naweSht: "",
            R_karton: "",
            R_darzan: "",
            R_search: null,
            R_rezha: 0,
            R_nrx: 0,
            R_addToTable: false
          },
          async () => {
            this.R_koyqazanjywasll();
          }
        );
      })
      .catch((err) => {
        swal({
          title: "تەواو",
          text: "پسولە سورکەوتوو بوو!",
          icon: "success",
          timer: 300,
          buttons: false
        });
      });
  };

  ///// get Rent Data
  getRenttableData = async (table) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/getSaleTable/${table._id}`, config);

    this.setState({
      R_dataRent: res.data.sales.saleTable
    });
  };
  getWaslakan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/getSaleakan`, config);

    this.setState({
      R_zh_wasl_katy: res.data.zhmara,
      R_page: res.data.zhmara,
      IT_no_invoice: res.data.zhmara
    });
  };
  setRnew = () => {
    this.setState({ R_nwe: null });
  };
  ////// radio change
  A_OpenModal = async (e, userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const { value: text } = await Swal.fire({
      input: "password",
      inputLabel: "Password",
      showLoaderOnConfirm: true,
      inputPlaceholder: "وشەی نهێنی داخیل بکە...",
      inputAttributes: {
        "aria-label": "وشەی نهێنی داخیل بکە"
      },
      showCancelButton: true
    });
    if (text === undefined) {
      this.setState(() => {
        return {
          A_openmodel: false
        };
      });
    }
    const data = {
      password: text
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data, config);

    if (pass.data.status === false) {
      this.setState(() => {
        return {
          A_openmodel: false
        };
      });
    } else if (pass.data.status === true) {
      this.setState(() => {
        return {
          A_openmodel: true
        };
      });
    }
  };
  radiochange = (e) => {
    const value = e.target.value;

    if (value === "6") {
      this.setState({
        A_role: "user"
      });
    } else if (value === "7") {
      this.setState({
        A_role: "admin"
      });
    } else if (value === "8") {
      this.setState({
        A_role: "ipad"
      });
    } else if (value === "9") {
      this.setState({
        A_role: "ipadadmin"
      });
    }
  };
  // NrxeRent ba Deare Krdne Darzan
  nrxRent = (darzan, carton) => {
  
    const nrxDollar = Number(this.state.R_nrx_dolar);
    const nrxDinar = Number(this.state.R_nrx_dinarr);


    let nrx = nrxDollar; // Default

    if (this.state.R_joripara === "دینار") {
        nrx = nrxDinar;
    }

    return Number(nrx);
  };

  // KoyGshty Rent ba DOLAR$$$
  R_getkoygahty = (darzan, karton) => {
    const nrx = Number(this.state.R_nrx);
    let koygshty = Number(darzan) * nrx;

    return Number(Number(koygshty).toFixed(2));
  };
  ///////saerch  in Table Rent
  // {**************saerch***************}
  ////// search product
  getProductDataBySearchRent = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    //// hold on to the input that fired the search, the focus only leaves it
    //// once we know the code really belongs to a product
    const codeInput = e.target;
    const form = codeInput.form;
    const index = form
      ? Array.prototype.indexOf.call(form, codeInput)
      : -1;
    const focusNextInput = () => {
      if (form && index > 0 && form.elements[index - 1]) {
        form.elements[index - 1].focus();
      }
    };
    const stayInCodeInput = () => {
      if (codeInput) {
        codeInput.focus();
        if (codeInput.select) {
          codeInput.select();
        }
      }
    };

    if (this.state.R_zhmara === "") {
      // alert("ناتوانی بێ ژمارەی کاڵا گەڕان بکەی");
      stayInCodeInput();
    } else {
      let res;
      try {
        res = await Instance.get(
          `/api/v1/searchtoproduct?code=${this.state.R_zhmara}&&nameofproduct=`,
          config
        );
      } catch (error) {
        //// the code is not a product, keep the user where they are
        this.setState({ R_search: null, R_zhmara: "" }, stayInCodeInput);
        return;
      }

      const data = res.data.product;
      if (!data) {
        // alert("ببورە ئەم کاڵایە بونی نیە")
        this.setState(
          {
            R_search: null,
            R_zhmara: "",
            R_zhmarasht: "",
            R_naweSht: "",
            R_rezha: "",
            R_nrx_dolar: "",
            R_nrx_dinarr: "",
            R_nrx_dinarr2: "",
            R_nrx: "",
            R_nrx_niwkarton: "",
            R_nrx_kmtrdadarzan: "",
            R_Dolar2: "",
            R_Dinar2: "",
            R_rasidKarton: "",
            R_qazanj: "",
            R_kren: "",
            R_karton: "",
            R_darzan: ""
          },
          stayInCodeInput
        );
      } else {
        this.setState(() => {
          // Safe fallback values for null/undefined fields
          const saleDolar = data.saleDolar || 0;
          const saleDinar = data.saleDinar || 0;
          const nrxeFroshtnDenar2 = data.nrxeFroshtnDenar2 || 0;
          const nrxeFroshtnDolar2 = data.nrxeFroshtnDolar2 || 0;
          const saleOfLessTenDarzan = data.saleOfLessTenDarzan || 0;
          const saleOfLessHalfCarton = data.saleOfLessHalfCarton || 0;
          const singleSale = data.singleSale || 0;
          const price = data.price || 0;
          const numberOfDarzan = data.numberOfDarzan || 0;

          // Calculate R_nrx based on conditions
          let calculatedNrx;
          if (this.state.R_joripara === "دینار") {
            calculatedNrx = saleDinar;
          } else  {
            calculatedNrx = saleDolar;
          } 

          // Calculate R_qazanj
          let calculatedQazanj;
          if (this.state.R_joripara === "دینار") {
            const nrxToUse = !this.state.R_Nrx_IQD_check
              ? saleDinar
              : nrxeFroshtnDenar2;
            calculatedQazanj = (
              (this.dinartodolar(nrxToUse) - price) *
              numberOfDarzan
            ).toFixed(2);
          } else {
            const nrxToUse = !this.state.R_Nrx_J_T_check
              ? saleDolar
              : nrxeFroshtnDolar2;
            calculatedQazanj = _.multiply(
              _.subtract(nrxToUse, price),
              numberOfDarzan
            );
          }

          return {
            R_search: true,
            R_productId: data._id || "",
            R_zhmara: data.code || "",
            R_zhmarasht: data.productCode || "",
            R_naweSht: data.nameofproduct || "",
            R_rezha: numberOfDarzan,
            R_nrx_dolar: saleDolar,
            R_nrx_dinarr: saleDinar,
            R_nrx_dinarr2: nrxeFroshtnDenar2,
            R_nrx: calculatedNrx,
            R_nrx_niwkarton: saleOfLessHalfCarton,
            R_nrx_kmtrdadarzan: saleOfLessTenDarzan,
            R_Dolar2: nrxeFroshtnDolar2,
            R_Dinar2: nrxeFroshtnDenar2,
            R_rasidKarton: data.rasidKarton
              ? Number(
                  parseFloat(data.rasidKarton.toString().split("e-"))
                ).toFixed(2)
              : "0.00",
            R_qazanj: calculatedQazanj,
            R_kren: price,
            R_nrxkaton: (price * numberOfDarzan).toFixed(2),
            R_waznkarton: data.weight || 0,
            R_karton: "",
            R_darzan: "",
            R_dataProduct: data,
            R_nrximufrad: singleSale,
            R_dp: data.dp || "",
            R_singleSale: singleSale,
            // Add missing fields from API response
            R_barcode: data.barcode || "",
            R_isopen: data.isopen || false,
            R_is_in_progress: data.is_in_progress || false,
            R_Karton_price: data.Karton_price || 0,
            R_nrxifroshtnkarton: data.nrxifroshtnkarton || 0,
            R_status: data.status || "",
            R_dateEmpty: data.dateEmpty || ""
          };
        }, focusNextInput);
      }
    }
  };
  ////// search Wakil
  ///to another input in wakil search
  R_anotherInputWakil = (e) => {
    e.preventDefault();
    if (
      this.state.R_frosth === "فرۆشتنی ڕاستەوخۆ" ||
      this.state.R_frosth === null
    ) {
      const form = e.target.form;
      const index = Array.prototype.indexOf.call(form, e.target);
      form.elements[index - 1].focus();
    } else {
      const form = e.target.form;
      const index = Array.prototype.indexOf.call(form, e.target);
      window.document.getElementById("code_Sale").focus();
      this.getWakilDataBySearchRent(e);
    }
  };
  getWakilDataBySearchRent = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    if (
      this.state.R_frosth === "فرۆشتنی ڕاستەوخۆ" ||
      this.state.R_frosth.toString().length === 0
    ) {
      alert("ببورە جۆری فرۆشتن وەکیل نیە");
    } else {
      let search = {
        code: Number(this.state.R_zh_barez),
        Name: this.state.R_nawe_barez,
        phone: this.state.R_mob
      };
      const res = await Instance.post(
        `/api/v1/searchwakilBody`,
        search,
        config
      );

      const data = res.data.wakils;
      if (data === null) {
        alert("ببورە ئەم بەڕێزە بونی نیە");
        this.setState({
          R_zh_barez: 0,
          R_nawe_barez: "",
          R_mob: 0,
          R_rasidWakildolar: 0,
          R_rasidWakildinar: 0
        });
      } else {
        this.setState(() => {
          return {
            R_search_wakil: true,
            R_zh_barez: data.code,
            R_nawe_barez: data.Name,
            R_mob: data.phone,
            R_rasidWakildolar: Number(data.rejaDolar).toFixed(2),
            R_rasidWakildinar: Number(data.rejaDinar).toFixed(2)
          };
        });
      }
    }
  };

  setSearchEmptyRentWakil = (e) => {
    e.preventDefault();
    this.setState({
      R_search_wakil: null,
      R_zh_barez: 0,
      R_nawe_barez: "",
      R_mob: 0,
      R_rasidWakildolar: 0,
      R_rasidWakildinar: 0,
      W_wakelakanSearch: [],
      R_wakilSuggestions: [],
      R_wakilCursor: -1
    });
  };

  setSaletSearchEmty = (e) => {
    e.preventDefault();
    this.setState({
      R_zhmara: "",
      R_zhmarasht: "",
      R_naweSht: "",
      R_karton: "",
      R_darzan: "",
      R_search: null,
      R_rezha: 0,
      R_nrx: 0,
      R_dp: "",
      R_singleSale: 0
    });
  };
  ////datetogler
  inputtogler = () => {
    this.setState({
      R_togler: !this.state.R_togler,
      R_date: ""
    });
  };
  /////// saerch wasl
  getWaslDataBySearchRent = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchwasll?numberofwasl=${Number(this.state.R_zh_wasl)}`,
      config
    );
    const data = res.data.pswla;
    let wakil, rasiddolar, rasiddinar;
    if (data.type === 1) {
      let search = {
        code: Number(data.numberOfWakil)
      };
      const res = await Instance.post(
        `/api/v1/searchwakilBody`,
        search,
        config
      );
      wakil = res.data.wakils;
      rasiddinar = _.subtract(
        wakil && Number(wakil.rejaDinar),
        Number(data.qarzinwedinar)
      );
      rasiddolar = _.subtract(
        wakil && Number(wakil.rejaDolar),
        Number(data.qarzinwedolar)
      );
    }

    if (data === null) {
      alert("ببورە ئەم پسولەیە بونی نیە");
    } else {
      this.setState(
        () => {
          return {
            R_wasl: data,
            R_search_wasl: true,
            R_zh_wasl: data.numberofwasl,
            R_page: data.numberofwasl,
            R_nawe_barez: data.wakil,
            R_mob: data.phone,
            R_zh_barez: data.numberOfWakil,
            R_total: data.koalldolar,
            R_totalID: data.koalldinar,
            R_dashkan: data.dashkandolar,
            R_dashkanID: data.dashkandinar,
            R_dataTable: data.saleTable,
            R_joripara: data.joripara,
            R_frosth: data.froshtn,
            R_wargr: data.whossale,
            R_paraDanID: data.paraydrawdinar,
            R_paraDan$: data.paraydrawdolar,
            R_kartonakan: data.koykartonkan,
            R_kreysayara: data.kreysayra,
            R_kreykrekar: data.kreykrekar,
            R_koywaznkarton: data.waznakan,
            R_paraywasl:
              data.joripara === "دۆلار"
                ? data.qarzinwedolar
                : data.qarzinwedinar,
            R_del_dis: true,
            R_up_froshtn: data.froshtn,
            R_date: data.date,
            R_togler: false,
            R_open: null,
            R_rasidWakildinar: Number(rasiddinar) ? Number(rasiddinar) : 0,
            R_rasidWakildolar: Number(rasiddolar) ? Number(rasiddolar) : 0,
            R_kateQarz: data.dateQazrz,
            R_paradanPechawana: data.paradnPechawana,
            R_Nrx_J_T_check: data.joripara_dolar,
            R_Nrx_IQD_check: data.joripara_IQD,
            R_Mufrad_check: data.R_Mufrad_check,
            R_Item_check: data.R_Item_check,
            FIB: data.FIB,
            cash: data.cash,
            owe: data.owe
          };
        },
        () => {
          this.GetRasidNEWOfWakil();
        }
      );
    }
  };
  getWaslDataBySearchRent_ForOpenSale = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchwasll?numberofwasl=${Number(this.state.R_zh_wasl)}`,
      config
    );
    const data = res.data.pswla;
    let wakil, rasiddolar, rasiddinar;
    if (data.type === 1) {
      let search = {
        code: Number(data.numberOfWakil)
      };
      const res = await Instance.post(
        `/api/v1/searchwakilBody`,
        search,
        config
      );
      wakil = res.data.wakils;
      rasiddinar = _.subtract(
        wakil && Number(wakil.rejaDinar),
        Number(data.qarzinwedinar)
      );
      rasiddolar = _.subtract(
        wakil && Number(wakil.rejaDolar),
        Number(data.qarzinwedolar)
      );
    }

    if (data === null) {
      alert("ببورە ئەم پسولەیە بونی نیە");
    } else {
      this.setState(
        () => {
          return {
            R_wasl: data,
            R_zh_wasl: data.numberofwasl,
            R_page: data.numberofwasl,
            R_nawe_barez: data.wakil,
            R_mob: data.phone,
            R_zh_barez: data.numberOfWakil,
            R_total: data.koalldolar,
            R_totalID: data.koalldinar,
            R_dashkan: data.dashkandolar,
            R_dashkanID: data.dashkandinar,
            R_dataTable: data.saleTable,
            R_joripara: data.joripara,
            R_frosth: data.froshtn,
            R_wargr: data.whossale,
            R_paraDanID: data.paraydrawdinar,
            R_paraDan$: data.paraydrawdolar,
            R_kartonakan: data.koykartonkan,
            R_kreysayara: data.kreysayra,
            R_kreykrekar: data.kreykrekar,
            R_koywaznkarton: data.waznakan,
            R_paraywasl:
              data.joripara === "دۆلار"
                ? data.qarzinwedolar
                : data.qarzinwedinar,
            R_up_froshtn: data.froshtn,
            R_date: data.date,
            R_rasidWakildinar: Number(rasiddinar) ? Number(rasiddinar) : 0,
            R_rasidWakildolar: Number(rasiddolar) ? Number(rasiddolar) : 0,
            R_kateQarz: data.dateQazrz,
            R_paradanPechawana: data.paradnPechawana,
            R_Nrx_J_T_check: data.joripara_dolar,
            R_Nrx_IQD_check: data.joripara_IQD,
            R_Mufrad_check: data.R_Mufrad_check,
            R_Item_check: data.R_Item_check,
            FIB: data.FIB,
            cash: data.cash,
            owe: data.owe
          };
        },
        () => {
          this.GetRasidNEWOfWakil();
        }
      );
    }
  };
  //////Rent pagination
  R_pageplusone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page = this.state.R_page + 1;
      const res = await Instance.get(
        `/api/v1/salepage?page=${page}&limit=1`,
        config
      );
      this.setSaletSearchEmty(e);
      const data = res.data.sales;
      let wakil, rasiddolar, rasiddinar;
      if (data.type === 1) {
        let search = {
          code: Number(data.numberOfWakil)
        };
        const res = await Instance.post(
          `/api/v1/searchwakilBody`,
          search,
          config
        );
        wakil = res.data.wakils;
        rasiddinar = _.subtract(
          wakil && Number(wakil.rejaDinar),
          Number(data.qarzinwedinar)
        );
        rasiddolar = _.subtract(
          wakil && Number(wakil.rejaDolar),
          Number(data.qarzinwedolar)
        );
      }
      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState(
          () => {
            return {
              R_page: res.data.page,
              R_wasl: data,
              R_search_wasl: true,
              R_zh_wasl: data.numberofwasl,
              R_nawe_barez: data.wakil,
              R_mob: data.phone,
              R_zh_barez: data.numberOfWakil,
              R_total: data.koalldolar,
              R_totalID: data.koalldinar,
              R_dashkan: data.dashkandolar,
              R_dashkanID: data.dashkandinar,
              R_dataTable: data.saleTable,
              R_joripara: data.joripara,
              R_frosth: data.froshtn,
              R_wargr: data.whossale,
              R_paraDanID: data.paraydrawdinar,
              R_paraDan$: data.paraydrawdolar,
              R_kartonakan: data.koykartonkan,
              R_kreysayara: data.kreysayra,
              R_kreykrekar: data.kreykrekar,
              R_koywaznkarton: data.waznakan,
              R_paraywasl:
                data.joripara === "دۆلار"
                  ? data.qarzinwedolar
                  : data.qarzinwedinar,
              R_del_dis: true,
              R_up_froshtn: data.froshtn,
              R_date: data.date,
              R_togler: false,
              R_WakilQard_isChecked: false,
              R_isChecked: false,
              R_rasidWakildinar: Number(rasiddinar) ? Number(rasiddinar) : 0,
              R_rasidWakildolar: Number(rasiddolar) ? Number(rasiddolar) : 0,
              R_kateQarz: data.dateQazrz !== "" ? data.dateQazrz : "",
              R_paradanPechawana: data.paradnPechawana,
              R_Nrx_J_T_check: data.joripara_dolar,
              R_Nrx_IQD_check: data.joripara_IQD,
              R_Mufrad_check: data.R_Mufrad_check,
              R_Item_check: data.R_Item_check,
              FIB: data.FIB,
              cash: data.cash,
              owe: data.owe
            };
          },
          () => {
            this.GetRasidNEWOfWakil();
          }
        );
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };
  R_pageminsone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page = this.state.R_page - 1;
      const res = await Instance.get(
        `/api/v1/salepage?page=${page}&limit=1`,
        config
      );
      this.setSaletSearchEmty(e);
      const data = res.data.sales;
      let wakil, rasiddolar, rasiddinar;
      if (data.type === 1) {
        let search = {
          code: Number(data.numberOfWakil)
        };
        const res = await Instance.post(
          `/api/v1/searchwakilBody`,
          search,
          config
        );
        wakil = res.data.wakils;
        rasiddinar = _.subtract(
          wakil && Number(wakil.rejaDinar),
          Number(data.qarzinwedinar)
        );
        rasiddolar = _.subtract(
          wakil && Number(wakil.rejaDolar),
          Number(data.qarzinwedolar)
        );
      }
      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState(
          () => {
            return {
              R_page: res.data.page,
              R_wasl: data,
              R_search_wasl: true,
              R_zh_wasl: data.numberofwasl,
              R_nawe_barez: data.wakil,
              R_mob: data.phone,
              R_zh_barez: data.numberOfWakil,
              R_total: data.koalldolar,
              R_totalID: data.koalldinar,
              R_dashkan: data.dashkandolar,
              R_dashkanID: data.dashkandinar,
              R_dataTable: data.saleTable,
              R_joripara: data.joripara,
              R_frosth: data.froshtn,
              R_wargr: data.whossale,
              R_paraDanID: data.paraydrawdinar,
              R_paraDan$: data.paraydrawdolar,
              R_kartonakan: data.koykartonkan,
              R_kreysayara: data.kreysayra,
              R_kreykrekar: data.kreykrekar,
              R_koywaznkarton: data.waznakan,
              R_paraywasl:
                data.joripara === "دۆلار"
                  ? data.qarzinwedolar
                  : data.qarzinwedinar,
              R_del_dis: true,
              R_up_froshtn: data.froshtn,
              R_date: data.date,
              R_togler: false,
              R_WakilQard_isChecked: false,
              R_isChecked: false,
              R_rasidWakildinar: Number(rasiddinar) ? Number(rasiddinar) : 0,
              R_rasidWakildolar: Number(rasiddolar) ? Number(rasiddolar) : 0,
              R_kateQarz: data.dateQazrz !== "" ? data.dateQazrz : "",
              R_paradanPechawana: data.paradnPechawana,
              R_Nrx_J_T_check: data.joripara_dolar,
              R_Nrx_IQD_check: data.joripara_IQD,
              R_Mufrad_check: data.R_Mufrad_check,
              R_Item_check: data.R_Item_check,
              FIB: data.FIB,
              cash: data.cash,
              owe: data.owe
            };
          },
          () => {
            this.GetRasidNEWOfWakil();
          }
        );
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };
  // {*****************************}
  ////// koygshty
  R_getkartonakan = () => {
    let subTotal = 0;
    this.state.R_dataTable.map((item) => (subTotal += Number(item.carton)));
    const cartTotals = Number(subTotal).toFixed(2);
    this.setState(() => {
      return {
        R_kartonakan: cartTotals
      };
    });
  };
  R_koyqazanjywasll = () => {
    let subTotal = 0;
    let arr = [];
    this.state.R_dataTable.map((el) => (arr = [...arr, el.qazanj]));
    const sum = arr.reduce((accumulator, current) => {
      return accumulator + current;
    }, subTotal);

    this.setState(
      {
        R_qazanjywasl: Number(sum).toFixed(2)
      },
      () => {}
    );
  };
  R_waznkartonakan = () => {
    let subTotal = 0;
    this.state.R_dataTable.map(
      (item) => (subTotal += Number(item.wazn) * Number(item.carton))
    );
    const wazns = Number(Number(subTotal).toFixed(2));

    this.setState(() => {
      return {
        R_koywaznkarton: wazns
      };
    });
  };
  R_getALLkoygshty = () => {
    if (this.state.R_kreykrekar > 0 || this.state.R_kreysayara > 0) {
      let subTotal = 0;
      let koykre =
        Number(this.state.R_kreysayara) + Number(this.state.R_kreykrekar);
      this.state.R_dataTable.map((item) => (subTotal += item.kodolar));
      const cartTotals = Number(Number(subTotal).toFixed(2));
      this.setState(() => {
        return {
          R_total: cartTotals + koykre
        };
      });
    } else {
      let subTotal = 0;
      this.state.R_dataTable.map((item) => (subTotal += item.kodolar));
      const cartTotals = Number(Number(subTotal).toFixed(2));
      this.setState(() => {
        return {
          R_total: cartTotals
        };
      });
    }
  };

  R_getALLkoygshtyID = () => {
    if (this.state.R_kreykrekar > 0 || this.state.R_kreysayara > 0) {
      let subTotal = 0;
      let koykre =
        Number(this.state.R_kreysayara) + Number(this.state.R_kreykrekar);
      this.state.R_dataTable.map((item) => (subTotal += Number(item.kodinar)));
      const cartTotals = Number(Number(subTotal).toFixed(2));
      this.setState(() => {
        return {
          R_totalID: cartTotals + koykre
        };
      });
    } else {
      let subTotal = 0;
      this.state.R_dataTable.map((item) => (subTotal += Number(item.kodinar)));
      const cartTotals = Number(Number(subTotal).toFixed(2));
      this.setState(() => {
        return {
          R_totalID: cartTotals
        };
      });
    }
  };

  R_kamkrdnawayNrx$ = () => {
    const dashkan = _.subtract(
      Number(this.state.R_total),
      Number(this.state.R_dashkan)
    );
    if (Number.isInteger(Number(dashkan))) {
      return Number(dashkan) !== 0 ? Number(dashkan) : 0;
    } else {
      return Number(dashkan) !== 0 ? Number(dashkan).toFixed(2) : 0;
    }
  };

  R_kamkrdnawayNrxID = () => {
    const dashkanID = _.subtract(
      Number(this.state.R_totalID),
      Number(this.state.R_dashkanID)
    );
    if (Number.isInteger(Number(dashkanID))) {
      return Number(dashkanID) !== 0 ? Number(dashkanID) : 0;
    } else {
      return Number(dashkanID) !== 0 ? Number(dashkanID).toFixed(2) : 0;
    }
  };

  R_waslKrdn = () => {
    if (this.state.R_dashkan === 0 || this.state.R_dashkan === "") {
      const paradan = parseFloat(
        this.state.R_paraDan$.toString().replace(/,/g, "")
      );
      const wasl = _.subtract(Number(this.state.R_total), paradan);
      if (Number.isInteger(Number(wasl))) {
        return Number(wasl) !== 0 ? Number(wasl) : 0;
      } else {
        return Number(wasl) !== 0 ? Number(wasl).toFixed(2) : 0;
      }
    } else if (this.state.R_dashkan !== 0 && this.state.R_dashkan !== "") {
      const paradan = parseFloat(
        this.state.R_paraDan$.toString().replace(/,/g, "")
      );
      const wasl = _.subtract(Number(this.R_kamkrdnawayNrx$()), paradan);
      if (Number.isInteger(Number(wasl))) {
        return Number(wasl) !== 0 ? Number(wasl) : 0;
      } else {
        return Number(wasl) !== 0 ? Number(wasl).toFixed(2) : 0;
      }
    }
  };

  R_waslKrdnID = () => {
    if (this.state.R_dashkanID === 0 || this.state.R_dashkanID === "") {
      const paradan = parseFloat(
        this.state.R_paraDanID.toString().replace(/,/g, "")
      );
      const wasl = _.subtract(Number(this.state.R_totalID), paradan);
      if (Number.isInteger(Number(wasl))) {
        return Number(wasl) !== 0 ? Number(wasl) : 0;
      } else {
        return Number(wasl) !== 0 ? Number(wasl).toFixed(2) : 0;
      }
    } else if (this.state.R_dashkanID !== 0 && this.state.R_dashkanID !== "") {
      const paradan = parseFloat(
        this.state.R_paraDanID.toString().replace(/,/g, "")
      );
      const wasl = _.subtract(Number(this.R_kamkrdnawayNrxID()), paradan);
      if (Number.isInteger(Number(wasl))) {
        return Number(wasl) !== 0 ? Number(wasl) : 0;
      } else {
        return Number(wasl) !== 0 ? Number(wasl).toFixed(2) : 0;
      }
    }
  };

  // {*****************************}
  // Wakel Context Functions
  setWakilEmpty = (e) => {
    e.preventDefault();
    this.setState({
      ...this.state,
      W_mob_Wakel: 0,
      W_naw: "",
      W_nawneshan: "",
      W_raseddolar: 0,
      W_raseddenar: 0,
      W_code: 0
    });
    this.W_ClearError();
  };
  W_tofirstInput = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 3].focus();
    this.onSaveWakel(e);
  };
  onSaveWakel = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    try {
      if (
        this.state.W_code === 0 ||
        this.state.W_mob_Wakel === 0 ||
        this.state.W_naw === ""
      ) {
        swal({
          title: "ببورە",
          text: "تکایە خانەکان پڕبکەرەوە",
          icon: "error"
        });
      }
      let data;
      data = {
        code: this.state.W_code,
        Name: this.state.W_naw,
        phone: this.state.W_mob_Wakel,
        rejaDolar: 0,
        rejaDinar: 0,
        adress: this.state.W_nawneshan
      };
      const res = await Instance.post("/api/v1/newWakil", data, config);
      swal({
        title: "دەست خۆش",
        text: "وەکیلێکی نوێت زیادکرد",
        icon: "success"
      });
      this.setState({
        W_dataWakel: [...this.state.W_dataWakel, res.data.newWakil]
      });
      this.W_ClearError();
      this.setWakilEmpty(e);
    } catch (error) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    }
  };
  ///// Wakil Clear Error
  W_ClearError = () => {
    this.setState({ W_error: null });
  };
  // delete wakel
  clickOnDeleteWakel = async (id) => {
    this.setState({
      W_dataWakel: this.state.W_dataWakel.filter((r) => r._id !== id)
    });
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    await Instance.delete(`/api/v1/deleteWakil/${id}`, config);
  };
  ////// wakil tabel data
  getWakiltableData = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/getWakilakan`, config);

    this.setState({
      W_dataWakel: res.data.wakilakan
    });
  };
  /////// rasid dolar
  getRasidDolar = async (NOW) => {
    let data;
    if (this.state.R_paraDan$ !== "") {
      data = {
        rejaDolar:
          Number(this.state.R_rasidWakildolar) + Number(this.R_waslKrdn())
      };
    } else if (this.state.R_paraDan$ === "") {
      data = {
        rejaDolar:
          Number(this.state.R_rasidWakildolar) +
          Number(this.R_kamkrdnawayNrx$())
      };
    }

    this.updateRasid(NOW, data);
  };
  ////
  getRasiddinar = async (NOW) => {
    let data;
    if (this.state.R_paraDanID !== "") {
      data = {
        rejaDinar:
          Number(this.state.R_rasidWakildinar) + Number(this.R_waslKrdnID())
      };
    } else if (this.state.R_paraDanID === "") {
      data = {
        rejaDinar:
          Number(this.state.R_rasidWakildinar) +
          Number(this.R_kamkrdnawayNrxID())
      };
    }
    this.updateRasid(NOW, data);
  };

  updateRasid = async (NOW, data) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      if (this.state.R_joripara === "دۆلار") {
        const update = await Instance.put(
          `/api/v1/rejadolar?code=${NOW}`,
          data,
          config
        );

        this.setState({
          W_raseddolar: update.data.dolar.rejaDolar
        });
      } else if (this.state.R_joripara === "دینار") {
        const update = await Instance.put(
          `/api/v1/rejadinar?code=${NOW}`,
          data,
          config
        );

        this.setState({
          W_raseddenar: update.data.dinar.rejaDinar
        });
      }
    } catch (error) {
      if (this.state.R_frosth === "فرۆشتنی وەکیل") {
        alert("کێشە هەیە لەژمارەی ئەم وەکیلە");
      }
    }
  };
  SearchWakil = (e) => {
    this.setState({
      W_search: e.target.value
    });
  };
  ////// update
  updtae_Wakil = async (e, wakil) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    let data;
    data = {
      code: this.state.W_code,
      Name: this.state.W_naw,
      phone: this.state.W_mob_Wakel,
      adress: this.state.W_nawneshan
    };
    const res = await Instance.put(
      `/api/v1/updateWakil/${wakil._id}`,
      data,
      config
    );

    this.setState({
      W_dataWakel: this.state.W_dataWakel.map((wakil) =>
        wakil._id === res.data.update._id ? res.data.update : wakil
      )
    });
    swal({
      title: "تەواو",
      text: "پسولە سورکەوتوو بوو!",
      icon: "success",
      timer: 1500
    });
    this.clear_edit(e);
  };
  //// get wakilakna
  W_getwakelakan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/getWakilakan`, config);

    this.setState({
      W_wakelakan: res.data.wakilakan
    });
  };

  W_SearchWakil = async (name) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(
      `/api/v1/SearchNameWakil?name=${this.state.R_nawe_barez}`,
      config
    );
    this.setState({
      W_wakelakanSearch: res.data.wakils,
      R_wakilSuggestions: res.data.wakils || [],
      R_wakilCursor: -1
    });
  };

  WakilNameHandle = (e) => {
    this.setState(
      {
        R_nawe_barez: e.target.value
      },
      () => {
        if (
          !this.state.R_nawe_barez ||
          this.state.R_nawe_barez === "" ||
          this.state.R_nawe_barez === null
        ) {
          this.setState({
            W_wakelakanSearch: [],
            R_wakilSuggestions: [],
            R_wakilCursor: -1
          });
        } else {
          this.W_SearchWakil();
        }
      }
    );
  };

  //// close the wakil name suggestion list
  R_emptyWakilSuggestions = () => {
    this.setState({
      R_wakilSuggestions: [],
      R_wakilCursor: -1
    });
  };

  //// pick a wakil from the suggestion list -> code + name + phone (+ rasid)
  R_wakilSuggestionSelected = (wakil) => {
    if (!wakil) {
      return;
    }
    this.setState(
      {
        R_search_wakil: true,
        R_zh_barez: wakil.code,
        R_nawe_barez: wakil.Name,
        R_mob: wakil.phone,
        R_rasidWakildolar: Number(wakil.rejaDolar).toFixed(2),
        R_rasidWakildinar: Number(wakil.rejaDinar).toFixed(2),
        W_wakelakanSearch: [],
        R_wakilSuggestions: [],
        R_wakilCursor: -1
      },
      () => {
        //// same jump as the Enter search: straight to the product code
        const codeInput = window.document.getElementById("code_Sale");
        if (codeInput) {
          codeInput.focus();
        }
      }
    );
  };

  //// arrow up/down moves inside the list, Enter picks the highlighted wakil.
  //// While nothing is highlighted (R_wakilCursor === -1) Enter keeps its old
  //// behaviour and falls through to R_anotherInputWakil.
  R_wakilListKeydown = (e) => {
    const { R_wakilSuggestions, R_wakilCursor } = this.state;
    if (!R_wakilSuggestions || R_wakilSuggestions.length === 0) {
      return;
    }
    if (e.keyCode === 27) {
      this.R_emptyWakilSuggestions();
      return;
    }
    if (e.keyCode === 40) {
      e.preventDefault();
      this.setState((prevState) => ({
        R_wakilCursor:
          prevState.R_wakilCursor < R_wakilSuggestions.length - 1
            ? prevState.R_wakilCursor + 1
            : prevState.R_wakilCursor
      }));
    } else if (e.keyCode === 38) {
      e.preventDefault();
      this.setState((prevState) => ({
        R_wakilCursor:
          prevState.R_wakilCursor > 0
            ? prevState.R_wakilCursor - 1
            : prevState.R_wakilCursor
      }));
    } else if (e.keyCode === 13 && R_wakilCursor >= 0) {
      e.preventDefault();
      this.R_wakilSuggestionSelected(R_wakilSuggestions[R_wakilCursor]);
    }
  };
  //// show rasid
  W_showrasid = async (e, userid) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    if (this.state.W_show === false) {
      const promp = prompt("وشەی نهێنی داخیل بکە");
      let data = {
        password: promp
      };
      const pass = await Instance.post(
        `api/v1/open?id=${userid}`,
        data,
        config
      );

      if (pass.data.status === false) {
        alert("وشەی نهێنی هەڵەیە");
      } else {
        this.setState({ W_show: !this.state.W_show }, () =>
          this.getWakiltableData()
        );
      }
    } else {
      this.setState({ W_show: !this.state.W_show });
    }
  };
  getWakilDataBySearchWakil = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    this.toanotherInput(e);
    const res = await Instance.get(
      `/api/v1/searchwakil?code=${Number(this.state.W_code)}&&Name=${
        this.state.W_naw
      }&&phone=${Number(this.state.W_mob_Wakel)}`,
      config
    );

    const data = res.data.wakils;
    if (data === null) {
    } else {
      alert("ئەم داخیل کردنە دووبارەیە");
    }
  };
  // end of Wakel Context Functions

  // {*****************************}
  // Context && function of Add User
  onSaveAddUser = async (e) => {
    // if(this.state.A_bakarhenar==='' || this.state.A_zh_mobile===0 ){
    //     return false
    // }
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let data;
      data = {
        name: this.state.A_bakarhenar,
        password: this.state.A_password,
        role: this.state.A_role,
        phone: this.state.A_zh_mobile,
        passwordCheck: this.state.A_passCheck
      };
      const res = await Instance.post("/api/v1/createuser", data, config);

      this.setState({
        A_addUserData: [...this.state.A_addUserData, res.data.newUser]
      });
      this.setState({
        A_bakarhenar: "",
        A_password: "",
        A_role: ""
      });
    } catch (error) {
      this.setState({
        A_error: { msg: "تکایە خانەکان پڕبکەوە" }
      });
    }
  };
  ////// User tabel data
  getUsertableData = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/getusers`, config);
    this.setState({
      A_addUserData: res.data.users
    });
  };
  clickOnDeleteAddUser = async (id) => {
    this.setState({
      A_addUserData: this.state.A_addUserData.filter((r) => r._id !== id)
    });
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    await Instance.delete(`/api/v1/deleteUserById/${id}`, config);
  };
  updtae_User = async (e, user) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    let data;
    data = {
      name: this.state.A_bakarhenar,
      role: this.state.A_role,
      phone: this.state.A_zh_mobile
    };
    const res = await Instance.put(
      `/api/v1/updateUserById/${user._id}`,
      data,
      config
    );

    this.setState({
      A_addUserData: this.state.A_addUserData.map((user) =>
        user._id === res.data.update._id ? res.data.update : user
      )
    });

    data = {
      passwordCurrent: this.state.A_password,
      password: this.state.A_newPassword,
      passwordCheck: this.state.A_passCheck
    };
    await Instance.patch(
      `/api/v1/updateUserPassword/${user._id}`,
      data,
      config
    );

    this.clear_edit(e);
  };

  // end of Context && function of Add User

  // {*****************************}
  ////update password
  onUpdatePassword = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      if (this.state.U_newPassword !== this.state.U_newPassword2) {
        alert("وشەی نهێنی دوەم هەڵەیە");
      } else {
        const data = {
          passwordCurrent: this.state.U_currentpasword,
          password: this.state.U_newPassword
        };
        await Instance.patch(`/api/v1/updateUserPassword`, data, config);
        this.setState({
          U_save: true,
          U_newPassword: "",
          U_newPassword2: "",
          U_currentpasword: ""
        });
      }
    } catch (error) {
      alert("وشەی نهێنی کۆن هەڵەیە");
    }
  };

  AU_onUpdatePassword = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const data = {
        password: this.state.AU_newPassword
      };
      await Instance.put(`/api/v1/UpdatePassword`, data, config);
      this.setState({
        AU_save: true,
        AU_newPassword: ""
      });
    } catch (error) {
      alert("وشەی نهێنی کۆن هەڵەیە");
    }
  };
  U_ClearError = () => {
    this.setState({ U_error: null });
  };

  ////// show password function

  showpassword = () => {
    this.setState({ U_show: !this.state.U_show });
  };
  AU_showpassword = () => {
    this.setState({ AU_show: !this.state.AU_show });
  };

  //// setUsave
  labrdnisave = () => {
    this.setState({ U_save: false });
  };
  //////////// end

  ///////take money functions

  ////open para to update
  ////open para to update
  P_getPrint = () => {
    window.setTimeout("window.print()", 3500);
  };

  P_openUpdate = async (userid, e, id) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(
      `api/v1/OpenPara/${id}?id=${userid}`,
      data,
      config
    );

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      // Fetch wakil data first to get the correct debt values

      this.setState(
        {
          P_del_dis: null,
          P_open: true
        },
        async () => {
          ////// refresh krdnawa
          let datarefresh;
          datarefresh = {
            _id: id,
            zhmara: this.state.P_zhmara,
            wakilcode: this.state.P_zh_barez,
            namewakil: this.state.P_nawe_barez,
            paraywargirawdolar:
              this.state.P_joripara === "دۆلار"
                ? parseFloat(this.state.P_brePara.toString().replace(/,/g, ""))
                : 0,
            paraywargirawdinar:
              this.state.P_joripara === "دینار"
                ? parseFloat(this.state.P_brePara.toString().replace(/,/g, ""))
                : 0,
            kmkrdnawa: this.state.P_dashkan,
            paradwaykmkrdndolar:
              this.state.P_joripara === "دۆلار"
                ? this.state.P_dashkan > 0
                  ? this.P_kamkrdnawayNrx()
                  : this.bripara()
                : 0,
            paradwaykmkrdndinar:
              this.state.P_joripara === "دینار"
                ? this.state.P_dashkan > 0
                  ? this.P_kamkrdnawayNrx()
                  : this.bripara()
                : 0,
            nawiwargr: this.state.P_wargr,
            joripara: this.state.P_joripara,
            note: this.state.P_note,
            rasiddolar: this.state.P_qarzeKonDolar,
            rasiddinar: this.state.P_qarzeKonID,
            date: this.state.P_barwar
          };
          localStorage.setItem("paradata", JSON.stringify(datarefresh));
        }
      );
    }
  };

  DecimalNumber = (State) => {
    const num = Number(State);
    if (Number.isInteger(num)) return num;

    const str = Math.abs(num).toString();
    const decimalPart = str.split(".")[1] || "";

    let significantDigits = 0;
    let decimalPlaces = 0;

    for (let i = 0; i < decimalPart.length; i++) {
      decimalPlaces++;
      if (decimalPart[i] !== "0") {
        significantDigits++;
        if (significantDigits === 2) break;
      }
    }

    return num.toFixed(Math.max(2, decimalPlaces));
  };
  P_OnChangeBripara = (e) => {
    this.setState(
      {
        [e.target.name]:
          parseFloat(e.target.value.toString().replace(/,/g, "")) || 0
      },
      () => {
        let dashakn =
          parseFloat(this.state.P_dashkan.toString().replace(/,/g, "")) || 0;
        let paradan =
          parseFloat(this.state.P_brePara.toString().replace(/,/g, "")) || 0;

        if (this.state.P_joripara === "دینار") {
          this.setState({
            P_briparaypechawana: paradan !== 0 ? this.dinartodolar(paradan) : 0,
            P_qarzeKonID_: Number(
              _.subtract(this.state.P_qarzeKonID, _.add(paradan, dashakn))
            ).toFixed(2),
            P_pashDashkan:
              dashakn > 0 ? this.P_kamkrdnawayNrx() : this.bripara()
          });
        } else if (this.state.P_joripara === "دۆلار") {
          this.setState({
            P_briparaypechawana: paradan !== 0 ? this.dolartodinar(paradan) : 0,
            P_qarzeKonDolar_: Number(
              _.subtract(this.state.P_qarzeKonDolar, _.add(paradan, dashakn))
            ).toFixed(2),
            P_pashDashkan:
              dashakn > 0 ? this.P_kamkrdnawayNrx() : this.bripara()
          });
        } else {
          // When no currency is selected yet
          this.setState({
            P_briparaypechawana: 0,
            P_pashDashkan: 0
          });
        }
      }
    );
  };
  P_OnDolarChange = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value
      },
      () => {
        let dashakn =
          parseFloat(this.state.P_dashkan.toString().replace(/,/g, "")) || 0;
        let paradan =
          parseFloat(this.state.P_brePara.toString().replace(/,/g, "")) || 0;

        if (this.state.P_joripara === "دینار") {
          let remainingAfterPayment = Number(
            _.subtract(this.state.P_qarzeKonID, paradan)
          ).toFixed(2);
          this.setState({
            P_briparaypechawana: paradan !== 0 ? this.dinartodolar(paradan) : 0,
            P_qarzeKonID_: Number(
              _.subtract(remainingAfterPayment, dashakn)
            ).toFixed(2),
            P_pashDashkan:
              dashakn > 0
                ? Number(_.subtract(remainingAfterPayment, dashakn)).toFixed(2)
                : remainingAfterPayment
          });
        } else if (this.state.P_joripara === "دۆلار") {
          let remainingAfterPayment = Number(
            _.subtract(this.state.P_qarzeKonDolar, paradan)
          ).toFixed(2);
          this.setState({
            P_briparaypechawana: paradan !== 0 ? this.dolartodinar(paradan) : 0,
            P_qarzeKonDolar_: Number(
              _.subtract(remainingAfterPayment, dashakn)
            ).toFixed(2),
            P_pashDashkan:
              dashakn > 0
                ? Number(_.subtract(remainingAfterPayment, dashakn)).toFixed(2)
                : remainingAfterPayment
          });
        } else {
          // When no currency is selected yet
          this.setState({
            P_briparaypechawana: 0,
            P_pashDashkan: 0
          });
        }
      }
    );
  };
  P_calculateBripara = (e) => {
    this.setState(
      {
        [e.target.name]: parseFloat(e.target.value.toString().replace(/,/g, ""))
      },
      () => {
        let bripara =
          this.state.P_joripara === "دینار"
            ? this.dolartodinar(this.state.P_briparaypechawana)
            : this.dinartodolar(this.state.P_briparaypechawana);
        let dashakn = parseFloat(
          this.state.P_dashkan.toString().replace(/,/g, "")
        );
        let paradan = parseFloat(bripara.toString().replace(/,/g, ""));

        this.setState(
          {
            P_brePara: bripara
          },
          () => {
            if (this.state.P_joripara === "دینار" && this.state.P_brePara) {
              this.setState({
                P_qarzeKonID_: Number(
                  _.subtract(
                    Number(this.state.P_qarzeKonID),
                    _.add(Number(paradan), Number(dashakn))
                  )
                ).toFixed(2),
                P_pashDashkan:
                  this.state.P_dashkan > 0
                    ? this.P_kamkrdnawayNrx()
                    : this.bripara()
              });
            } else if (
              this.state.P_joripara === "دۆلار" &&
              this.state.P_brePara
            ) {
              this.setState({
                P_qarzeKonDolar_: Number(
                  _.subtract(
                    Number(this.state.P_qarzeKonDolar),
                    _.add(Number(paradan), Number(dashakn))
                  )
                ).toFixed(2),
                P_pashDashkan:
                  this.state.P_dashkan > 0
                    ? this.P_kamkrdnawayNrx()
                    : this.bripara()
              });
            }
          }
        );
      }
    );
  };
  //// open update and refresh

  P_onopenUpdateAndRefresh = (data) => {
    this.setState({
      P_search_wasl: true,
      P_zhmara: data.zhmara,
      P_nawe_barez: data.namewakil,
      P_barwar: data.date,
      P_zh_barez: data.wakilcode,
      P_paraPashDashkan:
        data.joripara === "دینار"
          ? data.paradwaykmkrdndinar
          : data.paradwaykmkrdndolar,
      P_dashkan: data.kmkrdnawa ? data.kmkrdnawa : 0,
      P_brePara:
        data.joripara === "دینار"
          ? data.paraywargirawdinar
          : data.paraywargirawdolar,
      P_joripara: data.joripara,
      P_wargr: data.nawiwargr,
      P_note: data.note,
      P_qarzeKonDolar: data.rasiddolar,
      P_qarzeKonID: data.rasiddinar,
      P_del_dis: null,
      P_paraywasl: data.paradwaykmkrdn,
      P_wasl: data,
      P_togler: false,
      P_open: true
    });
  };
  /// barwar toogle para watrgrtn

  P_inputtogler = (e) => {
    e.preventDefault();
    this.setState({
      P_togler: !this.state.P_togler,
      P_barwar: ""
    });
  };
  ///// loading para
  P_hideLoader = () => {
    this.setState({ P_loading: false });
  };

  P_showLoader = () => {
    this.setState({ P_loading: true });
  };
  ////save wasl para
  onSaveMoney = async (e) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    if (
      this.state.P_nawe_barez.toString().length === 0 ||
      this.state.P_zh_barez === 0 ||
      this.state.P_wargr === null ||
      this.state.P_brePara === 0 ||
      this.state.P_joripara === null 
    ) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    } else {
      let data;
      data = {
        wakilcode: this.state.P_zh_barez,
        namewakil: this.state.P_nawe_barez,
        paraywargirawdolar:
          this.state.P_joripara === "دۆلار"
            ? parseFloat(this.state.P_brePara.toString().replace(/,/g, ""))
            : 0,
        paraywargirawdinar:
          this.state.P_joripara === "دینار"
            ? parseFloat(this.state.P_brePara.toString().replace(/,/g, ""))
            : 0,
        kmkrdnawa: this.state.P_dashkan,
        paradwaykmkrdndolar:
          this.state.P_joripara === "دۆلار"
            ? this.state.P_dashkan > 0
              ? this.P_kamkrdnawayNrx()
              : this.bripara()
            : 0,
        paradwaykmkrdndinar:
          this.state.P_joripara === "دینار"
            ? this.state.P_dashkan > 0
              ? this.P_kamkrdnawayNrx()
              : this.bripara()
            : 0,
        nawiwargr: this.state.P_wargr,
        joripara: this.state.P_joripara,
        note: this.state.P_note,
        rasiddolar: this.state.P_qarzeKonDolar,
        rasiddinar: this.state.P_qarzeKonID,
        date: this.state.P_barwar === "" ? Date.now : this.state.P_barwar,
        jwlla: "پارەوەرگرتن",
        parayPechawana: this.state.P_briparaypechawana,
        cash: this.state.M_cash,
        FIB: this.state.M_FIB
      };
      const res = await Instance.post("/api/v1/newPara", data, config);
      this.P_showLoader();

      if (res) {
        this.P_hideLoader();
      }
      this.setState(
        {
          P_save: true,
          P_zhmara: res.data.wargrtn.zhmara,
          P_barwar: res.data.wargrtn.date,
          P_del_dis: true,
          P_paraywasl: res.data.wargrtn.paradwaykmkrdn,
          P_wasl: res.data.wargrtn,
          P_togler: false,
          P_wakilSearch: false
        },
        async () => {}
      );
    }
  };
  ////// update Mony
  updtate_para = async (e, para, NOW) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    try {
      if (
        !this.state.P_nawe_barez
      ) {
        swal({
          title: "ببورە",
          text: "تکایە خانەکان پڕبکەرەوە",
          icon: "error"
        });
      } else {
        let data;
        data = {
          wakilcode: this.state.P_zh_barez,
          namewakil: this.state.P_nawe_barez,
          paraywargirawdolar:
            this.state.P_joripara === "دۆلار"
              ? parseFloat(this.state.P_brePara.toString().replace(/,/g, ""))
              : 0,
          paraywargirawdinar:
            this.state.P_joripara === "دینار"
              ? parseFloat(this.state.P_brePara.toString().replace(/,/g, ""))
              : 0,
          kmkrdnawa: this.state.P_dashkan,
          paradwaykmkrdndolar:
            this.state.P_joripara === "دۆلار"
              ? this.state.P_dashkan > 0
                ? this.P_kamkrdnawayNrx()
                : this.bripara()
              : 0,
          paradwaykmkrdndinar:
            this.state.P_joripara === "دینار"
              ? this.state.P_dashkan > 0
                ? this.P_kamkrdnawayNrx()
                : this.bripara()
              : 0,
          nawiwargr: this.state.P_wargr,
          joripara: this.state.P_joripara,
          note: this.state.P_note,
          rasiddolar: this.state.P_qarzeKonDolar,
          rasiddinar: this.state.P_qarzeKonID,
          date: this.state.P_barwar,
          parayPechawana: this.state.P_briparaypechawana,
          cash: this.state.M_cash,
          FIB: this.state.M_FIB
        };
        await Instance.put(`/api/v1/updatepara/${para._id}`, data, config);

        localStorage.removeItem("paradata");

        this.setState(
          {
            P_open: null,
            P_del_dis: true,
            P_togler: false
          },
          async () => {
            swal({
              title: "تەواو",
              text: "پسولە سورکەوتوو بوو!",
              icon: "success",
              timer: 2000
            });
          }
        );
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    }
  };
  ////search name of wakil
  getWakilDataBySearchMoney = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchwakil?code=${this.state.P_zh_barez}&&Name=${this.state.P_nawe_barez}`,
      config
    );

    const data = res.data.wakils;
    if (data === null) {
      alert("ببورە ئەم بەڕێزە بونی نیە");
    } else {
      this.setState(
        () => {
          return {
            P_zh_barez: data.code,
            P_nawe_barez: data.Name,
            P_qarzeKonDolar: Number(data.rejaDolar).toFixed(2),
            P_qarzeKonID: Number(data.rejaDinar).toFixed(2),
            P_wakilSearch: true
          };
        },
        () => {
          this.P_recalcAfterWakil();
        }
      );
    }
  };

  //// recalculate the money totals once a wakil got loaded, no matter if the
  //// wakil came from the code search or from the name suggestion list
  P_recalcAfterWakil = () => {
    let dashakn =
      parseFloat(this.state.P_dashkan.toString().replace(/,/g, "")) || 0;
    let paradan =
      parseFloat(this.state.P_brePara.toString().replace(/,/g, "")) || 0;

    if (this.state.P_joripara === "دینار") {
      this.setState({
        P_briparaypechawana: paradan !== 0 ? this.dinartodolar(paradan) : 0,
        P_qarzeKonID_: Number(
          _.subtract(this.state.P_qarzeKonID, _.add(paradan, dashakn))
        ).toFixed(2),
        P_pashDashkan: dashakn > 0 ? this.P_kamkrdnawayNrx() : this.bripara()
      });
    } else if (this.state.P_joripara === "دۆلار") {
      this.setState({
        P_briparaypechawana: paradan !== 0 ? this.dolartodinar(paradan) : 0,
        P_qarzeKonDolar_: Number(
          _.subtract(this.state.P_qarzeKonDolar, _.add(paradan, dashakn))
        ).toFixed(2),
        P_pashDashkan: dashakn > 0 ? this.P_kamkrdnawayNrx() : this.bripara()
      });
    } else {
      // When no currency is selected yet
      this.setState({
        P_briparaypechawana: 0,
        P_pashDashkan: 0
      });
    }
  };

  //////// name search of the wakil inside پارە وەرگرتن ////////
  //// every keystroke in the ناوی بەرێز input asks the server for the wakils
  //// whose name contains what got typed so far
  P_searchWakilByName = async (name) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/SearchNameWakil?name=${encodeURIComponent(name)}`,
        config
      );
      this.setState({
        P_wakilSuggestions: res.data.wakils || [],
        P_wakilCursor: -1
      });
    } catch (error) {
      this.setState({ P_wakilSuggestions: [], P_wakilCursor: -1 });
    }
  };

  P_wakilNameHandle = (e) => {
    const name = e.target.value;
    this.setState({ P_nawe_barez: name }, () => {
      if (!name || name === "") {
        this.P_emptyWakilSuggestions();
      } else {
        this.P_searchWakilByName(name);
      }
    });
  };

  P_emptyWakilSuggestions = () => {
    this.setState({
      P_wakilSuggestions: [],
      P_wakilCursor: -1
    });
  };

  //// clicking (or pressing Enter on) a name loads the whole wakil detail
  P_wakilSuggestionSelected = (wakil) => {
    if (!wakil) {
      return;
    }
    this.setState(
      {
        P_zh_barez: wakil.code,
        P_nawe_barez: wakil.Name,
        P_qarzeKonDolar: Number(wakil.rejaDolar).toFixed(2),
        P_qarzeKonID: Number(wakil.rejaDinar).toFixed(2),
        P_wakilSearch: true,
        P_wakilSuggestions: [],
        P_wakilCursor: -1
      },
      () => {
        this.P_recalcAfterWakil();
        const amount = window.document.getElementById("P_brePara_input");
        if (amount) {
          amount.focus();
        }
      }
    );
  };

  //// arrow up/down moves inside the list, Enter picks the highlighted wakil
  P_wakilListKeydown = (e) => {
    const { P_wakilSuggestions, P_wakilCursor } = this.state;
    if (!P_wakilSuggestions || P_wakilSuggestions.length === 0) {
      return;
    }
    if (e.keyCode === 27) {
      this.P_emptyWakilSuggestions();
      return;
    }
    if (e.keyCode === 40) {
      e.preventDefault();
      this.setState((prevState) => ({
        P_wakilCursor:
          prevState.P_wakilCursor < P_wakilSuggestions.length - 1
            ? prevState.P_wakilCursor + 1
            : prevState.P_wakilCursor
      }));
    } else if (e.keyCode === 38) {
      e.preventDefault();
      this.setState((prevState) => ({
        P_wakilCursor:
          prevState.P_wakilCursor > 0
            ? prevState.P_wakilCursor - 1
            : prevState.P_wakilCursor
      }));
    } else if (e.keyCode === 13 && P_wakilCursor >= 0) {
      e.preventDefault();
      this.P_wakilSuggestionSelected(P_wakilSuggestions[P_wakilCursor]);
    }
  };

  getParaDataBySearchMoney = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/search?zhmara=${this.state.P_zhmara}`,
      config
    );

    const data = res.data.parakan;
    if (data === null) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
      this.setState({ P_zhmara: 0 });
    } else {
      this.setState(() => {
        return {
          P_search_wasl: true,
          P_zhmara: data.zhmara,
          P_nawe_barez: data.namewakil,
          P_barwar: data.date,
          P_zh_barez: data.wakilcode,
          P_paraPashDashkan:
            data.joripara === "دینار"
              ? data.paradwaykmkrdndinar
              : data.paradwaykmkrdndolar,
          P_dashkan: data.kmkrdnawa ? data.kmkrdnawa : 0,
          P_brePara:
            data.joripara === "دینار"
              ? data.paraywargirawdinar
              : data.paraywargirawdolar,
          P_joripara: data.joripara,
          P_wargr: data.nawiwargr,
          P_note: data.note,
          P_qarzeKonDolar: data.rasiddolar,
          P_qarzeKonID: data.rasiddinar,
          P_del_dis: true,
          P_paraywasl: data.paradwaykmkrdn,
          P_wasl: data,
          P_togler: false,
          P_briparaypechawana: data.parayPechawana,
          M_cash: data.cash,
          M_FIB: data.FIB,
          P_pashDashkan:
            data.joripara === "دینار"
              ? data.paradwaykmkrdndinar
              : data.paradwaykmkrdndolar
        };
      });
    }
  };
  P_kamkrdnawayNrx = () => {
    if (this.state.P_joripara === "دۆلار") {
      const dashkan = this.bripara() - this.state.P_dashkan;
      return Number(dashkan).toFixed(2);
    } else if (this.state.P_joripara === "دینار") {
      const dashkan = this.bripara() - this.state.P_dashkan;
      return Number(dashkan).toFixed(2);
    }
  };
  bripara = () => {
    if (this.state.P_joripara === "دۆلار") {
      const para =
        this.state.P_qarzeKonDolar -
        parseFloat(this.state.P_brePara.toString().replace(/,/g, ""));
      return Number(para).toFixed(2);
    } else if (this.state.P_joripara === "دینار") {
      const para =
        this.state.P_qarzeKonID -
        parseFloat(this.state.P_brePara.toString().replace(/,/g, ""));
      return Number(para).toFixed(2);
    }
  };

  getParakan = async () => {
    try {
      const res = await Instance.get(`/api/v1/parakan`);
      this.setState({
        P_zhmara: res.data.parakan.length + 1
      });
    } catch (error) {
      return;
    }
  };
  setSearchMonyWakilEmpty = (e) => {
    e.preventDefault();
    this.setState({
      P_zh_barez: 0,
      P_nawe_barez: "",
      P_qarzeKonDolar: 0,
      P_qarzeKonID: 0,
      P_wakilSearch: false,
      P_wakilSuggestions: [],
      P_wakilCursor: -1
    });
  };
  createNewMony = () => {
    this.setState(
      {
        P_zh_barez: 0,
        P_nawe_barez: "",
        P_qarzeKonDolar: 0,
        P_qarzeKonID: 0,
        P_brePara: 0,
        P_briparaypechawana: "",
        P_dashkan: 0,
        P_paraPashDashkan: 0,
        P_error: null,
        P_note: "",
        P_search_wasl: null,
        P_save: null,
        P_joripara: "دینار",
        P_wargr: "ئەنوەر",
        P_isChecked: false,
        P_open: null,
        P_del_dis: null,
        P_page: this.state.P_zhmara,
        P_barwar: "",
        P_wakilSearch: false,
        P_wakilSuggestions: [],
        P_wakilCursor: -1,
        M_cash: false,
        M_FIB: false,
        P_pashDashkan: 0
      },
      () => {
        this.getParakan();
      }
    );
    // this.P_ClearError();
  };

  P_getIsChecked = (e) => {
    let checked = e.target.checked;
    if (checked) {
      this.setState({ P_isChecked: true });
    } else {
      this.setState({ P_isChecked: false });
    }
  };
  P_ClearError = () => {
    this.setState({ P_error: null });
  };

  ToNmberWithPars = (parm) => {
    return parm ? parseFloat(parm.toString().replace(/,/g, "")) : 0;
  };
  P_DolartoRemembi_In_Balance = (e) => {
    e.preventDefault();
    this.setState({
      P_DolarTR: !this.state.P_DolarTR,
      P_DinarTR: false
    });
  };
  P_DolartoDinar = (e) => {
    e.preventDefault();
    let DolarToDinar = _.multiply(
      this.ToNmberWithPars(this.state.P_Amount_Dolar),
      this.ToNmberWithPars(this.state.P_High_Dolar)
    );
    this.setState({
      PD_brepara: Number(DolarToDinar).toFixed(2),
      PD_joredraw: "دینار",
      P_DolarTR: false,
      P_DinarTR: false
    });
  };
  P_DolartoRemembi_WithOut_Balance = (e) => {
    e.preventDefault();
    let DolarToDinar = _.multiply(
      this.ToNmberWithPars(this.state.P_Amount_Dolar),
      this.ToNmberWithPars(this.state.P_High_Dolar)
    );
    let DinarToDolar = _.divide(
      this.ToNmberWithPars(DolarToDinar),
      this.ToNmberWithPars(this.state.P_Low_Dolar)
    );
    let DolarToRemebi = _.multiply(
      this.ToNmberWithPars(DinarToDolar),
      this.ToNmberWithPars(this.state.P_Remebi_Price)
    );
    this.setState({
      PD_brepara: Number(DolarToRemebi).toFixed(2),
      PD_joredraw: "ڕیمێمبی",
      P_DolarTR: false,
      P_DinarTR: false
    });
  };
  P_DinartoRemembi_In_Balance = (e) => {
    e.preventDefault();
    this.setState({
      P_DolarTR: false,
      P_DinarTR: !this.state.P_DinarTR
    });
  };

  P_DinartoRemembi_Without_Balance = (e) => {
    e.preventDefault();
    let DinarToDolar = _.divide(
      this.ToNmberWithPars(this.state.P_Amount_Dinar),
      this.ToNmberWithPars(this.state.P_Low_Dolar)
    );
    let DolarToRemebi = _.multiply(
      this.ToNmberWithPars(DinarToDolar),
      this.ToNmberWithPars(this.state.P_Remebi_Price)
    );
    this.setState({
      PD_brepara: Number(DolarToRemebi).toFixed(2),
      PD_joredraw: "ڕیمێمبی",
      P_DolarTR: false,
      P_DinarTR: false
    });
  };

  pageplusone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page = this.state.P_zhmara + 1;
      const res = await Instance.get(
        `/api/v1/page?page=${page}&limit=1`,
        config
      );

      const data = res.data.paras;
      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState(
          () => {
            return {
              P_search_wasl: true,
              P_zhmara: data.zhmara,
              P_nawe_barez: data.namewakil,
              P_barwar: data.date,
              P_zh_barez: data.wakilcode,
              P_paraPashDashkan:
                data.joripara === "دینار"
                  ? data.paradwaykmkrdndinar
                  : data.paradwaykmkrdndolar,
              P_dashkan: data.kmkrdnawa ? data.kmkrdnawa : 0,
              P_brePara:
                data.joripara === "دینار"
                  ? data.paraywargirawdinar
                  : data.paraywargirawdolar,
              P_joripara: data.joripara,
              P_wargr: data.nawiwargr,
              P_note: data.note,
              P_qarzeKonDolar: data.rasiddolar,
              P_qarzeKonID: data.rasiddinar,
              P_del_dis: true,
              P_paraywasl: data.paradwaykmkrdn,
              P_wasl: data,
              P_save: null,
              P_briparaypechawana: data.parayPechawana
                ? data.parayPechawana
                : 0,
              M_cash: data.cash,
              M_FIB: data.FIB,
              P_pashDashkan:
                data.joripara === "دینار"
                  ? data.paradwaykmkrdndinar
                  : data.paradwaykmkrdndolar
            };
          },
          () => {
            this.Money_getWakilDataBySearchMoney(e);
          }
        );
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };
  pageminsone = async (e) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    e.preventDefault();
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page;
      this.state.P_zhmara <= 1 ? (page = 1) : (page = this.state.P_zhmara - 1);
      const res = await Instance.get(
        `/api/v1/page?page=${page}&limit=1`,
        config
      );

      const data = res.data.paras;
      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState(
          () => {
            return {
              P_search_wasl: true,
              P_zhmara: data.zhmara,
              P_nawe_barez: data.namewakil,
              P_barwar: data.date,
              P_zh_barez: data.wakilcode,
              P_paraPashDashkan:
                data.joripara === "دینار"
                  ? data.paradwaykmkrdndinar
                  : data.paradwaykmkrdndolar,
              P_dashkan: data.kmkrdnawa ? data.kmkrdnawa : 0,
              P_brePara:
                data.joripara === "دینار"
                  ? data.paraywargirawdinar
                  : data.paraywargirawdolar,
              P_joripara: data.joripara,
              P_wargr: data.nawiwargr,
              P_note: data.note,
              P_qarzeKonDolar: data.rasiddolar,
              P_qarzeKonID: data.rasiddinar,
              P_del_dis: true,
              P_paraywasl: data.paradwaykmkrdn,
              P_wasl: data,
              P_save: null,
              P_briparaypechawana: data.parayPechawana,
              M_cash: data.cash,
              M_FIB: data.FIB,
              P_pashDashkan:
                data.joripara === "دینار"
                  ? data.paradwaykmkrdndinar
                  : data.paradwaykmkrdndolar
            };
          },
          () => {
            this.Money_getWakilDataBySearchMoney(e);
          }
        );
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };
  /////end

  // garanawa bo koga function
  G_getWaslDataBySearchRent = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchgaranawa?numberofwasl=${Number(this.state.G_zh_wasl)}`,
      config
    );

    const data = res.data.pswla;
    if (data === null) {
      alert("ببورە ئەم پسولەیە بونی نیە");
    } else {
      this.setState(
        () => {
          return {
            G_wasl: data,
            G_search_wasl: true,
            G_zh_wasl: data.numberofwasl,
            G_nawe_barez: data.wakil,
            G_mob: data.phone,
            G_zh_barez: data.numberOfWakil,
            G_total: data.koalldolar,
            G_totalID: data.koalldinar,
            G_dashkan: data.dashkandolar,
            G_dashkanID: data.dashkandinar,
            G_dataTable: data.saleTable,
            G_joripara: data.joripara,
            G_frosht: data.froshtn,
            G_wargr: data.whossale,
            G_paraDanID: data.paraydrawdinar,
            G_paraDan$: data.paraydrawdolar,
            G_kartonakan: data.koykartonkan,
            G_kreysayara: data.kreysayra,
            G_kreykrekar: data.kreykrekar,
            G_koywaznkarton: data.waznakan,
            G_paraywasl:
              data.joripara === "دۆلار"
                ? data.qarzinwedolar
                : data.qarzinwedinar,
            G_del_dis: true,
            G_up_froshtn: data.froshtn,
            G_togler: false,
            G_date: data.date,
            G_Nrx_J_T_check: data.joripara_dolar,
            G_Nrx_IQD_check: data.joripara_IQD
          };
        },
        () => {
          if (this.state.G_frosht === "فرۆشتنی وەکیل") {
            this.G_getWakilDataBySearchRent(e);
          }
        }
      );
    }
  };

  ///// loading product
  G_hideLoader = () => {
    this.setState({ G_loading: false });
  };

  G_showLoader = () => {
    this.setState({ G_loading: true });
  };

  G_wakilRasidData = async (code) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/getWakilData/${code}`, config);
    return res.data.doc;
  };
  G_onSaveRent = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      if (
        this.state.G_dataTable.length === 0 ||
        this.state.G_kartonakan === 0
      ) {
        alert("تکایە کاڵا داخیل بکە ");
        const sawtError = new Audio(errorAduio);
        sawtError.play().catch(() => {});
        return false;
      } else if (this.state.G_nawe_barez === "") {
        alert("تکایە ناوی بەڕێز پڕبکەوە");
        const sawtError = new Audio(errorAduio);
        sawtError.play().catch(() => {});
      } else if (this.state.G_frosht === "" || this.state.G_wargr === "") {
        swal({
          title: "ببورە",
          text: "تکایە خانەکان پڕبکەرەوە",
          icon: "error"
        });
        const sawtError = new Audio(errorAduio);
        sawtError.play().catch(() => {});
      } else {
        let data;
        data = {
          numberOfWakil:
            this.state.G_frosht === "فرۆشتنی وەکیل"
              ? Number(this.state.G_zh_barez)
              : "",
          wakil: this.state.G_nawe_barez,
          phone: this.state.G_mob,
          whossale: this.state.G_wargr,
          joripara: this.state.G_joripara,
          froshtn: this.state.G_frosht,
          saleTable: this.state.G_dataTable,
          koalldinar:
            this.state.G_joripara === "دینار" ? this.state.G_totalID : 0,
          koalldolar:
            this.state.G_joripara === "دۆلار" ? this.state.G_total : 0,
          paraydrawdolar:
            this.state.G_joripara === "دۆلار" &&
            this.state.G_paraDan$ !== "" &&
            this.state.G_paraDan$ !== null
              ? parseFloat(this.state.G_paraDan$.replace(/,/g, ""))
              : 0,
          paraydrawdinar:
            this.state.G_joripara === "دینار" &&
            this.state.G_paraDanID !== "" &&
            this.state.G_paraDanID !== null
              ? parseFloat(this.state.G_paraDanID.replace(/,/g, ""))
              : 0,
          qarzinwedolar:
            this.state.G_joripara === "دۆلار"
              ? this.state.G_paraDan$ !== ""
                ? this.G_waslKrdn()
                : this.state.G_total
              : 0,
          qarzinwedinar:
            this.state.G_joripara === "دینار"
              ? this.state.G_paraDanID !== ""
                ? this.G_waslKrdnID()
                : this.state.G_totalID
              : 0,
          koykartonkan: this.state.G_kartonakan,
          waznakan: this.state.G_koywaznkarton,
          qaznjygarawa: this.state.G_qazanjywasl,
          date: this.state.G_date === "" ? Date.now : this.state.G_date
        };
        let wakildata = {};
        if (this.state.G_zh_barez) {
          wakildata = await this.G_wakilRasidData(this.state.G_zh_barez);
        }
        const draw = this.state.G_joripara === "دینار" ? "dinar" : "dolar";
        const res = await Instance.post(
          `/api/v1/newwaslgaranawa?opr=-&joridraw=${draw}`,
          data,
          config
        );

        this.setState(
          {
            G_togler: false,
            G_save: true,
            G_zh_wasl: res.data.garanawaproduct.numberofwasl,
            W_raseddenar: 0,
            W_raseddolar: 0,
            G_wasl: res.data.garanawaproduct,
            G_paraywasl:
              res.data.garanawaproduct.joripara === "دۆلار"
                ? res.data.garanawaproduct.qarzinwedolar
                : res.data.garanawaproduct.qarzinwedinar,
            G_del_dis: true,
            G_up_froshtn: res.data.garanawaproduct.froshtn,
            G_date: res.data.garanawaproduct.date,
            G_table: false,
            G_rasidWakildinarNew: _.add(
              Number(wakildata.rejaDinar),
              res.data.qarzikonwakildinar
            ),
            G_rasidWakildolarNew: _.add(
              Number(wakildata.rejaDolar),
              res.data.qarzinwedolar
            ),
            G_rasidWakildinar: Number(wakildata.rejaDinar),
            G_rasidWakildolar: Number(wakildata.rejaDolar)
          },
          async () => {
            this.getWaslakan();
            this.G_hideLoader();
          }
        );
        this.G_setSaletSearchEmty(e);
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    }
  };

  G_koyqazanjywasll = () => {
    let subTotal = 0;
    this.state.G_dataTable.map(
      (item) => (subTotal += Number(item.qazanjykalla))
    );
    const cartTotals = Number(Number(subTotal).toFixed(2));
    this.setState(() => {
      return {
        G_qazanjywasl: cartTotals
      };
    });
  };

  G_setSaletSearchEmty = (e) => {
    e.preventDefault();
    this.setState({
      G_zhmara: "",
      G_zhmaraysht: "",
      G_productId: "",

      G_naweSht: "",
      G_karton: "",
      G_darzan: "",
      G_search: null,
      G_rezha: 0,
      G_nrx: 0,
      G_dp: ""
    });
  };

  G_calculateDarzan = () => {
    const zhmarayKarton = this.state.G_rezha;
    const darzan = Number(this.state.G_darzan);
    const karton = darzan / zhmarayKarton;
    return karton.toFixed(2);
  };

  G_DarzanChange = (e) => {
    this.setState(
      {
        darzan: e.target.value,
        G_darzan: e.target.value
      },
      () => {
        this.setState(
          {
            karton: this.calculateDarzan(),
            G_karton: this.G_calculateDarzan(),
            koygshty: this.getkoygahty(this.state.darzan, this.state.karton),
            G_nrx: this.G_nrxRent(this.state.G_darzan, this.state.G_karton)
          },
          () => {
            if (this.state.G_joripara === "دۆلار") {
              this.setState({
                G_qazanj: (
                  (Number(this.state.G_nrx) - this.state.G_kren) *
                  this.state.G_rezha
                ).toFixed(2)
              });
            } else if (this.state.G_joripara === "دینار") {
              this.setState({
                G_qazanj: (
                  (this.dinartodolar(Number(this.state.G_nrx)) -
                    this.state.G_kren) *
                  this.state.G_rezha
                ).toFixed(2)
              });
            }
          }
        );
      }
    );
    if (e.target.value === ".") {
      this.setState({
        [e.target.name]: "0."
      });
    }
    this.ClearError();
  };

  OnChangeSwitch_G = (checked) => {
    this.setState(
      {
        G_Nrx_J_T_check: !this.state.G_Nrx_J_T_check
      },
      () => {
        let data = this.state.G_dataProduct;
        this.setState({
          G_nrx:
            this.state.G_joripara != "دینار" && !this.state.G_Nrx_J_T_check
              ? data.saleDolar
              : data.nrxeFroshtnDolar2,
          G_joripara: "دۆلار"
        });
      }
    );
  };
  OnChangeSwitch_G_IQD = (checked) => {
    this.setState(
      {
        G_Nrx_IQD_check: !this.state.G_Nrx_IQD_check
      },
      () => {
        let data = this.state.G_dataProduct;
        this.setState({
          G_nrx:
            this.state.G_joripara === "دینار" && !this.state.G_Nrx_IQD_check
              ? data.saleDinar
              : data.nrxeFroshtnDenar2,
          G_joripara: "دینار"
        });
      }
    );
  };

  G_getkartonakan = () => {
    let subTotal = 0;
    this.state.G_dataTable.map((item) => (subTotal += Number(item.carton)));
    const cartTotals = Number(Number(subTotal).toFixed(2));
    this.setState(() => {
      return {
        G_kartonakan: cartTotals
      };
    });
  };

  G_waznkartonakan = () => {
    let subTotal = 0;
    this.state.G_dataTable.map(
      (item) => (subTotal += Number(item.wazn) * Number(item.carton))
    );
    const wazns = Number(Number(subTotal).toFixed(2));

    this.setState(() => {
      return {
        G_koywaznkarton: wazns
      };
    });
  };

  G_DeleteSail = async (id, table, i) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const check = window.confirm("دڵنیای لە سڕینەوەی ئەم کاڵایە؟");
    if (check) {
      this.setState(
        {
          G_dataTable: this.state.G_dataTable.filter((r, idx) => idx != i)
        },
        async () => {
          if (this.state.G_dataTable.length === 0) {
            this.setState({
              G_table: false
            });
          }
          if (this.state.G_joripara === "دۆلار") {
            this.G_getALLkoygshty();
          } else if (this.state.G_joripara === "دینار") {
            this.G_getALLkoygshtyID();
          }
          this.UpdateRasidCarton(table.raqam, Number(table.carton), "-");
          this.G_getkartonakan();
          this.G_waznkartonakan();
          this.G_koyqazanjywasll();
        }
      );
    }
  };

  G_openUpdate = async (NOW, userid, e, id) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(
      `api/v1/openGaranwa/${id}?id=${userid}`,
      data,
      config
    );

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.G_koyqazanjywasll();
      this.setState({
        G_del_dis: null,
        G_open: true
      });
      this.G_koyqazanjywasll();
    }
  };

  G_updateSale = async (NOW, id, e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      if (this.state.G_nawe_barez === "") {
        swal({
          title: "ببورە",
          text: "هەڵە هەیە لە خانەکان",
          icon: "error"
        });
      } else {
        this.G_koyqazanjywasll();
        let hamwi = {
          numberOfWakil:
            this.state.G_frosht === "فرۆشتنی وەکیل"
              ? Number(this.state.G_zh_barez)
              : "",
          wakil: this.state.G_nawe_barez,
          phone: this.state.G_mob,
          whossale: this.state.G_wargr,
          joripara: this.state.G_joripara,
          froshtn: this.state.G_frosht,
          saleTable: this.state.G_dataTable,
          koalldinar:
            this.state.G_joripara === "دینار" ? this.state.G_totalID : 0,
          koalldolar:
            this.state.G_joripara === "دۆلار" ? this.state.G_total : 0,
          paraydrawdolar:
            this.state.G_joripara === "دۆلار" &&
            this.state.G_paraDan$ !== "" &&
            this.state.G_paraDan$ !== null
              ? parseFloat(this.state.G_paraDan$.toString().replace(/,/g, ""))
              : 0,
          paraydrawdinar:
            this.state.G_joripara === "دینار" &&
            this.state.G_paraDanID !== "" &&
            this.state.G_paraDanID !== null
              ? parseFloat(this.state.G_paraDanID.toString().replace(/,/g, ""))
              : 0,
          qarzinwedolar:
            this.state.G_joripara === "دۆلار"
              ? this.state.G_paraDan$ !== ""
                ? this.G_waslKrdn()
                : this.state.G_total
              : 0,
          qarzinwedinar:
            this.state.G_joripara === "دینار"
              ? this.state.G_paraDanID !== ""
                ? this.G_waslKrdnID()
                : this.state.G_totalID
              : 0,
          koykartonkan: this.state.G_kartonakan,
          waznakan: this.state.G_koywaznkarton,
          date: this.state.G_date,
          qaznjygarawa: this.state.G_qazanjywasl
        };
        const res = await Instance.put(
          `/api/v1/updateallgaranawa/${id}`,
          hamwi,
          config
        );

        this.setState({
          G_up_wasl: true,
          G_del_dis: true,
          G_open: null,
          G_togler: false,
          G_wasl: res.data.update,
          G_paraywasl:
            res.data.update.joripara === "دۆلار"
              ? res.data.update.qarzinwedolar
              : res.data.update.qarzinwedinar,
          G_table: false
        });
        this.G_setSaletSearchEmty(e);
      }
      swal({
        title: "تەواو",
        text: "پسولە سورکەوتوو بوو!",
        icon: "success",
        timer: 2000
      });
    } catch (error) {
      swal({
        title: "ببورە",
        text: "هەڵە هەیە لە خانەکان",
        icon: "error"
      });
    }
  };
  G_inputtogler = () => {
    this.setState({
      G_togler: !this.state.G_togler,
      G_date: ""
    });
  };

  G_nrxchange = (e) => {
    this.setState(
      {
        G_nrx: e.target.value
      },
      () => {
        let sawt = new Audio(warningAdiuo);
        sawt.play().catch(() => {});
        if (this.state.G_joripara === "دۆلار") {
          this.setState({
            G_qazanj: (
              (Number(this.state.G_nrx) - this.state.G_kren) *
              this.state.G_rezha
            ).toFixed(2)
          });
        } else if (this.state.G_joripara === "دینار") {
          this.setState({
            G_qazanj: (
              (this.dinartodolar(Number(this.state.G_nrx)) -
                this.state.G_kren) *
              this.state.G_rezha
            ).toFixed(2)
          });
        }
      }
    );
  };

  G_getProductDataBySearchRent = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    this.toanotherInput(e);

    const res = await Instance.get(
      `/api/v1/searchtoproduct?code=${this.state.G_zhmara}&&nameofproduct=`,
      config
    );

    const data = res.data.product;
    if (data === null) {
      alert("ببورە ئەم کاڵایە بونی نیە");
    } else {
      this.setState(() => {
        return {
          G_search: true,
          G_zhmara: data.code,
          G_productId: data._id,
          G_zhmaraysht: data.productCode,
          G_naweSht: data.nameofproduct,
          G_rezha: data.numberOfDarzan,
          G_nrx_dolar: data.saleDolar,
          G_nrx_dinarr: data.saleDinar,
          G_nrx:
            this.state.G_joripara === "دینار"
              ? !this.state.G_Nrx_IQD_check
                ? data.saleDinar
                : data.nrxeFroshtnDenar2
              : !this.state.G_Nrx_J_T_check
              ? data.saleDolar
              : data.nrxeFroshtnDolar2,
          G_nrx_niwkarton: data.saleOfLessHalfCarton,
          G_nrx_kmtrdadarzan: data.saleOfLessTenDarzan,
          G_Dolar2: data.nrxeFroshtnDolar2,
          G_Dinar2: data.nrxeFroshtnDenar2,
          G_dataProduct: data,
          G_rasidKarton: data.rasidKarton
            ? Number(
                parseFloat(data.rasidKarton.toString().split("e-"))
              ).toFixed(2)
            : 0,
          G_qazanj:
            this.state.G_joripara === "دینار"
              ? (
                  (this.dinartodolar(
                    !this.state.G_Nrx_IQD_check
                      ? data.saleDinar
                      : data.nrxeFroshtnDenar2
                  ) -
                    data.price) *
                  data.numberOfDarzan
                ).toFixed(2)
              : (
                  (!this.state.G_Nrx_J_T_check
                    ? data.saleDolar
                    : data.nrxeFroshtnDolar2 - data.price) * data.numberOfDarzan
                ).toFixed(2),
          G_kren: data.price,
          G_nrxkaton: (data.price * data.numberOfDarzan).toFixed(2),
          G_waznkarton: data.weight,
          G_dp: data.dp || ""
        };
      });
    }
  };

  G_tofirstInputINRent = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 6].focus();
    this.G_saveDetail(e);
  };

  G_anotherInputWakil = (e) => {
    e.preventDefault();
    if (
      this.state.G_frosht === "فرۆشتنی ڕاستەوخۆ" ||
      this.state.G_frosht === null
    ) {
      const form = e.target.form;
      const index = Array.prototype.indexOf.call(form, e.target);
      form.elements[index - 1].focus();
    } else {
      const form = e.target.form;
      const index = Array.prototype.indexOf.call(form, e.target);
      form.elements[index - 1].focus();
      this.G_getWakilDataBySearchRent(e);
    }
  };

  G_getALLkoygshty = () => {
    let subTotal = 0;
    this.state.G_dataTable.map((item) => (subTotal += item.kodolar));
    const cartTotals = Number(Number(subTotal).toFixed(2));
    this.setState(() => {
      return {
        G_total: cartTotals
      };
    });
  };

  G_waslKrdn = () => {
    const wasl =
      this.state.G_total -
      parseFloat(this.state.G_paraDan$.toString().replace(/,/g, ""));
    return wasl.toFixed(2);
  };

  G_waslKrdnID = () => {
    const wasl =
      this.state.G_totalID -
      parseFloat(this.state.G_paraDanID.toString().replace(/,/g, ""));
    return wasl.toFixed(2);
  };

  G_getALLkoygshtyID = () => {
    let subTotal = 0;
    this.state.G_dataTable.map((item) => (subTotal += Number(item.kodinar)));
    const cartTotals = Number(Number(subTotal).toFixed(2));
    this.setState(() => {
      return {
        G_totalID: cartTotals
      };
    });
  };

  G_calculateCarton = () => {
    const zhmarayKarton = this.state.G_rezha;
    const carton = Number(this.state.G_karton);
    const darzan = carton * zhmarayKarton;
    return darzan.toFixed(2);
  };

  G_nrxRent = (darzan, carton) => {
    const nrxDollar = Number(this.state.G_nrx_dolar);
    const nrxDollar2 = Number(this.state.G_Dolar2);
    const nrxDinar = Number(this.state.G_nrx_dinarr);
    const nrxDinar2 = Number(this.state.G_Dinar2);
    const nrxNiwKarton = Number(this.state.G_nrx_niwkarton);
    const nrxKmtrDaDarzan = Number(this.state.G_nrx_kmtrdadarzan);

    let nrx = nrxDollar;

    if (this.state.G_joripara === "دینار") {
      // Use IQD row 1 or row 2 based on toggle
      const selectedDinar = !this.state.G_Nrx_IQD_check ? nrxDinar : nrxDinar2;

      nrx = nrxDinar;
        return Number(nrx);
    } else if (this.state.G_joripara === "دۆلار") {
      // Use dollar row 1 or row 2 based on toggle
      nrx =nrxDollar;
      return Number(nrx);
    }
  };

  G_CartonChange = (e) => {
    this.setState(
      {
        G_karton: e.target.value
      },
      () => {
        this.setState(
          {
            G_darzan: this.G_calculateCarton(),
            G_nrx: this.G_nrxRent(this.state.G_darzan, this.state.G_karton)
          },
          () => {
            if (this.state.G_joripara === "دۆلار") {
              this.setState({
                G_qazanj: (
                  (Number(this.state.G_nrx) - this.state.G_kren) *
                  this.state.G_rezha
                ).toFixed(2)
              });
            } else if (this.state.G_joripara === "دینار") {
              this.setState({
                G_qazanj: (
                  (this.dinartodolar(Number(this.state.G_nrx)) -
                    this.state.G_kren) *
                  this.state.G_rezha
                ).toFixed(2)
              });
            }
          }
        );
      }
    );
    if (e.target.value === ".") {
      this.setState({
        [e.target.name]: "0."
      });
    }
  };

  G_saveDetail = async (e) => {
    e.preventDefault();
    if (
      this.state.G_karton === 0 ||
      this.state.G_zhmara === "" ||
      this.state.G_joripara === null
    ) {
      alert("!تکایە خانەکان پڕ بکەرەوە");
    } else {
      if (localStorage.token) {
        setToken(localStorage.token);
      }
      const config = {
        "Content-Type": "application/json"
      };
      let Table = this.state.G_dataTable;
      Table.unshift({
        _id: this.state.G_productId,
        raqam: this.state.G_zhmara,
        jamaraysht: this.state.G_zhmaraysht,
        nawisht: this.state.G_naweSht,
        carton: Number(this.state.G_karton),
        darzan: Number(this.state.G_darzan),
        nrx: Number(this.state.G_nrx),
        reja: this.state.G_rezha,
        kodolar:
          this.state.G_joripara === "دۆلار"
            ? this.G_getkoygahty(this.state.G_darzan, this.state.G_karton)
            : 0,
        kodinar:
          this.state.G_joripara === "دینار"
            ? this.G_getkoygahty(this.state.G_darzan, this.state.G_karton)
            : 0,
        wazn: this.state.G_waznkarton,
        qazanjykalla: this.state.G_qazanj * Number(this.state.G_karton),
        dp: this.state.G_dp || ""
      });
      this.UpdateRasidCarton(
        this.state.G_zhmara,
        Number(this.state.G_karton),
        "plus"
      );
      this.setState(
        {
          G_dataTable: Table,
          G_zhmaraysht: "",
          G_productId: "",
          G_karton: "",
          G_darzan: "",
          G_nrx: 0,
          G_naweSht: "",
          G_rezha: 0,
          G_koygshty$: 0,
          G_koygshtyID: 0,
          G_zhmara: "",
          G_nrx_dolar: 0,
          G_nrx_dinarr: 0,
          G_nrx_niwkarton: 0,
          G_nrx_kmtrdadarzan: 0,
          G_Dolar2: "",
          G_Dinar2: "",
          G_search: null,
          G_rasidKarton: 0,
          G_qazanj: 0,
          G_kren: 0,
          G_nrxkaton: 0,
          G_table: true,
          G_dp: ""
        },
        () => {
          if (this.state.G_joripara === "دۆلار") {
            this.G_getALLkoygshty();
          } else if (this.state.G_joripara === "دینار") {
            this.G_getALLkoygshtyID();
          }
          this.G_getkartonakan();
          this.G_waznkartonakan();
          this.G_koyqazanjywasll();
        }
      );
    }
  };

  G_getkoygahty = (darzan, karton) => {
    if (karton !== 0) {
      const nrx = Number(this.state.G_nrx);
      let koygshty = darzan * nrx;

      return Number(koygshty.toFixed(2));
    } else {
      const nrx = Number(this.state.G_nrx);
      let koygshty = darzan * nrx;

      return Number(koygshty.toFixed(2));
    }
  };

  G_getWakilDataBySearchRent = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    if (
      this.state.G_frosht === "فرۆشتنی ڕاستەوخۆ" ||
      this.state.G_frosht === null
    ) {
      alert("ببورە جۆری فرۆشتن وەکیل نیە");
    } else {
      const res = await Instance.get(
        `/api/v1/searchwakil?code=${Number(this.state.G_zh_barez)}&&Name=${
          this.state.G_nawe_barez
        }&&phone=${this.state.G_mob}`,
        config
      );

      const data = res.data.wakils;
      if (data === null) {
        alert("ببورە ئەم بەڕێزە بونی نیە");
        this.setState({
          G_zh_barez: 0,
          G_nawe_barez: "",
          G_mob: 0,
          G_rasidWakildolar: 0,
          G_rasidWakildinar: 0
        });
      } else {
        this.setState(() => {
          return {
            G_search_wakil: true,
            G_zh_barez: data.code,
            G_nawe_barez: data.Name,
            G_mob: data.phone,
            G_rasidWakildolar: data.rejaDolar,
            G_rasidWakildinar: data.rejaDinar
          };
        });
      }
    }
  };
  G_getWaslakan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/getGaranawakan`, config);

    this.setState({
      G_zh_wasl_katy: res.data.Garanawas.length + 1,
      G_page: res.data.Garanawas.length + 1
    });
  };

  G_setSearchEmptyRentWakil = (e) => {
    e.preventDefault();
    this.setState({
      G_search_wakil: null,
      G_zh_barez: 0,
      G_nawe_barez: "",
      G_mob: 0,
      G_rasidWakildolar: 0,
      G_rasidWakildinar: 0
    });
  };

  G_createNewPage = (e) => {
    e.preventDefault();
    this.setState(
      {
        G_nawe_barez: "",
        G_mob: 0,
        G_zh_barez: 0,
        G_total: 0,
        G_totalID: 0,
        G_dashkan: "",
        G_dashkanID: "",
        G_dataTable: [],
        G_search: null,
        dinar: false,
        dolar: false,
        G_search_wasl: null,
        G_kartonakan: 0,
        G_nwe: true,
        G_joripara: null,
        G_zhmara: "",
        G_naweSht: "",
        G_karton: "",
        G_darzan: "",
        G_kreykrekar: 0,
        G_kreysayara: 0,
        G_save: null,
        G_nrx: 0,
        G_waznkarton: 0,
        G_paraDan$: "",
        G_paraDanID: "",
        G_WakilQard_isChecked: false,
        G_isChecked: null,
        G_search_wakil: null,
        G_zh_wasl: 0,
        G_wargr: "ئەنوەر",
        G_frosht: null,
        G_rezha: 0,
        G_rasidKarton: 0,
        G_up_wasl: null,
        G_del_dis: null,
        G_paraywasl: 0,
        G_open: null,
        G_wasl: null,
        G_zhmaraysht: "",
        G_date: "",
        G_koywaznkarton: 0,
        G_dp: ""
      },
      () => {
        this.G_getWaslakan();
      }
    );
    this.R_ClearError();
  };

  G_pageplusone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page = this.state.G_page + 1;
      const res = await Instance.get(
        `/api/v1/ganaranawapage?page=${page}&limit=1`,
        config
      );
      this.G_setSaletSearchEmty(e);
      const data = res.data.Garanawas;
      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState(() => {
          return {
            G_page: page,
            G_wasl: data,
            G_search_wasl: true,
            G_zh_wasl: data.numberofwasl,
            G_nawe_barez: data.wakil,
            G_mob: data.phone,
            G_zh_barez: data.numberOfWakil,
            G_total: data.koalldolar,
            G_totalID: data.koalldinar,
            G_dashkan: data.dashkandolar,
            G_dashkanID: data.dashkandinar,
            G_dataTable: data.saleTable,
            G_joripara: data.joripara,
            G_frosht: data.froshtn,
            G_wargr: data.whossale,
            G_paraDanID: data.paraydrawdinar,
            G_paraDan$: data.paraydrawdolar,
            G_kartonakan: data.koykartonkan,
            G_kreysayara: data.kreysayra,
            G_kreykrekar: data.kreykrekar,
            G_koywaznkarton: data.waznakan,
            G_paraywasl:
              data.joripara === "دۆلار"
                ? data.qarzinwedolar
                : data.qarzinwedinar,
            G_del_dis: true,
            G_up_froshtn: data.froshtn,
            G_togler: false,
            G_date: data.date,
            G_Nrx_J_T_check: data.joripara_dolar,
            G_Nrx_IQD_check: data.joripara_IQD
          };
        });
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };

  G_pageminsone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page;
      this.state.G_page <= 1 ? (page = 1) : (page = this.state.G_page - 1);
      const res = await Instance.get(
        `/api/v1/ganaranawapage?page=${page}&limit=1`,
        config
      );
      this.G_setSaletSearchEmty(e);
      const data = res.data.Garanawas;
      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState(() => {
          return {
            G_page: page,
            G_wasl: data,
            G_search_wasl: true,
            G_zh_wasl: data.numberofwasl,
            G_nawe_barez: data.wakil,
            G_mob: data.phone,
            G_zh_barez: data.numberOfWakil,
            G_total: data.koalldolar,
            G_totalID: data.koalldinar,
            G_dashkan: data.dashkandolar,
            G_dashkanID: data.dashkandinar,
            G_dataTable: data.saleTable,
            G_joripara: data.joripara,
            G_frosht: data.froshtn,
            G_wargr: data.whossale,
            G_paraDanID: data.paraydrawdinar,
            G_paraDan$: data.paraydrawdolar,
            G_kartonakan: data.koykartonkan,
            G_kreysayara: data.kreysayra,
            G_kreykrekar: data.kreykrekar,
            G_koywaznkarton: data.waznakan,
            G_paraywasl:
              data.joripara === "دۆلار"
                ? data.qarzinwedolar
                : data.qarzinwedinar,
            G_del_dis: true,
            G_up_froshtn: data.froshtn,
            G_togler: false,
            G_date: data.date,
            G_Nrx_J_T_check: data.joripara_dolar,
            G_Nrx_IQD_check: data.joripara_IQD
          };
        });
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };

  G_getPrintPasswordRent = (NOW) => {
    if (this.state.G_kartonakan === 0) {
      swal({
        title: "ببورە",
        text: "بەبێ کاڵا ناتوانی پسوولە چاپ بکەی",
        icon: "error"
      });
    } else {
      const p = prompt("وشەی نهێنی داخیل بکە!");
      if (p === "55") {
        this.setState({ G_pass: true }, () => {
          this.getPrint(NOW);
        });
      }
    }
  };

  //end of garanawa bo koga

  // functions of raporty Qazanj
  Q_getfooter = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/qazanjykalla?from=${this.state.Q_from}&to=${this.state.Q_to}&jwlla=pswla&nrxdolar=${this.state.navdolar}`,
        config
      );
      let datasale = res.data.salefooter;
      let datagaranawa = res.data.garanawafooter;
      this.setState(
        {
          Q_koyQazanj:
            datasale.length !== 0
              ? Number(datasale[0].qazanjywasl).toFixed(2)
              : 0,
          Q_dashkandolar:
            datasale.length !== 0
              ? Number(datasale[0].dashkandolar).toFixed(2)
              : 0,
          Q_dashkandinar:
            datasale.length !== 0
              ? Number(datasale[0].dashkandinar).toFixed(2)
              : 0,
          Q_ganawa:
            datagaranawa.length !== 0
              ? Number(datagaranawa[0].qaznjygarawa).toFixed(2)
              : 0
        },
        () => {
          let qz = _.subtract(this.state.Q_koyQazanj, this.state.Q_ganawa);
          let dashkan = this.state.Q_dashkandolar;
          let safi = Number(_.subtract(qz, dashkan)).toFixed(2);
          this.setState({
            Q_qazanjysafi: safi
          });
        }
      );
    } catch (error) {
      alert("هیج پسولەیەک لەم بەروارە نیە");
    }
  };

  Q_getkala = () => {
    this.setState(
      {
        Q_kala: !this.state.Q_kala,
        Q_wasl: false,
        Q_rastawxo: false,
        Q_wakel: false,
        Q_data: []
      },
      () => {
        this.Q_peshandan();
      }
    );
  };

  Q_getwakel = () => {
    this.setState(
      {
        Q_wakel: !this.state.Q_wakel,
        Q_wasl: false,
        Q_rastawxo: false,
        Q_kala: false,
        Q_data: []
      },
      () => {
        this.Q_peshandan();
      }
    );
  };

  Q_getwasl = () => {
    this.setState(
      {
        Q_wasl: !this.state.Q_wasl,
        Q_wakel: false,
        Q_rastawxo: false,
        Q_kala: false,
        Q_data: []
      },
      () => {
        this.Q_peshandan();
      }
    );
  };

  Q_getrastawxo = () => {
    this.setState(
      {
        Q_rastawxo: !this.state.Q_rastawxo,
        Q_wasl: false,
        Q_wakel: false,
        Q_kala: false,
        Q_data: []
      },
      () => {
        this.Q_peshandan();
      }
    );
  };
  Q_peshandan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    if (this.state.Q_from === "" || this.state.Q_to === "") {
      alert("بەروار داخل بکە");
    } else {
      let res;
      if (this.state.Q_wasl === true) {
        res = await Instance.get(
          `/api/v1/qazanjykalla?from=${this.state.Q_from}&to=${this.state.Q_to}&jwlla=pswla`,
          config
        );
      } else if (this.state.Q_wakel === true) {
        res = await Instance.get(
          `/api/v1/qazanjykalla?from=${this.state.Q_from}&to=${this.state.Q_to}&jwlla=wakil`,
          config
        );
      } else if (this.state.Q_rastawxo === true) {
        res = await Instance.get(
          `/api/v1/qazanjykalla?from=${this.state.Q_from}&to=${this.state.Q_to}&jwlla=rastawxo`,
          config
        );
      } else if (this.state.Q_kala === true) {
        res = await Instance.get(
          `/api/v1/qazanjykalla?from=${this.state.Q_from}&to=${this.state.Q_to}&jwlla=kalla`,
          config
        );
      } else {
        ///deafult
        res = await Instance.get(
          `/api/v1/qazanjykalla?from=${this.state.Q_from}&to=${this.state.Q_to}&jwlla=pswla`,
          config
        );
      }

      this.setState({
        Q_data: res.data.wasl
      });
      this.Q_getfooter();
      this.Q_CloseModal();
    }
  };
  Q_OpenModal = async (userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const promp = prompt("وشەی نهێنی داخیل بکە");
      let data = {
        password: promp
      };
      const pass = await Instance.post(
        `api/v1/open?id=${userid}`,
        data,
        config
      );

      if (pass.data.status === false) {
        alert("وشەی نهێنی هەڵەیە");
      } else if (pass.data.status === true) {
        this.setState(() => {
          return {
            Q_modalOpen: !this.state.Q_modalOpen,
            Q_data: [],
            Q_koyQazanj: 0,
            Q_qazanjysafi: 0,
            Q_dashkandolar: 0,
            Q_dashkandinar: 0,
            Q_ganawa: 0
          };
        });
      }
    } catch (error) {
      alert("وشەی نهێنی هەڵەیە");
    }
  };

  Q_OpenModal = async (userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const promp = prompt("وشەی نهێنی داخیل بکە");
      let data = {
        password: promp
      };
      const pass = await Instance.post(
        `api/v1/open?id=${userid}`,
        data,
        config
      );

      if (pass.data.status === false) {
        alert("وشەی نهێنی هەڵەیە");
      } else if (pass.data.status === true) {
        this.setState(() => {
          return {
            Q_modalOpen: !this.state.Q_modalOpen,
            Q_data: [],
            Q_koyQazanj: 0,
            Q_qazanjysafi: 0,
            Q_dashkandolar: 0,
            Q_dashkandinar: 0,
            Q_ganawa: 0
          };
        });
      }
    } catch (error) {
      alert("وشەی نهێنی هەڵەیە");
    }
  };

  Q_CloseModal = () => {
    this.setState(() => {
      return { Q_modalOpen: false };
    });
  };

  // functions of Raporty Rozhana

  D_OpenModal = async (e, userid) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(
      `api/v1/open?id=${userid}&perms=yes`,
      data,
      config
    );

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(() => {
        return {
          d_modalOpen: !this.state.d_modalOpen,
          d_dataRozhana: [],
          d_paraynadraw$: 0,
          d_paraynadrawID: 0,
          d_paraywargeraw$: 0,
          d_paraywargerawID: 0,
          d_froahraw$: 0,
          d_froshrawID: 0,
          d_rahel$: 0,
          d_rahelID: 0,
          d_yassin$: 0,
          d_yassinID: 0,
          d_wargrtnawayQarz$: 0,
          d_wargrtnawayQarzID: 0,
          d_fib: 0,
          d_fib_Iqd: 0,
          d_cash: 0,
          d_cash_Iqd: 0,
          d_dashkan: 0,
          d_dashkan_iqd: 0,
          d_koyparakomRRR: 0,
          d_koyparadanRRR: 0,
          d_koyparadandinar: 0,
          d_koyparadandolar: 0,
          d_garanawa_Dolar: "",
          d_garanawa_Dinar: ""
        };
      });
    }
  };

  D_CloseModal = () => {
    this.setState(() => {
      return { d_modalOpen: false };
    });
  };

  // end
  /////////daily raport
  D_hameJwllakan = async () => {
    this.D_CloseModal();
    this.D_rozhanafooter();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    if (this.state.d_hamw === true) {
      const res = await Instance.get(
        `/api/v1/dailiyReport?from=${this.state.d_from}&to=${this.state.d_to}&jwlla=`,
        config
      );
      const data = res.data.wasl;
      this.setState({
        d_dataRozhana: data
      });
    } else {
      const res = await Instance.get(
        `/api/v1/dailiyReport?from=${this.state.d_from}&to=${this.state.d_to}&jwlla=`,
        config
      );
      const data = res.data.wasl;
      this.setState({
        d_dataRozhana: data
      });
    }
  };

  D_rozhanafroshtn = async () => {
    this.setState(
      {
        d_froshtn: true,
        d_parawargrtn: false,
        d_hamw: false,
        d_dataRozhana: [],
        d_garanawa: false,
        JK_paradan: false,
        JK_kompanyakan: false
      },
      async () => {
        if (localStorage.token) {
          setToken(localStorage.token);
        }
        const config = {
          "Content-Type": "application/json"
        };
        const res = await Instance.get(
          `/api/v1/dailiyReport?from=${this.state.d_from}&to=${this.state.d_to}&jwlla=froshtn`,
          config
        );
        const data = res.data.wasl;
        this.setState({
          d_dataRozhana: data
        });
      }
    );
  };

  JK_Paradanakan = async () => {
    this.setState(
      {
        JK_paradan: true,
        JK_kompanyakan: false,
        d_froshtn: false,
        d_parawargrtn: false,
        d_hamw: false,
        d_dataRozhana: [],
        d_garanawa: false
      },
      async () => {
        if (localStorage.token) {
          setToken(localStorage.token);
        }
        const config = {
          "Content-Type": "application/json"
        };
        const res = await Instance.get(
          `/api/v1/dailiyReport?from=${this.state.d_from}&to=${this.state.d_to}&jwlla=paradan`,
          config
        );
        const data = res.data.wasl;
        this.setState({
          d_dataRozhana: data
        });
      }
    );
  };

  JK_mandubakan = async () => {
    this.setState(
      {
        JK_kompanyakan: true,
        d_froshtn: false,
        d_parawargrtn: false,
        d_hamw: false,
        d_dataRozhana: [],
        JK_paradan: false,
        d_garanawa: false
      },
      async () => {
        if (localStorage.token) {
          setToken(localStorage.token);
        }
        const config = {
          "Content-Type": "application/json"
        };
        const res = await Instance.get(
          `/api/v1/dailiyReport?from=${this.state.d_from}&to=${this.state.d_to}&jwlla=Maf`,
          config
        );
        const data = res.data.wasl;
        this.setState({
          d_dataRozhana: data
        });
      }
    );
  };

  D_rozhanaGaranawa = async () => {
    this.setState(
      {
        d_garanawa: true,
        d_parawargrtn: false,
        d_froshtn: false,
        d_hamw: false,
        d_dataRozhana: [],
        JK_paradan: false,
        JK_kompanyakan: false
      },
      async () => {
        if (localStorage.token) {
          setToken(localStorage.token);
        }
        const config = {
          "Content-Type": "application/json"
        };
        const res = await Instance.get(
          `/api/v1/dailiyReport?from=${this.state.d_from}&to=${this.state.d_to}&jwlla=garanawa`,
          config
        );
        const data = res.data.wasl;
        this.setState({
          d_dataRozhana: data
        });
      }
    );
  };

  D_rozhanafooter = async () => {
    const res = await Instance.get(
      `/api/v1/waslkan?from=${this.state.d_from}&to=${this.state.d_to}`
    );
    const data = res.data.pswla[0];
    const rahel = await Instance.get(
      `/api/v1/rahel?from=${this.state.d_from}&to=${this.state.d_to}`
    );
    const raheldata = rahel.data.pswla[0];
    const yassin = await Instance.get(
      `/api/v1/yassin?from=${this.state.d_from}&to=${this.state.d_to}`
    );
    const yassindata = yassin.data.pswla[0];
    const para = await Instance.get(
      `/api/v1/para?from=${this.state.d_from}&to=${this.state.d_to}`
    );
    const paradata = para.data.paras[0];
    const prahel = await Instance.get(
      `/api/v1/prahel?from=${this.state.d_from}&to=${this.state.d_to}`
    );
    const praheldata = prahel.data.pswla[0];
    const pyassin = await Instance.get(
      `/api/v1/pyassin?from=${this.state.d_from}&to=${this.state.d_to}`
    );
    const footerfroshtn = await Instance.get(
      `/api/v1/FooterFroshtn?from=${this.state.d_from}&to=${this.state.d_to}`
    );
    const footerfroshtnFIB = await Instance.get(
      `/api/v1/FooterFroshtnFIB?from=${this.state.d_from}&to=${this.state.d_to}`
    );
    const pyassindata = pyassin.data.pswla[0];

    const raheldolarsum = (
      (raheldata === undefined ? 0 : raheldata.totaldolar) +
      (praheldata === undefined ? 0 : praheldata.paraygarawadolar)
    ).toFixed(2);
    const raheldinarsum = (
      (raheldata === undefined ? 0 : raheldata.totaldinar) +
      (praheldata === undefined ? 0 : praheldata.paraygarawadinar)
    ).toFixed(2);
    const yassindolarsum = (
      (yassindata === undefined ? 0 : yassindata.totaldolar) +
      (pyassindata === undefined ? 0 : pyassindata.paraygarawadolar)
    ).toFixed(2);
    const yassindinarsum = (
      (yassindata === undefined ? 0 : yassindata.totaldinar) +
      (pyassindata === undefined ? 0 : pyassindata.paraygarawadinar)
    ).toFixed(2);

    const footer = await Instance.get(
      `/api/v1/paradanakanfromto?from=${this.state.d_from}&to=${this.state.d_to}`
    );
    const komp = await Instance.get(
      `/api/v1/mandwb?from=${this.state.d_from}&to=${this.state.d_to}`
    );
    let cashDOlar = _.add(
      _.add(
        footerfroshtn.data.pswla ? footerfroshtn.data.pswla.totaldolar : 0,
        footerfroshtn.data.wasl ? footerfroshtn.data.wasl.totaldolar : 0
      ),
      footerfroshtn.data.owe ? footerfroshtn.data.owe.totaldolar : 0
    );
    let cashIQD = _.add(
      _.add(
        footerfroshtn.data.pswla ? footerfroshtn.data.pswla.totaldinar : 0,
        footerfroshtn.data.wasl ? footerfroshtn.data.wasl.totaldinar : 0
      ),
      footerfroshtn.data.owe ? footerfroshtn.data.owe.totaldinar : 0
    );

    this.setState({
      d_paraynadraw$: data === undefined ? 0 : data.qarzdolar.toFixed(2),
      d_paraynadrawID: data === undefined ? 0 : data.qarzdinar.toFixed(2),
      d_paraywargeraw$:
        data === undefined ? 0 : data.paraywargirawdolar.toFixed(2),
      d_paraywargerawID:
        data === undefined ? 0 : data.paraywargirawdinar.toFixed(2),
      d_froahraw$: data === undefined ? 0 : data.totaldolar.toFixed(2),
      d_froshrawID: data === undefined ? 0 : data.totaldinar.toFixed(2),
      d_rahel$: _.subtract(raheldolarsum, rahel.data.garanawaDolar),
      d_rahelID: _.subtract(raheldinarsum, rahel.data.garanawaDinar),
      d_yassin$: _.subtract(yassindolarsum, yassin.data.garanawaDolar),
      d_yassinID: _.subtract(yassindinarsum, yassin.data.garanawaDinar),
      d_wargrtnawayQarz$:
        paradata === undefined ? 0 : paradata.paraygarawadolar.toFixed(2),
      d_wargrtnawayQarzID:
        paradata === undefined ? 0 : paradata.paraygarawadinar.toFixed(2),
      d_fib: _.add(
        footerfroshtnFIB.data.pswla
          ? footerfroshtnFIB.data.pswla.totaldolar
          : 0,
        Number(
          footerfroshtnFIB.data.wasl ? footerfroshtnFIB.data.wasl.totaldolar : 0
        )
      ),
      d_fib_Iqd: _.add(
        footerfroshtnFIB.data.pswla
          ? footerfroshtnFIB.data.pswla.totaldinar
          : 0,
        footerfroshtnFIB.data.wasl ? footerfroshtnFIB.data.wasl.totaldinar : 0
      ),
      d_cash: cashDOlar,
      d_cash_Iqd: cashIQD,
      d_dashkan: Number(res.data.discountdolar).toFixed(2),
      d_dashkan_iqd: Number(res.data.discountdinar).toFixed(2),
      d_garanawa_Dolar: Number(res.data.garanawaDolar),
      d_garanawa_Dinar: Number(res.data.garanawaDinar)
    });

    if (footer.data.paradanakan.length !== 0) {
      this.setState({
        d_koyparadandolar: footer.data.paradanakan[0].briparabadolar,
        d_koyparadandinar: footer.data.paradanakan[0].briparabadinar,
        d_koyparadanRRR:
          footer.data.paradanakan[0] && footer.data.paradanakan[0].briparabaRRR
            ? footer.data.paradanakan[0].briparabaRRR
            : 0
      });
    }

    if (komp.data.Mandwbs.length !== 0) {
      this.setState({
        d_koyparakomdolar: komp.data.Mandwbs[0].paraywargirawdolar,
        d_koyparakomdinar: komp.data.Mandwbs[0].paraywargirawdinar,
        d_koyparakomRRR:
          komp.data.Mandwbs[0] && komp.data.Mandwbs[0].paraywargirawrem
            ? komp.data.Mandwbs[0].paraywargirawrem
            : 0
      });
    }
  };

  D_jwllakan = () => {
    this.setState(
      {
        d_froshtn: false,
        d_parawargrtn: false,
        d_hamw: true,
        d_dataRozhana: [],
        d_garanawa: false,
        JK_paradan: false,
        JK_kompanyakan: false
      },
      () => {
        this.D_hameJwllakan();
      }
    );
  };

  D_rozhanaparawagrtn = async () => {
    this.setState(
      {
        d_parawargrtn: true,
        d_froshtn: false,
        d_hamw: false,
        d_dataRozhana: [],
        d_garanawa: false,
        JK_paradan: false,
        JK_kompanyakan: false
      },
      async () => {
        if (localStorage.token) {
          setToken(localStorage.token);
        }
        const config = {
          "Content-Type": "application/json"
        };
        const res = await Instance.get(
          `/api/v1/dailiyReport?from=${this.state.d_from}&to=${this.state.d_to}&jwlla=para`,
          config
        );
        const data = res.data.wasl;
        this.setState({
          d_dataRozhana: data
        });
      }
    );
  };

  /**
  |--------------------------------------------------
  | Go to RENT
  |--------------------------------------------------
  */

  D_gotowaslrentsearch = async (e, zhwasl, rest, index) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchwasll?numberofwasl=${Number(zhwasl)}`,
      config
    );

    const data = res.data.pswla;
    let wakil, rasiddolar, rasiddinar;
    if (data.type === 1) {
      let search = {
        code: Number(data.numberOfWakil)
      };
      const res = await Instance.post(
        `/api/v1/searchwakilBody`,
        search,
        config
      );
      wakil = res.data.wakils;
      rasiddinar = _.subtract(
        wakil && Number(wakil.rejaDinar),
        Number(data.qarzinwedinar)
      );
      rasiddolar = _.subtract(
        wakil && Number(wakil.rejaDolar),
        Number(data.qarzinwedolar)
      );
    }
    this.setState(
      () => {
        return {
          R_wasl: data,
          R_search_wasl: true,
          R_zh_wasl: data.numberofwasl,
          R_nawe_barez: data.wakil,
          R_mob: data.phone,
          R_zh_barez: data.numberOfWakil,
          R_total: data.koalldolar,
          R_totalID: data.koalldinar,
          R_dashkan: data.dashkandolar,
          R_dashkanID: data.dashkandinar,
          R_dataTable: data.saleTable,
          R_joripara: data.joripara,
          R_frosth: data.froshtn,
          R_wargr: data.whossale,
          R_paraDanID: data.paraydrawdinar,
          R_paraDan$: data.paraydrawdolar,
          R_kartonakan: data.koykartonkan,
          R_kreysayara: data.kreysayra,
          R_kreykrekar: data.kreykrekar,
          R_koywaznkarton: data.waznakan,
          R_paraywasl:
            data.joripara === "دۆلار" ? data.qarzinwedolar : data.qarzinwedinar,
          R_del_dis: true,
          R_up_froshtn: data.froshtn,
          R_date: data.date,
          R_togler: false,
          R_ItemSelect: rest,
          R_rasidWakildinar: Number(rasiddinar) ? Number(rasiddinar) : 0,
          R_rasidWakildolar: Number(rasiddolar) ? Number(rasiddolar) : 0,
          R_paradanPechawana: data.paradnPechawana,
          R_Nrx_J_T_check: data.joripara_dolar,
          R_Nrx_IQD_check: data.joripara_IQD,
          R_Mufrad_check: data.R_Mufrad_check,
          R_Item_check: data.R_Item_check,
          FIB: data.FIB,
          cash: data.cash,
          owe: data.owe,
          indexState: index
        };
      },
      () => {
        this.GetRasidNEWOfWakil();
      }
    );
    this.IT_createNewPage(e);
  };

  D_gotowaslparasearch = async (e, zhwasl, i) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/search?zhmara=${zhwasl}`, config);

    const data = res.data.parakan;
    this.setState(
      () => {
        return {
          P_search_wasl: true,
          P_zhmara: data.zhmara,
          P_nawe_barez: data.namewakil,
          P_barwar: data.date,
          P_zh_barez: data.wakilcode,
          P_paraPashDashkan:
            data.joripara === "دینار"
              ? data.paradwaykmkrdndinar
              : data.paradwaykmkrdndolar,
          P_dashkan: data.kmkrdnawa ? data.kmkrdnawa : 0,
          P_brePara:
            data.joripara === "دینار"
              ? data.paraywargirawdinar
              : data.paraywargirawdolar,
          P_joripara: data.joripara,
          P_wargr: data.nawiwargr,
          P_note: data.note,
          P_qarzeKonDolar: data.rasiddolar,
          P_qarzeKonID: data.rasiddinar,
          P_del_dis: true,
          P_paraywasl: data.paradwaykmkrdn,
          P_wasl: data,
          P_save: null,
          P_briparaypechawana: data.parayPechawana,
          M_cash: data.cash,
          M_FIB: data.FIB,
          P_pashDashkan:
            data.joripara === "دینار"
              ? data.paradwaykmkrdndinar
              : data.paradwaykmkrdndolar
        };
      },
      () => {
        this.Money_getWakilDataBySearchMoney(e);
      }
    );
  };

  D_gotowaslGaranawasearch = async (e, zhwasl, i) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchgaranawa?numberofwasl=${Number(zhwasl)}`,
      config
    );

    const data = res.data.pswla;
    if (data === null) {
      alert("ببورە ئەم پسولەیە بونی نیە");
    } else {
      this.setState(
        () => {
          return {
            G_wasl: data,
            G_search_wasl: true,
            G_zh_wasl: data.numberofwasl,
            G_nawe_barez: data.wakil,
            G_mob: data.phone,
            G_zh_barez: data.numberOfWakil,
            G_total: data.koalldolar,
            G_totalID: data.koalldinar,
            G_dashkan: data.dashkandolar,
            G_dashkanID: data.dashkandinar,
            G_dataTable: data.saleTable,
            G_joripara: data.joripara,
            G_frosht: data.froshtn,
            G_wargr: data.whossale,
            G_paraDanID: data.paraydrawdinar,
            G_paraDan$: data.paraydrawdolar,
            G_kartonakan: data.koykartonkan,
            G_kreysayara: data.kreysayra,
            G_kreykrekar: data.kreykrekar,
            G_koywaznkarton: data.waznakan,
            G_paraywasl:
              data.joripara === "دۆلار"
                ? data.qarzinwedolar
                : data.qarzinwedinar,
            G_del_dis: true,
            G_up_froshtn: data.froshtn,
            G_togler: false,
            G_date: data.date,
            indexState: i
          };
        },
        () => {
          this.R_ClearError();
          if (this.state.G_frosht === "فرۆشتنی وەکیل") {
            this.G_getWakilDataBySearchRent(e);
          }
        }
      );
    }
  };

  /**
  |--------------------------------------------------
  | functions of Raporty Wakel
  |--------------------------------------------------
  */

  RW_OpenModal = async (e, userid) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data, config);

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState({
        RW_dataWakelRaport: [],
        RW_koyfroshtndianr: 0,
        RW_koyfroshtndolar: 0,
        RW_nawibrez: "",
        RW_zh_barez: "",
        Rw_koyparaydrawba$: 0,
        Rw_koyparaydrawbaID: 0,
        RW_koyGaranawadolar: 0,
        RW_koyGaranawadianr: 0,
        RW_koyDashkanDolar: 0,
        RW_koyDashkanDinar: 0,
        RW_wakilSuggestions: [],
        RW_wakilCursor: -1,
        RW_modalOpen: !this.state.RW_modalOpen
      });
    }
  };

  RW_CloseModal = () => {
    this.setState(() => {
      return { RW_modalOpen: false };
    });
  };

  Rw_serchwakil = async (e) => {
    e.preventDefault(e);
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    //    this.toanotherInput(e)
    const res = await Instance.get(
      `/api/v1/searchwakil?code=${Number(this.state.RW_zh_barez)}`,
      config
    );

    const data = res.data.wakils;
    if (data === null) {
      alert("ببورە ئەم بەڕێزە بونی نیە");
    } else {
      this.setState(() => {
        return {
          RW_zh_barez: data.code,
          RW_nawibrez: data.Name,
          RW_mob: data.phone,
          RW_rasedyKotaye$: Number(data.rejaDolar).toFixed(2),
          RW_rasedyKotayeID: Number(data.rejaDinar).toFixed(2),
          R_rasidWakildolar: data.rejaDolar,
          R_rasidWakildinar: data.rejaDinar
        };
      });
    }
  };

  //////// name search of the wakil inside ڕاپۆرتی وەکیل ////////
  //// every keystroke in the name input asks the server for the wakils
  //// whose name contains what got typed so far
  RW_searchWakilByName = async (name) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/SearchNameWakil?name=${encodeURIComponent(name)}`,
        config
      );
      this.setState({
        RW_wakilSuggestions: res.data.wakils || [],
        RW_wakilCursor: -1
      });
    } catch (error) {
      this.setState({ RW_wakilSuggestions: [], RW_wakilCursor: -1 });
    }
  };

  RW_wakilNameHandle = (e) => {
    const name = e.target.value;
    this.setState({ RW_nawibrez: name }, () => {
      if (!name || name === "") {
        this.RW_emptyWakilSuggestions();
      } else {
        this.RW_searchWakilByName(name);
      }
    });
  };

  RW_emptyWakilSuggestions = () => {
    this.setState({
      RW_wakilSuggestions: [],
      RW_wakilCursor: -1
    });
  };

  //// clicking (or pressing Enter on) a name fills the same fields
  //// that Rw_serchwakil fills when the code gets typed
  RW_wakilSuggestionSelected = (wakil) => {
    if (!wakil) {
      return;
    }
    this.setState({
      RW_zh_barez: wakil.code,
      RW_nawibrez: wakil.Name,
      RW_mob: wakil.phone,
      RW_rasedyKotaye$: Number(wakil.rejaDolar).toFixed(2),
      RW_rasedyKotayeID: Number(wakil.rejaDinar).toFixed(2),
      R_rasidWakildolar: wakil.rejaDolar,
      R_rasidWakildinar: wakil.rejaDinar,
      RW_wakilSuggestions: [],
      RW_wakilCursor: -1
    });
  };

  //// arrow up/down moves inside the list, Enter picks the highlighted wakil
  RW_wakilListKeydown = (e) => {
    const { RW_wakilSuggestions, RW_wakilCursor } = this.state;
    if (!RW_wakilSuggestions || RW_wakilSuggestions.length === 0) {
      return;
    }
    if (e.keyCode === 27) {
      this.RW_emptyWakilSuggestions();
      return;
    }
    if (e.keyCode === 40) {
      e.preventDefault();
      this.setState((prevState) => ({
        RW_wakilCursor:
          prevState.RW_wakilCursor < RW_wakilSuggestions.length - 1
            ? prevState.RW_wakilCursor + 1
            : prevState.RW_wakilCursor
      }));
    } else if (e.keyCode === 38) {
      e.preventDefault();
      this.setState((prevState) => ({
        RW_wakilCursor:
          prevState.RW_wakilCursor > 0
            ? prevState.RW_wakilCursor - 1
            : prevState.RW_wakilCursor
      }));
    } else if (e.keyCode === 13) {
      //// nothing highlighted yet means the first match is the one wanted
      e.preventDefault();
      this.RW_wakilSuggestionSelected(
        RW_wakilCursor >= 0
          ? RW_wakilSuggestions[RW_wakilCursor]
          : RW_wakilSuggestions[0]
      );
    }
  };

  RW_setstInputEmpty = () => {
    this.setState(() => {
      return {
        RW_zh_barez: 0,
        RW_nawibrez: "",
        RW_wakilSuggestions: [],
        RW_wakilCursor: -1
      };
    });
  };
  /////// pshandani wkil raport
  RW_jwalakan = async (e) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    if (this.state.RW_nawibrez.toString().length !== 0) {
      this.RW_CloseModal();
      const config = {
        "Content-Type": "application/json"
      };

      if (this.state.RW_froshtn === true) {
        const res = await Instance.get(
          `/api/v1/wakilRaport?from=${this.state.RW_from}&to=${this.state.RW_to}&numberOfWakil=${this.state.RW_zh_barez}&jwlla=froshtn`,
          config
        );
        const data = res.data.wasl;
        this.setState({
          RW_dataWakelRaport: data
        });
      } else if (this.state.RW_parawargrtn === true) {
        const res = await Instance.get(
          `/api/v1/wakilRaport?from=${this.state.RW_from}&to=${this.state.RW_to}&numberOfWakil=${this.state.RW_zh_barez}&jwlla=para`,
          config
        );
        const data = res.data.wasl;
        this.setState({
          RW_dataWakelRaport: data
        });
      } else if (this.state.RW_garanawa === true) {
        const res = await Instance.get(
          `/api/v1/wakilRaport?from=${this.state.RW_from}&to=${this.state.RW_to}&numberOfWakil=${this.state.RW_zh_barez}&jwlla=garanawa`,
          config
        );
        const data = res.data.wasl;
        this.setState({
          RW_dataWakelRaport: data
        });
      } else {
        const res = await Instance.get(
          `/api/v1/wakilRaport?from=${this.state.RW_from}&to=${this.state.RW_to}&numberOfWakil=${this.state.RW_zh_barez}&jwlla=`,
          config
        );
        const data = res.data.wasl;
        this.setState({
          RW_dataWakelRaport: data
        });
      }
      this.RW_fooetr(e);
      this.RW_fooetrGaranawa(e);
    } else {
      this.setState({
        RW_dataWakelRaport: []
      });
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەوە",
        icon: "error"
      });
    }
  };

  RW_fooetr = async (e) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/wakilsaledata?from=${this.state.RW_from}&to=${this.state.RW_to}&numberOfWakil=${this.state.RW_zh_barez}`,
        config
      );

      const data = res.data.pswla[0];
      if (res.data.paraywargiraw.length !== 0) {
        this.setState({
          RW_koyfroshtndolar: Number(data.totaldolar).toFixed(2),
          RW_koyfroshtndianr: Number(data.totaldinar).toFixed(2),
          Rw_koyparaydrawba$: Number(
            res.data.paraywargiraw[0].paraygarawadolar + data.paraydrawdolar
          ).toFixed(2),
          Rw_koyparaydrawbaID: Number(
            res.data.paraywargiraw[0].paraygarawadinar + data.paraydrawdinar
          ).toFixed(2),
          RW_koyDashkanDolar: Number(res.data.discountdolar).toFixed(2),
          RW_koyDashkanDinar: Number(res.data.discountdinar).toFixed(2)
        });
      } else {
        this.setState({
          RW_koyfroshtndolar: Number(data.totaldolar).toFixed(2),
          RW_koyfroshtndianr: Number(data.totaldinar).toFixed(2),
          Rw_koyparaydrawba$: Number(data.paraydrawdolar).toFixed(2),
          Rw_koyparaydrawbaID: Number(data.paraydrawdinar).toFixed(2),
          RW_koyDashkanDolar: Number(res.data.discountdolar).toFixed(2),
          RW_koyDashkanDinar: Number(res.data.discountdinar).toFixed(2)
        });
      }
    } catch (error) {
      // alert('تکایە خانەکان پربکەرەوە')
    }
  };

  RW_fooetrGaranawa = async (e) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/wakilparaygarawa?from=${this.state.RW_from}&to=${this.state.RW_to}&numberOfWakil=${this.state.RW_zh_barez}`,
        config
      );

      const data = res.data.pswla[0];
      this.setState({
        RW_koyGaranawadolar: data.totaldolargaranawa,
        RW_koyGaranawadianr: data.totaldinargaranawa
      });
    } catch (error) {
      // alert('تکایە خانەکان پربکەرەوە')
    }
  };

  RW_jwllakan = () => {
    this.setState(
      {
        RW_froshtn: false,
        RW_parawargrtn: false,
        RW_hamw: true,
        RW_garanawa: false,
        RW_dataWakelRaport: []
      },
      () => {
        this.RW_jwalakan();
      }
    );
  };

  RW_rozhanafroshtn = async () => {
    this.setState(
      {
        RW_froshtn: true,
        RW_parawargrtn: false,
        RW_hamw: false,
        RW_garanawa: false,
        RW_dataWakelRaport: []
      },
      () => {
        this.RW_jwalakan();
      }
    );
  };

  RW_rozhanaparawagrtn = async () => {
    this.setState(
      {
        RW_parawargrtn: true,
        RW_garanawa: false,
        RW_froshtn: false,
        RW_hamw: false,
        RW_dataWakelRaport: []
      },
      () => {
        this.RW_jwalakan();
      }
    );
  };
  RW_wakilGaranawa = async () => {
    this.setState(
      {
        RW_garanawa: true,
        RW_parawargrtn: false,
        RW_froshtn: false,
        RW_hamw: false,
        RW_dataWakelRaport: []
      },
      () => {
        this.RW_jwalakan();
      }
    );
  };
  /////saerch
  RW_gotowaslrentsearch = async (e, zhwasl) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchwasll?numberofwasl=${Number(zhwasl)}`,
      config
    );

    const data = res.data.pswla;
    let wakil, rasiddolar, rasiddinar;
    if (data.type === 1) {
      let search = {
        code: Number(data.numberOfWakil)
      };
      const res = await Instance.post(
        `/api/v1/searchwakilBody`,
        search,
        config
      );
      wakil = res.data.wakils;
      rasiddinar = _.subtract(
        wakil && Number(wakil.rejaDinar),
        Number(data.qarzinwedinar)
      );
      rasiddolar = _.subtract(
        wakil && Number(wakil.rejaDolar),
        Number(data.qarzinwedolar)
      );
    }
    this.setState(
      () => {
        return {
          R_wasl: data,
          R_search_wasl: true,
          R_zh_wasl: data.numberofwasl,
          R_nawe_barez: data.wakil,
          R_mob: data.phone,
          R_zh_barez: data.numberOfWakil,
          R_total: data.koalldolar,
          R_totalID: data.koalldinar,
          R_dashkan: data.dashkandolar,
          R_dashkanID: data.dashkandinar,
          R_dataTable: data.saleTable,
          R_joripara: data.joripara,
          R_frosth: data.froshtn,
          R_wargr: data.whossale,
          R_paraDanID: data.paraydrawdinar,
          R_paraDan$: data.paraydrawdolar,
          R_kartonakan: data.koykartonkan,
          R_kreysayara: data.kreysayra,
          R_kreykrekar: data.kreykrekar,
          R_koywaznkarton: data.waznakan,
          R_paraywasl:
            data.joripara === "دۆلار" ? data.qarzinwedolar : data.qarzinwedinar,
          R_del_dis: true,
          R_up_froshtn: data.froshtn,
          R_date: data.date,
          R_togler: false,
          // R_open: null,
          R_rasidWakildinar: Number(rasiddinar) ? Number(rasiddinar) : 0,
          R_rasidWakildolar: Number(rasiddolar) ? Number(rasiddolar) : 0,
          R_paradanPechawana: data.paradnPechawana,
          R_Nrx_J_T_check: data.joripara_dolar,
          R_Nrx_IQD_check: data.joripara_IQD,
          R_Mufrad_check: data.R_Mufrad_check,
          R_Item_check: data.R_Item_check,
          FIB: data.FIB,
          cash: data.cash,
          owe: data.owe
        };
      },
      () => {
        this.GetRasidNEWOfWakil();
      }
    );
  };

  RW_gotowaslparasearch = async (e, zhwasl) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/search?zhmara=${zhwasl}`, config);

    const data = res.data.parakan;
    this.setState(() => {
      return {
        P_search_wasl: true,
        P_zhmara: data.zhmara,
        P_nawe_barez: data.namewakil,
        P_barwar: data.date,
        P_zh_barez: data.wakilcode,
        P_paraPashDashkan:
          data.joripara === "دینار"
            ? data.paradwaykmkrdndinar
            : data.paradwaykmkrdndolar,
        P_dashkan: data.kmkrdnawa ? data.kmkrdnawa : 0,
        P_brePara:
          data.joripara === "دینار"
            ? data.paraywargirawdinar
            : data.paraywargirawdolar,
        P_joripara: data.joripara,
        P_wargr: data.nawiwargr,
        P_note: data.note,
        P_qarzeKonDolar: data.rasiddolar,
        P_qarzeKonID: data.rasiddinar,
        P_del_dis: true,
        P_paraywasl: data.paradwaykmkrdn,
        P_wasl: data,
        P_togler: false,
        M_cash: data.cash,
        M_FIB: data.FIB,
        P_pashDashkan:
          data.joripara === "دینار"
            ? data.paradwaykmkrdndinar
            : data.paradwaykmkrdndolar
      };
    });
  };
  RW_gotowaslGaranawasearch = async (e, zhwasl) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchgaranawa?numberofwasl=${Number(zhwasl)}`,
      config
    );

    const data = res.data.pswla;
    if (data === null) {
      alert("ببورە ئەم پسولەیە بونی نیە");
    } else {
      this.setState(
        () => {
          return {
            G_wasl: data,
            G_search_wasl: true,
            G_zh_wasl: data.numberofwasl,
            G_nawe_barez: data.wakil,
            G_mob: data.phone,
            G_zh_barez: data.numberOfWakil,
            G_total: data.koalldolar,
            G_totalID: data.koalldinar,
            G_dashkan: data.dashkandolar,
            G_dashkanID: data.dashkandinar,
            G_dataTable: data.saleTable,
            G_joripara: data.joripara,
            G_frosht: data.froshtn,
            G_wargr: data.whossale,
            G_paraDanID: data.paraydrawdinar,
            G_paraDan$: data.paraydrawdolar,
            G_kartonakan: data.koykartonkan,
            G_kreysayara: data.kreysayra,
            G_kreykrekar: data.kreykrekar,
            G_koywaznkarton: data.waznakan,
            G_paraywasl:
              data.joripara === "دۆلار"
                ? data.qarzinwedolar
                : data.qarzinwedinar,
            G_del_dis: true,
            G_up_froshtn: data.froshtn,
            G_togler: false,
            G_date: data.date
          };
        },
        () => {
          if (this.state.G_frosht === "فرۆشتنی وەکیل") {
            this.G_getWakilDataBySearchRent(e);
          }
        }
      );
    }
  };

  // functions of Qarze Wakel

  QW_qazrywakil = async (e, userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const promp = prompt("وشەی نهێنی داخیل بکە");
      let data = {
        password: promp
      };
      const pass = await Instance.post(
        `api/v1/open?id=${userid}`,
        data,
        config
      );

      if (pass.data.status === false) {
        alert("وشەی نهێنی هەڵەیە");
        this.setState({
          QW_dataWakelQarz: [],
          QW_koyqarzakan: 0,
          QW_koyqarzakanID: 0,
          QW_rasiddinar: 0,
          QW_rasiddolar: 0
        });
      } else if (pass.data.status === true) {
        try {
          const res = await Instance.get("/api/v1/getWakilakan", config);
          this.setState({
            QW_dataWakelQarz: res.data.wakilakan
          });

          this.QW_koyqarzakan();
          this.QW_koyqarzakanID();
        } catch (error) {
          alert("هەڵە هەیە لە بەروار");
        }
      }
    } catch (error) {
      alert("وشەی نهێنی هەڵەیە");
    }
  };

  QW_koyqarzakan = () => {
    let subTotal = 0;
    this.state.QW_dataWakelQarz.map(
      (item) => (subTotal += Number(item.rejaDolar))
    );
    const kartons = Number(Number(subTotal).toFixed(2));

    this.setState(() => {
      return {
        QW_rasiddolar: kartons
      };
    });
  };

  QW_koyqarzakanID = () => {
    let subTotal = 0;
    this.state.QW_dataWakelQarz.map(
      (item) => (subTotal += Number(item.rejaDinar))
    );
    const kartons = Number(Number(subTotal).toFixed(2));

    this.setState(() => {
      return {
        QW_rasiddinar: kartons
      };
    });
  };

  // functions of Jarde Maxzan ean raporty Koga

  JM_jardyrasidkarton = () => {
    let subTotal = 0;
    this.state.JM_dataRaportyKoga.map(
      (item) => (subTotal += Number(item.rasidKarton))
    );
    const kartons = Number(Number(subTotal).toFixed(2));

    this.setState(() => {
      return {
        JM_koyrasidkarton: kartons
      };
    });
  };

  JM_jardyrasidparakan = () => {
    let subTotal = 0;
    this.state.JM_dataRaportyKoga.map(
      (item) =>
        (subTotal += Number(
          item.rasidKarton * item.numberOfDarzan * item.price
        ))
    );
    const kartons = Number(Number(subTotal).toFixed(2));

    this.setState(() => {
      return {
        JM_koyrasidparakan: kartons
      };
    });
  };

  JM_yaksanbasfrfn = () => {
    this.setState(
      {
        JM_dataRaportyKoga: this.state.JM_allproducts,
        JM_yaksanbasfr: true,
        JM_zyattrlasfr: false
      },
      () => {
        this.setState({
          JM_dataRaportyKoga: this.state.JM_dataRaportyKoga.filter(
            (el) => parseFloat(el.rasidKarton.toString().split("e-")) <= 0.009
          )
        });
      }
    );
  };

  JM_zyatrlasfrfn = () => {
    this.setState(
      {
        JM_dataRaportyKoga: this.state.JM_allproducts,
        JM_zyattrlasfr: true,
        JM_yaksanbasfr: false
      },
      () => {
        this.setState({
          JM_dataRaportyKoga: this.state.JM_dataRaportyKoga.filter(
            (el) => parseFloat(el.rasidKarton.toString().split("e-")) > 0
          )
        });
      }
    );
  };

  JM_pshandan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get("/api/v1/getProducts", config);
      this.setState({
        JM_dataRaportyKoga: res.data.products,
        JM_allproducts: res.data.products,
        JM_zyattrlasfr: false,
        JM_yaksanbasfr: false
      });
      this.JM_CloseModal();
      this.JM_jardyrasidkarton();
      this.JM_jardyrasidparakan();
    } catch (error) {
      alert("هەڵە هەیە لە بەروار");
    }
  };

  JM_OpenModal = async (e, userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const promp = prompt("وشەی نهێنی داخیل بکە");
      let data = {
        password: promp
      };
      const pass = await Instance.post(
        `api/v1/open?id=${userid}`,
        data,
        config
      );

      if (pass.data.status === false) {
        alert("وشەی نهێنی هەڵەیە");
      } else if (pass.data.status === true) {
        this.setState(() => {
          return {
            JM_modalOpen: !this.state.JM_modalOpen,
            JM_dataRaportyKoga: [],
            JM_footer_rasedyhamukartonakan: 0
          };
        });
      }
    } catch (error) {
      alert("وشەی نهێنی هەڵەیە");
    }
  };

  JM_CloseModal = () => {
    this.setState(() => {
      return { JM_modalOpen: false };
    });
  };

  /////// delete product ;la raporty koga jardy maxzan
  JM_clickOnDelete = async (id) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    if (window.confirm("دڵنیای لە ڕەشکردنەوەی ئەم کاڵایە؟")) {
      this.setState(
        {
          JM_dataRaportyKoga: this.state.JM_dataRaportyKoga.filter(
            (r) => r._id !== id
          )
        },
        () => {
          this.JM_jardyrasidkarton();
          this.JM_jardyrasidparakan();
        }
      );
      await Instance.delete(`/api/v1/deleteProduct/${id}`, config);
    }
  };

  //functions of Raporty Kala (mawad)

  K_OpenModal = async (e, userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const promp = prompt("وشەی نهێنی داخیل بکە");
      let data = {
        password: promp
      };
      const pass = await Instance.post(
        `api/v1/open?id=${userid}&perms=yes`,
        data,
        config
      );

      if (pass.data.status === false) {
        alert("وشەی نهێنی هەڵەیە");
      } else if (pass.data.status === true) {
        this.setState(() => {
          return {
            K_modalOpen: !this.state.K_modalOpen,
            K_datatable: [],
            K_datafilter: [],
            K_rasedekartonKren: 0,
            K_rasedekartonfroshtn: 0,
            K_rasedekartongarnawa: 0,
            K_rasedeKarton: 0,
            K_naweKala: "",
            K_zhamara: ""
          };
        });
      }
    } catch (error) {
      alert("وشەی نهێنی هەڵەیە");
    }
  };

  K_CloseModal = () => {
    this.setState(() => {
      return { K_modalOpen: false };
    });
  };

  K_getGaranawa = () => {
    this.setState(
      {
        k_navbar_garanawa: true,
        k_navbar_froshtn: false,
        k_navbar_tomarkrdn: false,
        K_datatable: []
      },
      () => {
        this.K_pshandan();
      }
    );
  };

  K_getFroshtn = () => {
    this.setState(
      {
        k_navbar_froshtn: true,
        k_navbar_tomarkrdn: false,
        k_navbar_garanawa: false,
        K_datatable: []
      },
      () => {
        this.K_pshandan();
      }
    );
  };

  K_gettomarkrdn = (e) => {
    this.setState(
      {
        k_navbar_tomarkrdn: true,
        k_navbar_froshtn: false,
        k_navbar_garanawa: false,
        K_datatable: []
      },
      () => {
        this.K_pshandan();
      }
    );
  };
  K_getproduct = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    this.toanotherInput(e);

    const res = await Instance.get(
      `/api/v1/searchtoproduct?code=${this.state.K_zhamara}&&nameofproduct=`,
      config
    );

    const data = res.data.product;
    if (data === null) {
      alert("ببورە ئەم کاڵایە بونی نیە");
    } else {
      this.setState(() => {
        return {
          K_zhamara: data.code,
          K_naweKala: data.nameofproduct
        };
      });
    }
  };

  K_pshandan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      this.K_CloseModal();
      const table = this.state.K_datatable;
      const res = await Instance.get(
        `/api/v1/qazanjyharkallayak?raqam=${this.state.K_zhamara}&from=${this.state.K_from}&to=${this.state.K_to}`,
        config
      );
      const data = res.data.pswla;
      const froshtndata = res.data.mawad;

      const resgaranawa = await Instance.get(
        `/api/v1/garanhayharkallayak?raqam=${this.state.K_zhamara}&from=${this.state.K_from}&to=${this.state.K_to}`,
        config
      );
      const datagaranawa = resgaranawa.data.pswla;
      const garanawadata = res.data.mawad;

      const kalla = await Instance.get(
        `/api/v1/jardykalla?raqam=${this.state.K_zhamara}&from=${this.state.K_from}&to=${this.state.K_to}`,
        config
      );
      const kalladata = kalla.data.mawad;
      const kkk = kalla.data.kalladate;
      let nrxkrin, nrxdolar, nrxdinar, rased, nrxidwamfroshtn;
      kalladata.forEach((el) => {
        nrxdinar = el.saleDinar;
        nrxdolar = el.saleDolar;
        nrxkrin = el.price;
        rased = el.rasidKarton;
        nrxidwamfroshtn = el.nrxeFroshtnDolar2;
      });
      kkk.forEach((data) => {
        table.push({
          jwlla: "کڕین",
          barwar: data.date,
          joripara: "دۆلار",
          froshtn: data.numberOfCarton,
          krin: nrxkrin,
          froshtndolar: nrxdolar,
          froshtndinar: nrxdinar
        });
      });
      data.forEach((el) => {
        rased = froshtndata.rasidKarton;
        table.push({
          jwlla: "فرۆشتن",
          code: el.numberOfWakil,
          jor: el.froshtn,
          barwar: el.date,
          numberofwasl: el.numberofwasl,
          naw: el.wakil,
          joripara: el.joripara,
          froshtn: el.saleTable.carton,
          krin: froshtndata.saleDolar,
          froshtndolar: el.saleTable.nrx,
          froshtndinar: froshtndata.saleDinar,
          nrxeFroshtnDolar2: nrxidwamfroshtn,
          joripara_dolar: el.joripara_dolar
        });
      });
      datagaranawa.forEach((el) => {
        table.push({
          jwlla: "گەڕانەوە",
          code: el.numberOfWakil,
          jor: el.froshtn,
          barwar: el.date,
          numberofwasl: el.numberofwasl,
          naw: el.wakil,
          joripara: el.joripara,
          froshtn: el.saleTable.carton,
          krin: garanawadata.saleDolar,
          froshtndolar: el.saleTable.nrx,
          froshtndinar: garanawadata.saleDinar,
          nrxeFroshtnDolar2: nrxidwamfroshtn
        });
      });
      this.setState(
        {
          K_rasedeKarton: rased,
          K_datafilter: table.filter((el) => el.jwlla === "فرۆشتن"),
          K_kamtrlasfr: false,
          K_zyattrlasfr: false,
          K_yaksanbasfr: false
        },
        () => {
          this.K_getrasedFroshtn();
          this.K_getrasedKren();
          this.K_getrasedGaranawa();
        }
      );
      if (this.state.k_navbar_froshtn === true) {
        this.setState({
          K_datatable: table.filter((el) => el.jwlla === "فرۆشتن"),
          K_datafilter: table.filter((el) => el.jwlla === "فرۆشتن")
        });
      } else if (this.state.k_navbar_garanawa === true) {
        this.setState({
          K_datatable: table.filter((el) => el.jwlla === "گەڕانەوە"),
          K_datafilter: table.filter((el) => el.jwlla === "فرۆشتن")
        });
      } else if (this.state.k_navbar_tomarkrdn === true) {
        this.setState({
          K_datatable: table.filter((el) => el.jwlla === "کڕین"),
          K_datafilter: table.filter((el) => el.jwlla === "فرۆشتن")
        });
      }
    } catch (error) {
      alert("هەڵە هەیە لە بەروار");
    }
  };

  K_getrasedKren = () => {
    let subTotal = 0;
    this.state.K_datatable.filter((el) => el.jwlla === "کڕین").map(
      (item) => (subTotal += Number(item.froshtn))
    );
    const kartons = Number(Number(subTotal).toFixed(2));

    this.setState(() => {
      return {
        K_rasedekartonKren: kartons
      };
    });
  };

  K_getrasedFroshtn = () => {
    let subTotal = 0;
    this.state.K_datatable.filter((el) => el.jwlla === "فرۆشتن").map(
      (item) => (subTotal += Number(item.froshtn))
    );
    const kartons = Number(Number(subTotal).toFixed(2));

    this.setState(() => {
      return {
        K_rasedekartonfroshtn: kartons
      };
    });
  };
  K_getrasedGaranawa = () => {
    let subTotal = 0;
    this.state.K_datatable.filter((el) => el.jwlla === "گەڕانەوە").map(
      (item) => (subTotal += Number(item.froshtn))
    );
    const kartons = Number(Number(subTotal).toFixed(2));

    this.setState(() => {
      return {
        K_rasedekartongarnawa: kartons
      };
    });
  };
  K_grantr = (state) => {
    this.setState(
      {
        K_datatable: this.state.K_datafilter,
        K_yaksanbasfr: false,
        K_zyattrlasfr: state === false ? true : false,
        K_kamtrlasfr: false,
        K_dolar2: state === true ? true : false
      },
      () => {
        this.setState({
          K_datatable: this.state.K_datatable.filter((el) => {
            if (!state) {
              return el.joripara === "دۆلار"
                ? el.froshtndolar > el.krin
                : el.froshtndolar > el.froshtndinar;
            } else {
              return el.joripara_dolar;
            }
          })
        });
      }
    );
  };

  K_harzantr = () => {
    this.setState(
      {
        K_datatable: this.state.K_datafilter,
        K_yaksanbasfr: false,
        K_zyattrlasfr: false,
        K_kamtrlasfr: true
      },
      () => {
        this.setState({
          K_datatable: this.state.K_datatable.filter((el) =>
            el.joripara === "دۆلار"
              ? el.froshtndolar < el.krin
              : el.froshtndolar < el.froshtndinar
          )
        });
      }
    );
  };
  K_hamannrx = () => {
    this.setState(
      {
        K_datatable: this.state.K_datafilter,
        K_yaksanbasfr: true,
        K_zyattrlasfr: false,
        K_kamtrlasfr: false
      },
      () => {
        this.setState({
          K_datatable: this.state.K_datatable.filter((el) =>
            el.joripara === "دۆلار"
              ? el.froshtndolar === el.krin
              : el.froshtndolar === el.froshtndinar
          )
        });
      }
    );
  };

  K_gotowaslrentsearch = async (e, zhwasl) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchwasll?numberofwasl=${Number(zhwasl)}`,
      config
    );

    const data = res.data.pswla;
    this.setState(
      () => {
        return {
          R_wasl: data,
          R_search_wasl: true,
          R_zh_wasl: data.numberofwasl,
          R_nawe_barez: data.wakil,
          R_mob: data.phone,
          R_zh_barez: data.numberOfWakil,
          R_total: data.koalldolar,
          R_totalID: data.koalldinar,
          R_dashkan: data.dashkandolar,
          R_dashkanID: data.dashkandinar,
          R_dataTable: data.saleTable,
          R_joripara: data.joripara,
          R_frosth: data.froshtn,
          R_wargr: data.whossale,
          R_paraDanID: data.paraydrawdinar,
          R_paraDan$: data.paraydrawdolar,
          R_kartonakan: data.koykartonkan,
          R_kreysayara: data.kreysayra,
          R_kreykrekar: data.kreykrekar,
          R_koywaznkarton: data.waznakan,
          R_paraywasl:
            data.joripara === "دۆلار" ? data.qarzinwedolar : data.qarzinwedinar,
          R_del_dis: true,
          R_up_froshtn: data.froshtn,
          R_date: data.date,
          R_togler: false,
          // R_open: null,
          R_rasidWakildinar: Number(res.data.pswla.qarzikonwakildinar),
          R_rasidWakildolar: Number(res.data.pswla.qarzikonwakildolar),
          R_paradanPechawana: data.paradnPechawana,
          R_Nrx_J_T_check: data.joripara_dolar,
          R_Nrx_IQD_check: data.joripara_IQD,
          R_Mufrad_check: data.R_Mufrad_check,
          R_Item_check: data.R_Item_check,
          FIB: data.FIB,
          cash: data.cash,
          owe: data.owe
        };
      },
      () => {
        this.GetRasidNEWOfWakil();
      }
    );
  };

  K_gotowaslGaranawasearch = async (e, zhwasl) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchgaranawa?numberofwasl=${Number(zhwasl)}`,
      config
    );

    const data = res.data.pswla;
    if (data === null) {
      alert("ببورە ئەم پسولەیە بونی نیە");
    } else {
      this.setState(
        () => {
          return {
            G_wasl: data,
            G_search_wasl: true,
            G_zh_wasl: data.numberofwasl,
            G_nawe_barez: data.wakil,
            G_mob: data.phone,
            G_zh_barez: data.numberOfWakil,
            G_total: data.koalldolar,
            G_totalID: data.koalldinar,
            G_dashkan: data.dashkandolar,
            G_dashkanID: data.dashkandinar,
            G_dataTable: data.saleTable,
            G_joripara: data.joripara,
            G_frosht: data.froshtn,
            G_wargr: data.whossale,
            G_paraDanID: data.paraydrawdinar,
            G_paraDan$: data.paraydrawdolar,
            G_kartonakan: data.koykartonkan,
            G_kreysayara: data.kreysayra,
            G_kreykrekar: data.kreykrekar,
            G_koywaznkarton: data.waznakan,
            G_paraywasl:
              data.joripara === "دۆلار"
                ? data.qarzinwedolar
                : data.qarzinwedinar,
            G_del_dis: true,
            G_up_froshtn: data.froshtn,
            G_togler: false,
            G_date: data.date
          };
        },
        () => {
          this.R_ClearError();
          if (this.state.G_frosht === "فرۆشتنی وەکیل") {
            this.G_getWakilDataBySearchRent(e);
          }
        }
      );
    }
  };

  ///// end of raporty kalla

  //Rozhanay mawad

  RDM_OpenModal = async (e, userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data, config);
    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(() => {
        return {
          RDM_modalOpen: !this.state.RDM_modalOpen,
          RDM_dataWakelQarz: [],
          RDM_harzantr: false,
          RDM_harzantr_IQD: false,
          RDM_isSingle: false,
          GDM_grantr: false,
          GDM_grantr_IQD: false,
          GDM_isSingle: false
        };
      });
    }
  };
  RDM_CloseModal = () => {
    this.setState(() => {
      return { RDM_modalOpen: false };
    });
  };

  RDM_pshandan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(
      `/api/v1/getItemSaleTwoDate?from=${this.state.RDM_from}&to=${this.state.RDM_to}`,
      config
    );
    this.setState({
      RDM_dataWakelQarz: res.data.data
    });
    this.RDM_CloseModal();
  };
  ///// qarzy rastawxo functions
  QR_OpenModal = async (e, userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(
      `api/v1/open?id=${userid}&perms=yes`,
      data,
      config
    );
    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(() => {
        return {
          QR_openmodel: !this.state.QR_openmodel,
          QR_data: [],
          QR_rasiddinar: 0,
          QR_rasiddolar: 0
        };
      });
    }
  };
  QR_CloseModal = () => {
    this.setState(() => {
      return { QR_openmodel: false };
    });
  };

  QR_hamwqarzakan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(
      `/api/v1/waslrastawxo?from=${this.state.QR_from}&to=${this.state.QR_to}`,
      config
    );
    if (!res) {
      alert("هەڵە هەیە لە بەروار");
    }
    const footer = await Instance.get(
      `/api/v1/qarzrastawxo?from=${this.state.QR_from}&to=${this.state.QR_to}`,
      config
    );
    if (footer) {
      this.setState(
        {
          QR_data: res.data.pswla
        },
        () => {
          footer.data.pswla.forEach((el) => {
            this.setState({
              QR_rasiddolar: Number(el.qarzdolar).toFixed(2),
              QR_rasiddinar: Number(el.qarzdinar).toFixed(2)
            });
          });
        }
      );
    }

    this.QR_CloseModal();
  };

  QR_gotowaslrentsearch = async (e, zhwasl) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchwasll?numberofwasl=${Number(zhwasl)}`,
      config
    );

    const data = res.data.pswla;
    this.setState(
      () => {
        return {
          R_wasl: data,
          R_search_wasl: true,
          R_zh_wasl: data.numberofwasl,
          R_nawe_barez: data.wakil,
          R_mob: data.phone,
          R_zh_barez: data.numberOfWakil,
          R_total: data.koalldolar,
          R_totalID: data.koalldinar,
          R_dashkan: data.dashkandolar,
          R_dashkanID: data.dashkandinar,
          R_dataTable: data.saleTable,
          R_joripara: data.joripara,
          R_frosth: data.froshtn,
          R_wargr: data.whossale,
          R_paraDanID: data.paraydrawdinar,
          R_paraDan$: data.paraydrawdolar,
          R_kartonakan: data.koykartonkan,
          R_kreysayara: data.kreysayra,
          R_kreykrekar: data.kreykrekar,
          R_koywaznkarton: data.waznakan,
          R_paraywasl:
            data.joripara === "دۆلار" ? data.qarzinwedolar : data.qarzinwedinar,
          R_del_dis: true,
          R_up_froshtn: data.froshtn,
          R_date: data.date,
          R_togler: false,
          // R_open: null,
          R_rasidWakildinar: Number(res.data.pswla.qarzikonwakildinar),
          R_rasidWakildolar: Number(res.data.pswla.qarzikonwakildolar),
          R_paradanPechawana: data.paradnPechawana,
          R_Nrx_J_T_check: data.joripara_dolar,
          R_Nrx_IQD_check: data.joripara_IQD,
          R_Mufrad_check: data.R_Mufrad_check,
          R_Item_check: data.R_Item_check,
          FIB: data.FIB,
          cash: data.cash,
          owe: data.owe
        };
      },
      () => {
        this.GetRasidNEWOfWakil();
      }
    );
  };
  ///// end of qarzy rastawxo

  //functions of raporty chin

  RC_getnavbarRemembe = (e) => {
    e.preventDefault();
    if (this.state.RC_nrxeNavR !== "") {
      localStorage.setItem("rm", this.state.RC_nrxeNavR);
    }
    this.setState({ RC_R_disaebl: !this.state.RC_R_disaebl });
  };

  RC_getnavbarMatr = (e) => {
    e.preventDefault();
    if (this.state.RC_nrxNavM !== "") {
      localStorage.setItem("mm", this.state.RC_nrxNavM);
    }
    this.setState({ RC_M_desaebl: !this.state.RC_M_desaebl });
  };

  RC_getKOyGshtyRemembe = () => {
    let rezhaynawkarton = this.state.RC_rezhaynawKarton;
    let nrxeRemembe = this.state.RC_nrxRRR;
    let koygshtyremembe = rezhaynawkarton * nrxeRemembe;
    return koygshtyremembe.toFixed(2);
  };

  RC_getKOyGshty$ = () => {
    let koygshtyRemembe = this.RC_getKOyGshtyRemembe();
    let nrxenavRemembe = this.state.RC_nrxeNavR;
    let koygshty$ = koygshtyRemembe / nrxenavRemembe;
    return koygshty$.toFixed(2);
  };

  RRRchange = (e) => {
    this.setState(
      {
        RC_nrxRRR: e.target.value
      },
      () => {
        let kotaykalla = this.RC_nrxikotaykalla();
        let dabsh = Number(
          this.state.RC_rezhaynawKarton /
            (this.state.RC_rezhaynawKarton / this.state.RC_dabash)
        );
        let darzan = kotaykalla / dabsh;

        this.setState({
          RC_koygshtyR: this.RC_getKOyGshtyRemembe(),
          RC_koygshty$: this.RC_getKOyGshty$(),
          RC_koymatr$: this.RC_getKOyGshtyMatr(),
          RC_nrxekotayeKala$: this.RC_nrxikotaykalla(),
          RC_kren: darzan
        });
      }
    );
    if (e.target.value === ".") {
      this.setState({
        RC_nrxRRR: "0."
      });
    }
  };

  RC_getKOyGshtyMatr = () => {
    let drezhi = this.state.RC_drezhe;
    let pani = this.state.RC_pane;
    let barzi = this.state.RC_barze;
    let nrximatr = this.state.RC_nrxNavM;

    let koygshtymatr = drezhi * pani * barzi * nrximatr;
    return koygshtymatr.toFixed(2);
  };

  RC_nrxikotaykalla = () => {
    let koymatr = this.RC_getKOyGshtyMatr();
    let kodolar = this.RC_getKOyGshty$();

    let nrxikotayykalla = Number(kodolar) + Number(koymatr);
    return nrxikotayykalla.toFixed(2);
  };

  RC_barzichnage = (e) => {
    this.setState(
      {
        RC_barze: e.target.value
      },
      () => {
        this.setState({
          RC_koymatr$: this.RC_getKOyGshtyMatr(),
          RC_nrxekotayeKala$: this.RC_nrxikotaykalla()
        });
      }
    );
    if (e.target.value === ".") {
      this.setState({
        RC_barze: "0."
      });
    }
  };

  RC_nrxiyakdarzan = () => {
    let kotaykalla = this.state.RC_nrxekotayeKala$;
    let dabsh = Number(
      this.state.RC_rezhaynawKarton /
        (this.state.RC_rezhaynawKarton / this.state.RC_dabash)
    );
    let darzan = kotaykalla / dabsh;

    return darzan.toFixed(2);
  };

  RC_saveToTable = (e) => {
    e.preventDefault();
    if (
      this.state.RC_nrxekotayeKala$ === "" ||
      this.state.RC_nrxekotayeKala$ === 0
    ) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    } else {
      const arr = this.state.RC_data;

      arr.push({
        _id: Math.random(),
        wasl: this.state.RC_zhmaaryPswla,
        karton: this.state.RC_nrxekotayeKala$,
        darzan: this.RC_nrxiyakdarzan(),
        zhmaralakarton: Number(
          this.state.RC_rezhaynawKarton /
            (this.state.RC_rezhaynawKarton / this.state.RC_dabash)
        ),
        date: Date.now(),
        rezhaykarton: this.state.RC_rezhaykarton
      });
      this.setState({
        RC_data: arr,
        RC_kren: this.RC_nrxiyakdarzan(),
        RC_kreneakcartoon: this.state.RC_nrxekotayeKala$
      });
    }
  };

  RC_newChina = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    if (
      this.state.RC_zhmarayKala === 0 ||
      this.state.RC_zhmaaryDukan === 0 ||
      this.state.RC_zhmaaryPswla === 0
    ) {
      alert("تکایە خانەکان پربکەوە");
    } else {
      try {
        const data = {
          code: this.state.RC_zhmarayKala,
          dukan: this.state.RC_zhmaaryDukan,
          table: this.state.RC_data,
          dabash: this.state.RC_dabash,
          rezhanawkarton: this.state.RC_rezhaynawKarton,
          rrr: this.state.RC_nrxRRR,
          koygshtyR: this.state.RC_koygshtyR,
          koygshtyDolar: this.state.RC_koygshty$,
          drezhi: this.state.RC_drezhe,
          pane: this.state.RC_pane,
          barzi: this.state.RC_barze,
          koymatrdolar: this.state.RC_koymatr$,
          nrxikotayykalla: this.state.RC_nrxekotayeKala$,
          wasl: this.state.RC_zhmaaryPswla,
          nrxdarzan: this.state.RC_kren,
          nrxkarton: this.state.RC_nrxekotayeKala$,
          frosthniyakkarton: this.state.RC_froshtneakKarton
        };
        const res = await Instance.post(`/api/v1/newchina`, data, config);
        const kalla = await Instance.get(
          `/api/v1/searchtoproduct?code=${this.state.RC_zhmarayKala}`,
          config
        );
        this.setState({
          RC_wasl: res.data.newwasl,
          RC_kalladata: kalla.data.product,
          RC_open: false,
          RC_save: true,
          RC_dis: true,
          RC_updatekala: false
        });
      } catch (error) {
        swal({
          title: "ببورە",
          text: "هەڵە هەیە لە خانەکان",
          icon: "error"
        });
      }
    }
  };

  RC_searcheKala = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const mawad = await Instance.get(
        `/api/v1/searchtoproduct?code=${this.state.RC_zhmarayKala}`,
        config
      );

      this.setState({
        RC_nawikalla: mawad.data.product.nameofproduct,
        RC_froshtn: mawad.data.product.saleDolar,
        RC_qazanj: mawad.data.product.qazanj
      });
    } catch (error) {
      swal({
        title: "ببورە",
        text: "هەڵە هەیە لە خانەکان",
        icon: "error"
      });
    }
  };

  RC_search = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    this.toanotherInput(e);
    this.RC_searcheKala();
    try {
      const res = await Instance.get(
        `/api/v1/searchchina/${this.state.RC_zhmarayKala}`,
        config
      );
      const kalla = await Instance.get(
        `/api/v1/searchtoproduct?code=${this.state.RC_zhmarayKala}`,
        config
      );
      const mawad = await Instance.get(
        `/api/v1/searchtoproduct?code=${this.state.RC_zhmarayKala}`,
        config
      );

      const data = res.data.product;
      this.setState({
        RC_search_wasl: true,
        RC_wasl: data,
        RC_data: data.table,
        RC_zhmaaryDukan: data.dukan,
        RC_dabash: data.dabash,
        RC_rezhaynawKarton: data.rezhanawkarton,
        RC_nrxRRR: data.rrr,
        RC_koygshtyR: data.koygshtyR,
        RC_kalladata: kalla.data.product,
        RC_open: false,
        RC_save: false,
        RC_koygshty$: data.koygshtyDolar,
        RC_drezhe: data.drezhi,
        RC_barze: data.barzi,
        RC_pane: data.pane,
        RC_koymatr$: data.koymatrdolar,
        RC_nrxekotayeKala$: data.nrxikotayykalla,
        RC_updatekala: false,
        RC_zhmaaryPswla: data.wasl,
        RC_dis: true,
        RC_nawikalla: mawad.data.product.nameofproduct,
        RC_kren: data.nrxdarzan,
        RC_kreneakcartoon: data.nrxkarton,
        RC_froshtneakKarton: data.frosthniyakkarton,
        RC_froshtnID: mawad.data.product.saleDinar,
        RC_kamtrlaDadarzan: mawad.data.product.saleOfLessTenDarzan,
        RC_kamtrlaNewkarton: mawad.data.product.saleOfLessHalfCarton
      });
    } catch (error) {
      swal({
        title: "ببورە",
        text: "هەڵە هەیە لە خانەکان",
        icon: "error"
      });
    }
  };

  RC_update = async (e, id) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    if (
      this.state.RC_zhmarayKala === 0 ||
      this.state.RC_zhmaaryDukan === 0 ||
      this.state.RC_zhmaaryPswla === 0
    ) {
      alert("تکایە خانەکان پربکەوە");
    } else {
      try {
        const data = {
          code: this.state.RC_zhmarayKala,
          dukan: this.state.RC_zhmaaryDukan,
          table: this.state.RC_data,
          dabash: this.state.RC_dabash,
          rezhanawkarton: this.state.RC_rezhaynawKarton,
          rrr: this.state.RC_nrxRRR,
          koygshtyR: this.state.RC_koygshtyR,
          koygshtyDolar: this.state.RC_koygshty$,
          drezhi: this.state.RC_drezhe,
          pane: this.state.RC_pane,
          barzi: this.state.RC_barze,
          koymatrdolar: this.state.RC_koymatr$,
          nrxikotayykalla: this.state.RC_nrxekotayeKala$,
          wasl: this.state.RC_zhmaaryPswla,
          nrxdarzan: this.state.RC_kren,
          nrxkarton: this.state.RC_nrxekotayeKala$,
          frosthniyakkarton: this.RC_froshtneakKarton()
        };
        const res = await Instance.put(
          `/api/v1/updatechina/${id}`,
          data,
          config
        );

        this.setState({
          RC_open: false,
          RC_wasl: res.data.update,
          RC_save: true,
          RC_dis: true
        });
        swal({
          title: "تەواو",
          text: "پسولە سورکەوتوو بوو!",
          icon: "success",
          timer: 2000
        });
      } catch (error) {
        swal({
          title: "ببورە",
          text: "هەڵە هەیە لە خانەکان",
          icon: "error"
        });
      }
    }
  };

  RC_qazanjKalla = () => {
    let kren = this.state.RC_kren;
    let froshtn = this.state.RC_froshtn;
    let darzan = this.state.RC_dabash;
    let qazanj = (froshtn - kren) * darzan;

    return Number(qazanj).toFixed(2);
  };

  RC_froshtneakKarton = () => {
    let froshtn = this.state.RC_froshtn;
    let darzan = this.state.RC_dabash;
    let eakcartoon = froshtn * darzan;

    return Number(eakcartoon).toFixed(2);
  };

  RC_froshtnChange = (e) => {
    this.setState(
      {
        RC_froshtn: e.target.value
      },
      () => {
        this.setState({
          RC_qazanj: this.RC_qazanjKalla(),
          RC_froshtneakKarton: this.RC_froshtneakKarton()
        });
      }
    );

    if (e.target.value === ".") {
      this.setState({
        RC_barze: "0."
      });
    }
  };

  RC_nrxdarzan = () => {
    const dabash = this.state.RC_dabash;
    const nrxikrenkarton = this.state.RC_nrxekotayeKala$;
    const qazanj = this.state.RC_qazanj;

    const nrxidarzan = (Number(qazanj) + Number(nrxikrenkarton)) / dabash;
    return Number(nrxidarzan).toFixed(2);
  };

  RC_nrxkarton = () => {
    const nrxikrenkarton = this.state.RC_nrxekotayeKala$;
    const qazanj = this.state.RC_qazanj;

    const nrvxeakkarton = Number(qazanj) + Number(nrxikrenkarton);
    return Number(nrvxeakkarton).toFixed(2);
  };

  RC_qazanjchange = (e) => {
    this.setState(
      {
        RC_qazanj: e.target.value
      },
      () => {
        this.setState({
          RC_froshtn: this.RC_nrxdarzan(),
          RC_froshtneakKarton: this.RC_nrxkarton()
        });
      }
    );
  };

  RC_updateNawKalla = async (e, id) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const data = {
      price: this.state.RC_kren,
      saleDolar: this.state.RC_froshtn,
      qazanj: this.state.RC_qazanj,
      saleDinar: parseFloat(
        this.state.RC_froshtnID.toString().replace(/,/g, "")
      ),
      saleOfLessHalfCarton: parseFloat(
        this.state.RC_kamtrlaNewkarton.toString().replace(/,/g, "")
      ),
      saleOfLessTenDarzan: parseFloat(
        this.state.RC_kamtrlaDadarzan.toString().replace(/,/g, "")
      )
    };
    const res = await Instance.put(`/api/v1/updateProduct/${id}`, data, config);

    if (res.status === 200) {
      this.setState({
        RC_open: false,
        RC_updatekala: true
      });
    }
    swal({
      title: "تەواو",
      text: "پسولە سورکەوتوو بوو!",
      icon: "success",
      timer: 2000
    });
  };

  RC_openchina = async (e) => {
    e.preventDefault();

    this.setState({
      RC_open: true,
      RC_dis: false
    });
  };

  RC_matrremembychnage = (e) => {
    this.setState(
      {
        [e.target.name]: e.target.value
      },
      () => {
        let kotaykalla = this.RC_nrxikotaykalla();
        let dabsh = Number(
          this.state.RC_rezhaynawKarton /
            (this.state.RC_rezhaynawKarton / this.state.RC_dabash)
        );
        let darzan = kotaykalla / dabsh;

        const froshtn = this.RC_froshtneakKarton();
        const qazanj = Number(froshtn) - Number(kotaykalla);
        let froshtnikarton = this.state.RC_froshtn * dabsh;

        this.setState({
          RC_koygshtyR: this.RC_getKOyGshtyRemembe(),
          RC_koygshty$: this.RC_getKOyGshty$(),
          RC_koymatr$: this.RC_getKOyGshtyMatr(),
          RC_nrxekotayeKala$: this.RC_nrxikotaykalla(),
          RC_kren: Number(darzan).toFixed(2),
          RC_qazanj: Number(qazanj).toFixed(2),
          RC_froshtneakcartoon: Number(froshtnikarton).toFixed(2),
          RC_kreneakcartoon: this.RC_nrxikotaykalla()
        });
      }
    );
  };
  RC_newpage = (e) => {
    e.preventDefault();
    this.setState({
      RC_data: [],
      RC_nawikalla: "",
      RC_zhmarayKala: 0,
      RC_zhmaaryDukan: 0,
      RC_zhmaaryPswla: 0,
      RC_dabash: 0,
      RC_rezhaynawKarton: 0,
      RC_nrxRRR: 0,
      RC_koygshtyR: 0,
      RC_koygshty$: 0,
      RC_drezhe: 0,
      RC_pane: 0,
      RC_barze: 0,
      RC_koymatr$: 0,
      RC_nrxekotayeKala$: 0,
      RC_kren: 0,
      RC_froshtn: 0,
      RC_qazanj: 0,
      RC_R_disaebl: true,
      RC_M_desaebl: true,
      RC_search_wasl: null,
      RC_wasl: null,
      RC_open: false,
      RC_save: false,
      RC_kreneakcartoon: 0,
      RC_froshtneakKarton: 0,
      RC_dis: false,
      RC_froshtnID: 0,
      RC_kamtrlaDadarzan: 0,
      RC_kamtrlaNewkarton: 0,
      RC_rezhaykarton: 0
    });
  };

  RC_clickOnDelete = async (id) => {
    this.setState({
      RC_data: this.state.RC_data.filter((r) => r._id !== id)
    });
  };
  RC_setInputEmpty = () => {
    this.setState({
      RC_kren: 0,
      RC_froshtn: 0,
      RC_froshtnID: 0,
      RC_froshtneakKarton: 0,
      RC_froshtneakcartoon: 0,
      RC_kamtrlaDadarzan: 0,
      RC_kamtrlaNewkarton: 0,
      RC_qazanj: 0,
      RC_kreneakcartoon: 0
    });
  };

  // raporty kalay nafroshraw
  KN_OpenModal = async (e, userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data, config);

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(() => {
        return {
          KN_openmodel: !this.state.KN_openmodel,
          KN_data: []
        };
      });
    }
  };

  KN_CloseModal = () => {
    this.setState(() => {
      return { KN_openmodel: false };
    });
  };

  KN_peshandan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/kallaynafroshraw?from=${this.state.KN_from}&to=${this.state.KN_to}`,
        config
      );
      this.setState({
        KN_data: res.data.mawa
      });
      this.KN_CloseModal();
    } catch (error) {
      alert("بەروار داخل بکە");
    }
  };

  // Raporty Paray Nagaranawa la Wakel

  RP_ParayNahatu = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/nagranawayqarz?from=${this.state.RP_from}&to=${this.state.RP_to}`,
        config
      );
      this.setState({
        RP_dataPara: res.data.nadraw
      });
      this.RP_CloseModal();
    } catch (error) {
      alert("بەروار داخل بکە");
    }
  };

  RP_OpenModal = async (e, userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data, config);

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(() => {
        return {
          RP_openmodel: !this.state.RP_openmodel,
          RP_dataPara: []
        };
      });
    }
  };

  RP_CloseModal = () => {
    this.setState(() => {
      return { RP_openmodel: false };
    });
  };

  // functions of Add People
  Ap_setWakilEmpty = (e) => {
    e.preventDefault();
    this.setState({
      ...this.state,
      Ap_mob: 0,
      Ap_naw: "",
      Ap_jor: "فرۆشیار",
      Ap_code: 0
    });
  };

  //// get wakilakna
  Ap_getkasakan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/getpeopleakan`, config);

    this.setState({
      Ap_kasakan: res.data.peoples
    });
  };

  Ap_tofirstInput = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 3].focus();
    this.Ap_onSaveWakel(e);
  };

  Ap_onSaveWakel = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    try {
      if (
        this.state.Ap_code === 0 ||
        this.state.Ap_mob === 0 ||
        this.state.Ap_naw === ""
      ) {
        swal({
          title: "ببورە",
          text: "تکایە خانەکان پڕبکەرەوە",
          icon: "error"
        });
      }
      let data;
      data = {
        code: this.state.Ap_code,
        Name: this.state.Ap_naw,
        phone: this.state.Ap_mob,
        jor: this.state.Ap_jor,
        paradolar: 0,
        paradinar: 0
      };
      const res = await Instance.post("/api/v1/newaddpeople", data, config);

      this.setState({
        Ap_data: [...this.state.Ap_data, res.data.newp]
      });
      this.Ap_setWakilEmpty(e);
    } catch (error) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    }
  };

  // delete wakel
  Ap_clickOnDeleteWakel = async (id) => {
    this.setState({
      Ap_data: this.state.Ap_data.filter((r) => r._id !== id)
    });
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    await Instance.delete(`/api/v1/deletepeople/${id}`, config);
  };

  ////// wakil tabel data
  Ap_getWakiltableData = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/getpeopleakan`, config);

    this.setState({
      Ap_data: res.data.peoples
    });
  };

  // update peoples

  Ap_updtae_Wakil = async (e, peo) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    let data;
    data = {
      code: this.state.Ap_code,
      Name: this.state.Ap_naw,
      phone: this.state.Ap_mob,
      jor: this.state.Ap_jor
    };
    const res = await Instance.put(
      `/api/v1/updatepeople/${peo._id}`,
      data,
      config
    );

    this.setState({
      Ap_data: this.state.Ap_data.map((people) =>
        people._id === res.data.update._id ? res.data.update : people
      )
    });
    swal({
      title: "تەواو",
      text: "پسولە سورکەوتوو بوو!",
      icon: "success",
      timer: 2000
    });
    this.clear_edit(e);
  };

  Ap_getWakilDataBySearchWakil = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    this.toanotherInput(e);
    const res = await Instance.get(
      `/api/v1/searchpeople?code=${Number(this.state.Ap_code)}&&Name=${
        this.state.Ap_naw
      }&&phone=${Number(this.state.Ap_mob)}`,
      config
    );

    const data = res.data.peoples;
    if (data === null) {
    } else {
      alert("ئەم داخیل کردنە دووبارەیە");
    }
  };

  //// show rasid
  Ap_showrasid = async (e, userid) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    if (this.state.Ap_show === false) {
      const promp = prompt("وشەی نهێنی داخیل بکە");
      let data = {
        password: promp
      };
      const pass = await Instance.post(
        `api/v1/open?id=${userid}`,
        data,
        config
      );

      if (pass.data.status === false) {
        alert("وشەی نهێنی هەڵەیە");
      } else {
        this.setState({ Ap_show: !this.state.Ap_show });
      }
    } else {
      this.setState({ Ap_show: !this.state.Ap_show });
    }
  };

  // functions of Masrufat

  Ms_setWakilEmpty = (e) => {
    e.preventDefault();
    this.setState({
      ...this.state,
      Ms_naw: "",
      Ms_koypara: "",
      Ms_draw: null,
      Ms_date: ""
    });
  };

  Ms_tofirstInput = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 2].focus();
    this.Ms_onSaveWakel(e);
  };

  Ms_onSaveWakel = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    try {
      if (this.state.Ms_naw === "" || this.state.Ms_koypara === 0) {
        swal({
          title: "ببورە",
          text: "تکایە خانەکان پڕبکەرەوە",
          icon: "error"
        });
      }
      let data;
      data = {
        shwen: this.state.Ms_naw,
        koypara: parseFloat(this.state.Ms_koypara.toString().replace(/,/g, "")),
        joripara: this.state.Ms_draw,
        date:this.state.Ms_date
      };
      const res = await Instance.post("/api/v1/newMasrwfat", data, config);

      this.setState(
        {
          Ms_data: [...this.state.Ms_data, res.data.newm]
        },
        async () => {
          this.Ms_getkoymasrwfdinar();
          this.Ms_getkoymasrwfdolar();
          ///////

          let bardastdata;
          const respb = await Instance.get(`/api/v1/paraybardasakan`, config);
          if (res.data.newm.joripara === "دۆلار") {
            bardastdata = {
              paraybardastdolar:
                Number(respb.data.paraybardastakan.paraybardastdolar) -
                res.data.newm.koypara
            };
          } else if (res.data.newm.joripara === "دینار") {
            bardastdata = {
              paraybardastdinar:
                Number(respb.data.paraybardastakan.paraybardastdinar) -
                res.data.newm.koypara
            };
          }
          await Instance.put(
            `/api/v1/updateparabardastakan/${respb.data.paraybardastakan._id}`,
            bardastdata,
            config
          );

          /////////////
        }
      );
      this.Ms_setWakilEmpty(e);
    } catch (error) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    }
  };

  Ms_getkoymasrwfdolar = () => {
    let subTotal = 0;
    this.state.Ms_data.map((item) => {
      if (item.joripara === "دۆلار") {
        subTotal += Number(item.koypara);
      }
    });
    const koyparakandolar = Number(Number(subTotal).toFixed(2));
    this.setState(() => {
      return {
        Ms_koymasruf$: koyparakandolar
      };
    });
  };

  Ms_getkoymasrwfdinar = () => {
    let subTotal = 0;
    this.state.Ms_data.map((item) => {
      if (item.joripara === "دینار") {
        subTotal += Number(item.koypara);
      }
    });
    const koyparakandinar = Number(Number(subTotal).toFixed(2));
    this.setState(() => {
      return {
        Ms_koymasrufID: koyparakandinar
      };
    });
  };

  // delete wakel
  Ms_clickOnDeleteWakel = async (id) => {
    this.setState(
      {
        Ms_data: this.state.Ms_data.filter((r) => r._id !== id)
      },
      async () => {
        this.Ms_getkoymasrwfdinar();
        this.Ms_getkoymasrwfdolar();
      }
    );
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.delete(`/api/v1/deletemasrwf/${id}`, config);
    ///////
    let bardastdata;
    const respb = await Instance.get(`/api/v1/paraybardasakan`, config);
    if (res.data.dl.joripara === "دۆلار") {
      bardastdata = {
        paraybardastdolar:
          Number(respb.data.paraybardastakan.paraybardastdolar) +
          res.data.dl.koypara
      };
    } else if (res.data.dl.joripara === "دینار") {
      bardastdata = {
        paraybardastdinar:
          Number(respb.data.paraybardastakan.paraybardastdinar) +
          res.data.dl.koypara
      };
    }
    await Instance.put(
      `/api/v1/updateparabardastakan/${respb.data.paraybardastakan._id}`,
      bardastdata,
      config
    );

    /////////////
  };

  ////// wakil tabel data
  Ms_getWakiltableData = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/getmasrwfakan`, config);

    this.setState({
      Ms_data: res.data.masrwfs
    });
  };

  // update peoples

  Ms_updtae_Wakil = async (e, mas) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    let data;
    data = {
      shwen: this.state.Ms_naw,
      koypara: parseFloat(this.state.Ms_koypara.toString().replace(/,/g, "")),
      joripara: this.state.Ms_draw,
        date:this.state.Ms_date
    };
    const res = await Instance.put(
      `/api/v1/updatemasrwf/${mas._id}`,
      data,
      config
    );

    this.setState(
      {
        Ms_data: this.state.Ms_data.map((masrufat) =>
          masrufat._id === res.data.update._id ? res.data.update : masrufat
        )
      },
      () => {
        this.Ms_getkoymasrwfdinar();
        this.Ms_getkoymasrwfdolar();
      }
    );
    swal({
      title: "تەواو",
      text: "پسولە سورکەوتوو بوو!",
      icon: "success",
      timer: 2000
    });
    this.clear_edit(e);
  };

  //// show rasid
  Ms_showrasid = async (e, userid) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    if (this.state.Ms_show === false) {
      const promp = prompt("وشەی نهێنی داخیل بکە");
      let data = {
        password: promp
      };
      const pass = await Instance.post(
        `api/v1/open?id=${userid}`,
        data,
        config
      );

      if (pass.data.status === false) {
        alert("وشەی نهێنی هەڵەیە");
      } else {
        this.setState({ Ms_show: !this.state.Ms_show }, () => {
          this.Ms_getkoymasrwfdinar();
          this.Ms_getkoymasrwfdolar();
        });
      }
    } else {
      this.setState({
        Ms_show: !this.state.Ms_show,
        Ms_koymasruf$: 0,
        Ms_koymasrufID: 0
      });
    }
  };

  ////functions of paradan
  PD_getPrint = () => {
    window.setTimeout("window.print()", 3500);
  };

  PD_showrasid = async (e, userid) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    if (this.state.PD_show === false) {
      const promp = prompt("وشەی نهێنی داخیل بکە");
      let data = {
        password: promp
      };
      const pass = await Instance.post(
        `api/v1/open?id=${userid}`,
        data,
        config
      );

      if (pass.data.status === false) {
        alert("وشەی نهێنی هەڵەیە");
      } else {
        this.setState({ PD_show: true }, () => this.PB_gegtparaybardast());
      }
    } else {
      this.setState({ PD_show: !this.state.PD_show });
    }
  };

  PD_openUpdate = async (userid, e, id) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(
      `api/v1/openParadan/${id}?id=${userid}`,
      data,
      config
    );

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(
        {
          PD_del_dis: null,
          PD_open: true
        },
        async () => {
          this.PD_getdataOnRefreshSave(this.state.PD_wasl);
          // this.PD_getkasDataBySearchMoney(e);
          /// kmkrdnway paray qasa
          let bardastdata;
          const respb = await Instance.get(`/api/v1/paraybardasakan`, config);
          if (this.state.PD_joredraw === "دۆلار") {
            bardastdata = {
              paraybardastdolar:
                Number(respb.data.paraybardastakan.paraybardastdolar) +
                parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
            };
          } else if (this.state.PD_joredraw === "دینار") {
            bardastdata = {
              paraybardastdinar:
                Number(respb.data.paraybardastakan.paraybardastdinar) +
                parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
            };
          } else if (this.state.PD_joredraw === "ڕیمێمبی") {
            bardastdata = {
              paraybardastRemembe:
                Number(respb.data.paraybardastakan.paraybardastRemembe) +
                parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
            };
          }
          await Instance.put(
            `/api/v1/updateparabardastakan/${respb.data.paraybardastakan._id}`,
            bardastdata,
            config
          );
          this.PD_getkasDataBySearchMoney_kon(
            e,
            this.state.PD_zhmaraybarez,
            this.state.PD_nawebarez
          );
        }
      );
    }
  };

  /// barwar toogle para watrgrtn
  PD_getdataOnRefreshSave = (id) => {
    let data = {
      _id: id._id,
      kascode: this.state.PD_zhmaraybarez,
      nawekas: this.state.PD_nawebarez,
      briparabadolar:
        this.state.PD_joredraw === "دۆلار"
          ? parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
          : 0,
      briparabadinar:
        this.state.PD_joredraw === "دینار"
          ? parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
          : 0,
      briparabaRRR:
        this.state.PD_joredraw === "ڕیمێمبی"
          ? parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
          : 0,
      nawiwargr: this.state.PD_nawewargr,
      joripara: this.state.PD_joredraw,
      note: this.state.PD_note,
      date: this.state.Pd_barwar === "" ? Date.now : this.state.Pd_barwar,
      zhmaraaywasl: this.state.PD_wasleShareka,
      rasidkondolar: this.state.PD_qardekon$,
      rasiddkoninar: this.state.PD_qardekonID,
      rasiddkonRRR: this.state.PD_qardekonRR
    };
    localStorage.setItem("paradan", JSON.stringify(data));
  };

  PD_getDataOnRefresh = (data) => {
    this.setState({
      PD_search_wasl: true,
      PD_zhamara: data.zhmara,
      PD_nawebarez: data.nawekas,
      Pd_barwar: data.date,
      PD_zhmaraybarez: data.kascode,
      PD_brepara:
        data.joripara === "دینار"
          ? data.briparabadinar
          : data.joripara === "دۆلار"
          ? data.briparabadolar
          : data.briparabaRRR,
      PD_joredraw: data.joripara,
      PD_nawewargr: data.nawiwargr,
      PD_note: data.note,
      PD_del_dis: null,
      PD_open: true,
      PD_wasl: data,
      PD_toggler: false,
      PD_wasleShareka: data.zhmaraaywasl,
      PD_qardekon$: data.rasidkondolar,
      PD_qardekonID: data.rasiddkoninar,
      PD_qardekonRR: data.rasiddkonRRR,
      PD_nrx_Remembe: data.nrxe_RRR ? data.nrxe_RRR : 0,
      PD_nrx_Remembe_2: data.nrxe_RRR_2 ? data.nrxe_RRR_2 : 0,
      PD_Kren_dinar_2: data.Kreni_dinar ? data.Kreni_dinar : 0,
      PD_nrx_dolar_2: data.Nrxi_yakDolar ? data.Nrxi_yakDolar : 0,
      PD_Kren_Remembe: data.Krini_RRR ? data.Krini_RRR : 0,
      P_Amount_Dolar: data.Amount_Dolar,
      P_High_Dolar: data.High_Dolar,
      P_Low_Dolar: data.Low_Dolar,
      P_Amount_Dinar: data.Amount_Dinar,
      P_Remebi_Price: data.Remebi_Price,
      P_DolarTR: data.DolarTR,
      P_DinarTR: data.DinarTR
    });
  };
  PD_inputtogler = (e) => {
    e.preventDefault();
    this.setState({
      PD_toggler: !this.state.PD_toggler,
      Pd_barwar: ""
    });
  };
  ////save wasl para
  PD_onSaveMoney = async (e) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    if (
      this.state.PD_nawebarez.toString().length === 0 ||
      !this.state.PD_wasleShareka ||
      !this.state.PD_zhmaraybarez ||
      !this.state.PD_brepara 
    ) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    } else {
      let data;
      data = {
        kascode: this.state.PD_zhmaraybarez,
        nawekas: this.state.PD_nawebarez,
        briparabadolar:
          this.state.PD_joredraw === "دۆلار"
            ? parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
            : 0,
        briparabadinar:
          this.state.PD_joredraw === "دینار"
            ? parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
            : 0,
        briparabaRRR:
          this.state.PD_joredraw === "ڕیمێمبی"
            ? parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
            : 0,
        nawiwargr: this.state.PD_nawewargr,
        joripara: this.state.PD_joredraw,
        note: this.state.PD_note,
        date: this.state.Pd_barwar === "" ? Date.now : this.state.Pd_barwar,
        zhmaraaywasl: this.state.PD_wasleShareka,
        rasidkondolar: this.state.PD_qardekon$,
        rasiddkoninar: this.state.PD_qardekonID,
        rasiddkonRRR: this.state.PD_qardekonRR,
        nrxe_RRR: this.state.PD_nrx_Remembe
          ? parseFloat(this.state.PD_nrx_Remembe.toString().replace(/,/g, ""))
          : 0,
        Krini_RRR: this.state.PD_Kren_Remembe
          ? parseFloat(this.state.PD_Kren_Remembe.toString().replace(/,/g, ""))
          : 0,
        Kreni_dinar: this.state.PD_Kren_dinar_2
          ? parseFloat(this.state.PD_Kren_dinar_2.toString().replace(/,/g, ""))
          : 0,
        Nrxi_yakDolar: this.state.PD_nrx_dolar_2
          ? parseFloat(this.state.PD_nrx_dolar_2.toString().replace(/,/g, ""))
          : 0,
        nrxe_RRR_2: this.state.PD_nrx_Remembe_2
          ? parseFloat(this.state.PD_nrx_Remembe_2.toString().replace(/,/g, ""))
          : 0,
        Amount_Dolar: this.ToNmberWithPars(this.state.P_Amount_Dolar),
        High_Dolar: this.ToNmberWithPars(this.state.P_High_Dolar),
        Low_Dolar: this.ToNmberWithPars(this.state.P_Low_Dolar),
        Amount_Dinar: this.ToNmberWithPars(this.state.P_Amount_Dinar),
        Remebi_Price: this.ToNmberWithPars(this.state.P_Remebi_Price),
        DinarTR: this.state.P_DinarTR,
        DolarTR: this.state.P_DolarTR
      };
      const res = await Instance.post("/api/v1/newParadana", data, config);


      this.setState(
        {
          PD_save: true,
          PD_zhamara: res.data.paradan.zhmara,
          Pd_barwar: res.data.paradan.date,
          PD_del_dis: true,
          //    P_paraywasl:res.data.wargrtn.paradwaykmkrdn,
          PD_wasl: res.data.paradan,
          PD_toggler: false,
          PD_wakilSearch: false
        },
        async () => {
          this.PB_gegtparaybardast();
          /// kmkrdnway paaray qasa
          let bardastdata;
          const respb = await Instance.get(`/api/v1/paraybardasakan`, config);
          if (this.state.PD_joredraw === "دۆلار") {
            bardastdata = {
              paraybardastdolar:
                Number(respb.data.paraybardastakan.paraybardastdolar) -
                parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
            };
          } else if (this.state.PD_joredraw === "دینار") {
            bardastdata = {
              paraybardastdinar:
                Number(respb.data.paraybardastakan.paraybardastdinar) -
                parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
            };
          } else if (this.state.PD_joredraw === "ڕیمێمبی") {
            bardastdata = {
              paraybardastRemembe:
                Number(respb.data.paraybardastakan.paraybardastRemembe) -
                parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
            };
          }
          this.PD_getkasDataBySearchMoney_kon(
            e,
            this.state.PD_zhmaraybarez,
            this.state.PD_nawebarez
          );
          await Instance.put(
            `/api/v1/updateparabardastakan/${respb.data.paraybardastakan._id}`,
            bardastdata,
            config
          );
        }
      );
    }
  };

  ////// update Mony
  PD_updtate_para = async (e, para, NOW) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    try {
      if (
        this.state.PD_brepara === "" ||
        this.state.PD_brepara === 0 ||
        this.state.PD_nawebarez === "" ||
        this.state.Pd_barwar === "" ||
        this.state.PD_wasleShareka === 0 ||
        this.state.PD_wasleShareka === "" 
      ) {
        swal({
          title: "ببورە",
          text: "تکایە خانەکان پڕبکەرەوە",
          icon: "error"
        });
      } else {
        let data;
        data = {
          kascode: this.state.PD_zhmaraybarez,
          nawekas: this.state.PD_nawebarez,
          briparabadolar:
            this.state.PD_joredraw === "دۆلار"
              ? parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
              : 0,
          briparabadinar:
            this.state.PD_joredraw === "دینار"
              ? parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
              : 0,
          briparabaRRR:
            this.state.PD_joredraw === "ڕیمێمبی"
              ? parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
              : 0,
          nawiwargr: this.state.PD_nawewargr,
          joripara: this.state.PD_joredraw,
          note: this.state.PD_note,
          date: this.state.Pd_barwar === "" ? Date.now : this.state.Pd_barwar,
          zhmaraaywasl: this.state.PD_wasleShareka,
          rasidkondolar: this.state.PD_qardekon$,
          rasiddkoninar: this.state.PD_qardekonID,
          rasiddkonRRR: this.state.PD_qardekonRR,
          nrxe_RRR: this.state.PD_nrx_Remembe
            ? parseFloat(this.state.PD_nrx_Remembe.toString().replace(/,/g, ""))
            : 0,
          Krini_RRR: this.state.PD_Kren_Remembe
            ? parseFloat(
                this.state.PD_Kren_Remembe.toString().replace(/,/g, "")
              )
            : 0,
          Kreni_dinar: this.state.PD_Kren_dinar_2
            ? parseFloat(
                this.state.PD_Kren_dinar_2.toString().replace(/,/g, "")
              )
            : 0,
          Nrxi_yakDolar: this.state.PD_nrx_dolar_2
            ? parseFloat(this.state.PD_nrx_dolar_2.toString().replace(/,/g, ""))
            : 0,
          nrxe_RRR_2: this.state.PD_nrx_Remembe_2
            ? parseFloat(
                this.state.PD_nrx_Remembe_2.toString().replace(/,/g, "")
              )
            : 0,
          Amount_Dolar: this.ToNmberWithPars(this.state.P_Amount_Dolar),
          High_Dolar: this.ToNmberWithPars(this.state.P_High_Dolar),
          Low_Dolar: this.ToNmberWithPars(this.state.P_Low_Dolar),
          Amount_Dinar: this.ToNmberWithPars(this.state.P_Amount_Dinar),
          Remebi_Price: this.ToNmberWithPars(this.state.P_Remebi_Price),
          DinarTR: this.state.P_DinarTR,
          DolarTR: this.state.P_DolarTR
        };
        await Instance.put(`/api/v1/updateparadan/${para._id}`, data, config);
        localStorage.removeItem("paradan");
        this.setState(
          {
            PD_open: null,
            PD_del_dis: true,
            PD_toggler: false
          },
          async () => {
            ///// kmkrdnway paray qasa
            let bardastdata;
            const respb = await Instance.get(`/api/v1/paraybardasakan`, config);
            if (this.state.PD_joredraw === "دۆلار") {
              bardastdata = {
                paraybardastdolar:
                  Number(respb.data.paraybardastakan.paraybardastdolar) -
                  parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
              };
            } else if (this.state.PD_joredraw === "دینار") {
              bardastdata = {
                paraybardastdinar:
                  Number(respb.data.paraybardastakan.paraybardastdinar) -
                  parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
              };
            } else if (this.state.PD_joredraw === "ڕیمێمبی") {
              bardastdata = {
                paraybardastRemembe:
                  Number(respb.data.paraybardastakan.paraybardastRemembe) -
                  parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""))
              };
            }
            this.PD_getkasDataBySearchMoney_kon(
              e,
              this.state.PD_zhmaraybarez,
              this.state.PD_nawebarez
            );
            await Instance.put(
              `/api/v1/updateparabardastakan/${respb.data.paraybardastakan._id}`,
              bardastdata,
              config
            );
          }
        );
        swal({
          title: "تەواو",
          text: "پسولە سورکەوتوو بوو!",
          icon: "success",
          timer: 2000
        });
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    }
  };

  ////search name of wakil
  PD_getkasDataBySearchMoney = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchpeople?code=${this.state.PD_zhmaraybarez}&&Name=${this.state.PD_nawebarez}`,
      config
    );

    const data = res.data.peoples;
    if (data === null) {
      alert("ببورە ئەم بەڕێزە بونی نیە");
    } else {
      this.setState(() => {
        return {
          PD_zhmaraybarez: data.code,
          PD_nawebarez: data.Name,
          PD_qardekon$: Number(data.paradolar).toFixed(2),
          PD_qardekonID: Number(data.paradinar).toFixed(2),
          PD_qardekonRR: Number(data.paraRRR).toFixed(2),
          PD_wakilSearch: true
        };
      });
    }
  };
  //////// name search of the kas inside پارە دان ////////
  PD_searchKasByName = async (name) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/SearchNamePeople?name=${encodeURIComponent(name)}`,
        config
      );
      this.setState({
        PD_kasSuggestions: res.data.peoples || [],
        PD_kasCursor: -1
      });
    } catch (error) {
      this.setState({ PD_kasSuggestions: [], PD_kasCursor: -1 });
    }
  };

  PD_kasNameHandle = (e) => {
    const name = e.target.value;
    this.setState({ PD_nawebarez: name }, () => {
      if (!name || name === "") {
        this.PD_emptyKasSuggestions();
      } else {
        this.PD_searchKasByName(name);
      }
    });
  };

  PD_emptyKasSuggestions = () => {
    this.setState({
      PD_kasSuggestions: [],
      PD_kasCursor: -1
    });
  };

  //// clicking (or pressing Enter on) a name loads the whole kas detail
  PD_kasSuggestionSelected = (kas) => {
    if (!kas) {
      return;
    }
    this.setState(
      {
        PD_zhmaraybarez: kas.code,
        PD_nawebarez: kas.Name,
        PD_qardekon$: Number(kas.paradolar).toFixed(2),
        PD_qardekonID: Number(kas.paradinar).toFixed(2),
        PD_qardekonRR: Number(kas.paraRRR).toFixed(2),
        PD_wakilSearch: true,
        PD_kasSuggestions: [],
        PD_kasCursor: -1
      },
      () => {
        const amount = window.document.getElementById("PD_brepara_input");
        if (amount) {
          amount.focus();
        }
      }
    );
  };

  //// arrow up/down moves inside the list, Enter picks the highlighted kas
  PD_kasListKeydown = (e) => {
    const { PD_kasSuggestions, PD_kasCursor } = this.state;
    if (!PD_kasSuggestions || PD_kasSuggestions.length === 0) {
      return;
    }
    if (e.keyCode === 27) {
      this.PD_emptyKasSuggestions();
      return;
    }
    if (e.keyCode === 40) {
      e.preventDefault();
      this.setState((prevState) => ({
        PD_kasCursor:
          prevState.PD_kasCursor < PD_kasSuggestions.length - 1
            ? prevState.PD_kasCursor + 1
            : prevState.PD_kasCursor
      }));
    } else if (e.keyCode === 38) {
      e.preventDefault();
      this.setState((prevState) => ({
        PD_kasCursor:
          prevState.PD_kasCursor > 0
            ? prevState.PD_kasCursor - 1
            : prevState.PD_kasCursor
      }));
    } else if (e.keyCode === 13 && PD_kasCursor >= 0) {
      e.preventDefault();
      this.PD_kasSuggestionSelected(PD_kasSuggestions[PD_kasCursor]);
    }
  };

  PD_getkasDataBySearchMoney_kon = async (e, code, naw) => {
    const res = await Instance.get(
      `/api/v1/searchpeople?code=${code}&&Name=${naw}`
    );
    const data = res.data.peoples;
    if (data === null) {
      alert("ببورە ئەم بەڕێزە بونی نیە");
    } else {
      this.setState(() => {
        return {
          PD_para$_kon: Number(data.paradolar).toFixed(2),
          PD_paraID_kon: Number(data.paradinar).toFixed(2),
          PD_paraRR_kon: Number(data.paraRRR).toFixed(2)
        };
      });
    }
  };

  PD_getParaDataBySearchMoney = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchpardan?zhmara=${this.state.PD_zhamara}`,
      config
    );

    const data = res.data.parakan;
    if (data === null) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
      this.setState({ PD_zhmaraybarez: 0 });
    } else {
      this.setState(
        () => {
          return {
            PD_search_wasl: true,
            PD_zhamara: data.zhmara,
            PD_nawebarez: data.nawekas,
            Pd_barwar: data.date,
            PD_zhmaraybarez: data.kascode,
            PD_brepara:
              data.joripara === "دینار"
                ? data.briparabadinar
                : data.joripara === "دۆلار"
                ? data.briparabadolar
                : data.briparabaRRR,
            PD_joredraw: data.joripara,
            PD_nawewargr: data.nawiwargr,
            PD_note: data.note,
            PD_del_dis: true,
            PD_wasleShareka: data.zhmaraaywasl,
            PD_wasl: data,
            PD_toggler: false,
            PD_qardekon$: data.rasidkondolar,
            PD_qardekonID: data.rasiddkoninar,
            PD_qardekonRR: data.rasiddkonRRR,
            PD_nrx_Remembe: data.nrxe_RRR ? data.nrxe_RRR : 0,
            PD_nrx_Remembe_2: data.nrxe_RRR_2 ? data.nrxe_RRR_2 : 0,
            PD_Kren_dinar_2: data.Kreni_dinar ? data.Kreni_dinar : 0,
            PD_nrx_dolar_2: data.Nrxi_yakDolar ? data.Nrxi_yakDolar : 0,
            PD_Kren_Remembe: data.Krini_RRR ? data.Krini_RRR : 0,
            P_Amount_Dolar: data.Amount_Dolar,
            P_High_Dolar: data.High_Dolar,
            P_Low_Dolar: data.Low_Dolar,
            P_Amount_Dinar: data.Amount_Dinar,
            P_Remebi_Price: data.Remebi_Price,
            P_DolarTR: data.DolarTR,
            P_DinarTR: data.DinarTR
          };
        },
        (e) => {
          this.PD_getkasDataBySearchMoney_kon(
            e,
            this.state.PD_zhmaraybarez,
            this.state.PD_nawebarez
          );
        }
      );
    }
  };

  PD_peshandaniQarzyPeshw = () => {
    if (this.state.PD_joredraw == "دۆلار") {
      let paraykon = this.state.PD_qardekon$;
      let parayesta =
        Number(paraykon) -
        parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""));
      return Number(parayesta).toFixed(2);
    } else if (this.state.PD_joredraw == "دینار") {
      let paraykon = this.state.PD_qardekonID;
      let parayesta =
        Number(paraykon) -
        parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""));
      return Number(parayesta).toFixed(2);
    } else if (this.state.PD_joredraw == "ڕیمێمبی") {
      let paraykon = this.state.PD_qardekonRR;
      let parayesta =
        Number(paraykon) -
        parseFloat(this.state.PD_brepara.toString().replace(/,/g, ""));
      return Number(parayesta).toFixed(2);
    } else {
      return 0;
    }
  };

  PD_peshandaniQarzyPeshw_kon = (joredraw) => {
    if (joredraw == "دۆلار") {
      return Number(this.state.PD_para$_kon).toFixed(2);
    } else if (joredraw == "دینار") {
      return Number(this.state.PD_paraID_kon).toFixed(2);
    } else if (joredraw == "ڕیمێمبی") {
      return Number(this.state.PD_paraRR_kon).toFixed(2);
    } else {
      return 0;
    }
  };
  Money_Change = (e) => {
    this.setState(
      {
        P_brePara: e.target.value
      },
      () => {
        let bripara = parseFloat(this.state.P_brePara);
        if (this.state.P_joripara == "دۆلار") {
          this.setState({
            P_qarzeKonDolar_: Number(
              _.subtract(this.state.P_qarzeKonDolar_, bripara)
            ).toFixed(2)
          });
        } else if (this.state.P_joripara == "دینار") {
          this.setState({
            P_qarzeKonID_: Number(
              _.subtract(this.state.P_qarzeKonID_, bripara)
            ).toFixed(2)
          });
        }
      }
    );
  };
  Money_peshandaniQarzyPeshw_kon = (joredraw) => {
    if (joredraw == "دۆلار") {
      return Number(this.state.P_qarzeKonDolar_).toFixed(2);
    } else if (joredraw == "دینار") {
      return Number(this.state.P_qarzeKonID_).toFixed(2);
    } else {
      return 0;
    }
  };
  ////search name of wakil
  Money_getWakilDataBySearchMoney = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchwakil?code=${this.state.P_zh_barez}&&Name=${this.state.P_nawe_barez}`,
      config
    );

    const data = res.data.wakils;
    if (data === null) {
      return;
    } else {
      this.setState(() => {
        return {
          P_qarzeKonDolar_: Number(data.rejaDolar).toFixed(2),
          P_qarzeKonID_: Number(data.rejaDinar).toFixed(2)
        };
      });
    }
  };
  // Gorine Remembe bo Dolar
  PD_Change_R_Dolar = (e) => {
    e.preventDefault();
    let RRR = parseFloat(
      this.state.PD_nrx_Remembe.toString().replace(/,/g, "")
    );
    let K_R = parseFloat(
      this.state.PD_Kren_Remembe.toString().replace(/,/g, "")
    );
    let all = Number(K_R / RRR).toFixed(2);

    this.setState({
      PD_brepara: all,
      PD_joredraw: "دۆلار",
      PD_ok: true
    });
  };

  PD_Change_Dinar_to_R = (e) => {
    e.preventDefault();
    let RRR = parseFloat(
      this.state.PD_nrx_Remembe_2.toString().replace(/,/g, "")
    );
    let K_R = parseFloat(
      this.state.PD_Kren_dinar_2.toString().replace(/,/g, "")
    );
    let nrxdolar = parseFloat(
      this.state.PD_nrx_dolar_2.toString().replace(/,/g, "")
    );
    let changedinartodolar = _.divide(K_R, nrxdolar);
    let all = Number(_.multiply(changedinartodolar, RRR)).toFixed(2);
    this.setState({
      PD_brepara: all,
      PD_ok_2: true,
      PD_joredraw: "ڕیمێمبی"
    });
  };
  PD_getParakan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/paradanakan`, config);

    this.setState({
      PD_zhamara: res.data.paradanakan.length + 1
    });
  };

  PD_setSearchMonyWakilEmpty = (e) => {
    e.preventDefault();
    this.setState({
      PD_zhmaraybarez: 0,
      PD_nawebarez: "",
      PD_qardekon$: 0,
      PD_qardekonID: 0,
      PD_qardekonRR: 0,
      PD_wakilSearch: false,
      PD_kasSuggestions: [],
      PD_kasCursor: -1
    });
  };
  RKP_getPrint = () => {
    window.setTimeout("window.print()", 3500);
  };
  PD_createNewMony = () => {
    this.setState(
      {
        PD_zhmaraybarez: 0,
        PD_nawebarez: "",
        PD_brepara: 0,
        PD_note: "",
        PD_search_wasl: null,
        PD_save: null,
        PD_joredraw: "دۆلار",
        PD_nawewargr: "ئەنوەر",
        PD_open: null,
        PD_del_dis: null,
        PD_page: this.state.PD_zhamara,
        PD_wasl: null,
        PD_qardekon$: 0,
        PD_qardekonID: 0,
        PD_qardekonRR: 0,
        PD_isChecked: false,
        PD_wasleShareka: 0,
        Pd_barwar: "",
        PD_wakilSearch: false,
        PD_kasSuggestions: [],
        PD_kasCursor: -1,
        // zyad krdni remembe
        PD_nrx_Remembe: "",
        PD_Kren_Remembe: "",
        PD_ok: null,
        PD_nrx_Remembe_2: "",
        PD_nrx_dolar_2: "",
        PD_Kren_dinar_2: "",
        PD_ok_2: null,
        PD_indexState: "",
        P_Amount_Dolar: "",
        P_High_Dolar: "",
        P_Low_Dolar: "",
        P_Amount_Dinar: "",
        P_Remebi_Price: "",
        P_DolarTR: false,
        P_DinarTR: false
      },
      () => {
        this.PD_getParakan();
        // this.PB_gegtparaybardast();
      }
    );
  };

  PD_getIsChecked = (e) => {
    let checked = e.target.checked;
    if (checked) {
      this.setState({ PD_isChecked: true });
    } else {
      this.setState({ PD_isChecked: false });
    }
  };

  PD_pageplusone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page = this.state.PD_zhamara + 1;
      const res = await Instance.get(
        `/api/v1/pagepardan?page=${page}&limit=1`,
        config
      );

      const data = res.data.paras;
      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState(
          () => {
            return {
              PD_search_wasl: true,
              PD_zhamara: data.zhmara,
              PD_nawebarez: data.nawekas,
              Pd_barwar: data.date,
              PD_zhmaraybarez: data.kascode,
              PD_brepara:
                data.joripara === "دینار"
                  ? data.briparabadinar
                  : data.joripara === "دۆلار"
                  ? data.briparabadolar
                  : data.briparabaRRR,
              PD_joredraw: data.joripara,
              PD_nawewargr: data.nawiwargr,
              PD_note: data.note,
              PD_del_dis: true,
              PD_wasl: data,
              PD_toggler: false,
              PD_wasleShareka: data.zhmaraaywasl,
              PD_qardekon$: data.rasidkondolar,
              PD_qardekonID: data.rasiddkoninar,
              PD_qardekonRR: data.rasiddkonRRR,
              PD_nrx_Remembe: data.nrxe_RRR ? data.nrxe_RRR : 0,
              PD_nrx_Remembe_2: data.nrxe_RRR_2 ? data.nrxe_RRR_2 : 0,
              PD_Kren_dinar_2: data.Kreni_dinar ? data.Kreni_dinar : 0,
              PD_nrx_dolar_2: data.Nrxi_yakDolar ? data.Nrxi_yakDolar : 0,
              PD_Kren_Remembe: data.Krini_RRR ? data.Krini_RRR : 0,
              P_Amount_Dolar: data.Amount_Dolar,
              P_High_Dolar: data.High_Dolar,
              P_Low_Dolar: data.Low_Dolar,
              P_Amount_Dinar: data.Amount_Dinar,
              P_Remebi_Price: data.Remebi_Price,
              P_DolarTR: data.DolarTR,
              P_DinarTR: data.DinarTR
            };
          },
          (e) => {
            this.PD_getkasDataBySearchMoney_kon(
              e,
              this.state.PD_zhmaraybarez,
              this.state.PD_nawebarez
            );
          }
        );
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };

  PD_pageminsone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page;
      this.state.PD_zhamara <= 1
        ? (page = 1)
        : (page = this.state.PD_zhamara - 1);
      const res = await Instance.get(
        `/api/v1/pagepardan?page=${page}&limit=1`,
        config
      );

      const data = res.data.paras;
      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState(
          () => {
            return {
              PD_search_wasl: true,
              PD_zhamara: data.zhmara,
              PD_nawebarez: data.nawekas,
              Pd_barwar: data.date,
              PD_zhmaraybarez: data.kascode,
              PD_brepara:
                data.joripara === "دینار"
                  ? data.briparabadinar
                  : data.joripara === "دۆلار"
                  ? data.briparabadolar
                  : data.briparabaRRR,
              PD_joredraw: data.joripara,
              PD_nawewargr: data.nawiwargr,
              PD_note: data.note,
              PD_del_dis: true,
              PD_wasleShareka: data.zhmaraaywasl,
              PD_wasl: data,
              PD_toggler: false,
              PD_qardekon$: data.rasidkondolar,
              PD_qardekonID: data.rasiddkoninar,
              PD_qardekonRR: data.rasiddkonRRR,
              PD_nrx_Remembe: data.nrxe_RRR ? data.nrxe_RRR : 0,
              PD_nrx_Remembe_2: data.nrxe_RRR_2 ? data.nrxe_RRR_2 : 0,
              PD_Kren_dinar_2: data.Kreni_dinar ? data.Kreni_dinar : 0,
              PD_nrx_dolar_2: data.Nrxi_yakDolar ? data.Nrxi_yakDolar : 0,
              PD_Kren_Remembe: data.Krini_RRR ? data.Krini_RRR : 0,
              P_Amount_Dolar: data.Amount_Dolar,
              P_High_Dolar: data.High_Dolar,
              P_Low_Dolar: data.Low_Dolar,
              P_Amount_Dinar: data.Amount_Dinar,
              P_Remebi_Price: data.Remebi_Price,
              P_DolarTR: data.DolarTR,
              P_DinarTR: data.DinarTR
            };
          },
          (e) => {
            this.PD_getkasDataBySearchMoney_kon(
              e,
              this.state.PD_zhmaraybarez,
              this.state.PD_nawebarez
            );
          }
        );
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };
  /////end of functions para dan

  ////functions of paradarhenan
  PM_getPrint = () => {
    window.setTimeout("window.print()", 3500);
  };

  PM_showrasid = async (e, userid) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    if (this.state.PM_show === false) {
      const promp = prompt("وشەی نهێنی داخیل بکە");
      let data = {
        password: promp
      };
      const pass = await Instance.post(
        `api/v1/open?id=${userid}`,
        data,
        config
      );

      if (pass.data.status === false) {
        alert("وشەی نهێنی هەڵەیە");
      } else {
        this.setState({ PM_show: !this.state.PM_show }, () =>
          this.PB_gegtparaybardast()
        );
      }
    } else {
      this.setState({ PM_show: !this.state.PM_show });
    }
  };

  PM_openUpdate = async (userid, e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data, config);

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(
        {
          PM_del_dis: null,
          PM_open: true
        },
        async () => {
          let bardastdata;
          const respb = await Instance.get(`/api/v1/paraybardasakan`, config);
          if (this.state.PM_joredraw === "دۆلار") {
            bardastdata = {
              paraybardastdolar:
                Number(respb.data.paraybardastakan.paraybardastdolar) +
                parseFloat(this.state.PM_brepara.toString().replace(/,/g, ""))
            };
          } else if (this.state.PM_joredraw === "دینار") {
            bardastdata = {
              paraybardastdinar:
                Number(respb.data.paraybardastakan.paraybardastdinar) +
                parseFloat(this.state.PM_brepara.toString().replace(/,/g, ""))
            };
          }
          await Instance.put(
            `/api/v1/updateparabardastakan/${respb.data.paraybardastakan._id}`,
            bardastdata,
            config
          );
        }
      );
    }
  };

  PM_inputtogler = (e) => {
    e.preventDefault();
    this.setState({
      PM_toggler: !this.state.PM_toggler,
      PM_barwar: ""
    });
  };

  PM_onSaveMoney = async (e) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    if (
      this.state.PM_brepara === 0 ||
      this.state.PM_joredraw === null ||
      this.state.PM_nawikas.toString().length === 0
    ) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    } else {
      let data;
      data = {
        briparabadolar:
          this.state.PM_joredraw === "دۆلار"
            ? parseFloat(this.state.PM_brepara.toString().replace(/,/g, ""))
            : 0,
        briparabadinar:
          this.state.PM_joredraw === "دینار"
            ? parseFloat(this.state.PM_brepara.toString().replace(/,/g, ""))
            : 0,
        nawiwargr: this.state.PM_nawewargr,
        joripara: this.state.PM_joredraw,
        note: this.state.PM_note,
        date: this.state.PM_barwar === "" ? Date.now : this.state.PM_barwar,
        nawikas: this.state.PM_nawikas
      };
      const res = await Instance.post("/api/v1/newParadarhenan", data, config);

      this.setState(
        {
          PM_save: true,
          PM_zhamara: res.data.paradarhenan.zhmara,
          PM_barwar: res.data.paradarhenan.date,
          PM_del_dis: true,
          //    P_paraywasl:res.data.wargrtn.paradwaykmkrdn,
          PM_wasl: res.data.paradarhenan,
          PM_toggler: false
        },
        async () => {
          let bardastdata;
          const respb = await Instance.get(`/api/v1/paraybardasakan`, config);
          if (this.state.PM_joredraw === "دۆلار") {
            bardastdata = {
              paraybardastdolar:
                Number(respb.data.paraybardastakan.paraybardastdolar) -
                parseFloat(this.state.PM_brepara.toString().replace(/,/g, ""))
            };
          } else if (this.state.PM_joredraw === "دینار") {
            bardastdata = {
              paraybardastdinar:
                Number(respb.data.paraybardastakan.paraybardastdinar) -
                parseFloat(this.state.PM_brepara.toString().replace(/,/g, ""))
            };
          }
          await Instance.put(
            `/api/v1/updateparabardastakan/${respb.data.paraybardastakan._id}`,
            bardastdata,
            config
          );
        }
      );
    }
  };

  ////// update Mony

  PM_updtate_para = async (e, para) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    try {
      if (
        this.state.PM_brepara === "" ||
        this.state.PM_brepara === 0 ||
        this.state.PM_barwar === "" ||
        this.state.PM_nawikas === ""
      ) {
        swal({
          title: "ببورە",
          text: "تکایە خانەکان پڕبکەرەوە",
          icon: "error"
        });
      } else {
        let data;
        data = {
          briparabadolar:
            this.state.PM_joredraw === "دۆلار"
              ? parseFloat(this.state.PM_brepara.toString().replace(/,/g, ""))
              : 0,
          briparabadinar:
            this.state.PM_joredraw === "دینار"
              ? parseFloat(this.state.PM_brepara.toString().replace(/,/g, ""))
              : 0,
          nawiwargr: this.state.PM_nawewargr,
          joripara: this.state.PM_joredraw,
          note: this.state.PM_note,
          date: this.state.PM_barwar === "" ? Date.now : this.state.PM_barwar,
          nawikas: this.state.PM_nawikas
        };
        const res = await Instance.put(
          `/api/v1/updateparadarhenan/${para._id}`,
          data,
          config
        );

        this.setState(
          {
            PM_open: null,
            PM_del_dis: true,
            PM_toggler: false
          },
          async () => {
            let bardastdata;
            const respb = await Instance.get(`/api/v1/paraybardasakan`, config);
            if (this.state.PM_joredraw === "دۆلار") {
              bardastdata = {
                paraybardastdolar:
                  Number(respb.data.paraybardastakan.paraybardastdolar) -
                  parseFloat(this.state.PM_brepara.toString().replace(/,/g, ""))
              };
            } else if (this.state.PM_joredraw === "دینار") {
              bardastdata = {
                paraybardastdinar:
                  Number(respb.data.paraybardastakan.paraybardastdinar) -
                  parseFloat(this.state.PM_brepara.toString().replace(/,/g, ""))
              };
            }
            await Instance.put(
              `/api/v1/updateparabardastakan/${respb.data.paraybardastakan._id}`,
              bardastdata,
              config
            );
          }
        );
        swal({
          title: "تەواو",
          text: "پسولە سورکەوتوو بوو!",
          icon: "success",
          timer: 2000
        });
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    }
  };

  PM_getParaDataBySearchMoney = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchparadarhenan?zhmara=${this.state.PM_zhamara}`,
      config
    );

    const data = res.data.parakan;
    if (data === null) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
      this.setState({ PD_zhmaraybarez: 0 });
    } else {
      this.setState(() => {
        return {
          PM_search_wasl: true,
          PM_zhamara: data.zhmara,
          PM_barwar: data.date,
          PM_brepara:
            data.joripara === "دینار"
              ? data.briparabadinar
              : data.briparabadolar,
          PM_joredraw: data.joripara,
          PM_nawewargr: data.nawiwargr,
          PM_note: data.note,
          PM_del_dis: true,
          PM_nawikas: data.nawikas,
          PM_wasl: data,
          PM_toggler: false
        };
      });
    }
  };

  PM_getParakan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/paradarhenanakan`, config);

    this.setState({
      PM_zhamara: res.data.paradarhenanakan.length + 1
    });
  };

  PM_createNewMony = () => {
    this.setState(
      {
        PM_brepara: 0,
        PM_note: "",
        PM_search_wasl: null,
        PM_save: null,
        PM_joredraw: "دۆلار",
        PM_nawewargr: "ئەنوەر",
        PM_open: null,
        PM_del_dis: null,
        PM_page: this.state.PM_zhamara,
        PM_wasl: null,
        PM_nawikas: "",
        PM_barwar: ""
      },
      () => {
        this.PM_getParakan();
        this.PB_gegtparaybardast();
      }
    );
  };

  PM_pageplusone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page = this.state.PM_zhamara + 1;
      const res = await Instance.get(
        `/api/v1/pageparadarhenan?page=${page}&limit=1`,
        config
      );

      const data = res.data.paras;
      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState(() => {
          return {
            PM_search_wasl: true,
            PM_zhamara: data.zhmara,
            PM_barwar: data.date,
            PM_brepara:
              data.joripara === "دینار"
                ? data.briparabadinar
                : data.briparabadolar,
            PM_joredraw: data.joripara,
            PM_nawewargr: data.nawiwargr,
            PM_note: data.note,
            PM_del_dis: true,
            PM_nawikas: data.nawikas,
            PM_wasl: data,
            PM_toggler: false
          };
        });
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };

  PM_pageminsone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page;
      this.state.PM_zhamara <= 1
        ? (page = 1)
        : (page = this.state.PM_zhamara - 1);
      const res = await Instance.get(
        `/api/v1/pageparadarhenan?page=${page}&limit=1`,
        config
      );

      const data = res.data.paras;
      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState(() => {
          return {
            PM_search_wasl: true,
            PM_zhamara: data.zhmara,
            PM_barwar: data.date,
            PM_brepara:
              data.joripara === "دینار"
                ? data.briparabadinar
                : data.briparabadolar,
            PM_joredraw: data.joripara,
            PM_nawewargr: data.nawiwargr,
            PM_note: data.note,
            PM_del_dis: true,
            PM_nawikas: data.nawikas,
            PM_wasl: data,
            PM_toggler: false
          };
        });
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };
  /////end of functions para darhenan

  ///////paray mandub functions

  MM_getdataOnRefreshSave = (id) => {
    let data = {
      _id: id._id,
      shwencode: this.state.MM_zhmaraybarez,
      nawishwen: this.state.MM_nawebarez,
      paraywargirawdolar:
        this.state.MM_brepara.length !== 0 && this.state.MM_joredraw === "دۆلار"
          ? parseFloat(this.state.MM_brepara.toString().replace(/,/g, ""))
          : 0,
      paraywargirawdinar:
        this.state.MM_brepara.length !== 0 && this.state.MM_joredraw === "دینار"
          ? parseFloat(this.state.MM_brepara.toString().replace(/,/g, ""))
          : 0,
      nawiwargr: this.state.MM_nawewargr,
      joripara: this.state.MM_joredraw,
      note: this.state.MM_note,
      rasidkondolar: this.state.MM_qarzeKonDolar,
      rasiddkoninar: this.state.MM_qarzeKonID,
      rasiddkonRR: this.state.MM_qarzeKonR,
      date: this.state.MM_barwar === "" ? Date.now : this.state.MM_barwar,
      zhmaraaywasl: this.state.MM_wasleShareka,
      nrxe_RRR: this.state.M_nrx_Remembe
        ? parseFloat(this.state.M_nrx_Remembe.toString().replace(/,/g, ""))
        : 0,
      Krini_RRR: this.state.M_Kren_Remembe
        ? parseFloat(this.state.M_Kren_Remembe.toString().replace(/,/g, ""))
        : 0,
      Kreni_dinar: this.state.M_Kren_dinar_2
        ? parseFloat(this.state.M_Kren_dinar_2.toString().replace(/,/g, ""))
        : 0,
      Nrxi_yakDolar: this.state.M_nrx_dolar_2
        ? parseFloat(this.state.M_nrx_dolar_2.toString().replace(/,/g, ""))
        : 0
    };
    localStorage.setItem("mandub", JSON.stringify(data));
  };

  MM_getDataOnRefresh = (data) => {
    this.setState({
      MM_search_wasl: true,
      MM_zhamara: data.zhmara,
      MM_nawebarez: data.nawishwen,
      MM_barwar: data.date,
      MM_zhmaraybarez: data.shwencode,
      MM_brepara:
        data.joripara === "دینار"
          ? data.paraywargirawdinar
          : data.paraywargirawdolar,
      MM_joredraw: data.joripara,
      MM_nawewargr: data.nawiwargr,
      MM_note: data.note,
      MM_qarzeKonDolar: data.rasidkondolar,
      MM_qarzeKonID: data.rasiddkoninar,
      MM_qarzeKonR: data.rasiddkonRR,
      MM_del_dis: null,
      MM_open: true,
      MM_wasl: data,
      MM_toggler: false,
      MM_wasleShareka: data.zhmaraaywasl,
      M_nrx_Remembe: data.nrxe_RRR ? data.nrxe_RRR : 0,
      M_Kren_Remembe: data.Krini_RRR ? data.Krini_RRR : 0,
      MM_wasl: data,
      M_nrx_Remembe_2: data.nrxe_RRR_2 ? data.nrxe_RRR_2 : 0,
      M_Kren_dinar_2: data.Kreni_dinar ? data.Kreni_dinar : 0,
      M_nrx_dolar_2: data.Nrxi_yakDolar ? data.Nrxi_yakDolar : 0,
      MM_Amount_Dolar: data.Amount_Dolar,
      MM_High_Dolar: data.High_Dolar,
      MM_Low_Dolar: data.Low_Dolar,
      MM_lastPayment: data.MM_lastPayment ? data.MM_lastPayment : 0,
      MM_Amount_Dinar: data.Amount_Dinar,
      MM_Remebi_Price: data.Remebi_Price,
      MM_DolarTR: data.DolarTR,
      MM_DinarTR: data.DinarTR
    });
  };

  MM_getPrint = () => {
    window.setTimeout("window.print()", 3500);
  };

  MM_openUpdate = async (userid, e, id) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(
      `api/v1/openMandub/${id}?id=${userid}`,
      data,
      config
    );

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      // this.MM_getdataOnRefreshSave(this.state.MM_wasl);
      this.setState(
        {
          MM_del_dis: null,
          MM_open: true
        },
        async () => {
          // this.MM_getWakilDataBySearchMoney(e);
          const respb = await Instance.get(`/api/v1/paraybardasakan`, config);
          let bardastdata;
          if (
            this.state.MM_joredraw === "دۆلار" &&
            (this.state.M_Kren_Remembe !== "" ||
              this.state.M_Kren_Remembe !== 0 ||
              this.state.M_Kren_Remembe !== null ||
              !this.state.M_Kren_Remembe)
          ) {
            let krinRR =
              this.state.M_Kren_Remembe !== null
                ? this.state.M_Kren_Remembe.toString().replace(/,/g, "")
                : 0;
            bardastdata = {
              paraybardastRemembe:
                respb.data.paraybardastakan.paraybardastRemembe -
                parseFloat(krinRR)
            };
            this.PD_getkasDataBySearchMoney_kon(
              e,
              this.state.MM_zhmaraybarez,
              this.state.MM_nawebarez
            );
            await Instance.put(
              `/api/v1/updateparabardastakan/${respb.data.paraybardastakan._id}`,
              bardastdata,
              config
            );
          }
        }
      );
    }
  };
  /// barwar toogle paray mandub

  MM_inputtogler = (e) => {
    e.preventDefault();
    this.setState({
      MM_toggler: !this.state.MM_toggler,
      MM_barwar: ""
    });
  };

  ////save paray mandub
  MM_onSaveMoney = async (e) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      if (
        this.state.MM_nawebarez === "" ||
        this.state.MM_zhmaraybarez === 0 ||
        this.state.MM_wasleShareka === 0 ||
        this.state.MM_brepara === 0 ||
        this.state.MM_brepara === "" ||
        this.state.MM_joredraw === null 
      ) {
        swal({
          title: "ببورە",
          text: "تکایە خانەکان پڕبکەرەوە",
          icon: "error"
        });
      } else {
        let data;
        data = {
          shwencode: this.state.MM_zhmaraybarez,
          nawishwen: this.state.MM_nawebarez,
          paraywargirawdolar:
            this.state.MM_joredraw === "دۆلار"
              ? parseFloat(this.state.MM_brepara.toString().replace(/,/g, ""))
              : 0,
          paraywargirawdinar:
            this.state.MM_joredraw === "دینار"
              ? parseFloat(this.state.MM_brepara.toString().replace(/,/g, ""))
              : 0,
          paraywargirawrem:
            this.state.MM_joredraw === "ڕیمێمبی"
              ? parseFloat(this.state.MM_brepara.toString().replace(/,/g, ""))
              : 0,
          nawiwargr: this.state.MM_nawewargr,
          joripara: this.state.MM_joredraw,
          note: this.state.MM_note,
          rasidkondolar: this.state.MM_qarzeKonDolar,
          rasiddkoninar: this.state.MM_qarzeKonID,
          rasiddkonRR: this.state.MM_qarzeKonR,
          date: this.state.MM_barwar === "" ? Date.now : this.state.MM_barwar,
          zhmaraaywasl: this.state.MM_wasleShareka,
          nrxe_RRR: parseFloat(
            this.state.M_nrx_Remembe.toString().replace(/,/g, "")
          ),
          Krini_RRR: parseFloat(
            this.state.M_Kren_Remembe.toString().replace(/,/g, "")
          ),
          Kreni_dinar: this.state.M_Kren_dinar_2
            ? parseFloat(this.state.M_Kren_dinar_2.toString().replace(/,/g, ""))
            : 0,
          Nrxi_yakDolar: this.state.M_nrx_dolar_2
            ? parseFloat(this.state.M_nrx_dolar_2.toString().replace(/,/g, ""))
            : 0,
          nrxe_RRR_2: this.state.M_nrx_Remembe_2
            ? parseFloat(
                this.state.M_nrx_Remembe_2.toString().replace(/,/g, "")
              )
            : 0,
          Amount_Dolar: this.ToNmberWithPars(this.state.MM_Amount_Dolar),
          High_Dolar: this.ToNmberWithPars(this.state.MM_High_Dolar),
          Low_Dolar: this.ToNmberWithPars(this.state.MM_Low_Dolar),
          Amount_Dinar: this.ToNmberWithPars(this.state.MM_Amount_Dinar),
          Remebi_Price: this.ToNmberWithPars(this.state.MM_Remebi_Price),
          DinarTR: this.state.MM_DinarTR,
          DolarTR: this.state.MM_DolarTR,
          MM_lastPayment: this.state.MM_lastPayment
        };
        const res = await Instance.post("/api/v1/newMandwb", data, config);

        this.setState(
          {
            MM_save: true,
            MM_zhamara: res.data.mandwb.zhmara,
            MM_barwar: res.data.mandwb.date,
            MM_del_dis: true,
            MM_wasl: res.data.mandwb,
            MM_toggler: false,
            MM_wakilSearch: false
          },
          async () => {
            let bardastdata;
            const respb = await Instance.get(`/api/v1/paraybardasakan`, config);
            bardastdata = {
              paraybardastRemembe:
                Number(respb.data.paraybardastakan.paraybardastRemembe) +
                parseFloat(
                  this.state.M_Kren_Remembe.toString().replace(/,/g, "")
                )
            };
            this.PD_getkasDataBySearchMoney_kon(
              e,
              this.state.MM_zhmaraybarez,
              this.state.MM_nawebarez
            );
            await Instance.put(
              `/api/v1/updateparabardastakan/${respb.data.paraybardastakan._id}`,
              bardastdata,
              config
            );
            this.PB_gegtparaybardast();
          }
        );
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    }
  };

  ////// update paray mandub
  MM_updtate_para = async (e, para, NOW) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    try {
      if (
        this.state.MM_brepara === "" ||
        this.state.MM_brepara === 0 ||
        this.state.MM_nawebarez === "" ||
        this.state.MM_barwar === "" ||
        this.state.MM_wasleShareka === 0 ||
        this.state.MM_wasleShareka === ""
      ) {
        swal({
          title: "ببورە",
          text: "تکایە خانەکان پڕبکەرەوە",
          icon: "error"
        });
      } else {
        let data;
        data = {
          shwencode: this.state.MM_zhmaraybarez,
          nawishwen: this.state.MM_nawebarez,
          paraywargirawdolar:
            this.state.MM_joredraw === "دۆلار"
              ? parseFloat(this.state.MM_brepara.toString().replace(/,/g, ""))
              : 0,
          paraywargirawdinar:
            this.state.MM_joredraw === "دینار"
              ? parseFloat(this.state.MM_brepara.toString().replace(/,/g, ""))
              : 0,
          paraywargirawrem:
            this.state.MM_joredraw === "ڕیمێمبی"
              ? parseFloat(this.state.MM_brepara.toString().replace(/,/g, ""))
              : 0,
          nawiwargr: this.state.MM_nawewargr,
          joripara: this.state.MM_joredraw,
          note: this.state.MM_note,
          rasidkondolar: this.state.MM_qarzeKonDolar,
          rasiddkoninar: this.state.MM_qarzeKonID,
          rasiddkonRR: this.state.MM_qarzeKonR,
          date: this.state.MM_barwar === "" ? Date.now : this.state.MM_barwar,
          zhmaraaywasl: this.state.MM_wasleShareka,
          nrxe_RRR: this.state.M_nrx_Remembe
            ? parseFloat(this.state.M_nrx_Remembe.toString().replace(/,/g, ""))
            : 0,
          Krini_RRR: this.state.M_Kren_Remembe
            ? parseFloat(this.state.M_Kren_Remembe.toString().replace(/,/g, ""))
            : 0,
          nrxe_RRR_2: this.state.M_nrx_Remembe_2
            ? parseFloat(
                this.state.M_nrx_Remembe_2.toString().replace(/,/g, "")
              )
            : 0,
          Amount_Dolar: this.ToNmberWithPars(this.state.MM_Amount_Dolar),
          High_Dolar: this.ToNmberWithPars(this.state.MM_High_Dolar),
          Low_Dolar: this.ToNmberWithPars(this.state.MM_Low_Dolar),
          Amount_Dinar: this.ToNmberWithPars(this.state.MM_Amount_Dinar),
          Remebi_Price: this.ToNmberWithPars(this.state.MM_Remebi_Price),
          DinarTR: this.state.MM_DinarTR,
          DolarTR: this.state.MM_DolarTR,
          MM_lastPayment: this.state.MM_lastPayment
        };
        const res = await Instance.put(
          `/api/v1/updatemandwb/${para._id}`,
          data,
          config
        );
        localStorage.removeItem("mandub");
        this.setState(
          {
            MM_open: null,
            MM_del_dis: true,
            MM_toggler: false,
            MM_wasl: res.data.update,
            MM_wakilSearch: false
          },
          async () => {
            this.PD_getkasDataBySearchMoney_kon(
              e,
              this.state.MM_zhmaraybarez,
              this.state.MM_nawebarez
            );
            const respb = await Instance.get(`/api/v1/paraybardasakan`, config);
            let bardastdata;
            if (
              this.state.MM_joredraw === "دۆلار" &&
              this.state.M_Kren_Remembe !== "" &&
              this.state.M_Kren_Remembe !== 0 &&
              this.state.M_Kren_Remembe !== null
            ) {
              bardastdata = {
                paraybardastRemembe:
                  Number(respb.data.paraybardastakan.paraybardastRemembe) +
                  parseFloat(
                    this.state.M_Kren_Remembe.toString().replace(/,/g, "")
                  )
              };
              await Instance.put(
                `/api/v1/updateparabardastakan/${respb.data.paraybardastakan._id}`,
                bardastdata,
                config
              );
            }
          }
        );
        swal({
          title: "تەواو",
          text: "پسولە سورکەوتوو بوو!",
          icon: "success",
          timer: 2000
        });
      }
    } catch (error) {
      console.log("error", error);
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    }
  };

  ////search paray mandub
  MM_getWakilDataBySearchMoney = async (e, zh_barez, BriPara) => {
    e.preventDefault();
    let zhMarayBarez = zh_barez ? zh_barez : this.state.MM_zhmaraybarez;
    const res = await Instance.get(
      `/api/v1/searchpeople?code=${zhMarayBarez}&&Name=${this.state.MM_nawebarez}`
    );
    const data = res.data.peoples;
    if (data === null) {
      alert("ببورە ئەم بەڕێزە بونی نیە");
    } else {
      this.setState(() => {
        return {
          MM_zhmaraybarez: data.code,
          MM_nawebarez: data.Name,
          MM_qarzeKonDolar: Number(data.paradolar).toFixed(2),
          MM_qarzeKonID: Number(data.paradinar).toFixed(2),
          MM_qarzeKonR: Number(data.paraRRR).toFixed(2),
          MM_qarzeKonRState: _.subtract(Number(data.paraRRR), BriPara),
          MM_wakilSearch: true
        };
      });
    }
  };

  //////// name search of the kas inside مافی کۆمپانیا ////////
  MM_searchKasByName = async (name) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/SearchNamePeople?name=${encodeURIComponent(name)}`,
        config
      );
      this.setState({
        MM_kasSuggestions: res.data.peoples || [],
        MM_kasCursor: -1
      });
    } catch (error) {
      this.setState({ MM_kasSuggestions: [], MM_kasCursor: -1 });
    }
  };

  MM_kasNameHandle = (e) => {
    const name = e.target.value;
    this.setState({ MM_nawebarez: name }, () => {
      if (!name || name === "") {
        this.MM_emptyKasSuggestions();
      } else {
        this.MM_searchKasByName(name);
      }
    });
  };

  MM_emptyKasSuggestions = () => {
    this.setState({
      MM_kasSuggestions: [],
      MM_kasCursor: -1
    });
  };

  //// clicking (or pressing Enter on) a name loads the whole kas detail
  MM_kasSuggestionSelected = (kas) => {
    if (!kas) {
      return;
    }
    const briPara =
      parseFloat(this.state.MM_brepara.toString().replace(/,/g, "")) || 0;
    this.setState(
      {
        MM_zhmaraybarez: kas.code,
        MM_nawebarez: kas.Name,
        MM_qarzeKonDolar: Number(kas.paradolar).toFixed(2),
        MM_qarzeKonID: Number(kas.paradinar).toFixed(2),
        MM_qarzeKonR: Number(kas.paraRRR).toFixed(2),
        MM_qarzeKonRState: _.subtract(Number(kas.paraRRR), briPara),
        MM_wakilSearch: true,
        MM_kasSuggestions: [],
        MM_kasCursor: -1
      },
      () => {
        const amount = window.document.getElementById("MM_brepara_input");
        if (amount) {
          amount.focus();
        }
      }
    );
  };

  //// arrow up/down moves inside the list, Enter picks the highlighted kas
  MM_kasListKeydown = (e) => {
    const { MM_kasSuggestions, MM_kasCursor } = this.state;
    if (!MM_kasSuggestions || MM_kasSuggestions.length === 0) {
      return;
    }
    if (e.keyCode === 27) {
      this.MM_emptyKasSuggestions();
      return;
    }
    if (e.keyCode === 40) {
      e.preventDefault();
      this.setState((prevState) => ({
        MM_kasCursor:
          prevState.MM_kasCursor < MM_kasSuggestions.length - 1
            ? prevState.MM_kasCursor + 1
            : prevState.MM_kasCursor
      }));
    } else if (e.keyCode === 38) {
      e.preventDefault();
      this.setState((prevState) => ({
        MM_kasCursor:
          prevState.MM_kasCursor > 0
            ? prevState.MM_kasCursor - 1
            : prevState.MM_kasCursor
      }));
    } else if (e.keyCode === 13 && MM_kasCursor >= 0) {
      e.preventDefault();
      this.MM_kasSuggestionSelected(MM_kasSuggestions[MM_kasCursor]);
    }
  };

  MM_peshandaniQarzyPeshw = () => {
    if (this.state.MM_joredraw == "دۆلار") {
      let paraykon = this.state.MM_qarzeKonDolar;
      let parayesta =
        Number(paraykon) +
        parseFloat(this.state.MM_brepara.toString().replace(/,/g, ""));
      return Number(parayesta).toFixed(2);
    } else if (this.state.MM_joredraw == "دینار") {
      let paraykon = this.state.MM_qarzeKonID;
      let parayesta =
        Number(paraykon) +
        parseFloat(this.state.MM_brepara.toString().replace(/,/g, ""));
      return Number(parayesta).toFixed(2);
    } else {
      let paraykon = this.state.MM_qarzeKonR;
      let parayesta =
        Number(paraykon) +
        parseFloat(this.state.MM_brepara.toString().replace(/,/g, ""));
      return Number(parayesta).toFixed(2);
    }
  };
  MM_getParaDataBySearchMoney = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchmandwb?zhmara=${this.state.MM_zhamara}`,
      config
    );

    const data = res.data.Mandwbkan;
    // this.MM_getWakilDataBySearchMoney(e, data.shwencode);
    if (data === null) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
      this.setState({ MM_zhamara: 0 });
    } else {
      this.setState(
        () => {
          return {
            MM_search_wasl: true,
            MM_zhamara: data.zhmara,
            MM_nawebarez: data.nawishwen,
            MM_barwar: data.date,
            MM_zhmaraybarez: data.shwencode,
            MM_brepara:
              data.joripara === "دینار"
                ? data.paraywargirawdinar
                : data.joripara === "دۆلار"
                ? data.paraywargirawdolar
                : data.paraywargirawrem,
            MM_joredraw: data.joripara,
            MM_nawewargr: data.nawiwargr,
            MM_note: data.note,
            MM_qarzeKonDolar: data.rasidkondolar,
            MM_qarzeKonID: data.rasiddkoninar,
            MM_qarzeKonR: data.rasiddkonRR,
            MM_del_dis: true,
            MM_wasl: data,
            MM_toggler: false,
            MM_wasleShareka: data.zhmaraaywasl,
            M_nrx_Remembe: data.nrxe_RRR ? data.nrxe_RRR : 0,
            M_Kren_Remembe: data.Krini_RRR ? data.Krini_RRR : 0,
            M_nrx_Remembe_2: data.nrxe_RRR_2 ? data.nrxe_RRR_2 : 0,
            M_Kren_dinar_2: data.Kreni_dinar ? data.Kreni_dinar : 0,
            M_nrx_dolar_2: data.Nrxi_yakDolar ? data.Nrxi_yakDolar : 0,
            MM_Amount_Dolar: data.Amount_Dolar,
            MM_High_Dolar: data.High_Dolar,
            MM_Low_Dolar: data.Low_Dolar,
            MM_lastPayment: data.MM_lastPayment ? data.MM_lastPayment : 0,
            MM_Amount_Dinar: data.Amount_Dinar,
            MM_Remebi_Price: data.Remebi_Price,
            MM_DolarTR: data.DolarTR,
            MM_DinarTR: data.DinarTR
          };
        },
        (e) => {
          this.PD_getkasDataBySearchMoney_kon(
            e,
            this.state.MM_zhmaraybarez,
            this.state.MM_nawebarez
          );
        }
      );
    }
  };

  MM_getParaDataBySearcInvoice = async (e) => {
    e.preventDefault();
    const res = await Instance.get(
      `/api/v1/getMandwbByInvoiceNo/${this.state.MM_wasleShareka}?invno=${this.state.MM_zhamara}`
    );
    const data = res.data.result;
    this.setState(() => {
      return {
        MM_lastPayment: data
      };
    });
  };

  MM_getParakan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/mandwbakan`, config);

    this.setState({
      MM_zhamara: res.data.Mandwbkan.length + 1
    });
  };

  MM_setSearchMonyWakilEmpty = (e) => {
    e.preventDefault();
    this.setState({
      MM_zhmaraybarez: 0,
      MM_nawebarez: "",
      MM_qarzeKonDolar: 0,
      MM_lastPayment: "",
      MM_qarzeKonID: 0,
      MM_qarzeKonR: 0,
      MM_wakilSearch: false,
      MM_qarzeKonRState: 0,
      MM_kasSuggestions: [],
      MM_kasCursor: -1
    });
  };

  MM_createNewMony = () => {
    this.setState(
      {
        MM_zhmaraybarez: 0,
        MM_nawebarez: "",
        MM_lastPayment: "",
        MM_qarzeKonDolar: 0,
        MM_qarzeKonR: 0,
        MM_qarzeKonID: 0,
        MM_qarzeKonRState: 0,
        MM_brepara: 0,
        MM_note: "",
        MM_search_wasl: null,
        MM_save: null,
        MM_joredraw: "دۆلار",
        MM_nawewargr: "ئەنوەر",
        MM_open: null,
        MM_del_dis: null,
        MM_page: this.state.MM_zhamara,
        MM_wasleShareka: 0,
        MM_isChecked: false,
        MM_barwar: "",
        M_nrx_Remembe: 0,
        M_Kren_Remembe: 0,
        ok: null,
        M_nrx_Remembe_2: "",
        M_nrx_dolar_2: "",
        M_Kren_dinar_2: "",
        ok_2: null,
        MM_wakilSearch: false,
        MM_kasSuggestions: [],
        MM_kasCursor: -1,
        MM_Amount_Dolar: "",
        MM_High_Dolar: "",
        MM_Low_Dolar: "",
        MM_Amount_Dinar: "",
        MM_Remebi_Price: "",
        MM_DolarTR: false,
        MM_DinarTR: false
      },
      () => {
        this.MM_getParakan();
        // this.PB_gegtparaybardast();
      }
    );
  };

  MM_getIsChecked = (e) => {
    let checked = e.target.checked;
    if (checked) {
      this.setState({ MM_isChecked: true });
    } else {
      this.setState({ MM_isChecked: false });
    }
  };
  MM_DolartoDinare = (e) => {
    e.preventDefault();
    let DolarToDinar = _.multiply(
      this.ToNmberWithPars(this.state.MM_Amount_Dolar),
      this.ToNmberWithPars(this.state.MM_High_Dolar)
    );
    this.setState({
      MM_brepara: Number(DolarToDinar).toFixed(2),
      MM_joredraw: "دینار",
      MM_DolarTR: false,
      MM_DinarTR: false
    });
  };
  MM_DolartoRemembi_In_Balance = (e) => {
    e.preventDefault();
    this.setState({
      MM_DolarTR: !this.state.MM_DolarTR,
      MM_DinarTR: false
    });
  };
  MM_DolartoRemembi_WithOut_Balance = (e) => {
    e.preventDefault();
    let DolarToDinar = _.multiply(
      this.ToNmberWithPars(this.state.MM_Amount_Dolar),
      this.ToNmberWithPars(this.state.MM_High_Dolar)
    );
    let DinarToDolar = _.divide(
      this.ToNmberWithPars(DolarToDinar),
      this.ToNmberWithPars(this.state.MM_Low_Dolar)
    );
    let DolarToRemebi = _.multiply(
      this.ToNmberWithPars(DinarToDolar),
      this.ToNmberWithPars(this.state.MM_Remebi_Price)
    );
    this.setState({
      MM_brepara: Number(DolarToRemebi).toFixed(2),
      MM_joredraw: "ڕیمێمبی",
      MM_DolarTR: false,
      MM_DinarTR: false
    });
  };
  MM_DinartoRemembi_In_Balance = (e) => {
    e.preventDefault();
    this.setState({
      MM_DolarTR: false,
      MM_DinarTR: !this.state.MM_DinarTR
    });
  };

  MM_DinartoRemembi_Without_Balance = (e) => {
    e.preventDefault();
    let DinarToDolar = _.divide(
      this.ToNmberWithPars(this.state.MM_Amount_Dinar),
      this.ToNmberWithPars(this.state.MM_Low_Dolar)
    );
    let DolarToRemebi = _.multiply(
      this.ToNmberWithPars(DinarToDolar),
      this.ToNmberWithPars(this.state.MM_Remebi_Price)
    );
    this.setState({
      MM_brepara: Number(DolarToRemebi).toFixed(2),
      MM_joredraw: "ڕیمێمبی",
      MM_DolarTR: false,
      MM_DinarTR: false
    });
  };

  MM_pageplusone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page = this.state.MM_zhamara + 1;
      const res = await Instance.get(
        `/api/v1/pagemandwb?page=${page}&limit=1`,
        config
      );

      const data = res.data.Mandwbs;
      // this.MM_getWakilDataBySearchMoney(e, data.shwencode);
      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState(
          () => {
            return {
              MM_search_wasl: true,
              MM_zhamara: data.zhmara,
              MM_nawebarez: data.nawishwen,
              MM_barwar: data.date,
              MM_zhmaraybarez: data.shwencode,
              MM_brepara:
                data.joripara === "دینار"
                  ? data.paraywargirawdinar
                  : data.joripara === "دۆلار"
                  ? data.paraywargirawdolar
                  : data.paraywargirawrem,
              MM_joredraw: data.joripara,
              MM_nawewargr: data.nawiwargr,
              MM_note: data.note,
              MM_qarzeKonDolar: data.rasidkondolar,
              MM_qarzeKonID: data.rasiddkoninar,
              MM_qarzeKonR: data.rasiddkonRR,
              MM_del_dis: true,
              //  P_paraywasl:data.paradwaykmkrdn,
              MM_wasl: data,
              MM_toggler: false,
              MM_wasleShareka: data.zhmaraaywasl,
              M_nrx_Remembe: data.nrxe_RRR ? data.nrxe_RRR : 0,
              M_Kren_Remembe: data.Krini_RRR ? data.Krini_RRR : 0,
              M_nrx_Remembe_2: data.nrxe_RRR_2 ? data.nrxe_RRR_2 : 0,
              M_Kren_dinar_2: data.Kreni_dinar ? data.Kreni_dinar : 0,
              M_nrx_dolar_2: data.Nrxi_yakDolar ? data.Nrxi_yakDolar : 0,
              MM_Amount_Dolar: data.Amount_Dolar,
              MM_High_Dolar: data.High_Dolar,
              MM_Low_Dolar: data.Low_Dolar,
              MM_lastPayment: data.MM_lastPayment ? data.MM_lastPayment : 0,
              MM_Amount_Dinar: data.Amount_Dinar,
              MM_Remebi_Price: data.Remebi_Price,
              MM_DolarTR: data.DolarTR,
              MM_DinarTR: data.DinarTR
            };
          },
          (e) => {
            this.PD_getkasDataBySearchMoney_kon(
              e,
              this.state.MM_zhmaraybarez,
              this.state.MM_nawebarez
            );
          }
        );
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };

  MM_pageminsone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page;
      this.state.MM_zhamara <= 1
        ? (page = 1)
        : (page = this.state.MM_zhamara - 1);
      const res = await Instance.get(
        `/api/v1/pagemandwb?page=${page}&limit=1`,
        config
      );

      const data = res.data.Mandwbs;
      // this.MM_getWakilDataBySearchMoney(e, data.shwencode);
      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState(
          () => {
            return {
              MM_search_wasl: true,
              MM_zhamara: data.zhmara,
              MM_nawebarez: data.nawishwen,
              MM_barwar: data.date,
              MM_zhmaraybarez: data.shwencode,
              MM_brepara:
                data.joripara === "دینار"
                  ? data.paraywargirawdinar
                  : data.joripara === "دۆلار"
                  ? data.paraywargirawdolar
                  : data.paraywargirawrem,
              MM_joredraw: data.joripara,
              MM_nawewargr: data.nawiwargr,
              MM_note: data.note,
              MM_qarzeKonDolar: data.rasidkondolar,
              MM_qarzeKonID: data.rasiddkoninar,
              MM_qarzeKonR: data.rasiddkonRR,
              MM_del_dis: true,
              //  P_paraywasl:data.paradwaykmkrdn,
              MM_wasl: data,
              MM_toggler: false,
              MM_wasleShareka: data.zhmaraaywasl,
              M_nrx_Remembe: data.nrxe_RRR ? data.nrxe_RRR : 0,
              M_Kren_Remembe: data.Krini_RRR ? data.Krini_RRR : 0,
              M_nrx_Remembe_2: data.nrxe_RRR_2 ? data.nrxe_RRR_2 : 0,
              M_Kren_dinar_2: data.Kreni_dinar ? data.Kreni_dinar : 0,
              M_nrx_dolar_2: data.Nrxi_yakDolar ? data.Nrxi_yakDolar : 0,
              MM_Amount_Dolar: data.Amount_Dolar,
              MM_High_Dolar: data.High_Dolar,
              MM_Low_Dolar: data.Low_Dolar,
              MM_lastPayment: data.MM_lastPayment ? data.MM_lastPayment : 0,
              MM_Amount_Dinar: data.Amount_Dinar,
              MM_Remebi_Price: data.Remebi_Price,
              MM_DolarTR: data.DolarTR,
              MM_DinarTR: data.DinarTR
            };
          },
          (e) => {
            this.PD_getkasDataBySearchMoney_kon(
              e,
              this.state.MM_zhmaraybarez,
              this.state.MM_nawebarez
            );
          }
        );
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };
  /////end of Mandubakan

  // Functions of raporty paradan
  RPD_OpenModal = async (e, userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data, config);

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(() => {
        return {
          RPD_openmodel: !this.state.RPD_openmodel,
          RPD_data: [],
          RPD_para$: 0,
          RPD_paraID: 0,
          RPD_paraRRR: 0
        };
      });
    }
  };
  RPD_filterPara = (jor) => {
    this.setState({
      RPD_jorfilter: jor
    });
  };
  RPD_CloseModal = () => {
    this.setState(() => {
      return { RPD_openmodel: false };
    });
  };

  RPD_peshandan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(
      `/api/v1/paradanakandata?from=${this.state.RPD_from}&to=${this.state.RPD_to}`,
      config
    );
    const footer = await Instance.get(
      `/api/v1/paradanakanfromto?from=${this.state.RPD_from}&to=${this.state.RPD_to}`,
      config
    );
    if (footer.data.paradanakan.length !== 0) {
      footer.data.paradanakan.forEach((data) => {
        this.setState({
          RPD_para$: data.briparabadolar,
          RPD_paraID: data.briparabadinar,
          RPD_paraRRR: data.briparabaRRR
        });
      });
      this.setState({
        RPD_data: res.data.paradanakan
      });
    }
    this.RPD_CloseModal();
  };

  RPD_getParaDataBySearchMoney = async (e, zhmara) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchpardan?zhmara=${zhmara}`,
      config
    );

    const data = res.data.parakan;
    if (data === null) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
      this.setState({ PD_zhmaraybarez: 0 });
    } else {
      this.setState(() => {
        return {
          PD_search_wasl: true,
          PD_zhamara: data.zhmara,
          PD_nawebarez: data.nawekas,
          Pd_barwar: data.date,
          PD_zhmaraybarez: data.kascode,
          PD_brepara:
            data.joripara === "دینار"
              ? data.briparabadinar
              : data.joripara === "دۆلار"
              ? data.briparabadolar
              : data.briparabaRRR,
          PD_joredraw: data.joripara,
          PD_nawewargr: data.nawiwargr,
          PD_note: data.note,
          PD_del_dis: true,
          PD_wasl: data,
          PD_toggler: false,
          PD_wasleShareka: data.zhmaraaywasl,
          PD_qardekon$: data.rasidkondolar,
          PD_qardekonID: data.rasiddkoninar,
          PD_qardekonRR: data.rasiddkonRRR,
          PD_nrx_Remembe: data.nrxe_RRR ? data.nrxe_RRR : 0,
          PD_nrx_Remembe_2: data.nrxe_RRR_2 ? data.nrxe_RRR_2 : 0,
          PD_Kren_dinar_2: data.Kreni_dinar ? data.Kreni_dinar : 0,
          PD_nrx_dolar_2: data.Nrxi_yakDolar ? data.Nrxi_yakDolar : 0,
          PD_Kren_Remembe: data.Krini_RRR ? data.Krini_RRR : 0,
          P_Amount_Dolar: data.Amount_Dolar,
          P_High_Dolar: data.High_Dolar,
          P_Low_Dolar: data.Low_Dolar,
          P_Amount_Dinar: data.Amount_Dinar,
          P_Remebi_Price: data.Remebi_Price,
          P_DolarTR: data.DolarTR,
          P_DinarTR: data.DinarTR
        };
      });
    }
  };

  // Functions of raporty paradan
  RPM_OpenModal = async (e, userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data, config);

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(() => {
        return {
          RPM_openmodel: !this.state.RPM_openmodel,
          RPM_data: [],
          RPM_para$: 0,
          RPM_paraID: 0
        };
      });
    }
  };

  RPM_CloseModal = () => {
    this.setState(() => {
      return { RPM_openmodel: false };
    });
  };

  RPM_peshandan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/paradarhinanakndata?from=${this.state.RPM_from}&to=${this.state.RPM_to}`,
        config
      );
      const footer = await Instance.get(
        `/api/v1/paradarhinan?from=${this.state.RPM_from}&to=${this.state.RPM_to}`,
        config
      );
      footer.data.paradarhinanakan.forEach((data) => {
        this.setState({
          RPM_para$: data.briparabadolar,
          RPM_paraID: data.briparabadinar
        });
      });
      this.setState({
        RPM_data: res.data.paradarhenanakan
      });
      this.RPM_CloseModal();
    } catch (error) {
      alert("وشەی نهێنی هەڵەیە");
    }
  };

  RPM_getParaDataBySearchMoney = async (e, zhmara) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchparadarhenan?zhmara=${zhmara}`,
      config
    );

    const data = res.data.parakan;
    if (data === null) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
      this.setState({ PD_zhmaraybarez: 0 });
    } else {
      this.setState(() => {
        return {
          PM_search_wasl: true,
          PM_zhamara: data.zhmara,
          PM_barwar: data.date,
          PM_brepara:
            data.joripara === "دینار"
              ? data.briparabadinar
              : data.briparabadolar,
          PM_joredraw: data.joripara,
          PM_nawewargr: data.nawiwargr,
          PM_note: data.note,
          PM_del_dis: true,
          //  P_paraywasl:data.paradwaykmkrdn,
          PM_wasl: data,
          PM_toggler: false
        };
      });
    }
  };
  //end of Functions of raporty paradan

  // functions of raporty masrufat
  RMS_OpenModal = async (e, userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data, config);

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(() => {
        return {
          RMS_openmodel: !this.state.RMS_openmodel,
          RMS_data: [],
          RMS_para$: 0,
          RMS_paraID: 0
        };
      });
    }
  };

  RMS_CloseModal = () => {
    this.setState(() => {
      return { RMS_openmodel: false };
    });
  };

  RMS_peshandan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/masrwffromto?from=${this.state.RMS_from}&to=${this.state.RMS_to}`,
        config
      );

      this.setState(
        {
          RMS_data: res.data.masrwf
        },
        () => {
          this.RMS_getkoymasrwfdolar();
          this.RMS_getkoymasrwfdinar();
        }
      );
      this.RMS_CloseModal();
    } catch (error) {
      alert("وشەی نهێنی هەڵەیە");
    }
  };

  RMS_getkoymasrwfdolar = () => {
    let subTotal = 0;
    this.state.RMS_data.map((item) => {
      if (item.joripara === "دۆلار") {
        subTotal += Number(item.koypara);
      }
    });
    const koyparakandolar = Number(Number(subTotal).toFixed(2));
    this.setState(() => {
      return {
        RMS_koymasruf$: koyparakandolar
      };
    });
  };

  RMS_getkoymasrwfdinar = () => {
    let subTotal = 0;
    this.state.RMS_data.map((item) => {
      if (item.joripara === "دینار") {
        subTotal += Number(item.koypara);
      }
    });
    const koyparakandinar = Number(Number(subTotal).toFixed(2));
    this.setState(() => {
      return {
        RMS_koymasrufID: koyparakandinar
      };
    });
  };
  // end of functions of raporty masrufat

  // functions of Raporty tak kasakan
  RT_filter = (jor) => {
    this.setState({
      RT_jor: jor
    });
  };
  RT_OpenModal = async (e, userid) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data, config);

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(() => {
        return {
          RT_openmodel: !this.state.RT_openmodel,
          RT_data: [],
          RT_nawibrez: "",
          RT_zhmaraybarez: "",
          RT_koyparadan$: 0,
          RT_koyparadanID: 0,
          RT_koyparadanRRR: 0,
          RT_koyparadarhinan$: 0,
          RT_koyparadarhinanID: 0,
          RT_koyparadarhinanRRR: 0,
          RT_KoyKriniRR: 0,
          RT_kasSuggestions: [],
          RT_kasCursor: -1
        };
      });
    }
  };

  RT_CloseModal = () => {
    this.setState(() => {
      return { RT_openmodel: false };
    });
  };

  RT_serchwakil = async (e) => {
    e.preventDefault(e);
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(
      `/api/v1/searchpeople?code=${Number(this.state.RT_zhmaraybarez)}`,
      config
    );

    const data = res.data.peoples;
    if (data === null) {
      alert("ببورە ئەم بەڕێزە بونی نیە");
    } else {
      this.setState(() => {
        return {
          RT_zhmaraybarez: data.code,
          RT_nawibrez: data.Name,
          RT_mob: data.phone,
          RT_para$: Number(data.paradolar).toFixed(2),
          RT_paraID: Number(data.paradinar).toFixed(2),
          RT_paraRR: Number(data.paraRRR).toFixed(2)
        };
      });
    }
  };

  //////// name search of the kas inside ڕاپۆرتی کەسەکان ////////
  //// every keystroke in the name input asks the server for the kasakan
  //// whose name contains what got typed so far
  RT_searchKasByName = async (name) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/SearchNamePeople?name=${encodeURIComponent(name)}`,
        config
      );
      this.setState({
        RT_kasSuggestions: res.data.peoples || [],
        RT_kasCursor: -1
      });
    } catch (error) {
      this.setState({ RT_kasSuggestions: [], RT_kasCursor: -1 });
    }
  };

  RT_kasNameHandle = (e) => {
    const name = e.target.value;
    this.setState({ RT_nawibrez: name }, () => {
      if (!name || name === "") {
        this.RT_emptyKasSuggestions();
      } else {
        this.RT_searchKasByName(name);
      }
    });
  };

  RT_emptyKasSuggestions = () => {
    this.setState({
      RT_kasSuggestions: [],
      RT_kasCursor: -1
    });
  };

  //// clicking (or pressing Enter on) a name fills the same fields
  //// that RT_serchwakil fills when the code gets typed
  RT_kasSuggestionSelected = (kas) => {
    if (!kas) {
      return;
    }
    this.setState({
      RT_zhmaraybarez: kas.code,
      RT_nawibrez: kas.Name,
      RT_mob: kas.phone,
      RT_para$: Number(kas.paradolar).toFixed(2),
      RT_paraID: Number(kas.paradinar).toFixed(2),
      RT_paraRR: Number(kas.paraRRR).toFixed(2),
      RT_kasSuggestions: [],
      RT_kasCursor: -1
    });
  };

  //// arrow up/down moves inside the list, Enter picks the highlighted kas
  RT_kasListKeydown = (e) => {
    const { RT_kasSuggestions, RT_kasCursor } = this.state;
    if (!RT_kasSuggestions || RT_kasSuggestions.length === 0) {
      return;
    }
    if (e.keyCode === 27) {
      this.RT_emptyKasSuggestions();
      return;
    }
    if (e.keyCode === 40) {
      e.preventDefault();
      this.setState((prevState) => ({
        RT_kasCursor:
          prevState.RT_kasCursor < RT_kasSuggestions.length - 1
            ? prevState.RT_kasCursor + 1
            : prevState.RT_kasCursor
      }));
    } else if (e.keyCode === 38) {
      e.preventDefault();
      this.setState((prevState) => ({
        RT_kasCursor:
          prevState.RT_kasCursor > 0
            ? prevState.RT_kasCursor - 1
            : prevState.RT_kasCursor
      }));
    } else if (e.keyCode === 13) {
      //// nothing highlighted yet means the first match is the one wanted
      e.preventDefault();
      this.RT_kasSuggestionSelected(
        RT_kasCursor >= 0 ? RT_kasSuggestions[RT_kasCursor] : RT_kasSuggestions[0]
      );
    }
  };

  RT_setstInputEmpty = () => {
    this.setState(() => {
      return {
        RT_zhmaraybarez: 0,
        RT_nawibrez: "",
        RT_kasSuggestions: [],
        RT_kasCursor: -1
      };
    });
  };
  /////// pshandani kas/shwen raport
  RT_peshandan = async (from, to, code) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    try {
      this.RT_CloseModal();
      const config = {
        "Content-Type": "application/json"
      };
      const table = this.state.RT_data;
      const res = await Instance.get(
        `/api/v1/kasparadata?from=${from}&to=${to}&kascode=${code}`,
        config
      );
      const data = res.data.pswla;
      const sumdata = res.data.paradanakan;

      if (data.length !== 0) {
        data.forEach((data) => {
          table.push({
            joripara: data.joripara,
            koywasl:
              data.joripara === "دۆلار"
                ? data.briparabadolar
                : data.joripara === "دینار"
                ? data.briparabadinar
                : data.briparabaRRR,
            jwlla: "پارەدان",
            barwar: data.date,
            code: data.zhmara,
            nawewargr: data.nawiwargr,
            wasl: data.zhmaraaywasl,
            note: data.note
          });
        });
      }
      const para = await Instance.get(
        `/api/v1/shwenmandwbdata?from=${from}&to=${to}&shwencode=${code}`,
        config
      );
      const paras = para.data.pswla;
      const parasdata = para.data.Mandwbs;

      if (paras.length !== 0) {
        paras.forEach((paras) => {
          table.push({
            joripara: paras.joripara,
            koywasl:
              paras.joripara === "دۆلار"
                ? paras.paraywargirawdolar
                : paras.joripara === "دینار"
                ? paras.paraywargirawdinar
                : paras.paraywargirawrem,
            jwlla: "مافی.کۆمپانیا",
            barwar: paras.date,
            code: paras.zhmara,
            nawewargr: paras.nawiwargr,
            wasl: paras.zhmaraaywasl,
            note: paras.note,
            nrxe_RRR: paras.nrxe_RRR,
            Krini_RRR: paras.Krini_RRR
          });
        });
      }

      if (sumdata.length !== 0) {
        this.setState({
          RT_koyparadan$: sumdata[0].briparabadolar,
          RT_koyparadanID: sumdata[0].briparabadinar,
          RT_koyparadanRRR: sumdata[0].briparabaRRR
        });
      }

      if (parasdata.length !== 0) {
        this.setState({
          RT_koyparadarhinan$: parasdata[0].paraywargirawdolar,
          RT_koyparadarhinanID: parasdata[0].paraywargirawdinar,
          RT_koyparadarhinanRRR: parasdata[0].paraywargirawrem,
          RT_KoyKriniRR: parasdata[0].Krini_RRR
        });
      }
      console.log(
        "first",
        _.sumBy(data, function (o) {
          return o.Amount_Dinar ? o.Amount_Dinar : 0;
        })
      );
      this.setState({
        PD_RR_IQD: _.sumBy(data, function (o) {
          return o.Amount_Dinar ? o.Amount_Dinar : 0;
        }),
        PD_RR_$: _.sumBy(data, function (o) {
          return o.Amount_Dolar ? o.Amount_Dolar : 0;
        }),
        MM_RR_IQD: _.sumBy(paras, function (o) {
          return o.Amount_Dinar ? o.Amount_Dinar : 0;
        }),
        MM_RR_$: _.sumBy(paras, function (o) {
          return o.Amount_Dolar ? o.Amount_Dolar : 0;
        })
      });
      if (this.state.RT_paradan === true) {
        this.setState({
          RT_data: table.filter((data) => data.jwlla === "پارەدان")
        });
      } else if (this.state.RT_mandub === true) {
        this.setState({
          RT_data: table.filter((data) => data.jwlla === "مافی.کۆمپانیا")
        });
      }
    } catch (error) {
      alert("هیج جاڵاکیەکی نیە");
    }
  };
  ///// koy paray mandwb || koy kreen
  RT_koyKrenolar = () => {
    let subTotal = 0;
    this.state.RT_data.map((item) => {
      if (item.joripara === "دۆلار" && item.jwlla === "مافی.کۆمپانیا") {
        subTotal += Number(item.koywasl);
      }
    });
    const koypardab = Number(Number(subTotal).toFixed(2));
    this.setState(() => {
      return {
        RT_koyparadan$: koypardab
      };
    });
  };

  RT_koyKreninar = () => {
    let subTotal = 0;
    this.state.RT_data.map((item) => {
      if (item.joripara === "دینار" && item.jwlla === "مافی.کۆمپانیا") {
        subTotal += Number(item.koywasl);
      }
    });
    const koypardab = Number(Number(subTotal).toFixed(2));
    this.setState(() => {
      return {
        RT_koyparadanID: koypardab
      };
    });
  };
  //// koy paaradn
  RT_koypardandolar = () => {
    let subTotal = 0;
    this.state.RT_data.map((item) => {
      if (item.joripara === "دۆلار" && item.jwlla === "پارەدان") {
        subTotal += Number(item.koywasl);
      }
    });
    const koypardab = Number(Number(subTotal).toFixed(2));
    this.setState(() => {
      return {
        RT_koyparadan$: koypardab
      };
    });
  };

  RT_koypardandinar = () => {
    let subTotal = 0;
    this.state.RT_data.map((item) => {
      if (item.joripara === "دینار" && item.jwlla === "پارەدان") {
        subTotal += Number(item.koywasl);
      }
    });
    const koypardab = Number(Number(subTotal).toFixed(2));
    this.setState(() => {
      return {
        RT_koyparadanID: koypardab
      };
    });
  };
  RT_Paradanakan = async () => {
    this.setState(
      {
        RT_paradan: true,
        RT_mandub: false,
        RT_data: []
      },
      () => {
        this.RT_peshandan(
          this.state.RT_from,
          this.state.RT_to,
          this.state.RT_zhmaraybarez
        );
      }
    );
  };

  RT_mandubakan = async () => {
    this.setState(
      {
        RT_mandub: true,
        RT_paradan: false,
        RT_data: []
      },
      () => {
        this.RT_peshandan(
          this.state.RT_from,
          this.state.RT_to,
          this.state.RT_zhmaraybarez
        );
      }
    );
  };

  /////saerch
  RT_gotoMandub = async (e, zhwasl, i) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchmandwb?zhmara=${Number(zhwasl)}`,
      config
    );

    const data = res.data.Mandwbkan;

    // this.MM_getWakilDataBySearchMoney(e, data.shwencode);
    this.setState(
      () => {
        return {
          MM_search_wasl: true,
          MM_zhamara: data.zhmara,
          MM_nawebarez: data.nawishwen,
          MM_barwar: data.date,
          MM_zhmaraybarez: data.shwencode,
          MM_brepara:
            data.joripara === "دینار"
              ? data.paraywargirawdinar
              : data.joripara === "دۆلار"
              ? data.paraywargirawdolar
              : data.paraywargirawrem,
          MM_joredraw: data.joripara,
          MM_nawewargr: data.nawiwargr,
          MM_note: data.note,
          MM_qarzeKonDolar: data.rasidkondolar,
          MM_qarzeKonID: data.rasiddkoninar,
          MM_qarzeKonR: data.rasiddkonRR,
          MM_del_dis: true,
          MM_wasl: data,
          MM_toggler: false,
          MM_wasleShareka: data.zhmaraaywasl,
          M_nrx_Remembe: data.nrxe_RRR ? data.nrxe_RRR : 0,
          M_Kren_Remembe: data.Krini_RRR ? data.Krini_RRR : 0,
          M_nrx_Remembe_2: data.nrxe_RRR_2 ? data.nrxe_RRR_2 : 0,
          M_Kren_dinar_2: data.Kreni_dinar ? data.Kreni_dinar : 0,
          M_nrx_dolar_2: data.Nrxi_yakDolar ? data.Nrxi_yakDolar : 0,
          MM_Amount_Dolar: data.Amount_Dolar,
          MM_High_Dolar: data.High_Dolar,
          MM_Low_Dolar: data.Low_Dolar,
          MM_lastPayment: data.MM_lastPayment ? data.MM_lastPayment : 0,
          MM_Amount_Dinar: data.Amount_Dinar,
          MM_Remebi_Price: data.Remebi_Price,
          MM_DolarTR: data.DolarTR,
          MM_DinarTR: data.DinarTR,
          indexState: i
        };
      },
      (e) => {
        this.PD_getkasDataBySearchMoney_kon(
          e,
          this.state.MM_zhmaraybarez,
          this.state.MM_nawebarez
        );
      }
    );
  };

  RT_gotoParadanakan = async (e, zhwasl, i) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(
      `/api/v1/searchpardan?zhmara=${zhwasl}`,
      config
    );

    const data = res.data.parakan;
    this.setState(
      () => {
        return {
          PD_search_wasl: true,
          PD_zhamara: data.zhmara,
          PD_nawebarez: data.nawekas,
          Pd_barwar: data.date,
          PD_zhmaraybarez: data.kascode,
          PD_brepara:
            data.joripara === "دینار"
              ? data.briparabadinar
              : data.joripara === "دۆلار"
              ? data.briparabadolar
              : data.briparabaRRR,
          PD_joredraw: data.joripara,
          PD_nawewargr: data.nawiwargr,
          PD_note: data.note,
          PD_del_dis: true,
          PD_wasleShareka: data.zhmaraaywasl,
          PD_wasl: data,
          PD_toggler: false,
          PD_qardekon$: data.rasidkondolar,
          PD_qardekonID: data.rasiddkoninar,
          PD_qardekonRR: data.rasiddkonRRR,
          PD_nrx_Remembe: data.nrxe_RRR ? data.nrxe_RRR : 0,
          PD_nrx_Remembe_2: data.nrxe_RRR_2 ? data.nrxe_RRR_2 : 0,
          PD_Kren_dinar_2: data.Kreni_dinar ? data.Kreni_dinar : 0,
          PD_nrx_dolar_2: data.Nrxi_yakDolar ? data.Nrxi_yakDolar : 0,
          PD_Kren_Remembe: data.Krini_RRR ? data.Krini_RRR : 0,
          P_Amount_Dolar: data.Amount_Dolar,
          P_High_Dolar: data.High_Dolar,
          P_Low_Dolar: data.Low_Dolar,
          P_Amount_Dinar: data.Amount_Dinar,
          P_Remebi_Price: data.Remebi_Price,
          P_DolarTR: data.DolarTR,
          P_DinarTR: data.DinarTR
        };
      },
      (e) => {
        this.PD_getkasDataBySearchMoney_kon(
          e,
          this.state.PD_zhmaraybarez,
          this.state.PD_nawebarez
        );
      }
    );
  };
  // end of functions of Raporty tak kasakan

  // functions Raporty Mandubakan

  RMM_OpenModal = async (e, userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data, config);

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(() => {
        return {
          RMM_openmodel: !this.state.RMM_openmodel,
          RMM_data: []
        };
      });
    }
  };

  RMM_CloseModal = () => {
    this.setState(() => {
      return { RMM_openmodel: false };
    });
  };

  RMM_peshandan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const resfooter = await Instance.get(
        `/api/v1/mandwb?from=${this.state.RMM_from}&to=${this.state.RMM_to}`,
        config
      );
      resfooter.data.Mandwbs.map((el) => {
        this.setState({
          RMM_para$: el.paraywargirawdolar,
          RMM_paraRRR: el.Krini_RRR,
          RMM_paraID: el.paraywargirawdinar
        });
      });
      const res = await Instance.get(
        `/api/v1/mandwbdata?from=${this.state.RMM_from}&to=${this.state.RMM_to}`,
        config
      );
      this.setState({
        RMM_data: res.data.Mandwbs
      });

      this.RMM_CloseModal();
    } catch (error) {
      alert("وشەی نهێنی هەڵەیە");
    }
  };
  RMM_filterPara = (jor) => {
    this.setState({
      MM_jorfilter: jor
    });
  };

  RMM_getParaDataBySearchMoney = async (e, zhmara) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchmandwb?zhmara=${zhmara}`,
      config
    );

    const data = res.data.Mandwbkan;
    if (data === null) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
      this.setState({ MM_zhmaraybarez: 0 });
    } else {
      this.setState(() => {
        return {
          MM_search_wasl: true,
          MM_zhamara: data.zhmara,
          MM_nawebarez: data.nawishwen,
          MM_barwar: data.date,
          MM_zhmaraybarez: data.shwencode,
          MM_brepara:
            data.joripara === "دینار"
              ? data.paraywargirawdinar
              : data.joripara === "دۆلار"
              ? data.paraywargirawdolar
              : data.paraywargirawrem,
          MM_joredraw: data.joripara,
          MM_nawewargr: data.nawiwargr,
          MM_note: data.note,
          MM_qarzeKonDolar: data.rasidkondolar,
          MM_qarzeKonID: data.rasiddkoninar,
          MM_qarzeKonR: data.rasiddkonRR,
          MM_del_dis: true,
          MM_wasl: data,
          MM_toggler: false,
          MM_wasleShareka: data.zhmaraaywasl,
          M_nrx_Remembe: data.nrxe_RRR ? data.nrxe_RRR : 0,
          M_Kren_Remembe: data.Krini_RRR ? data.Krini_RRR : 0,
          M_nrx_Remembe_2: data.nrxe_RRR_2 ? data.nrxe_RRR_2 : 0,
          M_Kren_dinar_2: data.Kreni_dinar ? data.Kreni_dinar : 0,
          M_nrx_dolar_2: data.Nrxi_yakDolar ? data.Nrxi_yakDolar : 0,
          MM_Amount_Dolar: data.Amount_Dolar,
          MM_High_Dolar: data.High_Dolar,
          MM_Low_Dolar: data.Low_Dolar,
          MM_lastPayment: data.MM_lastPayment ? data.MM_lastPayment : 0,
          MM_Amount_Dinar: data.Amount_Dinar,
          MM_Remebi_Price: data.Remebi_Price,
          MM_DolarTR: data.DolarTR,
          MM_DinarTR: data.DinarTR
        };
      });
    }
  };
  // end of  functions Raporty Mandubakan

  ////functions of parawargrtn
  PW_getPrint = () => {
    window.setTimeout("window.print()", 3500);
  };
  PW_showrasid = async (e, userid) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    if (this.state.PW_show === false) {
      const promp = prompt("وشەی نهێنی داخیل بکە");
      let data = {
        password: promp
      };
      const pass = await Instance.post(
        `api/v1/open?id=${userid}`,
        data,
        config
      );

      if (pass.data.status === false) {
        alert("وشەی نهێنی هەڵەیە");
      } else {
        this.setState({ PW_show: !this.state.PW_show }, () =>
          this.PB_gegtparaybardast()
        );
      }
    } else {
      this.setState({ PW_show: !this.state.PW_show });
    }
  };

  PW_openUpdate = async (userid, e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data, config);

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(
        {
          PW_del_dis: null,
          PW_open: true
        },
        async () => {
          let bardastdata;
          const respb = await Instance.get(`/api/v1/paraybardasakan`, config);
          if (this.state.PW_joredraw === "دۆلار") {
            bardastdata = {
              paraybardastdolar:
                Number(respb.data.paraybardastakan.paraybardastdolar) -
                parseFloat(this.state.PW_brepara.toString().replace(/,/g, ""))
            };
          } else if (this.state.PW_joredraw === "دینار") {
            bardastdata = {
              paraybardastdinar:
                Number(respb.data.paraybardastakan.paraybardastdinar) -
                parseFloat(this.state.PW_brepara.toString().replace(/,/g, ""))
            };
          }
          await Instance.put(
            `/api/v1/updateparabardastakan/${respb.data.paraybardastakan._id}`,
            bardastdata,
            config
          );
        }
      );
    }
  };

  PW_inputtogler = (e) => {
    e.preventDefault();
    this.setState({
      PW_toggler: !this.state.PW_toggler,
      PW_barwar: ""
    });
  };

  PW_onSaveMoney = async (e) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      if (
        this.state.PW_nawewargr === null ||
        this.state.PW_brepara === 0 ||
        this.state.PW_joredraw === null ||
        this.state.PW_nawikas === ""
      ) {
        swal({
          title: "ببورە",
          text: "تکایە خانەکان پڕبکەرەوە",
          icon: "error"
        });
      } else {
        let data;
        data = {
          briparabadolar:
            this.state.PW_joredraw === "دۆلار"
              ? parseFloat(this.state.PW_brepara.toString().replace(/,/g, ""))
              : 0,
          briparabadinar:
            this.state.PW_joredraw === "دینار"
              ? parseFloat(this.state.PW_brepara.toString().replace(/,/g, ""))
              : 0,
          nawiwargr: this.state.PW_nawewargr,
          joripara: this.state.PW_joredraw,
          note: this.state.PW_note,
          date: this.state.PW_barwar === "" ? Date.now : this.state.PW_barwar,
          nawikas: this.state.PW_nawikas
        };
        const res = await Instance.post("/api/v1/newparawargrtn", data, config);

        this.setState(
          {
            PW_save: true,
            PW_zhamara: res.data.Parawargtn.zhmara,
            PW_barwar: res.data.Parawargtn.date,
            PW_del_dis: true,
            PW_wasl: res.data.Parawargtn,
            PW_toggler: false
          },
          async () => {
            let bardastdata;
            const respb = await Instance.get(`/api/v1/paraybardasakan`, config);
            if (this.state.PW_joredraw === "دۆلار") {
              bardastdata = {
                paraybardastdolar:
                  Number(respb.data.paraybardastakan.paraybardastdolar) +
                  parseFloat(this.state.PW_brepara.toString().replace(/,/g, ""))
              };
            } else if (this.state.PW_joredraw === "دینار") {
              bardastdata = {
                paraybardastdinar:
                  Number(respb.data.paraybardastakan.paraybardastdinar) +
                  parseFloat(this.state.PW_brepara.toString().replace(/,/g, ""))
              };
            }
            await Instance.put(
              `/api/v1/updateparabardastakan/${respb.data.paraybardastakan._id}`,
              bardastdata,
              config
            );
          }
        );
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    }
  };

  ////// update Mony

  PW_updtate_para = async (e, para) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    try {
      if (
        this.state.PW_brepara === "" ||
        this.state.PW_brepara === 0 ||
        this.state.PW_barwar === "" ||
        this.state.PW_nawikas === ""
      ) {
        swal({
          title: "ببورە",
          text: "تکایە خانەکان پڕبکەرەوە",
          icon: "error"
        });
      } else {
        let data;
        data = {
          briparabadolar:
            this.state.PW_joredraw === "دۆلار"
              ? parseFloat(this.state.PW_brepara.toString().replace(/,/g, ""))
              : 0,
          briparabadinar:
            this.state.PW_joredraw === "دینار"
              ? parseFloat(this.state.PW_brepara.toString().replace(/,/g, ""))
              : 0,
          nawiwargr: this.state.PW_nawewargr,
          joripara: this.state.PW_joredraw,
          note: this.state.PW_note,
          date: this.state.PW_barwar === "" ? Date.now : this.state.PW_barwar,
          nawikas: this.state.PW_nawikas
        };
        await Instance.put(
          `/api/v1/updateparawargrtn/${para._id}`,
          data,
          config
        );

        this.setState(
          {
            PW_open: null,
            PW_del_dis: true,
            PW_toggler: false
          },
          async () => {
            let bardastdata;
            const respb = await Instance.get(`/api/v1/paraybardasakan`, config);
            if (this.state.PW_joredraw === "دۆلار") {
              bardastdata = {
                paraybardastdolar:
                  Number(respb.data.paraybardastakan.paraybardastdolar) +
                  parseFloat(this.state.PW_brepara.toString().replace(/,/g, ""))
              };
            } else if (this.state.PW_joredraw === "دینار") {
              bardastdata = {
                paraybardastdinar:
                  Number(respb.data.paraybardastakan.paraybardastdinar) +
                  parseFloat(this.state.PW_brepara.toString().replace(/,/g, ""))
              };
            }
            await Instance.put(
              `/api/v1/updateparabardastakan/${respb.data.paraybardastakan._id}`,
              bardastdata,
              config
            );
          }
        );
        swal({
          title: "تەواو",
          text: "پسولە سورکەوتوو بوو!",
          icon: "success",
          timer: 2000
        });
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    }
  };

  PW_getParaDataBySearchMoney = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchparawargrtn?zhmara=${this.state.PW_zhamara}`,
      config
    );

    const data = res.data.parakan;
    if (data === null) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
      this.setState({ PW_zhamara: 0 });
    } else {
      this.setState(() => {
        return {
          PW_search_wasl: true,
          PW_zhamara: data.zhmara,
          PW_barwar: data.date,
          PW_brepara:
            data.joripara === "دینار"
              ? data.briparabadinar
              : data.briparabadolar,
          PW_joredraw: data.joripara,
          PW_nawewargr: data.nawiwargr,
          PW_note: data.note,
          PW_del_dis: true,
          PW_wasl: data,
          PW_toggler: false,
          PW_nawikas: data.nawikas
        };
      });
    }
  };

  PW_getParakan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/parawargrtnakan`, config);

    this.setState({
      PW_zhamara: res.data.Parawargtnakan.length + 1
    });
  };

  PW_createNewMony = () => {
    this.setState(
      {
        PW_brepara: 0,
        PW_note: "",
        PW_search_wasl: null,
        PW_save: null,
        PW_joredraw: "دۆلار",
        PW_nawewargr: "ئەنوەر",
        PW_open: null,
        PW_del_dis: null,
        PW_page: this.state.PW_zhamara,
        PW_wasl: null,
        PW_nawikas: "",
        PW_barwar: ""
      },
      () => {
        this.PW_getParakan();
        this.PB_gegtparaybardast();
      }
    );
  };

  PW_pageplusone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page = this.state.PW_zhamara + 1;
      const res = await Instance.get(
        `/api/v1/pageparawargrtn?page=${page}&limit=1`,
        config
      );

      const data = res.data.paras;
      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState(() => {
          return {
            PW_search_wasl: true,
            PW_zhamara: data.zhmara,
            PW_barwar: data.date,
            PW_brepara:
              data.joripara === "دینار"
                ? data.briparabadinar
                : data.briparabadolar,
            PW_joredraw: data.joripara,
            PW_nawewargr: data.nawiwargr,
            PW_note: data.note,
            PW_del_dis: true,
            PW_wasl: data,
            PW_toggler: false,
            PW_nawikas: data.nawikas
          };
        });
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };

  PW_pageminsone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page;
      this.state.PW_zhamara <= 1
        ? (page = 1)
        : (page = this.state.PW_zhamara - 1);
      const res = await Instance.get(
        `/api/v1/pageparawargrtn?page=${page}&limit=1`,
        config
      );

      const data = res.data.paras;
      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState(() => {
          return {
            PW_search_wasl: true,
            PW_zhamara: data.zhmara,
            PW_barwar: data.date,
            PW_brepara:
              data.joripara === "دینار"
                ? data.briparabadinar
                : data.briparabadolar,
            PW_joredraw: data.joripara,
            PW_nawewargr: data.nawiwargr,
            PW_note: data.note,
            PW_del_dis: true,
            PW_wasl: data,
            PW_toggler: false,
            PW_nawikas: data.nawikas
          };
        });
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };
  /////end of functions para wargrtn

  // Functions of raporty para wargrtnawakan
  RPW_OpenModal = async (e, userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data, config);

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(() => {
        return {
          RPW_openmodel: !this.state.RPW_openmodel,
          RPW_data: [],
          RPW_para$: 0,
          RPW_paraID: 0
        };
      });
    }
  };

  RPW_CloseModal = () => {
    this.setState(() => {
      return { RPW_openmodel: false };
    });
  };

  RPW_peshandan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/parawargrtnakanakndata?from=${this.state.RPW_from}&to=${this.state.RPW_to}`,
        config
      );
      const footer = await Instance.get(
        `/api/v1/parawargrtnakanfromto?from=${this.state.RPW_from}&to=${this.state.RPW_to}`,
        config
      );
      footer.data.paradarhinanakan.forEach((data) => {
        this.setState({
          RPW_para$: data.briparabadolar,
          RPW_paraID: data.briparabadinar
        });
      });
      this.setState({
        RPW_data: res.data.Parawargtnakan
      });
      this.RPW_CloseModal();
    } catch (error) {
      alert("وشەی نهێنی هەڵەیە");
    }
  };

  RPW_getParaDataBySearchMoney = async (e, zhmara) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchparawargrtn?zhmara=${zhmara}`,
      config
    );

    const data = res.data.parakan;
    if (data === null) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
      this.setState({ PW_zhmaraybarez: 0 });
    } else {
      this.setState(() => {
        return {
          PW_search_wasl: true,
          PW_zhamara: data.zhmara,
          PW_barwar: data.date,
          PW_brepara:
            data.joripara === "دینار"
              ? data.briparabadinar
              : data.briparabadolar,
          PW_joredraw: data.joripara,
          PW_nawewargr: data.nawiwargr,
          PW_note: data.note,
          PW_del_dis: true,
          PW_wasl: data,
          PW_toggler: false
        };
      });
    }
  };
  // end of Functions of raporty para wargrtnawakan

  /// paraay qasa functions
  PB_gegtparaybardast = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      header: {
        "Content-Type": "application/json"
      }
    };
    try {
      const res = await Instance.get(`/api/v1/paraybardasakan`, config);
      this.setState({
        PD_parayesta$: Number(
          res.data.paraybardastakan.paraybardastdolar
        ).toFixed(2),
        PD_parayestaID: Number(
          res.data.paraybardastakan.paraybardastdinar
        ).toFixed(2),
        PD_parayesta_RRR: Number(
          res.data.paraybardastakan.paraybardastRemembe
        ).toFixed(2),
        PM_parayesta$: Number(
          res.data.paraybardastakan.paraybardastdolar
        ).toFixed(2),
        PM_parayestaID: Number(
          res.data.paraybardastakan.paraybardastdinar
        ).toFixed(2),
        PW_parayesta$: Number(
          res.data.paraybardastakan.paraybardastdolar
        ).toFixed(2),
        PW_parayestaID: Number(
          res.data.paraybardastakan.paraybardastdinar
        ).toFixed(2),
        PG_parayesta$: Number(
          res.data.paraybardastakan.paraybardastdolar
        ).toFixed(2),
        PG_parayestaID: Number(
          res.data.paraybardastakan.paraybardastdinar
        ).toFixed(2)
      });
    } catch (error) {
      alert("پارەی بەردەست نیە");
    }
  };
  ///end of  paraay qasa functions

  // Function of ParaGorenawa
  PG_getPrint = () => {
    window.setTimeout("window.print()", 3500);
  };

  PG_showrasid = async (e, userid) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    if (this.state.PG_show === false) {
      const promp = prompt("وشەی نهێنی داخیل بکە");
      let data = {
        password: promp
      };
      const pass = await Instance.post(
        `api/v1/open?id=${userid}`,
        data,
        config
      );

      if (pass.data.status === false) {
        alert("وشەی نهێنی هەڵەیە");
      } else {
        this.setState({ PG_show: !this.state.PG_show }, () =>
          this.PB_gegtparaybardast()
        );
      }
    } else {
      this.setState({ PG_show: !this.state.PG_show });
    }
  };

  PG_openUpdate = async (userid, e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data, config);

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(
        {
          PG_del_dis: null,
          PG_open: true
        },
        async () => {
          let bardastdata;
          const respb = await Instance.get(`/api/v1/paraybardasakan`, config);
          bardastdata = {
            paraybardastdolar:
              Number(respb.data.paraybardastakan.paraybardastdolar) -
              parseFloat(this.state.PG_breKrini$.toString().replace(/,/g, "")),
            paraybardastdinar:
              Number(respb.data.paraybardastakan.paraybardastdinar) +
              parseFloat(this.state.PG_breParabaID.toString().replace(/,/g, ""))
          };

          await Instance.put(
            `/api/v1/updateparabardastakan/${respb.data.paraybardastakan._id}`,
            bardastdata,
            config
          );
        }
      );
    }
  };

  PG_inputtogler = (e) => {
    e.preventDefault();
    this.setState({
      PG_toggler: !this.state.PG_toggler,
      PG_barwar: ""
    });
  };

  PG_onSaveMoney = async (e) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      if (
        this.state.PG_nawewargr === null ||
        this.state.PG_breParabaID === 0 ||
        this.state.PG_nrxeKrine$ === 0 ||
        this.state.PG_breParabaID === "" ||
        this.state.PG_nrxeKrine$ === ""
      ) {
        swal({
          title: "ببورە",
          text: "تکایە خانەکان پڕبکەرەوە",
          icon: "error"
        });
      } else {
        let data;
        data = {
          briparabadinar: parseFloat(
            this.state.PG_breParabaID.toString().replace(/,/g, "")
          ),
          nrxikrinidolar: parseFloat(
            this.state.PG_nrxeKrine$.toString().replace(/,/g, "")
          ),
          brikrinidolar: parseFloat(
            this.state.PG_breKrini$.toString().replace(/,/g, "")
          ),
          nawiwargr: this.state.PG_nawewargr,
          note: this.state.PG_note,
          date: this.state.PG_barwar === "" ? Date.now : this.state.PG_barwar
        };
        const res = await Instance.post(
          "/api/v1/newParaGorinawa",
          data,
          config
        );

        this.setState({
          PG_save: true,
          PG_zhmara: res.data.paraGorinawa.zhmara,
          PG_barwar: res.data.paraGorinawa.date,
          PG_del_dis: true,
          //    P_paraywasl:res.data.wargrtn.paradwaykmkrdn,
          PG_wasl: res.data.paraGorinawa,
          PG_toggler: false
        });
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    }
  };

  ////// update Mony

  PG_updtate_para = async (e, para) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    try {
      if (
        this.state.PG_nawewargr === null ||
        this.state.PG_breParabaID === 0 ||
        this.state.PG_nrxeKrine$ === 0 ||
        this.state.PG_breParabaID === "" ||
        this.state.PG_nrxeKrine$ === ""
      ) {
        swal({
          title: "ببورە",
          text: "تکایە خانەکان پڕبکەرەوە",
          icon: "error"
        });
      } else {
        let data;
        data = {
          briparabadinar: parseFloat(
            this.state.PG_breParabaID.toString().replace(/,/g, "")
          ),
          nrxikrinidolar: parseFloat(
            this.state.PG_nrxeKrine$.toString().replace(/,/g, "")
          ),
          brikrinidolar: parseFloat(
            this.state.PG_breKrini$.toString().replace(/,/g, "")
          ),
          nawiwargr: this.state.PG_nawewargr,
          note: this.state.PG_note,
          date: this.state.PG_barwar === "" ? Date.now : this.state.PG_barwar
        };
        const res = await Instance.put(
          `/api/v1/updateParaGorinawa/${para._id}`,
          data,
          config
        );

        this.setState({
          PG_open: null,
          PG_del_dis: true,
          PG_toggler: false
        });
        swal({
          title: "تەواو",
          text: "پسولە سورکەوتوو بوو!",
          icon: "success",
          timer: 2000
        });
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "تکایە خانەکان پڕبکەرەوە",
        icon: "error"
      });
    }
  };

  PG_getParaDataBySearchMoney = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchParaGorinawa?zhmara=${this.state.PG_zhmara}`,
      config
    );

    const data = res.data.parakan;
    if (data === null) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
      this.setState({ PD_zhmaraybarez: 0 });
    } else {
      this.setState(() => {
        return {
          PG_search_wasl: true,
          PG_zhmara: data.zhmara,
          PG_barwar: data.date,
          PG_breKrini$: data.brikrinidolar,
          PG_nrxeKrine$: data.nrxikrinidolar,
          PG_breParabaID: data.briparabadinar,
          PG_nawewargr: data.nawiwargr,
          PG_note: data.note,
          PG_del_dis: true,
          PG_wasl: data,
          PG_toggler: false
        };
      });
    }
  };

  PG_getParakan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const res = await Instance.get(`/api/v1/paragorinaewakn`, config);

    this.setState({
      PG_zhmara: res.data.paraGorinawa.length + 1
    });
  };

  PG_createNewMony = () => {
    this.setState(
      {
        PM_brepara: 0,
        PG_note: "",
        PG_search_wasl: null,
        PG_save: null,
        PG_nawewargr: "ئەنوەر",
        PG_open: null,
        PG_del_dis: null,
        // PM_page:this.state.PG_zhamara,
        PG_wasl: null,
        PG_barwar: "",
        PG_breParabaID: 0,
        PG_breKrini$: 0,
        PG_nrxeKrine$: 0
      },
      () => {
        this.PG_getParakan();
        this.PB_gegtparaybardast();
      }
    );
  };

  PG_pageplusone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page = this.state.PG_zhmara + 1;
      const res = await Instance.get(
        `/api/v1/pageParaGorinawa?page=${page}&limit=1`,
        config
      );

      const data = res.data.paras;
      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState(() => {
          return {
            PG_search_wasl: true,
            PG_zhmara: data.zhmara,
            PG_barwar: data.date,
            PG_breKrini$: data.brikrinidolar,
            PG_nrxeKrine$: data.nrxikrinidolar,
            PG_breParabaID: data.briparabadinar,
            PG_nawewargr: data.nawiwargr,
            PG_note: data.note,
            PG_del_dis: true,
            PG_wasl: data,
            PG_toggler: false
          };
        });
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };

  PG_pageminsone = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      let page;
      this.state.PG_zhmara <= 1
        ? (page = 1)
        : (page = this.state.PG_zhmara - 1);
      const res = await Instance.get(
        `/api/v1/pageParaGorinawa?page=${page}&limit=1`,
        config
      );

      const data = res.data.paras;
      if (data.status === false) {
        swal({
          title: "ببورە",
          text: "ببورە ئەم پسولە بونی نیە",
          icon: "error"
        });
      } else {
        this.setState(() => {
          return {
            PG_search_wasl: true,
            PG_zhmara: data.zhmara,
            PG_barwar: data.date,
            PG_breKrini$: data.brikrinidolar,
            PG_nrxeKrine$: data.nrxikrinidolar,
            PG_breParabaID: data.briparabadinar,
            PG_nawewargr: data.nawiwargr,
            PG_note: data.note,
            PG_del_dis: true,
            PG_wasl: data,
            PG_toggler: false
          };
        });
      }
    } catch (error) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
    }
  };

  OngetDolar = () => {
    const z =
      (parseFloat(this.state.PG_breParabaID.toString().replace(/,/g, "")) /
        parseFloat(this.state.PG_nrxeKrine$.toString().replace(/,/g, ""))) *
      100;
    return z;
  };

  onChangeKriniDolar = (e) => {
    this.setState({ PG_nrxeKrine$: e.target.value }, () => {
      this.setState({ PG_breKrini$: this.OngetDolar() });
    });
  };

  onChangebreParaDanbaID = (e) => {
    this.setState({ PG_breParabaID: e.target.value }, () => {
      this.setState({ PG_breKrini$: this.OngetDolar() });
    });
  };
  /////end of functions para Gorenawa

  // raporty ParaGorenawa
  RPG_OpenModal = async (e, userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data, config);

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(() => {
        return {
          RPG_openmodel: !this.state.RPG_openmodel,
          RPG_data: []
        };
      });
    }
  };

  RPG_CloseModal = () => {
    this.setState(() => {
      return { RPG_openmodel: false };
    });
  };

  RPG_peshandan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/paragorinawafromto?from=${this.state.RPG_from}&to=${this.state.RPG_to}`,
        config
      );

      this.setState({
        RPG_data: res.data.paragorinawakan
      });
      this.RPG_CloseModal();
    } catch (error) {
      alert("بەروار داخل بکە");
    }
  };
  RPG_getParaDataBySearchMoney = async (e, zhmara) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };

    const res = await Instance.get(
      `/api/v1/searchParaGorinawa?zhmara=${zhmara}`,
      config
    );

    const data = res.data.parakan;
    if (data === null) {
      swal({
        title: "ببورە",
        text: "ببورە ئەم پسولە بونی نیە",
        icon: "error"
      });
      this.setState({ PD_zhmaraybarez: 0 });
    } else {
      this.setState(() => {
        return {
          PG_search_wasl: true,
          PG_zhmara: data.zhmara,
          PG_barwar: data.date,
          PG_breKrini$: data.brikrinidolar,
          PG_nrxeKrine$: data.nrxikrinidolar,
          PG_breParabaID: data.briparabadinar,
          PG_nawewargr: data.nawiwargr,
          PG_note: data.note,
          PG_del_dis: true,
          PG_wasl: data,
          PG_toggler: false
        };
      });
    }
  };

  R_toAnotherRow = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 5].focus();
  };

  G_toAnotherRow = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 5].focus();
  };

  R_toThirdRow = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 8].focus();
  };

  G_toThirdRow = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index + 8].focus();
  };

  R_toSavebyEnter = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index - 5].focus();
    this.saveDetail(e, this.state.R_wasl);
  };

  G_toSavebyEnter = (e) => {
    e.preventDefault();
    const form = e.target.form;
    const index = Array.prototype.indexOf.call(form, e.target);
    form.elements[index - 5].focus();
    this.G_saveDetail(e, this.state.G_wasl);
  };

  RP_getPrint = () => {
    window.setTimeout("window.print()", 3500);
  };

  RPM_getPrint = () => {
    window.setTimeout("window.print()", 3500);
  };

  RPD_getPrint = () => {
    window.setTimeout("window.print()", 3500);
  };

  RMS_getPrint = () => {
    window.setTimeout("window.print()", 3500);
  };

  RPG_getPrint = () => {
    window.setTimeout("window.print()", 3500);
  };

  RMM_getPrint = () => {
    window.setTimeout("window.print()", 3500);
  };

  RPW_getPrint = () => {
    window.setTimeout("window.print()", 3500);
  };

  RT_getPrint = () => {
    window.setTimeout("window.print()", 3500);
  };

  ///Function Of Old Rasid

  SaveOldRasid = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const draw = this.state.OR_joriDraw == "دۆلار" ? "dolar" : "dinar";
      const briqarz = parseFloat(
        this.state.OR_briQarz.toString().replace(/,/g, "")
      );
      await Instance.put(
        `/api/v1/updaitwakilrasid?code=${this.state.OR_zhmarayBarez}&joridraw=${draw}&opr=plus&bripara=${briqarz}`,
        config
      );

      const data = {
        code: this.state.OR_zhmarayBarez,
        naw: this.state.OR_nawiBarez,
        para: briqarz,
        draw: this.state.OR_joriDraw
      };
      await Instance.post(`/api/v1/newRasid`, data, config);
      this.setState({
        OR_save: true,
        OR_open: null,
        OR_del_dis: true
      });
      swal({
        title: "تەواو",
        text: "قەرزی سەر دەفتەر خەزنکرا",
        icon: "success"
      });
    } catch (error) {
      swal({
        title: "ببورە",
        text: "هەڵە هەیە لە خانەکان",
        icon: "error"
      });
    }
  };
  NewOldRasid = (e) => {
    e.preventDefault();
    this.setState({
      OR_briQarz: "",
      OR_joriDraw: "دینار",
      OR_nawiBarez: "",
      OR_zhmarayBarez: "",
      OR_save: null,
      OR_open: null,
      OR_del_dis: null
    });
  };
  OpenOldRasid = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const draw = this.state.OR_joriDraw == "دۆلار" ? "dolar" : "dinar";
      const briqarz = parseFloat(
        this.state.OR_briQarz.toString().replace(/,/g, "")
      );
      await Instance.put(
        `/api/v1/updaitwakilrasid?code=${this.state.OR_zhmarayBarez}&joridraw=${draw}&opr=-&bripara=${briqarz}`,
        config
      );
      this.setState({
        OR_open: true,
        OR_del_dis: true
      });
    } catch (error) {
      swal({
        title: "ببورە",
        text: "هەڵە هەیە لە خانەکان",
        icon: "error"
      });
    }
  };
  SearchWakilOldRasid = async (e, NOW) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get(
        `/api/v1/searchwakil?code=${NOW}&&Name=&&phone=`,
        config
      );
      this.setState({
        OR_nawiBarez: res.data.wakils.Name,
        OR_zhmarayBarez: res.data.wakils.code
      });
    } catch (error) {
      alert("There is Now Wakil as this name");
    }
  };

  /// Function julay kompanyakan
  JK_CloseModal = () => {
    this.setState(() => {
      return { JK_modalOpen: false };
    });
  };

  JK_OpenModal = async (e, userid) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data, config);

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(() => {
        return {
          JK_modalOpen: !this.state.RT_openmodel,
          JK_data: [],
          PD_RR_IQD: 0,
          PD_RR_$: 0,
          MM_RR_IQD: 0,
          MM_RR_$: 0
          // RW_koyfroshtndianr:0,
          // RW_koyfroshtndolar:0,
        };
      });
    }
  };
  // RPD_peshandan = async () => {
  //   if (localStorage.token) {
  //     setToken(localStorage.token);
  //   }
  //   const config = {
  //     "Content-Type": "application/json",
  //   };
  //   try {
  //     const res = await Instance.get(
  //       `/api/v1/paradanakandata?from=${this.state.RPD_from}&to=${this.state.RPD_to}`,
  //       config
  //     );
  //     const footer = await Instance.get(
  //       `/api/v1/paradanakanfromto?from=${this.state.RPD_from}&to=${this.state.RPD_to}`,
  //       config
  //     );
  //     footer.data.paradanakan.forEach((data) => {
  //       this.setState({
  //         RPD_para$: data.briparabadolar,
  //         RPD_paraID: data.briparabadinar,
  //       });
  //     });
  //     this.setState({
  //       RPD_data: res.data.paradanakan,
  //     });
  //     this.RPD_CloseModal();
  //   } catch (error) {
  //     alert("وشەی نهێنی هەڵەیە");
  //   }
  // };

  JK_peshandan = async (e) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    try {
      this.JK_CloseModal();
      const config = {
        "Content-Type": "application/json"
      };
      const table = this.state.JK_data;
      const res = await Instance.get(
        `/api/v1/paradanakandata?from=${this.state.JK_from}&to=${this.state.JK_to}`,
        config
      );
      const data = res.data.pswla;

      data.forEach((data) => {
        table.push({
          joripara: data.joripara,
          koywasl:
            data.joripara === "دۆلار"
              ? data.briparabadolar
              : data.briparabadinar,
          jwlla: "پارەدان",
          barwar: data.date,
          code: data.zhmara,
          nawewargr: data.nawiwargr,
          wasl: data.zhmaraaywasl,
          note: data.note
        });
      });
      const para = await Instance.get(
        `/api/v1/mandwbdata?from=${this.state.JK_from}&to=${this.state.JK_to}`,
        config
      );
      const paras = para.data.pswla;

      paras.forEach((paras) => {
        table.push({
          joripara: paras.joripara,
          koywasl:
            paras.joripara === "دۆلار"
              ? paras.paraywargirawdolar
              : paras.paraywargirawdinar,
          jwlla: "مافی.کۆمپانیا",
          barwar: paras.date,
          code: paras.zhmara,
          nawewargr: paras.nawiwargr,
          wasl: paras.zhmaraaywasl,
          note: paras.note
        });
      });

      if (this.state.JK_paradan === true) {
        this.setState(
          {
            JK_data: table.filter((data) => data.jwlla === "پارەدان")
          },
          () => {
            // this.RT_koypardandolar(e);
            // this.RT_koypardandinar(e);
          }
        );
      } else if (this.state.JK_kompanyakan === true) {
        this.setState(
          {
            JK_data: table.filter((data) => data.jwlla === "مافی.کۆمپانیا")
          },
          () => {
            // this.RT_koyKreninar(e);
            // this.RT_koyKrenolar(e);
          }
        );
      } else if (this.state.JK_hamu === true) {
        this.setState(
          {
            JK_data: table
          },
          () => {
            // this.RT_koyKreninar(e);
            // this.RT_koyKrenolar(e);
          }
        );
      }
    } catch (error) {
      alert("هیج جاڵاکیەکی نیە");
    }
  };

  // JK_Paradanakan = async () => {
  //   this.setState(
  //     {
  //       JK_paradan: true,
  //       JK_hamu:false,
  //       JK_kompanyakan: false,
  //       JK_data: [],
  //     },
  //     () => {
  //       this.JK_peshandan();
  //     }
  //   );
  // };

  // JK_mandubakan = async () => {
  //   this.setState(
  //     {
  //       JK_kompanyakan: true,
  //       JK_paradan: false,
  //       JK_hamu:false,
  //       JK_data: [],
  //     },
  //     () => {
  //       this.JK_peshandan();
  //     }
  //   );
  // };

  // JK_Hamu = async () => {
  //   this.setState(
  //     {
  //       JK_kompanyakan: false,
  //       JK_paradan: false,
  //       JK_hamu:true,
  //       JK_data: [],
  //     },
  //     () => {
  //       this.JK_peshandan();
  //     }
  //   );
  // };

  /// function of bas remembe
  RB_CloseModal = () => {
    this.setState(() => {
      return { RB_openmodel: false };
    });
  };

  RB_peshandan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const footer = await Instance.get(
        `/api/v1/ratpotyRRfooter?from=${this.state.RB_from}&to=${this.state.RB_to}`
      );

      footer.data.Mandwbs.forEach((el) => {
        this.setState({
          RB_para$: el.paraywargirawdolar,
          RB_paraRRR: el.Krini_RRR
        });
      });
      const res = await Instance.get(
        `/api/v1/ratpotyRR?from=${this.state.RB_from}&to=${this.state.RB_to}`,
        config
      );

      this.setState({
        RB_data: res.data.Mandwbs
      });
      this.RB_CloseModal();
    } catch (error) {
      alert("وشەی نهێنی هەڵەیە");
    }
  };

  RB_OpenModal = async (e, userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    const promp = prompt("وشەی نهێنی داخیل بکە");
    let data = {
      password: promp
    };
    const pass = await Instance.post(`api/v1/open?id=${userid}`, data, config);

    if (pass.data.status === false) {
      alert("وشەی نهێنی هەڵەیە");
    } else if (pass.data.status === true) {
      this.setState(() => {
        return {
          RB_openmodel: !this.state.RB_openmodel,
          RB_data: [],
          RB_paraRRR: 0,
          RB_para$: 0
        };
      });
    }
  };

  ///function OF Qarzi Asto

  QA_OpenModal = async (e, userid) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const promp = prompt("وشەی نهێنی داخیل بکە");
      let data = {
        password: promp
      };
      const pass = await Instance.post(
        `api/v1/open?id=${userid}`,
        data,
        config
      );

      if (pass.data.status === false) {
        alert("وشەی نهێنی هەڵەیە");
      } else if (pass.data.status === true) {
        this.setState(() => {
          return {
            QA_modalOpen: !this.state.QA_modalOpen
          };
        });
      }
    } catch (error) {
      alert("وشەی نهێنی هەڵەیە");
    }
  };

  KoyqarziAssto = async (e) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      this.QA_CloseModal();
      const res = await Instance.get(`/api/v1/getkoyqarziasto`, config);
      this.setState({
        QA_qarzdinar: res.data.qarz[0].dinar,
        QA_qarzdolar: res.data.qarz[0].dolar
      });
    } catch (error) {
      alert("There is Now Wakil as this name");
    }
  };

  QA_CloseModal = () => {
    this.setState(() => {
      return { QA_modalOpen: false };
    });
  };
  /// 3arze Kala Function
  HK_pshandan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get("/api/v1/getProducts", config);

      this.setState({
        HK_all3arzKala: res.data.products,
        HK_code: "",
        HK_name: ""
      });
      this.HK_CloseModal();
    } catch (error) {
      alert("هەڵە هەیە لە بەروار");
    }
  };

  HK_OpenModal = async (e, userid) => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      this.setState(() => {
        return {
          HK_modalOpen: !this.state.HK_modalOpen,
          HK_all3arzKala: []
        };
      });
    } catch (error) {
      alert("وشەی نهێنی هەڵەیە");
    }
  };
  HK_getProductDetail = async (e) => {
    e.preventDefault();
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      if (this.state.HK_code2 === "") {
        alert("بەبێ ژمارەی کاڵا ناتوانی بگەڕێی");
      } else {
        const res = await Instance.get(
          `/api/v1/searchtoproduct?code=${this.state.HK_code2}&nameofproduct=`,
          config
        );

        const data = res.data.product;
        let arr = this.state.HK_all3arzKala;

        if (data) {
          arr = _.concat(this.state.HK_all3arzKala, data);
        } else {
          alert("ببورە ئەم کاڵایە بونی نیە");
          arr = this.state.HK_all3arzKala;
        }

        this.setState({
          HK_all3arzKala: arr,
          HK_code2: ""
        });
      }
    } catch (error) {
      this.setError({ msg: "ببورە ئەم کاڵایە بونی نیە" });
    }
  };
  HK_delete = (e, id) => {
    e.preventDefault();
    this.setState({
      HK_all3arzKala: this.state.HK_all3arzKala.filter((el, i) => el._id !== id)
    });
  };
  HK_CloseModal = () => {
    this.setState(() => {
      return { HK_modalOpen: false };
    });
  };

  KD_pshandan = async () => {
    if (localStorage.token) {
      setToken(localStorage.token);
    }
    const config = {
      "Content-Type": "application/json"
    };
    try {
      const res = await Instance.get("/api/v1/getProductsempty", config);

      this.setState({
        KD_all3arzKala: res.data.products
      });
    } catch (error) {
      alert("هەڵە هەیە لە بەروار");
    }
  };
  /**
   * Function of Buy Items
   */

  exportToCSV = (apiData, fileName) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  AllDataexportToCSV = (apiData, fileName) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const fileExtension = ".xlsx";
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: fileType });
    FileSaver.saveAs(data, fileName + fileExtension);
  };

  // Audit Log Functions
  AL_getLogs = async () => {
    try {
      const params = {
        page: this.state.AL_page,
        limit: 30,
        ...(this.state.AL_model && { model: this.state.AL_model }),
        ...(this.state.AL_action && { action: this.state.AL_action }),
        ...(this.state.AL_from && { from: this.state.AL_from }),
        ...(this.state.AL_to && { to: this.state.AL_to })
      };

      const response = await getAuditLogs(params);

      if (response.status) {
        this.setState({
          AL_data: response.logs,
          AL_total: response.total,
          AL_pages: response.pages || 1,
          AL_page: response.page || this.state.AL_page
        });
      }
    } catch (error) {
      toast.error("هەلەیەک ڕویدا لە خوێندنەوەی ژوورنالی");
    }
  };

  AL_OpenModal = async (id) => {
    try {
      const response = await getAuditLogById(id);
      if (response.status) {
        this.setState({
          AL_selectedLog: response.log,
          AL_modalOpen: true
        });
      }
    } catch (error) {
      toast.error("هەلەیەک ڕویدا");
    }
  };

  AL_CloseModal = () => {
    this.setState({
      AL_selectedLog: null,
      AL_modalOpen: false
    });
  };

  AL_pageplusone = () => {
    if (this.state.AL_page < this.state.AL_pages) {
      this.setState({ AL_page: this.state.AL_page + 1 }, () =>
        this.AL_getLogs()
      );
    }
  };

  AL_pageminsone = () => {
    if (this.state.AL_page > 1) {
      this.setState({ AL_page: this.state.AL_page - 1 }, () =>
        this.AL_getLogs()
      );
    }
  };

  AL_applyFilter = () => {
    this.setState({ AL_page: 1 }, () => this.AL_getLogs());
  };

  render() {
    return (
      <>
        <ToastContainer></ToastContainer>
        <ProductContext.Provider
          value={{
            ...this.state,
            //function of Qarzi Asto
            AllDataexportToCSV: this.AllDataexportToCSV,
            exportToCSV: this.exportToCSV,
            QA_OpenModal: this.QA_OpenModal,
            QA_CloseModal: this.QA_CloseModal,
            KoyqarziAssto: this.KoyqarziAssto,
            //function of bas remembe
            RB_peshandan: this.RB_peshandan,
            RB_OpenModal: this.RB_OpenModal,
            RB_CloseModal: this.RB_CloseModal,
            // julay kompanyakan
            JK_OpenModal: this.JK_OpenModal,
            JK_Hamu: this.JK_Hamu,
            JK_Paradanakan: this.JK_Paradanakan,
            JK_mandubakan: this.JK_mandubakan,
            JK_CloseModal: this.JK_CloseModal,
            JK_peshandan: this.JK_peshandan,
            ///
            SearchWakilOldRasid: this.SearchWakilOldRasid,
            SaveOldRasid: this.SaveOldRasid,
            NewOldRasid: this.NewOldRasid,
            OpenOldRasid: this.OpenOldRasid,
            RT_getPrint: this.RT_getPrint,
            RPW_getPrint: this.RPW_getPrint,
            RMM_getPrint: this.RMM_getPrint,
            RPG_getPrint: this.RPG_getPrint,
            RMS_getPrint: this.RMS_getPrint,
            RPD_getPrint: this.RPD_getPrint,
            RPM_getPrint: this.RPM_getPrint,
            G_toSavebyEnter: this.G_toSavebyEnter,
            RP_getPrint: this.RP_getPrint,
            R_toAnotherRow: this.R_toAnotherRow,
            G_toAnotherRow: this.G_toAnotherRow,
            R_toThirdRow: this.R_toThirdRow,
            G_toThirdRow: this.G_toThirdRow,
            R_toSavebyEnter: this.R_toSavebyEnter,
            // Raporty ParaGorenawa
            RPG_CloseModal: this.RPG_CloseModal,
            RPG_OpenModal: this.RPG_OpenModal,
            RPG_peshandan: this.RPG_peshandan,
            RPG_getParaDataBySearchMoney: this.RPG_getParaDataBySearchMoney,
            //ParaGorenawa Functions
            onChangebreParaDanbaID: this.onChangebreParaDanbaID,
            PG_pageminsone: this.PG_pageminsone,
            PG_pageplusone: this.PG_pageplusone,
            PG_inputtogler: this.PG_inputtogler,
            PG_openUpdate: this.PG_openUpdate,
            PG_showrasid: this.PG_showrasid,
            PG_updtate_para: this.PG_updtate_para,
            PG_getParaDataBySearchMoney: this.PG_getParaDataBySearchMoney,
            onChangeKriniDolar: this.onChangeKriniDolar,
            PG_onSaveMoney: this.PG_onSaveMoney,
            PG_getPrint: this.PG_getPrint,
            PG_createNewMony: this.PG_createNewMony,
            //// loading dunction
            ProducthideLoader: this.ProducthideLoader,
            ProductshowLoader: this.ProductshowLoader,
            P_hideLoader: this.P_hideLoader,
            P_showLoader: this.P_showLoader,
            G_showLoader: this.G_showLoader,
            G_hideLoader: this.G_hideLoader,
            hideLoader: this.hideLoader,
            showLoader: this.showLoader,
            // functions of raporty parawargrtnawakan
            RPW_getParaDataBySearchMoney: this.RPW_getParaDataBySearchMoney,
            RPW_peshandan: this.RPW_peshandan,
            RPW_OpenModal: this.RPW_OpenModal,
            RPW_CloseModal: this.RPW_CloseModal,
            ////functions of parawargrtn
            PW_onSaveMoney: this.PW_onSaveMoney,
            PW_getParaDataBySearchMoney: this.PW_getParaDataBySearchMoney,
            PW_pageminsone: this.PW_pageminsone,
            PW_pageplusone: this.PW_pageplusone,
            PW_createNewMony: this.PW_createNewMony,
            PW_getParakan: this.PW_getParakan,
            PW_updtate_para: this.PW_updtate_para,
            PW_inputtogler: this.PW_inputtogler,
            PW_openUpdate: this.PW_openUpdate,
            PW_getPrint: this.PW_getPrint,
            PW_showrasid: this.PW_showrasid,
            //Raporty Mandubakan
            RMM_getParaDataBySearchMoney: this.RMM_getParaDataBySearchMoney,
            RMM_peshandan: this.RMM_peshandan,
            RMM_CloseModal: this.RMM_CloseModal,
            RMM_OpenModal: this.RMM_OpenModal,
            RMM_filterPara: this.RMM_filterPara,
            // raporty tak kas
            RT_gotoParadanakan: this.RT_gotoParadanakan,
            RT_gotoMandub: this.RT_gotoMandub,
            RT_mandubakan: this.RT_mandubakan,
            RT_Paradanakan: this.RT_Paradanakan,
            RT_peshandan: this.RT_peshandan,
            RT_OpenModal: this.RT_OpenModal,
            RT_CloseModal: this.RT_CloseModal,
            RT_setstInputEmpty: this.RT_setstInputEmpty,
            RT_serchwakil: this.RT_serchwakil,
            //// name search inside ڕاپۆرتی کەسەکان
            RT_kasNameHandle: this.RT_kasNameHandle,
            RT_kasListKeydown: this.RT_kasListKeydown,
            RT_kasSuggestionSelected: this.RT_kasSuggestionSelected,
            RT_emptyKasSuggestions: this.RT_emptyKasSuggestions,
            RT_filter: this.RT_filter,
            // raporty masrufat
            RMS_OpenModal: this.RMS_OpenModal,
            RMS_CloseModal: this.RMS_CloseModal,
            RMS_peshandan: this.RMS_peshandan,
            // raporty paradarhenan
            RPM_OpenModal: this.RPM_OpenModal,
            RPM_CloseModal: this.RPM_CloseModal,
            RPM_peshandan: this.RPM_peshandan,
            RPM_getParaDataBySearchMoney: this.RPM_getParaDataBySearchMoney,
            // raporty paradan
            RPD_OpenModal: this.RPD_OpenModal,
            RPD_CloseModal: this.RPD_CloseModal,
            RPD_peshandan: this.RPD_peshandan,
            RPD_getParaDataBySearchMoney: this.RPD_getParaDataBySearchMoney,
            RPD_filterPara: this.RPD_filterPara,
            ////money mandubs
            MM_onSaveMoney: this.MM_onSaveMoney,
            MM_getWakilDataBySearchMoney: this.MM_getWakilDataBySearchMoney,
            MM_kasNameHandle: this.MM_kasNameHandle,
            MM_kasListKeydown: this.MM_kasListKeydown,
            MM_kasSuggestionSelected: this.MM_kasSuggestionSelected,
            MM_emptyKasSuggestions: this.MM_emptyKasSuggestions,
            MM_getParaDataBySearchMoney: this.MM_getParaDataBySearchMoney,
            MM_getParaDataBySearcInvoice: this.MM_getParaDataBySearcInvoice,
            MM_createNewMony: this.MM_createNewMony,
            MM_setSearchMonyWakilEmpty: this.MM_setSearchMonyWakilEmpty,
            MM_openUpdate: this.MM_openUpdate,
            MM_updtate_para: this.MM_updtate_para,
            MM_pageplusone: this.MM_pageplusone,
            MM_pageminsone: this.MM_pageminsone,
            MM_inputtogler: this.MM_inputtogler,
            MM_getPrint: this.MM_getPrint,
            MM_getIsChecked: this.MM_getIsChecked,
            MM_peshandaniQarzyPeshw: this.MM_peshandaniQarzyPeshw,
            MM_DolartoRemembi_In_Balance: this.MM_DolartoRemembi_In_Balance,
            MM_DinartoRemembi_In_Balance: this.MM_DinartoRemembi_In_Balance,
            MM_DinartoRemembi_Without_Balance:
              this.MM_DinartoRemembi_Without_Balance,
            MM_DolartoDinare: this.MM_DolartoDinare,
            MM_DolartoRemembi_WithOut_Balance:
              this.MM_DolartoRemembi_WithOut_Balance,

            ////functions of paradarhenan
            PM_onSaveMoney: this.PM_onSaveMoney,
            PM_getParaDataBySearchMoney: this.PM_getParaDataBySearchMoney,
            PM_pageminsone: this.PM_pageminsone,
            PM_pageplusone: this.PM_pageplusone,
            PM_createNewMony: this.PM_createNewMony,
            PM_getParakan: this.PM_getParakan,
            PM_updtate_para: this.PM_updtate_para,
            PM_inputtogler: this.PM_inputtogler,
            PM_openUpdate: this.PM_openUpdate,
            PM_getPrint: this.PM_getPrint,
            PM_showrasid: this.PM_showrasid,

            ////functions of pardan
            PD_onSaveMoney: this.PD_onSaveMoney,
            PD_getParaDataBySearchMoney: this.PD_getParaDataBySearchMoney,
            PD_pageminsone: this.PD_pageminsone,
            PD_pageplusone: this.PD_pageplusone,
            PD_createNewMony: this.PD_createNewMony,
            RKP_getPrint: this.RKP_getPrint,
            PD_setSearchMonyWakilEmpty: this.PD_setSearchMonyWakilEmpty,
            PD_getParakan: this.PD_getParakan,
            PD_getkasDataBySearchMoney: this.PD_getkasDataBySearchMoney,
            PD_kasNameHandle: this.PD_kasNameHandle,
            PD_kasListKeydown: this.PD_kasListKeydown,
            PD_kasSuggestionSelected: this.PD_kasSuggestionSelected,
            PD_emptyKasSuggestions: this.PD_emptyKasSuggestions,
            PD_updtate_para: this.PD_updtate_para,
            PD_inputtogler: this.PD_inputtogler,
            PD_openUpdate: this.PD_openUpdate,
            PD_getPrint: this.PD_getPrint,
            PD_getIsChecked: this.PD_getIsChecked,
            PD_showrasid: this.PD_showrasid,
            PD_peshandaniQarzyPeshw: this.PD_peshandaniQarzyPeshw,
            PD_peshandaniQarzyPeshw_kon: this.PD_peshandaniQarzyPeshw_kon,
            PD_Change_R_Dolar: this.PD_Change_R_Dolar,
            PD_Change_Dinar_to_R: this.PD_Change_Dinar_to_R,
            Money_peshandaniQarzyPeshw_kon: this.Money_peshandaniQarzyPeshw_kon,
            Money_Change: this.Money_Change,
            // functions of masrufat
            Ms_setWakilEmpty: this.Ms_setWakilEmpty,
            Ms_tofirstInput: this.Ms_tofirstInput,
            Ms_onSaveWakel: this.Ms_onSaveWakel,
            Ms_clickOnDeleteWakel: this.Ms_clickOnDeleteWakel,
            Ms_getWakiltableData: this.Ms_getWakiltableData,
            Ms_updtae_Wakil: this.Ms_updtae_Wakil,
            Ms_showrasid: this.Ms_showrasid,
            // functions of add people
            Ap_updtae_Wakil: this.Ap_updtae_Wakil,
            Ap_clickOnDeleteWakel: this.Ap_clickOnDeleteWakel,
            Ap_tofirstInput: this.Ap_tofirstInput,
            Ap_setWakilEmpty: this.Ap_setWakilEmpty,
            Ap_getWakilDataBySearchWakil: this.Ap_getWakilDataBySearchWakil,
            Ap_onSaveWakel: this.Ap_onSaveWakel,
            Ap_showrasid: this.Ap_showrasid,
            SearchWakil: this.SearchWakil,
            /////input pass
            toanotherInput: this.toanotherInput,
            saerch: this.saerch,
            aynamictoanotherInput: this.aynamictoanotherInput,
            HandleChange: this.HandleChange,
            /////user
            L_ClearError: this.L_ClearError,
            loginuser: this.loginuser,
            ///////////////add ptoduct functions
            newPage: this.newPage,
            clickOnDelete: this.clickOnDelete,
            DolarChange: this.DolarChange,
            AddProChange: this.AddProChange,
            OnKrenChange: this.OnKrenChange,
            OnCHange: this.OnCHange,
            CartonDarzanChange: this.CartonDarzanChange,
            calculateQazanj: this.calculateQazanj,
            MeterTogler: this.MeterTogler,
            MerterChange: this.MerterChange,
            KoyGshtyR: this.KoyGshtyR,
            KoyGshtydolar_: this.KoyGshtydolar_,
            dolartodinar: this.dolartodinar,
            ClearError: this.ClearError,
            refreshPage: this.refreshPage,
            getkoygahty: this.getkoygahty,
            onSaveTable: this.onSaveTable,
            edit_product: this.edit_product,
            KM_onchangeSalePer: this.KM_onchangeSalePer,
            EditTableProduct: this.EditTableProduct,
            clear_edit: this.clear_edit,
            calculateCarton: this.calculateCarton,
            calculateDarzan: this.calculateDarzan,
            onSave: this.onSave,
            getProductDataBySearch: this.getProductDataBySearch,
            getProductDataBySearchName: this.getProductDataBySearchName,
            getProductDataBySearchByNumber: this.getProductDataBySearchByNumber,
            Addsaerch_toanotherInput: this.Addsaerch_toanotherInput,
            Add_toanotherInputttttt: this.Add_toanotherInputttttt,
            Add_toanotherInput: this.Add_toanotherInput,
            setStateEmpty: this.setStateEmpty,
            updtae_product: this.updtae_product,
            updtae_Right_product: this.updtae_Right_product,
            close_update: this.close_update,
            getNameOfData: this.getNameOfData,
            CartonChange: this.CartonChange,
            DarzanChange: this.DarzanChange,
            setProductSearchEmty: this.setProductSearchEmty,
            openUpdateproduct: this.openUpdateproduct,
            productpageplusone: this.productpageplusone,
            productpageminsone: this.productpageminsone,
            ////////////end of Add Product

            /////////////// REnt And Wakil
            DeleteSail: this.DeleteSail,
            onSaveRent: this.onSaveRent,
            R_calculateBripara: this.R_calculateBripara,
            R_zhmaraycarton: this.R_zhmaraycarton,
            R_zhmaraydarzan: this.R_zhmaraydarzan,
            nrxRent: this.nrxRent,
            R_getkoygahty: this.R_getkoygahty,
            R_kamkrdnawayNrx$: this.R_kamkrdnawayNrx$,
            R_waslKrdn: this.R_waslKrdn,
            dinartodolar: this.dinartodolar,
            R_kamkrdnawayNrxID: this.R_kamkrdnawayNrxID,
            R_waslKrdnID: this.R_waslKrdnID,
            onSaveWakel: this.onSaveWakel,
            clickOnDeleteWakel: this.clickOnDeleteWakel,
            getQazanj: this.getQazanj,
            radiochange: this.radiochange,
            A_OpenModal: this.A_OpenModal,
            updtae_Wakil: this.updtae_Wakil,
            W_ClearError: this.W_ClearError,
            setWakilEmpty: this.setWakilEmpty,
            R_DarzanChange: this.R_DarzanChange,
            R_CartonChange: this.R_CartonChange,
            R_CartonDarzanSfr: this.R_CartonDarzanSfr,
            getProductDataBySearchRent: this.getProductDataBySearchRent,
            getWakilDataBySearchRent: this.getWakilDataBySearchRent,
            createNewPage: this.createNewPage,
            getWaslDataBySearchRent: this.getWaslDataBySearchRent,
            R_ClearError: this.R_ClearError,
            saveDetail: this.saveDetail,
            W_showrasid: this.W_showrasid,
            setSearchEmptyRentWakil: this.setSearchEmptyRentWakil,
            setSaletSearchEmty: this.setSaletSearchEmty,
            R_getIsChecked: this.R_getIsChecked,
            R_WakilQard_getIsChecked: this.R_WakilQard_getIsChecked,
            W_getwakelakan: this.W_getwakelakan,
            WakilNameHandle: this.WakilNameHandle,
            R_wakilSuggestionSelected: this.R_wakilSuggestionSelected,
            R_emptyWakilSuggestions: this.R_emptyWakilSuggestions,
            R_wakilListKeydown: this.R_wakilListKeydown,
            updateSale: this.updateSale,
            getPrintPasswordRent: this.getPrintPasswordRent,
            OnChangePaymentFIB: this.OnChangePaymentFIB,
            OnChangePaymentCash: this.OnChangePaymentCash,
            OnChangePayment: this.OnChangePayment,
            OnHarzantrChange: this.OnHarzantrChange,
            OnHarzantrChange_IQD: this.OnHarzantrChange_IQD,
            OnCancleHarzantrChange: this.OnCancleHarzantrChange,
            OnIsSignleReturn: this.OnIsSignleReturn,
            onGrantrCHange: this.onGrantrCHange,
            onGrantrCHange_IQD: this.onGrantrCHange_IQD,
            OnIsSignleGrantrChange: this.OnIsSignleGrantrChange,
            R_nrxchange: this.R_nrxchange,
            tofirstInputINRent: this.tofirstInputINRent,
            NrxtofirstInputINRent: this.NrxtofirstInputINRent,
            R_anotherInputWakil: this.R_anotherInputWakil,
            openUpdate: this.openUpdate,
            toKoyGshtiSave: this.toKoyGshtiSave,
            getWakilDataBySearchWakil: this.getWakilDataBySearchWakil,
            inputtogler: this.inputtogler,
            R_pageminsone: this.R_pageminsone,
            R_pageplusone: this.R_pageplusone,
            getWaslakan: this.getWaslakan,
            W_tofirstInput: this.W_tofirstInput,
            R_darzankartontoanotherInput: this.R_darzankartontoanotherInput,
            getNewRaidForwakil: this.getNewRaidForwakil,
            Search_Rent_Handle: this.Search_Rent_Handle,
            R_suggestionSelected: this.R_suggestionSelected,
            R_emptysuggections: this.R_emptysuggections,
            R_hanldeKeydown: this.R_hanldeKeydown,
            R_hanldeKeyup: this.R_hanldeKeyup,
            R_handleListKeydown: this.R_handleListKeydown,
            //////////////// zyadkrdni user
            onSaveAddUser: this.onSaveAddUser,
            clickOnDeleteAddUser: this.clickOnDeleteAddUser,
            updtae_User: this.updtae_User,

            //// updatepassword
            onUpdatePassword: this.onUpdatePassword,
            U_ClearError: this.U_ClearError,
            showpassword: this.showpassword,
            labrdnisave: this.labrdnisave,
            AU_onUpdatePassword: this.AU_onUpdatePassword,
            AU_showpassword: this.AU_showpassword,
            ////money
            onSaveMoney: this.onSaveMoney,
            getWakilDataBySearchMoney: this.getWakilDataBySearchMoney,
            P_wakilNameHandle: this.P_wakilNameHandle,
            P_wakilListKeydown: this.P_wakilListKeydown,
            P_wakilSuggestionSelected: this.P_wakilSuggestionSelected,
            P_emptyWakilSuggestions: this.P_emptyWakilSuggestions,
            bripara: this.bripara,
            P_kamkrdnawayNrx: this.P_kamkrdnawayNrx,
            getParaDataBySearchMoney: this.getParaDataBySearchMoney,
            createNewMony: this.createNewMony,
            P_ClearError: this.P_ClearError,
            P_getIsChecked: this.P_getIsChecked,
            setSearchMonyWakilEmpty: this.setSearchMonyWakilEmpty,
            P_openUpdate: this.P_openUpdate,
            P_calculateBripara: this.P_calculateBripara,
            P_OnChangeBripara: this.P_OnChangeBripara,
            DecimalNumber: this.DecimalNumber,
            P_OnDolarChange: this.P_OnDolarChange,
            updtate_para: this.updtate_para,
            pageplusone: this.pageplusone,
            pageminsone: this.pageminsone,
            P_inputtogler: this.P_inputtogler,
            P_getPrint: this.P_getPrint,
            P_DolartoRemembi_In_Balance: this.P_DolartoRemembi_In_Balance,
            P_DinartoRemembi_In_Balance: this.P_DinartoRemembi_In_Balance,
            P_DinartoRemembi_Without_Balance:
              this.P_DinartoRemembi_Without_Balance,
            P_DolartoRemembi_WithOut_Balance:
              this.P_DolartoRemembi_WithOut_Balance,
            P_DolartoDinar: this.P_DolartoDinar,
            /// print functiond
            getPrint: this.getPrint,
            handleKeypress: this.handleKeypress,

            ////logout
            logoutUser: this.logoutUser,

            // navdolar toogle
            toggleNavdolar: this.toggleNavdolar,

            //garanawa bo koga functions
            G_createNewPage: this.G_createNewPage,
            G_setSearchEmptyRentWakil: this.G_setSearchEmptyRentWakil,
            G_getWaslDataBySearchRent: this.G_getWaslDataBySearchRent,
            G_getWakilDataBySearchRent: this.G_getWakilDataBySearchRent,
            G_getkoygahty: this.G_getkoygahty,
            G_getProductDataBySearchRent: this.G_getProductDataBySearchRent,
            G_saveDetail: this.G_saveDetail,
            G_setSaletSearchEmty: this.G_setSaletSearchEmty,
            G_nrxchange: this.G_nrxchange,
            G_tofirstInputINRent: this.G_tofirstInputINRent,
            G_anotherInputWakil: this.G_anotherInputWakil,
            G_CartonChange: this.G_CartonChange,
            G_DarzanChange: this.G_DarzanChange,
            OnChangeSwitch_G: this.OnChangeSwitch_G,
            OnChangeSwitch_G_IQD: this.OnChangeSwitch_G_IQD,
            G_DeleteSail: this.G_DeleteSail,
            G_waslKrdn: this.G_waslKrdn,
            G_waslKrdnID: this.G_waslKrdnID,
            G_onSaveRent: this.G_onSaveRent,
            G_openUpdate: this.G_openUpdate,
            G_updateSale: this.G_updateSale,
            G_pageminsone: this.G_pageminsone,
            G_pageplusone: this.G_pageplusone,
            G_inputtogler: this.G_inputtogler,
            G_getPrintPasswordRent: this.G_getPrintPasswordRent,

            // functions of raporty Qazanj
            Q_OpenModal: this.Q_OpenModal,
            Q_CloseModal: this.Q_CloseModal,
            Q_peshandan: this.Q_peshandan,
            Q_getwakel: this.Q_getwakel,
            Q_getrastawxo: this.Q_getrastawxo,
            Q_getkala: this.Q_getkala,
            Q_getwasl: this.Q_getwasl,

            // functions of Raporty Rozhana
            D_OpenModal: this.D_OpenModal,
            D_CloseModal: this.D_CloseModal,
            D_hameJwllakan: this.D_hameJwllakan,
            D_rozhanafooter: this.D_rozhanafooter,
            D_rozhanafroshtn: this.D_rozhanafroshtn,
            D_rozhanaparawagrtn: this.D_rozhanaparawagrtn,
            D_gotowaslrentsearch: this.D_gotowaslrentsearch,
            D_gotowaslparasearch: this.D_gotowaslparasearch,
            D_jwllakan: this.D_jwllakan,
            D_rozhanaGaranawa: this.D_rozhanaGaranawa,
            D_gotowaslGaranawasearch: this.D_gotowaslGaranawasearch,

            /// functions of Raporty Wakel
            RW_OpenModal: this.RW_OpenModal,
            RW_CloseModal: this.RW_CloseModal,
            Rw_serchwakil: this.Rw_serchwakil,
            //// name search inside ڕاپۆرتی وەکیل
            RW_wakilNameHandle: this.RW_wakilNameHandle,
            RW_wakilListKeydown: this.RW_wakilListKeydown,
            RW_wakilSuggestionSelected: this.RW_wakilSuggestionSelected,
            RW_emptyWakilSuggestions: this.RW_emptyWakilSuggestions,
            RW_jwalakan: this.RW_jwalakan,
            RW_jwllakan: this.RW_jwllakan,
            RW_rozhanafroshtn: this.RW_rozhanafroshtn,
            RW_rozhanaparawagrtn: this.RW_rozhanaparawagrtn,
            RW_gotowaslparasearch: this.RW_gotowaslparasearch,
            RW_gotowaslrentsearch: this.RW_gotowaslrentsearch,
            RW_wakilGaranawa: this.RW_wakilGaranawa,
            RW_gotowaslGaranawasearch: this.RW_gotowaslGaranawasearch,
            RW_setstInputEmpty: this.RW_setstInputEmpty,

            /////rapoty qarzy wakil functions
            QW_qazrywakil: this.QW_qazrywakil,

            // functions Of Jarde Maxzan Raporty Koga
            JM_OpenModal: this.JM_OpenModal,
            JM_CloseModal: this.JM_CloseModal,
            JM_pshandan: this.JM_pshandan,
            JM_yaksanbasfrfn: this.JM_yaksanbasfrfn,
            JM_zyatrlasfrfn: this.JM_zyatrlasfrfn,
            JM_clickOnDelete: this.JM_clickOnDelete,
            HK_pshandan: this.HK_pshandan,
            HK_OpenModal: this.HK_OpenModal,
            HK_CloseModal: this.HK_CloseModal,
            KD_pshandan: this.KD_pshandan,
            HK_getProductDetail: this.HK_getProductDetail,
            HK_delete: this.HK_delete,
            // raporty kala
            K_getFroshtn: this.K_getFroshtn,
            K_gettomarkrdn: this.K_gettomarkrdn,
            K_getGaranawa: this.K_getGaranawa,
            K_OpenModal: this.K_OpenModal,
            K_CloseModal: this.K_CloseModal,
            K_getproduct: this.K_getproduct,
            K_pshandan: this.K_pshandan,
            K_grantr: this.K_grantr,
            K_harzantr: this.K_harzantr,
            K_hamannrx: this.K_hamannrx,
            K_gotowaslrentsearch: this.K_gotowaslrentsearch,
            K_gotowaslGaranawasearch: this.K_gotowaslGaranawasearch,

            ///raporty qarzy rastawxo functions
            QR_OpenModal: this.QR_OpenModal,
            QR_CloseModal: this.QR_CloseModal,
            QR_hamwqarzakan: this.QR_hamwqarzakan,
            QR_gotowaslrentsearch: this.QR_gotowaslrentsearch,

            ///end of qarzy rastawxo
            RDM_pshandan: this.RDM_pshandan,
            RDM_CloseModal: this.RDM_CloseModal,
            RDM_OpenModal: this.RDM_OpenModal,
            ////
            RC_getnavbarRemembe: this.RC_getnavbarRemembe,
            RC_getnavbarMatr: this.RC_getnavbarMatr,
            RRRchange: this.RRRchange,
            RC_barzichnage: this.RC_barzichnage,
            RC_saveToTable: this.RC_saveToTable,
            tofirstInput: this.tofirstInput,
            tofirstInpuMatr: this.tofirstInpuMatr,
            tofirstInpuKalla: this.tofirstInpuKalla,
            RC_newChina: this.RC_newChina,
            RC_search: this.RC_search,
            RC_update: this.RC_update,
            RC_updateNawKalla: this.RC_updateNawKalla,
            RC_froshtnChange: this.RC_froshtnChange,
            RC_openchina: this.RC_openchina,
            RC_newpage: this.RC_newpage,
            RC_matrremembychnage: this.RC_matrremembychnage,
            RC_clickOnDelete: this.RC_clickOnDelete,
            RC_setInputEmpty: this.RC_setInputEmpty,
            RC_qazanjchange: this.RC_qazanjchange,

            ///// function of kalay nafroshraw
            KN_CloseModal: this.KN_CloseModal,
            KN_OpenModal: this.KN_OpenModal,
            KN_peshandan: this.KN_peshandan,
            calculateNrxDarzan: this.calculateNrxDarzan,

            // Functions of Raporty Paray Nahatu
            RP_ParayNahatu: this.RP_ParayNahatu,
            RP_OpenModal: this.RP_OpenModal,
            RP_CloseModal: this.RP_CloseModal,
            /// remembe to dolar
            Change_R_Dolar: this.Change_R_Dolar,
            Change_Dinar_to_R: this.Change_Dinar_to_R,
            PR_getProductByCode: this.PR_getProductByCode,
            PR_drowpdownchange: this.PR_drowpdownchange,
            PR_checkboxchange: this.PR_checkboxchange,
            PR_save: this.PR_save,
            PR_newpage: this.PR_newpage,
            PR_delete: this.PR_delete,
            PR_setempty: this.PR_setempty,
            //
            IO_OpenModal: this.IO_OpenModal,
            IO_CloseModal: this.IO_CloseModal,
            IO_peshandan: this.IO_peshandan,
            P_productUpdatePrice: this.P_productUpdatePrice,
            P_getListUpdatedItems: this.P_getListUpdatedItems,
            //
            OnChangeSwitch: this.OnChangeSwitch,
            OnChangeSwitch_IQD: this.OnChangeSwitch_IQD,
            OnChangeSwitch_Mufrad: this.OnChangeSwitch_Mufrad,
            M_OnChangePaymentCash: this.M_OnChangePaymentCash,
            OnChangeSwitch_Item: this.OnChangeSwitch_Item,
            M_OnChangePaymentFIB: this.M_OnChangePaymentFIB,

            daynamictoanotherInput: this.AU_onUpdatePassword,
            IT_searchItemName: this.IT_searchItemName,
            IT_setItemEmpty: this.IT_setItemEmpty,
            IT_searchItemINArray: this.IT_searchItemINArray,
            IT_searchBySelect: this.IT_searchBySelect,
            IT_countChange: this.IT_countChange,
            IT_deleteSearchedItem: this.IT_deleteSearchedItem,
            IT_getWakilData: this.IT_getWakilData,
            IT_saveDetail: this.IT_saveDetail,
            IT_saveOutStore: this.IT_saveOutStore,
            IT_deleteItem: this.IT_deleteItem,
            IT_save: this.IT_save,
            IT_updateInvoice: this.IT_updateInvoice,
            IT_openInvoice: this.IT_openInvoice,
            IT_createNewPage: this.IT_createNewPage,
            IT_pageminsone: this.IT_pageminsone,
            IT_pageplusone: this.IT_pageplusone,
            IT_get_Invoice: this.IT_get_Invoice,
            IT_fetchSalePage: this.IT_fetchSalePage,
            IT_nextPage: this.IT_nextPage,
            IT_prevPage: this.IT_prevPage,
            IT_pageplusone: this.IT_pageplusone,
            IT_pageminsone: this.IT_pageminsone,
            IT_totalPages: this.state.IT_totalPages,
            IT_disCount: this.IT_disCount,
            IT_openEditModel: this.IT_openEditModel,
            IT_updateItemInTable: this.IT_updateItemInTable,
            IT_closeModel: this.IT_closeModel,
            IT_onKeyUP: this.IT_onKeyUP,
            IT_OnChangePaymentFIB: this.IT_OnChangePaymentFIB,
            IT_OnChangePayment: this.IT_OnChangePayment,
            IT_OnChangePaymentCash: this.IT_OnChangePaymentCash,
            IT_OnDanaChange: this.IT_OnDanaChange,
            IT_OnKartonChange: this.IT_OnKartonChange,
            IT_OnDarzanChange: this.IT_OnDarzanChange,
            IT_OnChangeSwitch: this.IT_OnChangeSwitch,
            IT_OnNrxChange: this.IT_OnNrxChange,
            IT_OnMetrChange: this.IT_OnMetrChange,
            IT_OnRememberChange: this.IT_OnRememberChange,
            IT_metr: this.state.IT_metr,
            IT_remembi: this.state.IT_remembi,
            IT_editProfit: this.state.IT_editProfit,
            IT_qazanj: this.state.IT_qazanj,

            // Audit Log Functions
            AL_getLogs: this.AL_getLogs,
            AL_OpenModal: this.AL_OpenModal,
            AL_CloseModal: this.AL_CloseModal,
            AL_pageplusone: this.AL_pageplusone,
            AL_pageminsone: this.AL_pageminsone,
            AL_applyFilter: this.AL_applyFilter
          }}
        >
          {this.props.children}
        </ProductContext.Provider>
      </>
    );
  }
}

const ProductConsumer = ProductContext.Consumer;

export { AddProWakel, ProductConsumer };
